{
  "schemaVersion": 2,
  "meta": {
    "generatedAt": "2026-07-14T05:44:35.613Z",
    "asOf": "2026-07-14",
    "version": "0.1.0",
    "title": "AI Capital Cycle public-data baseline",
    "currency": "USD billions",
    "caveat": "Demand Index is a public adoption proxy until authenticated gateway token data is connected. It is not a global Token count."
  },
  "quarterly": [
    {
      "period": "2017-Q1",
      "end": "2017-03-31",
      "capex": 5.474,
      "revenue": 55.994,
      "operatingCashFlow": 25.266,
      "depreciation": 0.671,
      "companyCoverage": 3,
      "companyMetricCoverage": {
        "capex": 3,
        "revenue": 3,
        "operatingCashFlow": 3,
        "depreciation": 1,
        "core": 3
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.820857989439766,
      "freeCashFlow": 19.791999999999998,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": null,
      "capexGrowthYoY": null,
      "nvidiaRevenue": null,
      "coverage": {
        "hyperscalers": 3,
        "hyperscalersByMetric": {
          "capex": 3,
          "revenue": 3,
          "operatingCashFlow": 3,
          "depreciation": 1,
          "core": 3
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2017-Q2",
      "end": "2017-06-30",
      "capex": 7.083,
      "revenue": 71.893,
      "operatingCashFlow": 23.768,
      "depreciation": 0.729,
      "companyCoverage": 4,
      "companyMetricCoverage": {
        "capex": 4,
        "revenue": 4,
        "operatingCashFlow": 3,
        "depreciation": 1,
        "core": 4
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.820857989439766,
      "freeCashFlow": 16.685000000000002,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": null,
      "capexGrowthYoY": null,
      "nvidiaRevenue": 1.937,
      "coverage": {
        "hyperscalers": 4,
        "hyperscalersByMetric": {
          "capex": 4,
          "revenue": 4,
          "operatingCashFlow": 3,
          "depreciation": 1,
          "core": 4
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2017-Q3",
      "end": "2017-09-30",
      "capex": 10.972,
      "revenue": 115.486,
      "operatingCashFlow": 38.782000000000004,
      "depreciation": 3.684,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.820857989439766,
      "freeCashFlow": 27.810000000000002,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": null,
      "capexGrowthYoY": null,
      "nvidiaRevenue": 2.23,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2017-Q4",
      "end": "2017-12-31",
      "capex": 13.374,
      "revenue": 144.255,
      "operatingCashFlow": 39.022000000000006,
      "depreciation": 4.351,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.820857989439766,
      "freeCashFlow": 25.648000000000003,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": null,
      "capexGrowthYoY": null,
      "nvidiaRevenue": 2.636,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2018-Q1",
      "end": "2018-03-31",
      "capex": 16.429000000000002,
      "revenue": 130.649,
      "operatingCashFlow": 33.172,
      "depreciation": 4.62,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.820857989439766,
      "freeCashFlow": 16.742999999999995,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 133.32678501267995,
      "capexGrowthYoY": 200.1278772378517,
      "nvidiaRevenue": 2.911,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2018-Q2",
      "end": "2018-06-30",
      "capex": 16.538,
      "revenue": 139.87300000000002,
      "operatingCashFlow": 39.956999999999994,
      "depreciation": 4.664,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.9417076655489,
      "freeCashFlow": 23.418999999999993,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 94.55718915610703,
      "capexGrowthYoY": 133.48863475928277,
      "nvidiaRevenue": 3.207,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2018-Q3",
      "end": "2018-09-30",
      "capex": 15.961000000000002,
      "revenue": 142.32000000000002,
      "operatingCashFlow": 49.675,
      "depreciation": 4.885,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.9417076655489,
      "freeCashFlow": 33.714,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 23.235716883431778,
      "capexGrowthYoY": 45.47028800583306,
      "nvidiaRevenue": 3.123,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2018-Q4",
      "end": "2018-12-31",
      "capex": 19.244,
      "revenue": 170.606,
      "operatingCashFlow": 46.528000000000006,
      "depreciation": 5.487,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.9417076655489,
      "freeCashFlow": 27.284000000000006,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 18.266957817753294,
      "capexGrowthYoY": 43.89113204725585,
      "nvidiaRevenue": 3.181,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2019-Q1",
      "end": "2019-03-31",
      "capex": 14.772999999999998,
      "revenue": 151.30100000000002,
      "operatingCashFlow": 39.535,
      "depreciation": 6.209,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.9417076655489,
      "freeCashFlow": 24.762,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 15.807239244081472,
      "capexGrowthYoY": -10.079737050337844,
      "nvidiaRevenue": 2.205,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2019-Q2",
      "end": "2019-06-30",
      "capex": 17.785,
      "revenue": 164.088,
      "operatingCashFlow": 50.891,
      "depreciation": 6.704,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 21.9417076655489,
      "freeCashFlow": 33.105999999999995,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 17.31213314935689,
      "capexGrowthYoY": 7.540210424476967,
      "nvidiaRevenue": 2.22,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2019-Q3",
      "end": "2019-09-30",
      "capex": 18.732,
      "revenue": 170.405,
      "operatingCashFlow": 52.483000000000004,
      "depreciation": 6.978999999999999,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 22.342422680822207,
      "freeCashFlow": 33.751000000000005,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 19.733698707138814,
      "capexGrowthYoY": 17.361067602280535,
      "nvidiaRevenue": 2.579,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2019-Q4",
      "end": "2019-12-31",
      "capex": 19.358,
      "revenue": 201.113,
      "operatingCashFlow": 54.361999999999995,
      "depreciation": 7.638,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 23.032352784880736,
      "freeCashFlow": 35.00399999999999,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 17.881551645311422,
      "capexGrowthYoY": 0.5923924340054176,
      "nvidiaRevenue": 3.014,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2020-Q1",
      "end": "2020-03-31",
      "capex": 20.521,
      "revenue": 179.165,
      "operatingCashFlow": 46.032000000000004,
      "depreciation": 6.959,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 23.049218022670182,
      "freeCashFlow": 25.511000000000003,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 18.416269555389576,
      "capexGrowthYoY": 38.90882014485888,
      "nvidiaRevenue": 3.105,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2020-Q2",
      "end": "2020-06-30",
      "capex": 21.282,
      "revenue": 194.36800000000002,
      "operatingCashFlow": 60.763,
      "depreciation": 7.452,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 23.496929648073216,
      "freeCashFlow": 39.480999999999995,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 18.453512749256507,
      "capexGrowthYoY": 19.66263705369693,
      "nvidiaRevenue": 3.08,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2020-Q3",
      "end": "2020-09-30",
      "capex": 25.500999999999998,
      "revenue": 210.30899999999997,
      "operatingCashFlow": 64.084,
      "depreciation": 8.221,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 23.496929648073216,
      "freeCashFlow": 38.583000000000006,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 23.417153252545386,
      "capexGrowthYoY": 36.136023916292956,
      "nvidiaRevenue": 3.866,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2020-Q4",
      "end": "2020-12-31",
      "capex": 29.705000000000002,
      "revenue": 263.401,
      "operatingCashFlow": 81.05199999999999,
      "depreciation": 9.41,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0,
      "facilityPowerGW": 0,
      "h100EquivalentM": 0,
      "dataCenterCapitalCostB": 0,
      "powerCoverageSites": 0,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 23.496929648073216,
      "freeCashFlow": 51.346999999999994,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 30.971642807774735,
      "capexGrowthYoY": 53.45076970761442,
      "nvidiaRevenue": 4.726,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2021-Q1",
      "end": "2021-03-31",
      "capex": 27.830000000000002,
      "revenue": 241.794,
      "operatingCashFlow": 61.627,
      "depreciation": 9.48,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 23.496929648073216,
      "freeCashFlow": 33.797,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 34.95604610275444,
      "capexGrowthYoY": 35.61717265240485,
      "nvidiaRevenue": 5.003,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2021-Q2",
      "end": "2021-06-30",
      "capex": 31.594,
      "revenue": 261.416,
      "operatingCashFlow": 75.404,
      "depreciation": 10.024000000000001,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.18850663381812,
      "freeCashFlow": 43.809999999999995,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 34.495390187685196,
      "capexGrowthYoY": 48.454092660464255,
      "nvidiaRevenue": 5.661,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2021-Q3",
      "end": "2021-09-30",
      "capex": 33.785,
      "revenue": 259.985,
      "operatingCashFlow": 76.873,
      "depreciation": 10.943000000000001,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.311117842662505,
      "freeCashFlow": 43.08800000000001,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 23.62048224279516,
      "capexGrowthYoY": 32.48500058821222,
      "nvidiaRevenue": 6.507,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2021-Q4",
      "end": "2021-12-31",
      "capex": 37.507999999999996,
      "revenue": 308.49600000000004,
      "operatingCashFlow": 75.922,
      "depreciation": 11.953,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.311117842662505,
      "freeCashFlow": 38.414,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 17.12028428138086,
      "capexGrowthYoY": 26.268304999158374,
      "nvidiaRevenue": 7.103,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2022-Q1",
      "end": "2022-03-31",
      "capex": 36.619,
      "revenue": 272.236,
      "operatingCashFlow": 65.623,
      "depreciation": 11.349,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.411282913017384,
      "chipUnitsAdded": 147645,
      "h100eAddedM": 0.046554,
      "h100eCumulativeM": 0.046554,
      "chipPowerAddedGW": 0.059058,
      "freeCashFlow": 29.004000000000005,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 12.590055998081006,
      "capexGrowthYoY": 31.581027667984184,
      "nvidiaRevenue": 7.643,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2022-Q2",
      "end": "2022-06-30",
      "capex": 38.418000000000006,
      "revenue": 283.44599999999997,
      "operatingCashFlow": 69.197,
      "depreciation": 11.695,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.4379882502195,
      "chipUnitsAdded": 226324,
      "h100eAddedM": 0.071362,
      "h100eCumulativeM": 0.117916,
      "chipPowerAddedGW": 0.0905296,
      "freeCashFlow": 30.778999999999996,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 8.42718119778436,
      "capexGrowthYoY": 21.599037791985843,
      "nvidiaRevenue": 8.288,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2022-Q3",
      "end": "2022-09-30",
      "capex": 41.031,
      "revenue": 285.474,
      "operatingCashFlow": 74.041,
      "depreciation": 12.501999999999999,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.4379882502195,
      "chipUnitsAdded": 221306,
      "h100eAddedM": 0.073961,
      "h100eCumulativeM": 0.191877,
      "chipPowerAddedGW": 0.0903542,
      "freeCashFlow": 33.01,
      "sdkDownloads": null,
      "wikiViews": null,
      "demandIndex": null,
      "demandProxy": null,
      "revenueGrowthYoY": 9.804027155412797,
      "capexGrowthYoY": 21.44738789403582,
      "nvidiaRevenue": 6.704,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": false,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2022-Q4",
      "end": "2022-12-31",
      "capex": 41.694,
      "revenue": 322.439,
      "operatingCashFlow": 79.32,
      "depreciation": 15.061,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.048,
      "facilityPowerGW": 0.057,
      "h100EquivalentM": 0.0039413845376452756,
      "dataCenterCapitalCostB": 1.818336,
      "powerCoverageSites": 1,
      "frontierEci": null,
      "frontierTrainingComputeLog10": 24.4379882502195,
      "chipUnitsAdded": 276532,
      "h100eAddedM": 0.090844,
      "h100eCumulativeM": 0.282721,
      "chipPowerAddedGW": 0.109001015,
      "freeCashFlow": 37.62599999999999,
      "sdkDownloads": 385110,
      "wikiViews": 1882964,
      "demandIndex": 11.549103873579291,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 4.519669622944855,
      "capexGrowthYoY": 11.160285805694814,
      "nvidiaRevenue": 5.931,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2023-Q1",
      "end": "2023-03-31",
      "capex": 36.554,
      "revenue": 291.045,
      "operatingCashFlow": 71.01100000000001,
      "depreciation": 13.646999999999998,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.127,
      "facilityPowerGW": 0.152,
      "h100EquivalentM": 0.024911571500757956,
      "dataCenterCapitalCostB": 4.811014,
      "powerCoverageSites": 2,
      "frontierEci": 125.93,
      "frontierTrainingComputeLog10": 25.32221929473392,
      "chipUnitsAdded": 319754,
      "h100eAddedM": 0.116658,
      "h100eCumulativeM": 0.399379,
      "chipPowerAddedGW": 0.13094277,
      "freeCashFlow": 34.45700000000001,
      "sdkDownloads": 2984913,
      "wikiViews": 18213716,
      "demandIndex": 100,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 6.909078887435904,
      "capexGrowthYoY": -0.17750348179905728,
      "nvidiaRevenue": 6.051,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2023-Q2",
      "end": "2023-06-30",
      "capex": 35.333,
      "revenue": 311.0110000000001,
      "operatingCashFlow": 96.86800000000001,
      "depreciation": 14.212,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.214,
      "facilityPowerGW": 0.262,
      "h100EquivalentM": 0.08676099039919151,
      "dataCenterCapitalCostB": 8.106748,
      "powerCoverageSites": 3,
      "frontierEci": 125.93,
      "frontierTrainingComputeLog10": 25.32221929473392,
      "chipUnitsAdded": 459603,
      "h100eAddedM": 0.244645,
      "h100eCumulativeM": 0.644024,
      "chipPowerAddedGW": 0.21389101,
      "freeCashFlow": 61.53500000000001,
      "sdkDownloads": 9209563,
      "wikiViews": 20859756,
      "demandIndex": 187.97885703529488,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 9.724956429090593,
      "capexGrowthYoY": -8.030090061950146,
      "nvidiaRevenue": 7.192,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2023-Q3",
      "end": "2023-09-30",
      "capex": 38.261,
      "revenue": 322.892,
      "operatingCashFlow": 109.832,
      "depreciation": 14.99,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.295,
      "facilityPowerGW": 0.369,
      "h100EquivalentM": 0.1203132895401718,
      "dataCenterCapitalCostB": 11.175189999999999,
      "powerCoverageSites": 4,
      "frontierEci": 125.93,
      "frontierTrainingComputeLog10": 25.32221929473392,
      "chipUnitsAdded": 660416,
      "h100eAddedM": 0.393769,
      "h100eCumulativeM": 1.037793,
      "chipPowerAddedGW": 0.31477631,
      "freeCashFlow": 71.571,
      "sdkDownloads": 16437581,
      "wikiViews": 6953169,
      "demandIndex": 144.99239599195198,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 13.107323258860703,
      "capexGrowthYoY": -6.750993151519569,
      "nvidiaRevenue": 13.507,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2023-Q4",
      "end": "2023-12-31",
      "capex": 44.013999999999996,
      "revenue": 371.343,
      "operatingCashFlow": 99.78,
      "depreciation": 16.992,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.295,
      "facilityPowerGW": 0.369,
      "h100EquivalentM": 0.1203132895401718,
      "dataCenterCapitalCostB": 11.175189999999999,
      "powerCoverageSites": 4,
      "frontierEci": 125.93,
      "frontierTrainingComputeLog10": 25.698970004344705,
      "chipUnitsAdded": 869486,
      "h100eAddedM": 0.533666,
      "h100eCumulativeM": 1.571459,
      "chipPowerAddedGW": 0.414442035,
      "freeCashFlow": 55.766000000000005,
      "sdkDownloads": 18656568,
      "wikiViews": 6432805,
      "demandIndex": 148.57678345661975,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 15.166899785695897,
      "capexGrowthYoY": 5.564349786540013,
      "nvidiaRevenue": 18.12,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2024-Q1",
      "end": "2024-03-31",
      "capex": 45.962999999999994,
      "revenue": 335.44499999999994,
      "operatingCashFlow": 104.475,
      "depreciation": 15.058,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.428,
      "facilityPowerGW": 0.542,
      "h100EquivalentM": 0.19631126831733198,
      "dataCenterCapitalCostB": 16.213496000000003,
      "powerCoverageSites": 7,
      "frontierEci": 126.91,
      "frontierTrainingComputeLog10": 25.698970004344705,
      "chipUnitsAdded": 1496522,
      "h100eAddedM": 0.82586275,
      "h100eCumulativeM": 2.39732175,
      "chipPowerAddedGW": 0.712686755,
      "freeCashFlow": 58.512,
      "sdkDownloads": 24635434,
      "wikiViews": 7011084,
      "demandIndex": 178.24098563089797,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 15.255372880482376,
      "capexGrowthYoY": 25.74000109427146,
      "nvidiaRevenue": 22.103,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2024-Q2",
      "end": "2024-06-30",
      "capex": 55.650000000000006,
      "revenue": 350.80400000000003,
      "operatingCashFlow": 114.56700000000001,
      "depreciation": 15.675,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 0.743,
      "facilityPowerGW": 0.941,
      "h100EquivalentM": 0.3438100050530571,
      "dataCenterCapitalCostB": 28.146326000000006,
      "powerCoverageSites": 11,
      "frontierEci": 130,
      "frontierTrainingComputeLog10": 25.698970004344705,
      "chipUnitsAdded": 1742769,
      "h100eAddedM": 1.03026975,
      "h100eCumulativeM": 3.4275915,
      "chipPowerAddedGW": 0.874707385,
      "freeCashFlow": 58.917,
      "sdkDownloads": 32098794,
      "wikiViews": 4844434,
      "demandIndex": 169.12225496035285,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 12.794724302355842,
      "capexGrowthYoY": 57.501485863074194,
      "nvidiaRevenue": 26.044,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2024-Q3",
      "end": "2024-09-30",
      "capex": 61.16499999999999,
      "revenue": 366.62600000000003,
      "operatingCashFlow": 123,
      "depreciation": 17.469,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 1.191,
      "facilityPowerGW": 1.496,
      "h100EquivalentM": 0.5635169277412835,
      "dataCenterCapitalCostB": 45.117462,
      "powerCoverageSites": 14,
      "frontierEci": 136.56,
      "frontierTrainingComputeLog10": 25.698970004344705,
      "chipUnitsAdded": 2071186,
      "h100eAddedM": 1.30525875,
      "h100eCumulativeM": 4.73285025,
      "chipPowerAddedGW": 1.07437833,
      "freeCashFlow": 61.83500000000001,
      "sdkDownloads": 37193785,
      "wikiViews": 2722524,
      "demandIndex": 136.47588763415533,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 13.544466880566898,
      "capexGrowthYoY": 59.86252319594363,
      "nvidiaRevenue": 30.04,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2024-Q4",
      "end": "2024-12-31",
      "capex": 76.309,
      "revenue": 416.33700000000005,
      "operatingCashFlow": 136.332,
      "depreciation": 20.091,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 1.484,
      "facilityPowerGW": 1.873,
      "h100EquivalentM": 0.734411318847903,
      "dataCenterCapitalCostB": 56.216888,
      "powerCoverageSites": 17,
      "frontierEci": 142.7,
      "frontierTrainingComputeLog10": 25.698970004344705,
      "chipUnitsAdded": 2421249,
      "h100eAddedM": 1.92510275,
      "h100eCumulativeM": 6.657953,
      "chipPowerAddedGW": 1.36370092,
      "freeCashFlow": 60.022999999999996,
      "sdkDownloads": 40781823,
      "wikiViews": 5317914,
      "demandIndex": 199.72795420987438,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 12.11656069994589,
      "capexGrowthYoY": 73.3743808788113,
      "nvidiaRevenue": 35.082,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2025-Q1",
      "end": "2025-03-31",
      "capex": 77.764,
      "revenue": 372.411,
      "operatingCashFlow": 120.16799999999998,
      "depreciation": 18.162,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 2.021,
      "facilityPowerGW": 2.558,
      "h100EquivalentM": 0.9747347145022739,
      "dataCenterCapitalCostB": 76.559522,
      "powerCoverageSites": 19,
      "frontierEci": 144.84,
      "frontierTrainingComputeLog10": 26.57978359661681,
      "chipUnitsAdded": 2362086,
      "h100eAddedM": 2.57514775,
      "h100eCumulativeM": 9.23310075,
      "chipPowerAddedGW": 1.562272875,
      "freeCashFlow": 42.40399999999998,
      "sdkDownloads": 56955545,
      "wikiViews": 8293695,
      "demandIndex": 294.7656803313043,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 11.019988373652922,
      "capexGrowthYoY": 69.18826012227228,
      "nvidiaRevenue": 39.331,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2025-Q2",
      "end": "2025-06-30",
      "capex": 97.326,
      "revenue": 403.99000000000007,
      "operatingCashFlow": 134.627,
      "depreciation": 19.569,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 3.0776,
      "facilityPowerGW": 3.85,
      "h100EquivalentM": 1.7876174714889113,
      "dataCenterCapitalCostB": 116.5856432,
      "powerCoverageSites": 24,
      "frontierEci": 147.92,
      "frontierTrainingComputeLog10": 26.57978359661681,
      "chipUnitsAdded": 2285217,
      "h100eAddedM": 2.93689275,
      "h100eCumulativeM": 12.1699935,
      "chipPowerAddedGW": 1.63649192,
      "freeCashFlow": 37.301000000000016,
      "sdkDownloads": 86177671,
      "wikiViews": 12412955,
      "demandIndex": 443.57784628119816,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 15.161172620608676,
      "capexGrowthYoY": 74.8894878706199,
      "nvidiaRevenue": 44.062,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2025-Q3",
      "end": "2025-09-30",
      "capex": 105.77299999999998,
      "revenue": 426.356,
      "operatingCashFlow": 167.135,
      "depreciation": 21.759,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 3.7193,
      "facilityPowerGW": 4.684799999999999,
      "h100EquivalentM": 2.570719308110516,
      "dataCenterCapitalCostB": 140.8945226,
      "powerCoverageSites": 30,
      "frontierEci": 150,
      "frontierTrainingComputeLog10": 26.698970004336026,
      "chipUnitsAdded": 2451946,
      "h100eAddedM": 3.70746375,
      "h100eCumulativeM": 15.87745725,
      "chipPowerAddedGW": 1.98177389,
      "freeCashFlow": 61.36200000000001,
      "sdkDownloads": 135675996,
      "wikiViews": 12280114,
      "demandIndex": 553.5891753197683,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 16.291806909493587,
      "capexGrowthYoY": 72.93059756396632,
      "nvidiaRevenue": 46.743,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2025-Q4",
      "end": "2025-12-31",
      "capex": 130.665,
      "revenue": 484.43899999999996,
      "operatingCashFlow": 180.899,
      "depreciation": 24.881999999999998,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 5.6553,
      "facilityPowerGW": 7.180400000000001,
      "h100EquivalentM": 4.526251702341433,
      "dataCenterCapitalCostB": 214.23407459999996,
      "powerCoverageSites": 36,
      "frontierEci": 154.64,
      "frontierTrainingComputeLog10": 26.698970004336026,
      "chipUnitsAdded": 2475416,
      "h100eAddedM": 4.37662975,
      "h100eCumulativeM": 20.254087,
      "chipPowerAddedGW": 2.33121614,
      "freeCashFlow": 50.23400000000001,
      "sdkDownloads": 178939455,
      "wikiViews": 11295935,
      "demandIndex": 609.7460961968203,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 16.357421992280273,
      "capexGrowthYoY": 71.23144059023181,
      "nvidiaRevenue": 57.006,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    },
    {
      "period": "2026-Q1",
      "end": "2026-03-31",
      "capex": 148.385,
      "revenue": 447.80199999999996,
      "operatingCashFlow": 157.878,
      "depreciation": 24.944,
      "companyCoverage": 5,
      "companyMetricCoverage": {
        "capex": 5,
        "revenue": 5,
        "operatingCashFlow": 5,
        "depreciation": 2,
        "core": 5
      },
      "itPowerGW": 6.965199999999999,
      "facilityPowerGW": 8.852399999999998,
      "h100EquivalentM": 5.9263022329124295,
      "dataCenterCapitalCostB": 263.8557064,
      "powerCoverageSites": 41,
      "frontierEci": 157.83,
      "frontierTrainingComputeLog10": 26.698970004336026,
      "chipUnitsAdded": 1789750,
      "h100eAddedM": 4.232681,
      "h100eCumulativeM": 24.486768,
      "chipPowerAddedGW": 2.1551256,
      "freeCashFlow": 9.492999999999995,
      "sdkDownloads": 353265277,
      "wikiViews": 8702102,
      "demandIndex": 751.9646794111594,
      "demandProxy": "npm SDK downloads × Wikipedia product interest",
      "revenueGrowthYoY": 20.244031459865575,
      "capexGrowthYoY": 90.81451571421223,
      "nvidiaRevenue": 68.127,
      "coverage": {
        "hyperscalers": 5,
        "hyperscalersByMetric": {
          "capex": 5,
          "revenue": 5,
          "operatingCashFlow": 5,
          "depreciation": 2,
          "core": 5
        },
        "demandProxy": true,
        "tokenActual": false,
        "consensus": false
      }
    }
  ],
  "monthly": [
    {
      "month": "2022-11",
      "sdkDownloads": 129811,
      "wikiViews": null,
      "demandIndex": null
    },
    {
      "month": "2022-12",
      "sdkDownloads": 255299,
      "wikiViews": 1882964,
      "demandIndex": 39.62380282277142
    },
    {
      "month": "2023-01",
      "sdkDownloads": 572369,
      "wikiViews": 5349371,
      "demandIndex": 100
    },
    {
      "month": "2023-02",
      "sdkDownloads": 812909,
      "wikiViews": 5947457,
      "demandIndex": 125.66004468746127
    },
    {
      "month": "2023-03",
      "sdkDownloads": 1599635,
      "wikiViews": 6916888,
      "demandIndex": 190.09750167475775
    },
    {
      "month": "2023-04",
      "sdkDownloads": 2319338,
      "wikiViews": 8009498,
      "demandIndex": 246.3174948308251
    },
    {
      "month": "2023-05",
      "sdkDownloads": 3075023,
      "wikiViews": 7126714,
      "demandIndex": 267.5342803997246
    },
    {
      "month": "2023-06",
      "sdkDownloads": 3815202,
      "wikiViews": 5723544,
      "demandIndex": 267.0557111084154
    },
    {
      "month": "2023-07",
      "sdkDownloads": 5024375,
      "wikiViews": 2926034,
      "demandIndex": 219.12468039308496
    },
    {
      "month": "2023-08",
      "sdkDownloads": 5896611,
      "wikiViews": 1906589,
      "demandIndex": 191.61979410936104
    },
    {
      "month": "2023-09",
      "sdkDownloads": 5516595,
      "wikiViews": 2120546,
      "demandIndex": 195.4654430287464
    },
    {
      "month": "2023-10",
      "sdkDownloads": 6270965,
      "wikiViews": 2136737,
      "demandIndex": 209.19596914475568
    },
    {
      "month": "2023-11",
      "sdkDownloads": 6333766,
      "wikiViews": 2247191,
      "demandIndex": 215.60637069382213
    },
    {
      "month": "2023-12",
      "sdkDownloads": 6051837,
      "wikiViews": 2048877,
      "demandIndex": 201.23899662146107
    },
    {
      "month": "2024-01",
      "sdkDownloads": 7629758,
      "wikiViews": 2450449,
      "demandIndex": 247.10913715358228
    },
    {
      "month": "2024-02",
      "sdkDownloads": 7940683,
      "wikiViews": 2509270,
      "demandIndex": 255.10161917277597
    },
    {
      "month": "2024-03",
      "sdkDownloads": 9064993,
      "wikiViews": 2051365,
      "demandIndex": 246.44260780629762
    },
    {
      "month": "2024-04",
      "sdkDownloads": 10083713,
      "wikiViews": 1590709,
      "demandIndex": 228.88440118418467
    },
    {
      "month": "2024-05",
      "sdkDownloads": 11074395,
      "wikiViews": 1497623,
      "demandIndex": 232.74043625298017
    },
    {
      "month": "2024-06",
      "sdkDownloads": 10940686,
      "wikiViews": 1756102,
      "demandIndex": 250.50000231753415
    },
    {
      "month": "2024-07",
      "sdkDownloads": 11712176,
      "wikiViews": 870169,
      "demandIndex": 182.44467291275336
    },
    {
      "month": "2024-08",
      "sdkDownloads": 12683584,
      "wikiViews": 720853,
      "demandIndex": 172.8044564800999
    },
    {
      "month": "2024-09",
      "sdkDownloads": 12798025,
      "wikiViews": 1131502,
      "demandIndex": 217.47519483431188
    },
    {
      "month": "2024-10",
      "sdkDownloads": 13940324,
      "wikiViews": 1616960,
      "demandIndex": 271.3292789319343
    },
    {
      "month": "2024-11",
      "sdkDownloads": 13460909,
      "wikiViews": 1901699,
      "demandIndex": 289.1469873708774
    },
    {
      "month": "2024-12",
      "sdkDownloads": 13380590,
      "wikiViews": 1799255,
      "demandIndex": 280.41069861112385
    },
    {
      "month": "2025-01",
      "sdkDownloads": 16179141,
      "wikiViews": 2709059,
      "demandIndex": 378.3533209054245
    },
    {
      "month": "2025-02",
      "sdkDownloads": 18665187,
      "wikiViews": 2717623,
      "demandIndex": 407.0252633010771
    },
    {
      "month": "2025-03",
      "sdkDownloads": 22111217,
      "wikiViews": 2867013,
      "demandIndex": 455.0213168941252
    },
    {
      "month": "2025-04",
      "sdkDownloads": 24706416,
      "wikiViews": 4531696,
      "demandIndex": 604.7081857476448
    },
    {
      "month": "2025-05",
      "sdkDownloads": 27835497,
      "wikiViews": 2532203,
      "demandIndex": 479.7989994977497
    },
    {
      "month": "2025-06",
      "sdkDownloads": 33635758,
      "wikiViews": 5349056,
      "demandIndex": 766.5663841357501
    },
    {
      "month": "2025-07",
      "sdkDownloads": 39866334,
      "wikiViews": 3361403,
      "demandIndex": 661.567299914806
    },
    {
      "month": "2025-08",
      "sdkDownloads": 45294462,
      "wikiViews": 4284599,
      "demandIndex": 796.1377779706835
    },
    {
      "month": "2025-09",
      "sdkDownloads": 50515200,
      "wikiViews": 4634112,
      "demandIndex": 874.3894115353321
    },
    {
      "month": "2025-10",
      "sdkDownloads": 57173611,
      "wikiViews": 4321881,
      "demandIndex": 898.3484072043149
    },
    {
      "month": "2025-11",
      "sdkDownloads": 57415211,
      "wikiViews": 3732272,
      "demandIndex": 836.58623489613
    },
    {
      "month": "2025-12",
      "sdkDownloads": 64350633,
      "wikiViews": 3241782,
      "demandIndex": 825.4274423516481
    },
    {
      "month": "2026-01",
      "sdkDownloads": 82977228,
      "wikiViews": 3290017,
      "demandIndex": 944.2546250566332
    },
    {
      "month": "2026-02",
      "sdkDownloads": 106539099,
      "wikiViews": 2758046,
      "demandIndex": 979.6385142874158
    },
    {
      "month": "2026-03",
      "sdkDownloads": 163748950,
      "wikiViews": 2654039,
      "demandIndex": 1191.3887659050142
    },
    {
      "month": "2026-04",
      "sdkDownloads": 197878767,
      "wikiViews": 2539410,
      "demandIndex": 1281.0810263587848
    },
    {
      "month": "2026-05",
      "sdkDownloads": 242649062,
      "wikiViews": 2518942,
      "demandIndex": 1412.8920478800808
    },
    {
      "month": "2026-06",
      "sdkDownloads": 284333273,
      "wikiViews": 2903523,
      "demandIndex": 1642.0526044889255
    }
  ],
  "chipSales": [
    {
      "key": "Nvidia|A100|2022-01-01|2022-03-31",
      "name": "Q1 2022 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2022-01-01",
      "endDate": "2022-03-31",
      "quarter": "2022-Q1",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 113423,
        "p50": 147645,
        "p95": 191482
      },
      "sourceCompute": {
        "p05": 35763,
        "p50": 46554,
        "p95": 60376
      },
      "totalTdpW": {
        "p05": 45369200,
        "p50": 59058000,
        "p95": 76592800
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 1361076000,
        "p50": 1771740000,
        "p95": 2297784000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimate is incomplete because it is based on Nvidia fiscal quarters beginning 1/31/2022. Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A100|2022-04-01|2022-06-30",
      "name": "Q2 2022 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2022-04-01",
      "endDate": "2022-06-30",
      "quarter": "2022-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 173378,
        "p50": 226324,
        "p95": 293623
      },
      "sourceCompute": {
        "p05": 54668,
        "p50": 71362,
        "p95": 92582
      },
      "totalTdpW": {
        "p05": 69351200,
        "p50": 90529600,
        "p95": 117449200
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 2080536000,
        "p50": 2715888000,
        "p95": 3523476000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A100|2022-07-01|2022-09-30",
      "name": "Q3 2022 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2022-07-01",
      "endDate": "2022-09-30",
      "quarter": "2022-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 165507,
        "p50": 215200,
        "p95": 279450
      },
      "sourceCompute": {
        "p05": 52186,
        "p50": 67855,
        "p95": 88113
      },
      "totalTdpW": {
        "p05": 66202800,
        "p50": 86080000,
        "p95": 111780000
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 1986084000,
        "p50": 2582400000,
        "p95": 3353400000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H100|2022-07-01|2022-09-30",
      "name": "Q3 2022 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2022-07-01",
      "endDate": "2022-09-30",
      "quarter": "2022-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 5148,
        "p50": 6106,
        "p95": 7204
      },
      "sourceCompute": {
        "p05": 5148,
        "p50": 6106,
        "p95": 7204
      },
      "totalTdpW": {
        "p05": 3603600,
        "p50": 4274200,
        "p95": 5042800
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 128700000,
        "p50": 152650000,
        "p95": 180100000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Google|TPU v4i|2022-10-01|2022-12-31",
      "name": "Q4 2022 - TPU v4i",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v4i",
      "startDate": "2022-10-01",
      "endDate": "2022-12-31",
      "quarter": "2022-Q4",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 12640,
        "p50": 20603,
        "p95": 31385
      },
      "sourceCompute": {
        "p05": 881,
        "p50": 1436,
        "p95": 2188
      },
      "totalTdpW": {
        "p05": 2212000,
        "p50": 3605525,
        "p95": 5492375
      },
      "unitPriceUsd": 2322,
      "chipSpendUsd": {
        "p05": 29350080,
        "p50": 47840166,
        "p95": 72875970
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Broadcom fiscal quarters beginning 10/31/2022. Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v4|2022-10-01|2022-12-31",
      "name": "Q4 2022 - TPU v4",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v4",
      "startDate": "2022-10-01",
      "endDate": "2022-12-31",
      "quarter": "2022-Q4",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 48807,
        "p50": 66381,
        "p95": 87279
      },
      "sourceCompute": {
        "p05": 6782,
        "p50": 9224,
        "p95": 12128
      },
      "totalTdpW": {
        "p05": 16594380,
        "p50": 22569540,
        "p95": 29674860
      },
      "unitPriceUsd": 3389,
      "chipSpendUsd": {
        "p05": 165406923,
        "p50": 224965209,
        "p95": 295788531
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Broadcom fiscal quarters beginning 10/31/2022. Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5e|2022-10-01|2022-12-31",
      "name": "Q4 2022 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2022-10-01",
      "endDate": "2022-12-31",
      "quarter": "2022-Q4",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 9820,
        "p50": 15662,
        "p95": 23487
      },
      "sourceCompute": {
        "p05": 1950,
        "p50": 3110,
        "p95": 4664
      },
      "totalTdpW": {
        "p05": 2209500,
        "p50": 3523950,
        "p95": 5284575
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 26553280,
        "p50": 42350048,
        "p95": 63508848
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Broadcom fiscal quarters beginning 10/31/2022. Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|A100|2022-10-01|2022-12-31",
      "name": "Q4 2022 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2022-10-01",
      "endDate": "2022-12-31",
      "quarter": "2022-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 87190,
        "p50": 113277,
        "p95": 147290
      },
      "sourceCompute": {
        "p05": 27491,
        "p50": 35717,
        "p95": 46442
      },
      "totalTdpW": {
        "p05": 34876000,
        "p50": 45310800,
        "p95": 58916000
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 1046280000,
        "p50": 1359324000,
        "p95": 1767480000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H100|2022-10-01|2022-12-31",
      "name": "Q4 2022 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2022-10-01",
      "endDate": "2022-12-31",
      "quarter": "2022-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 27372,
        "p50": 32492,
        "p95": 38332
      },
      "sourceCompute": {
        "p05": 27372,
        "p50": 32492,
        "p95": 38332
      },
      "totalTdpW": {
        "p05": 19160400,
        "p50": 22744400,
        "p95": 26832400
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 684300000,
        "p50": 812300000,
        "p95": 958300000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A800|2022-10-01|2022-12-31",
      "name": "Q4 2022 - A800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A800",
      "startDate": "2022-10-01",
      "endDate": "2022-12-31",
      "quarter": "2022-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 21489,
        "p50": 28117,
        "p95": 36535
      },
      "sourceCompute": {
        "p05": 6775,
        "p50": 8865,
        "p95": 11520
      },
      "totalTdpW": {
        "p05": 8595600,
        "p50": 11246800,
        "p95": 14614000
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 257868000,
        "p50": 337404000,
        "p95": 438420000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Google|TPU v4i|2023-01-01|2023-03-31",
      "name": "Q1 2023 - TPU v4i",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v4i",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 5912,
        "p50": 9637,
        "p95": 14680
      },
      "sourceCompute": {
        "p05": 412,
        "p50": 672,
        "p95": 1023
      },
      "totalTdpW": {
        "p05": 1034600,
        "p50": 1686475,
        "p95": 2569000
      },
      "unitPriceUsd": 2322,
      "chipSpendUsd": {
        "p05": 13727664,
        "p50": 22377114,
        "p95": 34086960
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v4|2023-01-01|2023-03-31",
      "name": "Q1 2023 - TPU v4",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v4",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 85519,
        "p50": 119198,
        "p95": 161039
      },
      "sourceCompute": {
        "p05": 11883,
        "p50": 16563,
        "p95": 22377
      },
      "totalTdpW": {
        "p05": 29076460,
        "p50": 40527320,
        "p95": 54753260
      },
      "unitPriceUsd": 3389,
      "chipSpendUsd": {
        "p05": 289823891,
        "p50": 403962022,
        "p95": 545761171
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5e|2023-01-01|2023-03-31",
      "name": "Q1 2023 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 18516,
        "p50": 38963,
        "p95": 63052
      },
      "sourceCompute": {
        "p05": 3677,
        "p50": 7737,
        "p95": 12521
      },
      "totalTdpW": {
        "p05": 4166100,
        "p50": 8766675,
        "p95": 14186700
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 50067264,
        "p50": 105355952,
        "p95": 170492608
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|A100|2023-01-01|2023-03-31",
      "name": "Q1 2023 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 45347,
        "p50": 58773,
        "p95": 76478
      },
      "sourceCompute": {
        "p05": 14298,
        "p50": 18531,
        "p95": 24114
      },
      "totalTdpW": {
        "p05": 18138800,
        "p50": 23509200,
        "p95": 30591200
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 544164000,
        "p50": 705276000,
        "p95": 917736000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H100|2023-01-01|2023-03-31",
      "name": "Q1 2023 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 47792,
        "p50": 56536,
        "p95": 66904
      },
      "sourceCompute": {
        "p05": 47792,
        "p50": 56536,
        "p95": 66904
      },
      "totalTdpW": {
        "p05": 33454400,
        "p50": 39575200,
        "p95": 46832800
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 1194800000,
        "p50": 1413400000,
        "p95": 1672600000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A800|2023-01-01|2023-03-31",
      "name": "Q1 2023 - A800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A800",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 22439,
        "p50": 29250,
        "p95": 38054
      },
      "sourceCompute": {
        "p05": 7075,
        "p50": 9222,
        "p95": 11999
      },
      "totalTdpW": {
        "p05": 8975600,
        "p50": 11700000,
        "p95": 15221600
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 269268000,
        "p50": 351000000,
        "p95": 456648000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H800|2023-01-01|2023-03-31",
      "name": "Q1 2023 - H800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H800",
      "startDate": "2023-01-01",
      "endDate": "2023-03-31",
      "quarter": "2023-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 5980,
        "p50": 7397,
        "p95": 9252
      },
      "sourceCompute": {
        "p05": 5980,
        "p50": 7397,
        "p95": 9252
      },
      "totalTdpW": {
        "p05": 4186000,
        "p50": 5177900,
        "p95": 6476400
      },
      "unitPriceUsd": 30000,
      "chipSpendUsd": {
        "p05": 179400000,
        "p50": 221910000,
        "p95": 277560000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Google|TPU v4|2023-04-01|2023-06-30",
      "name": "Q2 2023 - TPU v4",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v4",
      "startDate": "2023-04-01",
      "endDate": "2023-06-30",
      "quarter": "2023-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 36987,
        "p50": 66489,
        "p95": 99179
      },
      "sourceCompute": {
        "p05": 5139,
        "p50": 9239,
        "p95": 13781
      },
      "totalTdpW": {
        "p05": 12575580,
        "p50": 22606260,
        "p95": 33720860
      },
      "unitPriceUsd": 3389,
      "chipSpendUsd": {
        "p05": 125348943,
        "p50": 225331221,
        "p95": 336117631
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5e|2023-04-01|2023-06-30",
      "name": "Q2 2023 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2023-04-01",
      "endDate": "2023-06-30",
      "quarter": "2023-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 80006,
        "p50": 119450,
        "p95": 170726
      },
      "sourceCompute": {
        "p05": 15888,
        "p50": 23721,
        "p95": 33903
      },
      "totalTdpW": {
        "p05": 18001350,
        "p50": 26876250,
        "p95": 38413350
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 216336224,
        "p50": 322992800,
        "p95": 461643104
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|A100|2023-04-01|2023-06-30",
      "name": "Q2 2023 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2023-04-01",
      "endDate": "2023-06-30",
      "quarter": "2023-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 49564,
        "p50": 64286,
        "p95": 83810
      },
      "sourceCompute": {
        "p05": 15628,
        "p50": 20270,
        "p95": 26426
      },
      "totalTdpW": {
        "p05": 19825600,
        "p50": 25714400,
        "p95": 33524000
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 594768000,
        "p50": 771432000,
        "p95": 1005720000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H100|2023-04-01|2023-06-30",
      "name": "Q2 2023 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2023-04-01",
      "endDate": "2023-06-30",
      "quarter": "2023-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 127870,
        "p50": 150868,
        "p95": 179142
      },
      "sourceCompute": {
        "p05": 127870,
        "p50": 150868,
        "p95": 179142
      },
      "totalTdpW": {
        "p05": 89509000,
        "p50": 105607600,
        "p95": 125399400
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 3196750000,
        "p50": 3771700000,
        "p95": 4478550000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A800|2023-04-01|2023-06-30",
      "name": "Q2 2023 - A800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A800",
      "startDate": "2023-04-01",
      "endDate": "2023-06-30",
      "quarter": "2023-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 20136,
        "p50": 26235,
        "p95": 34327
      },
      "sourceCompute": {
        "p05": 6349,
        "p50": 8272,
        "p95": 10823
      },
      "totalTdpW": {
        "p05": 8054400,
        "p50": 10494000,
        "p95": 13730800
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 241632000,
        "p50": 314820000,
        "p95": 411924000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H800|2023-04-01|2023-06-30",
      "name": "Q2 2023 - H800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H800",
      "startDate": "2023-04-01",
      "endDate": "2023-06-30",
      "quarter": "2023-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 26007,
        "p50": 32275,
        "p95": 39805
      },
      "sourceCompute": {
        "p05": 26007,
        "p50": 32275,
        "p95": 39805
      },
      "totalTdpW": {
        "p05": 18204900,
        "p50": 22592500,
        "p95": 27863500
      },
      "unitPriceUsd": 30000,
      "chipSpendUsd": {
        "p05": 780210000,
        "p50": 968250000,
        "p95": 1194150000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Google|TPU v4|2023-07-01|2023-09-30",
      "name": "Q3 2023 - TPU v4",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v4",
      "startDate": "2023-07-01",
      "endDate": "2023-09-30",
      "quarter": "2023-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 3027,
        "p50": 11379,
        "p95": 19700
      },
      "sourceCompute": {
        "p05": 420,
        "p50": 1581,
        "p95": 2737
      },
      "totalTdpW": {
        "p05": 1029180,
        "p50": 3868860,
        "p95": 6698000
      },
      "unitPriceUsd": 3389,
      "chipSpendUsd": {
        "p05": 10258503,
        "p50": 38563431,
        "p95": 66763300
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5e|2023-07-01|2023-09-30",
      "name": "Q3 2023 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2023-07-01",
      "endDate": "2023-09-30",
      "quarter": "2023-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 178999,
        "p50": 249318,
        "p95": 334109
      },
      "sourceCompute": {
        "p05": 35546,
        "p50": 49510,
        "p95": 66349
      },
      "totalTdpW": {
        "p05": 40274775,
        "p50": 56096550,
        "p95": 75174525
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 484013296,
        "p50": 674155872,
        "p95": 903430736
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|A100|2023-07-01|2023-09-30",
      "name": "Q3 2023 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2023-07-01",
      "endDate": "2023-09-30",
      "quarter": "2023-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 42108,
        "p50": 54904,
        "p95": 71649
      },
      "sourceCompute": {
        "p05": 13277,
        "p50": 17311,
        "p95": 22592
      },
      "totalTdpW": {
        "p05": 16843200,
        "p50": 21961600,
        "p95": 28659600
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 505296000,
        "p50": 658848000,
        "p95": 859788000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H100|2023-07-01|2023-09-30",
      "name": "Q3 2023 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2023-07-01",
      "endDate": "2023-09-30",
      "quarter": "2023-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 219080,
        "p50": 259631,
        "p95": 307406
      },
      "sourceCompute": {
        "p05": 219080,
        "p50": 259631,
        "p95": 307406
      },
      "totalTdpW": {
        "p05": 153356000,
        "p50": 181741700,
        "p95": 215184200
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 5477000000,
        "p50": 6490775000,
        "p95": 7685150000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A800|2023-07-01|2023-09-30",
      "name": "Q3 2023 - A800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A800",
      "startDate": "2023-07-01",
      "endDate": "2023-09-30",
      "quarter": "2023-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 21885,
        "p50": 28404,
        "p95": 37072
      },
      "sourceCompute": {
        "p05": 6900,
        "p50": 8956,
        "p95": 11689
      },
      "totalTdpW": {
        "p05": 8754000,
        "p50": 11361600,
        "p95": 14828800
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 262620000,
        "p50": 340848000,
        "p95": 444864000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H800|2023-07-01|2023-09-30",
      "name": "Q3 2023 - H800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H800",
      "startDate": "2023-07-01",
      "endDate": "2023-09-30",
      "quarter": "2023-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 45740,
        "p50": 56780,
        "p95": 70293
      },
      "sourceCompute": {
        "p05": 45740,
        "p50": 56780,
        "p95": 70293
      },
      "totalTdpW": {
        "p05": 32018000,
        "p50": 39746000,
        "p95": 49205100
      },
      "unitPriceUsd": 30000,
      "chipSpendUsd": {
        "p05": 1372200000,
        "p50": 1703400000,
        "p95": 2108790000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Google|TPU v5e|2023-10-01|2023-12-31",
      "name": "Q4 2023 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2023-10-01",
      "endDate": "2023-12-31",
      "quarter": "2023-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 283159,
        "p50": 388683,
        "p95": 509603
      },
      "sourceCompute": {
        "p05": 56231,
        "p50": 77186,
        "p95": 101199
      },
      "totalTdpW": {
        "p05": 63710775,
        "p50": 87453675,
        "p95": 114660675
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 765661936,
        "p50": 1050998832,
        "p95": 1377966512
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5p|2023-10-01|2023-12-31",
      "name": "Q4 2023 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2023-10-01",
      "endDate": "2023-12-31",
      "quarter": "2023-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 7237,
        "p50": 14459,
        "p95": 22369
      },
      "sourceCompute": {
        "p05": 3357,
        "p50": 6707,
        "p95": 10376
      },
      "totalTdpW": {
        "p05": 3907980,
        "p50": 7807860,
        "p95": 12079260
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 43581214,
        "p50": 87072098,
        "p95": 134706118
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|A100|2023-10-01|2023-12-31",
      "name": "Q4 2023 - A100",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A100",
      "startDate": "2023-10-01",
      "endDate": "2023-12-31",
      "quarter": "2023-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 11574,
        "p50": 15130,
        "p95": 19746
      },
      "sourceCompute": {
        "p05": 3649,
        "p50": 4770,
        "p95": 6226
      },
      "totalTdpW": {
        "p05": 4629600,
        "p50": 6052000,
        "p95": 7898400
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 138888000,
        "p50": 181560000,
        "p95": 236952000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H100|2023-10-01|2023-12-31",
      "name": "Q4 2023 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2023-10-01",
      "endDate": "2023-12-31",
      "quarter": "2023-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 355867,
        "p50": 422172,
        "p95": 500558
      },
      "sourceCompute": {
        "p05": 355867,
        "p50": 422172,
        "p95": 500558
      },
      "totalTdpW": {
        "p05": 249106900,
        "p50": 295520400,
        "p95": 350390600
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 8896675000,
        "p50": 10554300000,
        "p95": 12513950000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|A800|2023-10-01|2023-12-31",
      "name": "Q4 2023 - A800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "A800",
      "startDate": "2023-10-01",
      "endDate": "2023-12-31",
      "quarter": "2023-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 7005,
        "p50": 9071,
        "p95": 11815
      },
      "sourceCompute": {
        "p05": 2209,
        "p50": 2860,
        "p95": 3725
      },
      "totalTdpW": {
        "p05": 2802000,
        "p50": 3628400,
        "p95": 4726000
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 84060000,
        "p50": 108852000,
        "p95": 141780000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Nvidia|H800|2023-10-01|2023-12-31",
      "name": "Q4 2023 - H800",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H800",
      "startDate": "2023-10-01",
      "endDate": "2023-12-31",
      "quarter": "2023-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 16088,
        "p50": 19971,
        "p95": 24769
      },
      "sourceCompute": {
        "p05": 16088,
        "p50": 19971,
        "p95": 24769
      },
      "totalTdpW": {
        "p05": 11261600,
        "p50": 13979700,
        "p95": 17338300
      },
      "unitPriceUsd": 30000,
      "chipSpendUsd": {
        "p05": 482640000,
        "p50": 599130000,
        "p95": 743070000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:11+00:00"
    },
    {
      "key": "Google|TPU v5e|2024-01-01|2024-03-31",
      "name": "Q1 2024 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 301940,
        "p50": 417937,
        "p95": 554816
      },
      "sourceCompute": {
        "p05": 59960,
        "p50": 82996,
        "p95": 110178
      },
      "totalTdpW": {
        "p05": 67936500,
        "p50": 94035825,
        "p95": 124833600
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 816445760,
        "p50": 1130101648,
        "p95": 1500222464
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5p|2024-01-01|2024-03-31",
      "name": "Q1 2024 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 57901,
        "p50": 82569,
        "p95": 111241
      },
      "sourceCompute": {
        "p05": 26858,
        "p50": 38301,
        "p95": 51601
      },
      "totalTdpW": {
        "p05": 31266540,
        "p50": 44587260,
        "p95": 60070140
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 348679822,
        "p50": 497230518,
        "p95": 669893302
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2024-01-01|2024-03-31",
      "name": "Q1 2024 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 466753,
        "p50": 550503,
        "p95": 647115
      },
      "sourceCompute": {
        "p05": 466753,
        "p50": 550503,
        "p95": 647115
      },
      "totalTdpW": {
        "p05": 326727100,
        "p50": 385352100,
        "p95": 452980500
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 11668825000,
        "p50": 13762575000,
        "p95": 16177875000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2024-01-01|2024-03-31",
      "name": "Q1 2024 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 107118,
        "p50": 139117,
        "p95": 181766
      },
      "sourceCompute": {
        "p05": 16021,
        "p50": 20807,
        "p95": 27186
      },
      "totalTdpW": {
        "p05": 42847200,
        "p50": 55646800,
        "p95": 72706400
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 1285416000,
        "p50": 1669404000,
        "p95": 2181192000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI250X|2024-01-01|2024-03-31",
      "name": "FY24 Q1 - MI250X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI250X",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 20483,
        "p50": 30367,
        "p95": 42440
      },
      "sourceCompute": {
        "p05": 3964,
        "p50": 5877,
        "p95": 8213
      },
      "totalTdpW": {
        "p05": 10241500,
        "p50": 15183500,
        "p95": 21220000
      },
      "unitPriceUsd": 10000,
      "chipSpendUsd": {
        "p05": 204830000,
        "p50": 303670000,
        "p95": 424400000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2024-01-01|2024-03-31",
      "name": "FY24 Q1 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 24841,
        "p50": 34445,
        "p95": 47284
      },
      "sourceCompute": {
        "p05": 32825,
        "p50": 45514,
        "p95": 62480
      },
      "totalTdpW": {
        "p05": 18630750,
        "p50": 25833750,
        "p95": 35463000
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 310512500,
        "p50": 430562500,
        "p95": 591050000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300A|2024-01-01|2024-03-31",
      "name": "FY24 Q1 - MI300A",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300A",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 1098,
        "p50": 3537,
        "p95": 6369
      },
      "sourceCompute": {
        "p05": 1088,
        "p50": 3505,
        "p95": 6311
      },
      "totalTdpW": {
        "p05": 834480,
        "p50": 2688120,
        "p95": 4840440
      },
      "unitPriceUsd": 6700,
      "chipSpendUsd": {
        "p05": 7356600,
        "p50": 23697900,
        "p95": 42672300
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2024-01-01|2024-03-31",
      "name": "Q1 2024 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 87500,
        "p50": 100000,
        "p95": 125000
      },
      "sourceCompute": {
        "p05": 27362.75,
        "p50": 35378.75,
        "p95": 45990.5
      },
      "totalTdpW": {
        "p05": 35000000,
        "p50": 40000000,
        "p95": 50000000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 1312500000,
        "p50": 1500000000,
        "p95": 1875000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2024-01-01|2024-03-31",
      "name": "Q1 2024 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 6250,
        "p50": 12500,
        "p95": 25000
      },
      "sourceCompute": {
        "p05": 4876.75,
        "p50": 9649,
        "p95": 18995.25
      },
      "totalTdpW": {
        "p05": 4375000,
        "p50": 8750000,
        "p95": 17500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 125000000,
        "p50": 250000000,
        "p95": 500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium1|2024-01-01|2024-03-31",
      "name": "Q1 2024 Trainium1/Inferentia",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium1",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 50000,
        "p50": 110000,
        "p95": 250000
      },
      "sourceCompute": {
        "p05": 10611,
        "p50": 23345,
        "p95": 53057
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 33000000,
        "p95": 75000000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": true,
      "priceEstimated": false,
      "sourceUrl": "see AI Chip Sales methodology",
      "notes": "More speculative",
      "lastModified": "2026-03-09 21:03:30+00:00"
    },
    {
      "key": "Amazon|Trainium2|2024-01-01|2024-03-31",
      "name": "Q1 2024 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 5000,
        "p50": 15000,
        "p95": 25000
      },
      "sourceCompute": {
        "p05": 3281,
        "p50": 9845,
        "p95": 16409
      },
      "totalTdpW": {
        "p05": 2500000,
        "p50": 7500000,
        "p95": 12500000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 20000000,
        "p50": 60000000,
        "p95": 100000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2024-01-01|2024-03-31",
      "name": "2024 Q1 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2024-01-01",
      "endDate": "2024-03-31",
      "quarter": "2024-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 525,
        "p50": 547,
        "p95": 591
      },
      "sourceCompute": {
        "p05": 136,
        "p50": 142,
        "p95": 153
      },
      "totalTdpW": {
        "p05": 105000,
        "p50": 109400,
        "p95": 118200
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:23:47+00:00"
    },
    {
      "key": "Google|TPU v5e|2024-04-01|2024-06-30",
      "name": "Q2 2024 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 249109,
        "p50": 374515,
        "p95": 531956
      },
      "sourceCompute": {
        "p05": 49469,
        "p50": 74373,
        "p95": 105638
      },
      "totalTdpW": {
        "p05": 56049525,
        "p50": 84265875,
        "p95": 119690100
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 673590736,
        "p50": 1012688560,
        "p95": 1438409024
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5p|2024-04-01|2024-06-30",
      "name": "Q2 2024 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 96064,
        "p50": 144494,
        "p95": 199965
      },
      "sourceCompute": {
        "p05": 44561,
        "p50": 67026,
        "p95": 92758
      },
      "totalTdpW": {
        "p05": 51874560,
        "p50": 78026760,
        "p95": 107981100
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 578497408,
        "p50": 870142868,
        "p95": 1204189230
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2024-04-01|2024-06-30",
      "name": "Q2 2024 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 552079,
        "p50": 648803,
        "p95": 761640
      },
      "sourceCompute": {
        "p05": 552079,
        "p50": 648803,
        "p95": 761640
      },
      "totalTdpW": {
        "p05": 386455300,
        "p50": 454162100,
        "p95": 533148000
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 13801975000,
        "p50": 16220075000,
        "p95": 19041000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2024-04-01|2024-06-30",
      "name": "Q2 2024 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 172854,
        "p50": 223789,
        "p95": 290498
      },
      "sourceCompute": {
        "p05": 25853,
        "p50": 33472,
        "p95": 43450
      },
      "totalTdpW": {
        "p05": 69141600,
        "p50": 89515600,
        "p95": 116199200
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 2074248000,
        "p50": 2685468000,
        "p95": 3485976000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI250X|2024-04-01|2024-06-30",
      "name": "FY24 Q2 - MI250X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI250X",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 1363,
        "p50": 6645,
        "p95": 12299
      },
      "sourceCompute": {
        "p05": 263,
        "p50": 1286,
        "p95": 2380
      },
      "totalTdpW": {
        "p05": 681500,
        "p50": 3322500,
        "p95": 6149500
      },
      "unitPriceUsd": 10000,
      "chipSpendUsd": {
        "p05": 13630000,
        "p50": 66450000,
        "p95": 122990000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2024-04-01|2024-06-30",
      "name": "FY24 Q2 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 63192,
        "p50": 80701,
        "p95": 102794
      },
      "sourceCompute": {
        "p05": 83501,
        "p50": 106636,
        "p95": 135829
      },
      "totalTdpW": {
        "p05": 47394000,
        "p50": 60525750,
        "p95": 77095500
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 789900000,
        "p50": 1008762500,
        "p95": 1284925000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300A|2024-04-01|2024-06-30",
      "name": "FY24 Q2 - MI300A",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300A",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 3895,
        "p50": 10490,
        "p95": 17706
      },
      "sourceCompute": {
        "p05": 3860,
        "p50": 10395,
        "p95": 17545
      },
      "totalTdpW": {
        "p05": 2960200,
        "p50": 7972400,
        "p95": 13456560
      },
      "unitPriceUsd": 6700,
      "chipSpendUsd": {
        "p05": 26096500,
        "p50": 70283000,
        "p95": 118630200
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2024-04-01|2024-06-30",
      "name": "Q2 2024 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 87500,
        "p50": 100000,
        "p95": 125000
      },
      "sourceCompute": {
        "p05": 27362.75,
        "p50": 35378.75,
        "p95": 45990.5
      },
      "totalTdpW": {
        "p05": 35000000,
        "p50": 40000000,
        "p95": 50000000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 1312500000,
        "p50": 1500000000,
        "p95": 1875000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2024-04-01|2024-06-30",
      "name": "Q2 2024 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 6250,
        "p50": 12500,
        "p95": 25000
      },
      "sourceCompute": {
        "p05": 4876.75,
        "p50": 9649,
        "p95": 18995.25
      },
      "totalTdpW": {
        "p05": 4375000,
        "p50": 8750000,
        "p95": 17500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 125000000,
        "p50": 250000000,
        "p95": 500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium1|2024-04-01|2024-06-30",
      "name": "Q2 2024 Trainium1/Inferentia",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium1",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 50000,
        "p50": 110000,
        "p95": 250000
      },
      "sourceCompute": {
        "p05": 10611,
        "p50": 23345,
        "p95": 53057
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 33000000,
        "p95": 75000000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": true,
      "priceEstimated": false,
      "sourceUrl": "see AI Chip Sales methodology",
      "notes": "More speculative",
      "lastModified": "2026-03-09 21:03:31+00:00"
    },
    {
      "key": "Amazon|Trainium2|2024-04-01|2024-06-30",
      "name": "Q2 2024 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 20000,
        "p50": 30000,
        "p95": 50000
      },
      "sourceCompute": {
        "p05": 13127,
        "p50": 19691,
        "p95": 32819
      },
      "totalTdpW": {
        "p05": 10000000,
        "p50": 15000000,
        "p95": 25000000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 80000000,
        "p50": 120000000,
        "p95": 200000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2024-04-01|2024-06-30",
      "name": "2024 Q2 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2024-04-01",
      "endDate": "2024-06-30",
      "quarter": "2024-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 799,
        "p50": 832,
        "p95": 899
      },
      "sourceCompute": {
        "p05": 207,
        "p50": 215,
        "p95": 233
      },
      "totalTdpW": {
        "p05": 159800,
        "p50": 166400,
        "p95": 179800
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:23:55+00:00"
    },
    {
      "key": "Google|TPU v5e|2024-07-01|2024-09-30",
      "name": "Q3 2024 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 209924,
        "p50": 357492,
        "p95": 540503
      },
      "sourceCompute": {
        "p05": 41687,
        "p50": 70992,
        "p95": 107335
      },
      "totalTdpW": {
        "p05": 47232900,
        "p50": 80435700,
        "p95": 121613175
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 567634496,
        "p50": 966658368,
        "p95": 1461520112
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5p|2024-07-01|2024-09-30",
      "name": "Q3 2024 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 95846,
        "p50": 160391,
        "p95": 233742
      },
      "sourceCompute": {
        "p05": 44460,
        "p50": 74400,
        "p95": 108426
      },
      "totalTdpW": {
        "p05": 51756840,
        "p50": 86611140,
        "p95": 126220680
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 577184612,
        "p50": 965874602,
        "p95": 1407594324
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v6e|2024-07-01|2024-09-30",
      "name": "Q3 2024 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 17332,
        "p50": 40020,
        "p95": 71151
      },
      "sourceCompute": {
        "p05": 16079,
        "p50": 37128,
        "p95": 66010
      },
      "totalTdpW": {
        "p05": 6586160,
        "p50": 15207600,
        "p95": 27037380
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 70350588,
        "p50": 162441180,
        "p95": 288801909
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2024-07-01|2024-09-30",
      "name": "Q3 2024 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 675899,
        "p50": 791332,
        "p95": 930021
      },
      "sourceCompute": {
        "p05": 675899,
        "p50": 791332,
        "p95": 930021
      },
      "totalTdpW": {
        "p05": 473129300,
        "p50": 553932400,
        "p95": 651014700
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 16897475000,
        "p50": 19783300000,
        "p95": 23250525000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2024-07-01|2024-09-30",
      "name": "Q3 2024 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 212258,
        "p50": 274454,
        "p95": 354333
      },
      "sourceCompute": {
        "p05": 31747,
        "p50": 41050,
        "p95": 52997
      },
      "totalTdpW": {
        "p05": 84903200,
        "p50": 109781600,
        "p95": 141733200
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 2547096000,
        "p50": 3293448000,
        "p95": 4251996000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI250X|2024-07-01|2024-09-30",
      "name": "FY24 Q3 - MI250X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI250X",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 1589,
        "p50": 4449,
        "p95": 7692
      },
      "sourceCompute": {
        "p05": 307,
        "p50": 861,
        "p95": 1488
      },
      "totalTdpW": {
        "p05": 794500,
        "p50": 2224500,
        "p95": 3846000
      },
      "unitPriceUsd": 10000,
      "chipSpendUsd": {
        "p05": 15890000,
        "p50": 44490000,
        "p95": 76920000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2024-07-01|2024-09-30",
      "name": "FY24 Q3 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 75488,
        "p50": 94469,
        "p95": 118566
      },
      "sourceCompute": {
        "p05": 99749,
        "p50": 124829,
        "p95": 156671
      },
      "totalTdpW": {
        "p05": 56616000,
        "p50": 70851750,
        "p95": 88924500
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 943600000,
        "p50": 1180862500,
        "p95": 1482075000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300A|2024-07-01|2024-09-30",
      "name": "FY24 Q3 - MI300A",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300A",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 32854,
        "p50": 43514,
        "p95": 55701
      },
      "sourceCompute": {
        "p05": 32556,
        "p50": 43119,
        "p95": 55194
      },
      "totalTdpW": {
        "p05": 24969040,
        "p50": 33070640,
        "p95": 42332760
      },
      "unitPriceUsd": 6700,
      "chipSpendUsd": {
        "p05": 220121800,
        "p50": 291543800,
        "p95": 373196700
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2024-07-01|2024-09-30",
      "name": "Q3 2024 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 87500,
        "p50": 100000,
        "p95": 125000
      },
      "sourceCompute": {
        "p05": 27362.75,
        "p50": 35378.75,
        "p95": 45990.5
      },
      "totalTdpW": {
        "p05": 35000000,
        "p50": 40000000,
        "p95": 50000000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 1312500000,
        "p50": 1500000000,
        "p95": 1875000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2024-07-01|2024-09-30",
      "name": "Q3 2024 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 6250,
        "p50": 12500,
        "p95": 25000
      },
      "sourceCompute": {
        "p05": 4876.75,
        "p50": 9649,
        "p95": 18995.25
      },
      "totalTdpW": {
        "p05": 4375000,
        "p50": 8750000,
        "p95": 17500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 125000000,
        "p50": 250000000,
        "p95": 500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium1|2024-07-01|2024-09-30",
      "name": "Q3 2024 Trainium1/Inferentia",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium1",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 50000,
        "p50": 110000,
        "p95": 250000
      },
      "sourceCompute": {
        "p05": 10611,
        "p50": 23345,
        "p95": 53057
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 33000000,
        "p95": 75000000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": true,
      "priceEstimated": false,
      "sourceUrl": "see AI Chip Sales methodology",
      "notes": "More speculative",
      "lastModified": "2026-03-09 21:03:32+00:00"
    },
    {
      "key": "Amazon|Trainium2|2024-07-01|2024-09-30",
      "name": "Q3 2024 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 50000,
        "p50": 80000,
        "p95": 105000
      },
      "sourceCompute": {
        "p05": 32819,
        "p50": 52511,
        "p95": 68921
      },
      "totalTdpW": {
        "p05": 25000000,
        "p50": 40000000,
        "p95": 52500000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 200000000,
        "p50": 320000000,
        "p95": 420000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2024-07-01|2024-09-30",
      "name": "2024 Q3 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2024-07-01",
      "endDate": "2024-09-30",
      "quarter": "2024-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 2462,
        "p50": 2565,
        "p95": 2770
      },
      "sourceCompute": {
        "p05": 637,
        "p50": 664,
        "p95": 717
      },
      "totalTdpW": {
        "p05": 492400,
        "p50": 513000,
        "p95": 554000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:24:02+00:00"
    },
    {
      "key": "Google|TPU v5e|2024-10-01|2024-12-31",
      "name": "Q4 2024 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 183943,
        "p50": 300258,
        "p95": 448532
      },
      "sourceCompute": {
        "p05": 36528,
        "p50": 59626,
        "p95": 89071
      },
      "totalTdpW": {
        "p05": 41387175,
        "p50": 67558050,
        "p95": 100919700
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 497381872,
        "p50": 811897632,
        "p95": 1212830528
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5p|2024-10-01|2024-12-31",
      "name": "Q4 2024 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 83297,
        "p50": 134339,
        "p95": 194937
      },
      "sourceCompute": {
        "p05": 38639,
        "p50": 62316,
        "p95": 90425
      },
      "totalTdpW": {
        "p05": 44980380,
        "p50": 72543060,
        "p95": 105265980
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 501614534,
        "p50": 808989458,
        "p95": 1173910614
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v6e|2024-10-01|2024-12-31",
      "name": "Q4 2024 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 116548,
        "p50": 174062,
        "p95": 242743
      },
      "sourceCompute": {
        "p05": 108126,
        "p50": 161484,
        "p95": 225203
      },
      "totalTdpW": {
        "p05": 44288240,
        "p50": 66143560,
        "p95": 92242340
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 473068332,
        "p50": 706517658,
        "p95": 985293837
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2024-10-01|2024-12-31",
      "name": "Q4 2024 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 580308,
        "p50": 681252,
        "p95": 796953
      },
      "sourceCompute": {
        "p05": 580308,
        "p50": 681252,
        "p95": 796953
      },
      "totalTdpW": {
        "p05": 406215600,
        "p50": 476876400,
        "p95": 557867100
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 14507700000,
        "p50": 17031300000,
        "p95": 19923825000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2024-10-01|2024-12-31",
      "name": "Q4 2024 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 251072,
        "p50": 325386,
        "p95": 424357
      },
      "sourceCompute": {
        "p05": 37553,
        "p50": 48668,
        "p95": 63471
      },
      "totalTdpW": {
        "p05": 100428800,
        "p50": 130154400,
        "p95": 169742800
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 3012864000,
        "p50": 3904632000,
        "p95": 5092284000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|B200|2024-10-01|2024-12-31",
      "name": "Q4 2024 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 171886,
        "p50": 201198,
        "p95": 234850
      },
      "sourceCompute": {
        "p05": 434276,
        "p50": 508333,
        "p95": 593355
      },
      "totalTdpW": {
        "p05": 206263200,
        "p50": 241437600,
        "p95": 281820000
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 6359782000,
        "p50": 7444326000,
        "p95": 8689450000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI250X|2024-10-01|2024-12-31",
      "name": "FY24 Q4 - MI250X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI250X",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 1787,
        "p50": 3580,
        "p95": 5691
      },
      "sourceCompute": {
        "p05": 345,
        "p50": 692,
        "p95": 1101
      },
      "totalTdpW": {
        "p05": 893500,
        "p50": 1790000,
        "p95": 2845500
      },
      "unitPriceUsd": 10000,
      "chipSpendUsd": {
        "p05": 17870000,
        "p50": 35800000,
        "p95": 56910000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2024-10-01|2024-12-31",
      "name": "FY24 Q4 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 92687,
        "p50": 115303,
        "p95": 142968
      },
      "sourceCompute": {
        "p05": 122474,
        "p50": 152359,
        "p95": 188915
      },
      "totalTdpW": {
        "p05": 69515250,
        "p50": 86477250,
        "p95": 107226000
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 1158587500,
        "p50": 1441287500,
        "p95": 1787100000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300A|2024-10-01|2024-12-31",
      "name": "FY24 Q4 - MI300A",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300A",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 40045,
        "p50": 52315,
        "p95": 65563
      },
      "sourceCompute": {
        "p05": 39681,
        "p50": 51839,
        "p95": 64966
      },
      "totalTdpW": {
        "p05": 30434200,
        "p50": 39759400,
        "p95": 49827880
      },
      "unitPriceUsd": 6700,
      "chipSpendUsd": {
        "p05": 268301500,
        "p50": 350510500,
        "p95": 439272100
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2024-10-01|2024-12-31",
      "name": "Q4 2024 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 87500,
        "p50": 100000,
        "p95": 125000
      },
      "sourceCompute": {
        "p05": 27362.75,
        "p50": 35378.75,
        "p95": 45990.5
      },
      "totalTdpW": {
        "p05": 35000000,
        "p50": 40000000,
        "p95": 50000000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 1312500000,
        "p50": 1500000000,
        "p95": 1875000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2024-10-01|2024-12-31",
      "name": "Q4 2024 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 6250,
        "p50": 12500,
        "p95": 25000
      },
      "sourceCompute": {
        "p05": 4876.75,
        "p50": 9649,
        "p95": 18995.25
      },
      "totalTdpW": {
        "p05": 4375000,
        "p50": 8750000,
        "p95": 17500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 125000000,
        "p50": 250000000,
        "p95": 500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium1|2024-10-01|2024-12-31",
      "name": "Q4 2024 Trainium1/Inferentia",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium1",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 50000,
        "p50": 110000,
        "p95": 250000
      },
      "sourceCompute": {
        "p05": 10611,
        "p50": 23345,
        "p95": 53057
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 33000000,
        "p95": 75000000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": true,
      "priceEstimated": false,
      "sourceUrl": "see AI Chip Sales methodology",
      "notes": "More speculative",
      "lastModified": "2026-03-09 21:03:33+00:00"
    },
    {
      "key": "Amazon|Trainium2|2024-10-01|2024-12-31",
      "name": "Q4 2024 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 125000,
        "p50": 190000,
        "p95": 265000
      },
      "sourceCompute": {
        "p05": 82049,
        "p50": 124714,
        "p95": 173943
      },
      "totalTdpW": {
        "p05": 62500000,
        "p50": 95000000,
        "p95": 132500000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 500000000,
        "p50": 760000000,
        "p95": 1060000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2024-10-01|2024-12-31",
      "name": "2024 Q4 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2024-10-01",
      "endDate": "2024-12-31",
      "quarter": "2024-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 20214,
        "p50": 21056,
        "p95": 22740
      },
      "sourceCompute": {
        "p05": 5229,
        "p50": 5447,
        "p95": 5882
      },
      "totalTdpW": {
        "p05": 4042800,
        "p50": 4211200,
        "p95": 4548000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:24:10+00:00"
    },
    {
      "key": "Google|TPU v5e|2025-01-01|2025-03-31",
      "name": "Q1 2025 - TPU v5e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5e",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 62151,
        "p50": 95341,
        "p95": 139526
      },
      "sourceCompute": {
        "p05": 12342,
        "p50": 18933,
        "p95": 27707
      },
      "totalTdpW": {
        "p05": 13983975,
        "p50": 21451725,
        "p95": 31393350
      },
      "unitPriceUsd": 2704,
      "chipSpendUsd": {
        "p05": 168056304,
        "p50": 257802064,
        "p95": 377278304
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v5p|2025-01-01|2025-03-31",
      "name": "Q1 2025 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 43841,
        "p50": 96812,
        "p95": 150911
      },
      "sourceCompute": {
        "p05": 20336,
        "p50": 44908,
        "p95": 70003
      },
      "totalTdpW": {
        "p05": 23674140,
        "p50": 52278480,
        "p95": 81491940
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 264010502,
        "p50": 583001864,
        "p95": 908786042
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v6e|2025-01-01|2025-03-31",
      "name": "Q1 2025 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 297639,
        "p50": 406529,
        "p95": 529203
      },
      "sourceCompute": {
        "p05": 276132,
        "p50": 377153,
        "p95": 490964
      },
      "totalTdpW": {
        "p05": 113102820,
        "p50": 154481020,
        "p95": 201097140
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 1208116701,
        "p50": 1650101211,
        "p95": 2148034977
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2025-01-01|2025-03-31",
      "name": "Q1 2025 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 274294,
        "p50": 328883,
        "p95": 392144
      },
      "sourceCompute": {
        "p05": 274294,
        "p50": 328883,
        "p95": 392144
      },
      "totalTdpW": {
        "p05": 192005800,
        "p50": 230218100,
        "p95": 274500800
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 6857350000,
        "p50": 8222075000,
        "p95": 9803600000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2025-01-01|2025-03-31",
      "name": "Q1 2025 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 298201,
        "p50": 362365,
        "p95": 439700
      },
      "sourceCompute": {
        "p05": 44602,
        "p50": 54199,
        "p95": 65766
      },
      "totalTdpW": {
        "p05": 119280400,
        "p50": 144946000,
        "p95": 175880000
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 3578412000,
        "p50": 4348380000,
        "p95": 5276400000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|B200|2025-01-01|2025-03-31",
      "name": "Q1 2025 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 444056,
        "p50": 520940,
        "p95": 608605
      },
      "sourceCompute": {
        "p05": 1121922,
        "p50": 1316170,
        "p95": 1537659
      },
      "totalTdpW": {
        "p05": 532867200,
        "p50": 625128000,
        "p95": 730326000
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 16430072000,
        "p50": 19274780000,
        "p95": 22518385000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2025-01-01|2025-03-31",
      "name": "FY25 Q1 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 62759,
        "p50": 85189,
        "p95": 114284
      },
      "sourceCompute": {
        "p05": 82928,
        "p50": 112567,
        "p95": 151012
      },
      "totalTdpW": {
        "p05": 47069250,
        "p50": 63891750,
        "p95": 85713000
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 784487500,
        "p50": 1064862500,
        "p95": 1428550000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI300A|2025-01-01|2025-03-31",
      "name": "FY25 Q1 - MI300A",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300A",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 2176,
        "p50": 4565,
        "p95": 7468
      },
      "sourceCompute": {
        "p05": 2156,
        "p50": 4523,
        "p95": 7400
      },
      "totalTdpW": {
        "p05": 1653760,
        "p50": 3469400,
        "p95": 5675680
      },
      "unitPriceUsd": 6700,
      "chipSpendUsd": {
        "p05": 14579200,
        "p50": 30585500,
        "p95": 50035600
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI325X|2025-01-01|2025-03-31",
      "name": "FY25 Q1 - MI325X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI325X",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 19876,
        "p50": 32645,
        "p95": 52390
      },
      "sourceCompute": {
        "p05": 26264,
        "p50": 43137,
        "p95": 69226
      },
      "totalTdpW": {
        "p05": 19876000,
        "p50": 32645000,
        "p95": 52390000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 298140000,
        "p50": 489675000,
        "p95": 785850000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2025-01-01|2025-03-31",
      "name": "Q1 2025 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 37500,
        "p50": 50000,
        "p95": 66500
      },
      "sourceCompute": {
        "p05": 11946.5,
        "p50": 16816.5,
        "p95": 23883.25
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 20000000,
        "p95": 26600000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 562500000,
        "p50": 750000000,
        "p95": 997500000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2025-01-01|2025-03-31",
      "name": "Q1 2025 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 125000,
        "p50": 150000,
        "p95": 175000
      },
      "sourceCompute": {
        "p05": 97198.5,
        "p50": 115147.25,
        "p95": 136010.75
      },
      "totalTdpW": {
        "p05": 87500000,
        "p50": 105000000,
        "p95": 122500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 2500000000,
        "p50": 3000000000,
        "p95": 3500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium2|2025-01-01|2025-03-31",
      "name": "Q1 2025 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 180000,
        "p50": 210000,
        "p95": 250000
      },
      "sourceCompute": {
        "p05": 118150,
        "p50": 137842,
        "p95": 164098
      },
      "totalTdpW": {
        "p05": 90000000,
        "p50": 105000000,
        "p95": 125000000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 720000000,
        "p50": 840000000,
        "p95": 1000000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2025-01-01|2025-03-31",
      "name": "2025 Q1 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2025-01-01",
      "endDate": "2025-03-31",
      "quarter": "2025-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 17106,
        "p50": 18817,
        "p95": 25659
      },
      "sourceCompute": {
        "p05": 4425,
        "p50": 4869,
        "p95": 6638
      },
      "totalTdpW": {
        "p05": 3421200,
        "p50": 3763400,
        "p95": 5131800
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:24:16+00:00"
    },
    {
      "key": "Google|TPU v5p|2025-04-01|2025-06-30",
      "name": "Q2 2025 - TPU v5p",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v5p",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 9390,
        "p50": 32236,
        "p95": 53691
      },
      "sourceCompute": {
        "p05": 4355,
        "p50": 14953,
        "p95": 24905
      },
      "totalTdpW": {
        "p05": 5070600,
        "p50": 17407440,
        "p95": 28993140
      },
      "unitPriceUsd": 6022,
      "chipSpendUsd": {
        "p05": 56546580,
        "p50": 194125192,
        "p95": 323327202
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v6e|2025-04-01|2025-06-30",
      "name": "Q2 2025 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 503118,
        "p50": 664016,
        "p95": 828114
      },
      "sourceCompute": {
        "p05": 466763,
        "p50": 616035,
        "p95": 768275
      },
      "totalTdpW": {
        "p05": 191184840,
        "p50": 252326080,
        "p95": 314683320
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 2042155962,
        "p50": 2695240944,
        "p95": 3361314726
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2025-04-01|2025-06-30",
      "name": "Q2 2025 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 186151,
        "p50": 227846,
        "p95": 278409
      },
      "sourceCompute": {
        "p05": 186151,
        "p50": 227846,
        "p95": 278409
      },
      "totalTdpW": {
        "p05": 130305700,
        "p50": 159492200,
        "p95": 194886300
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 4653775000,
        "p50": 5696150000,
        "p95": 6960225000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2025-04-01|2025-06-30",
      "name": "Q2 2025 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 128948,
        "p50": 153073,
        "p95": 180663
      },
      "sourceCompute": {
        "p05": 19286,
        "p50": 22895,
        "p95": 27021
      },
      "totalTdpW": {
        "p05": 51579200,
        "p50": 61229200,
        "p95": 72265200
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 1547376000,
        "p50": 1836876000,
        "p95": 2167956000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|B200|2025-04-01|2025-06-30",
      "name": "Q2 2025 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 373418,
        "p50": 436018,
        "p95": 508893
      },
      "sourceCompute": {
        "p05": 943451,
        "p50": 1101612,
        "p95": 1285734
      },
      "totalTdpW": {
        "p05": 448101600,
        "p50": 523221600,
        "p95": 610671600
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 13816466000,
        "p50": 16132666000,
        "p95": 18829041000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|B300|2025-04-01|2025-06-30",
      "name": "Q2 2025 - B300",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B300",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 182592,
        "p50": 215467,
        "p95": 253869
      },
      "sourceCompute": {
        "p05": 461324,
        "p50": 544384,
        "p95": 641408
      },
      "totalTdpW": {
        "p05": 255628800,
        "p50": 301653800,
        "p95": 355416600
      },
      "unitPriceUsd": 43000,
      "chipSpendUsd": {
        "p05": 7851456000,
        "p50": 9265081000,
        "p95": 10916367000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2025-04-01|2025-06-30",
      "name": "FY25 Q2 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 31143,
        "p50": 45748,
        "p95": 65451
      },
      "sourceCompute": {
        "p05": 41152,
        "p50": 60450,
        "p95": 86485
      },
      "totalTdpW": {
        "p05": 23357250,
        "p50": 34311000,
        "p95": 49088250
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 389287500,
        "p50": 571850000,
        "p95": 818137500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI325X|2025-04-01|2025-06-30",
      "name": "FY25 Q2 - MI325X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI325X",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 15984,
        "p50": 26771,
        "p95": 43643
      },
      "sourceCompute": {
        "p05": 21121,
        "p50": 35374,
        "p95": 57668
      },
      "totalTdpW": {
        "p05": 15984000,
        "p50": 26771000,
        "p95": 43643000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 239760000,
        "p50": 401565000,
        "p95": 654645000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI350X|2025-04-01|2025-06-30",
      "name": "FY25 Q2 - MI350X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI350X",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 1764,
        "p50": 4089,
        "p95": 6953
      },
      "sourceCompute": {
        "p05": 4114,
        "p50": 9533,
        "p95": 16212
      },
      "totalTdpW": {
        "p05": 1764000,
        "p50": 4089000,
        "p95": 6953000
      },
      "unitPriceUsd": 23500,
      "chipSpendUsd": {
        "p05": 41454000,
        "p50": 96091500,
        "p95": 163395500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2025-04-01|2025-06-30",
      "name": "Q2 2025 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 37500,
        "p50": 50000,
        "p95": 66500
      },
      "sourceCompute": {
        "p05": 11946.5,
        "p50": 16816.5,
        "p95": 23883.25
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 20000000,
        "p95": 26600000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 562500000,
        "p50": 750000000,
        "p95": 997500000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2025-04-01|2025-06-30",
      "name": "Q2 2025 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 125000,
        "p50": 150000,
        "p95": 175000
      },
      "sourceCompute": {
        "p05": 97198.5,
        "p50": 115147.25,
        "p95": 136010.75
      },
      "totalTdpW": {
        "p05": 87500000,
        "p50": 105000000,
        "p95": 122500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 2500000000,
        "p50": 3000000000,
        "p95": 3500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium2|2025-04-01|2025-06-30",
      "name": "Q2 2025 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 215000,
        "p50": 250000,
        "p95": 285000
      },
      "sourceCompute": {
        "p05": 141124,
        "p50": 164098,
        "p95": 187071
      },
      "totalTdpW": {
        "p05": 107500000,
        "p50": 125000000,
        "p95": 142500000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 860000000,
        "p50": 1000000000,
        "p95": 1140000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2025-04-01|2025-06-30",
      "name": "2025 Q2 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2025-04-01",
      "endDate": "2025-06-30",
      "quarter": "2025-Q2",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 27230,
        "p50": 29953,
        "p95": 40845
      },
      "sourceCompute": {
        "p05": 7044,
        "p50": 7749,
        "p95": 10567
      },
      "totalTdpW": {
        "p05": 5446000,
        "p50": 5990600,
        "p95": 8169000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:24:22+00:00"
    },
    {
      "key": "Google|TPU v6e|2025-07-01|2025-09-30",
      "name": "Q3 2025 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 551548,
        "p50": 735022,
        "p95": 933068
      },
      "sourceCompute": {
        "p05": 511694,
        "p50": 681910,
        "p95": 865646
      },
      "totalTdpW": {
        "p05": 209588240,
        "p50": 279308360,
        "p95": 354565840
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 2238733332,
        "p50": 2983454298,
        "p95": 3787323012
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v7|2025-07-01|2025-09-30",
      "name": "Q3 2025 - TPU v7",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v7",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 23632,
        "p50": 51358,
        "p95": 80443
      },
      "sourceCompute": {
        "p05": 55097,
        "p50": 119740,
        "p95": 187553
      },
      "totalTdpW": {
        "p05": 22686720,
        "p50": 49303680,
        "p95": 77225280
      },
      "unitPriceUsd": 11737,
      "chipSpendUsd": {
        "p05": 277368784,
        "p50": 602788846,
        "p95": 944159491
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2025-07-01|2025-09-30",
      "name": "Q3 2025 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 103574,
        "p50": 126826,
        "p95": 155230
      },
      "sourceCompute": {
        "p05": 103574,
        "p50": 126826,
        "p95": 155230
      },
      "totalTdpW": {
        "p05": 72501800,
        "p50": 88778200,
        "p95": 108661000
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 2589350000,
        "p50": 3170650000,
        "p95": 3880750000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|H20|2025-07-01|2025-09-30",
      "name": "Q3 2025 - H20",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H20",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 14497,
        "p50": 17168,
        "p95": 20328
      },
      "sourceCompute": {
        "p05": 2168,
        "p50": 2567,
        "p95": 3040
      },
      "totalTdpW": {
        "p05": 5798800,
        "p50": 6867200,
        "p95": 8131200
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 173964000,
        "p50": 206016000,
        "p95": 243936000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|B200|2025-07-01|2025-09-30",
      "name": "Q3 2025 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 297528,
        "p50": 347023,
        "p95": 404125
      },
      "sourceCompute": {
        "p05": 751715,
        "p50": 876763,
        "p95": 1021033
      },
      "totalTdpW": {
        "p05": 357033600,
        "p50": 416427600,
        "p95": 484950000
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 11008536000,
        "p50": 12839851000,
        "p95": 14952625000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "Nvidia|B300|2025-07-01|2025-09-30",
      "name": "Q3 2025 - B300",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B300",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 460762,
        "p50": 541067,
        "p95": 637915
      },
      "sourceCompute": {
        "p05": 1164129,
        "p50": 1367022,
        "p95": 1611710
      },
      "totalTdpW": {
        "p05": 645066800,
        "p50": 757493800,
        "p95": 893081000
      },
      "unitPriceUsd": 43000,
      "chipSpendUsd": {
        "p05": 19812766000,
        "p50": 23265881000,
        "p95": 27430345000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-01-28 18:19:23+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2025-07-01|2025-09-30",
      "name": "FY25 Q3 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 28082,
        "p50": 45815,
        "p95": 67319
      },
      "sourceCompute": {
        "p05": 37108,
        "p50": 60539,
        "p95": 88954
      },
      "totalTdpW": {
        "p05": 21061500,
        "p50": 34361250,
        "p95": 50489250
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 351025000,
        "p50": 572687500,
        "p95": 841487500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI325X|2025-07-01|2025-09-30",
      "name": "FY25 Q3 - MI325X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI325X",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 8036,
        "p50": 19754,
        "p95": 35747
      },
      "sourceCompute": {
        "p05": 10619,
        "p50": 26102,
        "p95": 47235
      },
      "totalTdpW": {
        "p05": 8036000,
        "p50": 19754000,
        "p95": 35747000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 120540000,
        "p50": 296310000,
        "p95": 536205000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI350X|2025-07-01|2025-09-30",
      "name": "FY25 Q3 - MI350X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI350X",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 27124,
        "p50": 36291,
        "p95": 47410
      },
      "sourceCompute": {
        "p05": 63241,
        "p50": 84612,
        "p95": 110536
      },
      "totalTdpW": {
        "p05": 27124000,
        "p50": 36291000,
        "p95": 47410000
      },
      "unitPriceUsd": 23500,
      "chipSpendUsd": {
        "p05": 637414000,
        "p50": 852838500,
        "p95": 1114135000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "AMD|Instinct MI355X|2025-07-01|2025-09-30",
      "name": "FY25 Q3 - MI355X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI355X",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 7954,
        "p50": 12387,
        "p95": 17491
      },
      "sourceCompute": {
        "p05": 20230,
        "p50": 31503,
        "p95": 44483
      },
      "totalTdpW": {
        "p05": 11135600,
        "p50": 17341800,
        "p95": 24487400
      },
      "unitPriceUsd": 27500,
      "chipSpendUsd": {
        "p05": 218735000,
        "p50": 340642500,
        "p95": 481002500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 01-21-2026 16:32",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2025-07-01|2025-09-30",
      "name": "Q3 2025 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 37500,
        "p50": 50000,
        "p95": 66500
      },
      "sourceCompute": {
        "p05": 11946.5,
        "p50": 16816.5,
        "p95": 23883.25
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 20000000,
        "p95": 26600000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 562500000,
        "p50": 750000000,
        "p95": 997500000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2025-07-01|2025-09-30",
      "name": "Q3 2025 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 125000,
        "p50": 150000,
        "p95": 175000
      },
      "sourceCompute": {
        "p05": 97198.5,
        "p50": 115147.25,
        "p95": 136010.75
      },
      "totalTdpW": {
        "p05": 87500000,
        "p50": 105000000,
        "p95": 122500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 2500000000,
        "p50": 3000000000,
        "p95": 3500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium2|2025-07-01|2025-09-30",
      "name": "Q3 2025 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 250000,
        "p50": 290000,
        "p95": 330000
      },
      "sourceCompute": {
        "p05": 164098,
        "p50": 190353,
        "p95": 216609
      },
      "totalTdpW": {
        "p05": 125000000,
        "p50": 145000000,
        "p95": 165000000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 1000000000,
        "p50": 1160000000,
        "p95": 1320000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2025-07-01|2025-09-30",
      "name": "2025 Q3 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2025-07-01",
      "endDate": "2025-09-30",
      "quarter": "2025-Q3",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 26578,
        "p50": 29235,
        "p95": 39866
      },
      "sourceCompute": {
        "p05": 6877,
        "p50": 7563,
        "p95": 10313
      },
      "totalTdpW": {
        "p05": 5315600,
        "p50": 5847000,
        "p95": 7973200
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:24:30+00:00"
    },
    {
      "key": "Google|TPU v6e|2025-10-01|2025-12-31",
      "name": "Q4 2025 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 230801,
        "p50": 397371,
        "p95": 569125
      },
      "sourceCompute": {
        "p05": 214123,
        "p50": 368657,
        "p95": 528000
      },
      "totalTdpW": {
        "p05": 87704380,
        "p50": 151000980,
        "p95": 216267500
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 936821259,
        "p50": 1612928889,
        "p95": 2310078375
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Google|TPU v7|2025-10-01|2025-12-31",
      "name": "Q4 2025 - TPU v7",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v7",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 136001,
        "p50": 197711,
        "p95": 268151
      },
      "sourceCompute": {
        "p05": 317085,
        "p50": 460961,
        "p95": 625189
      },
      "totalTdpW": {
        "p05": 130560960,
        "p50": 189802560,
        "p95": 257424960
      },
      "unitPriceUsd": 11737,
      "chipSpendUsd": {
        "p05": 1596243737,
        "p50": 2320534007,
        "p95": 3147288287
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 16:14:25+00:00"
    },
    {
      "key": "Nvidia|H100|2025-10-01|2025-12-31",
      "name": "Q4 2025 - H100/H200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "H100",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 19005,
        "p50": 23295,
        "p95": 28561
      },
      "sourceCompute": {
        "p05": 19005,
        "p50": 23295,
        "p95": 28561
      },
      "totalTdpW": {
        "p05": 13303500,
        "p50": 16306500,
        "p95": 19992700
      },
      "unitPriceUsd": 25000,
      "chipSpendUsd": {
        "p05": 475125000,
        "p50": 582375000,
        "p95": 714025000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 01-28-2026 12:48",
      "lastModified": "2026-03-02 21:01:09+00:00"
    },
    {
      "key": "Nvidia|B200|2025-10-01|2025-12-31",
      "name": "Q4 2025 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 357988,
        "p50": 416504,
        "p95": 490079
      },
      "sourceCompute": {
        "p05": 904467,
        "p50": 1052310,
        "p95": 1238199
      },
      "totalTdpW": {
        "p05": 429585600,
        "p50": 499804800,
        "p95": 588094800
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 13245556000,
        "p50": 15410648000,
        "p95": 18132923000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 02-25-2026 19:39",
      "lastModified": "2026-03-02 20:59:50+00:00"
    },
    {
      "key": "Nvidia|B300|2025-10-01|2025-12-31",
      "name": "Q4 2025 - B300",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B300",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 632276,
        "p50": 744907,
        "p95": 873201
      },
      "sourceCompute": {
        "p05": 1597465,
        "p50": 1882029,
        "p95": 2206168
      },
      "totalTdpW": {
        "p05": 885186400,
        "p50": 1042869800,
        "p95": 1222481400
      },
      "unitPriceUsd": 43000,
      "chipSpendUsd": {
        "p05": 27187868000,
        "p50": 32031001000,
        "p95": 37547643000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 02-25-2026 19:39",
      "lastModified": "2026-03-02 21:01:06+00:00"
    },
    {
      "key": "AMD|Instinct MI300X|2025-11-01|2025-12-31",
      "name": "FY25 Q4 - MI300X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI300X",
      "startDate": "2025-11-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 6880,
        "p50": 11166,
        "p95": 17519
      },
      "sourceCompute": {
        "p05": 9092,
        "p50": 14755,
        "p95": 21149
      },
      "totalTdpW": {
        "p05": 5160000,
        "p50": 8374500,
        "p95": 13139250
      },
      "unitPriceUsd": 12500,
      "chipSpendUsd": {
        "p05": 86000000,
        "p50": 139575000,
        "p95": 218987500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 02-22-2026 15:29",
      "lastModified": "2026-02-22 20:29:48+00:00"
    },
    {
      "key": "AMD|Instinct MI325X|2025-11-01|2025-12-31",
      "name": "FY25 Q4 - MI325X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI325X",
      "startDate": "2025-11-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 5717,
        "p50": 12843,
        "p95": 23358
      },
      "sourceCompute": {
        "p05": 7555,
        "p50": 16970,
        "p95": 30865
      },
      "totalTdpW": {
        "p05": 5717000,
        "p50": 12843000,
        "p95": 23358000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 85755000,
        "p50": 192645000,
        "p95": 350370000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 02-22-2026 15:29",
      "lastModified": "2026-02-22 20:35:35+00:00"
    },
    {
      "key": "AMD|Instinct MI350X|2025-11-01|2025-12-31",
      "name": "FY25 Q4 - MI350X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI350X",
      "startDate": "2025-11-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 24801,
        "p50": 35084,
        "p95": 47147
      },
      "sourceCompute": {
        "p05": 57823,
        "p50": 81797,
        "p95": 109922
      },
      "totalTdpW": {
        "p05": 24801000,
        "p50": 35084000,
        "p95": 47147000
      },
      "unitPriceUsd": 23500,
      "chipSpendUsd": {
        "p05": 582823500,
        "p50": 824474000,
        "p95": 1107954500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 02-22-2026 15:29",
      "lastModified": "2026-02-22 20:36:59+00:00"
    },
    {
      "key": "AMD|Instinct MI355X|2025-11-01|2025-12-31",
      "name": "FY25 Q4 - MI355X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI355X",
      "startDate": "2025-11-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 26981,
        "p50": 37040,
        "p95": 48847
      },
      "sourceCompute": {
        "p05": 68618,
        "p50": 94201,
        "p95": 124229
      },
      "totalTdpW": {
        "p05": 37773400,
        "p50": 51856000,
        "p95": 68385800
      },
      "unitPriceUsd": 27500,
      "chipSpendUsd": {
        "p05": 741977500,
        "p50": 1018600000,
        "p95": 1343292500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 02-22-2026 15:29",
      "lastModified": "2026-02-22 20:38:10+00:00"
    },
    {
      "key": "Huawei|Ascend 910B|2025-10-01|2025-12-31",
      "name": "Q4 2025 Ascend 910B",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910B",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 37500,
        "p50": 50000,
        "p95": 66500
      },
      "sourceCompute": {
        "p05": 11946.5,
        "p50": 16816.5,
        "p95": 23883.25
      },
      "totalTdpW": {
        "p05": 15000000,
        "p50": 20000000,
        "p95": 26600000
      },
      "unitPriceUsd": 15000,
      "chipSpendUsd": {
        "p05": 562500000,
        "p50": 750000000,
        "p95": 997500000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Huawei|Ascend 910C|2025-10-01|2025-12-31",
      "name": "Q4 2025 Ascend 910C",
      "designer": "Huawei",
      "designerCountry": "China",
      "chipType": "Ascend 910C",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 125000,
        "p50": 150000,
        "p95": 175000
      },
      "sourceCompute": {
        "p05": 97198.5,
        "p50": 115147.25,
        "p95": 136010.75
      },
      "totalTdpW": {
        "p05": 87500000,
        "p50": 105000000,
        "p95": 122500000
      },
      "unitPriceUsd": 20000,
      "chipSpendUsd": {
        "p05": 2500000000,
        "p50": 3000000000,
        "p95": 3500000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "see methodology",
      "notes": "Confidence intervals in units are relatively unprincipled due to lack of revenue model. Don't take them too literally. H100e conversion incorporates some uncertainty over average chip specifications. See methodology",
      "lastModified": "2026-01-28 17:14:46+00:00"
    },
    {
      "key": "Amazon|Trainium2|2025-10-01|2025-12-31",
      "name": "Q4 2025 Trainium2",
      "designer": "Amazon",
      "designerCountry": "United States of America",
      "chipType": "Trainium2",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 285000,
        "p50": 335000,
        "p95": 390000
      },
      "sourceCompute": {
        "p05": 187071,
        "p50": 219891,
        "p95": 255992
      },
      "totalTdpW": {
        "p05": 142500000,
        "p50": 167500000,
        "p95": 195000000
      },
      "unitPriceUsd": 4000,
      "chipSpendUsd": {
        "p05": 1140000000,
        "p50": 1340000000,
        "p95": 1560000000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": "https://colab.research.google.com/github/epoch-research/ai-chip-counts/blob/main/trainium_timelines.ipynb",
      "notes": "Estimates generated on: 02-13-2026 14:27",
      "lastModified": "2026-02-13 22:31:47+00:00"
    },
    {
      "key": "AMD|Instinct MI308X|2025-11-01|2025-12-31",
      "name": "FY25 Q4 - MI308X",
      "designer": "AMD",
      "designerCountry": "United States of America",
      "chipType": "Instinct MI308X",
      "startDate": "2025-11-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 30042,
        "p50": 32500,
        "p95": 35546
      },
      "sourceCompute": {
        "p05": 19841,
        "p50": 21523,
        "p95": 23476
      },
      "totalTdpW": {
        "p05": 22531500,
        "p50": 24375000,
        "p95": 26659500
      },
      "unitPriceUsd": 12000,
      "chipSpendUsd": {
        "p05": 360504000,
        "p50": 390000000,
        "p95": 426552000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Date estimates were generated: 02-22-2026 15:29",
      "lastModified": "2026-02-22 20:33:47+00:00"
    },
    {
      "key": "Cambricon|Siyuan 590|2025-10-01|2025-12-31",
      "name": "2025 Q4 - Siyuan 590",
      "designer": "Cambricon",
      "designerCountry": "China",
      "chipType": "Siyuan 590",
      "startDate": "2025-10-01",
      "endDate": "2025-12-31",
      "quarter": "2025-Q4",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 29086,
        "p50": 31995,
        "p95": 43630
      },
      "sourceCompute": {
        "p05": 7525,
        "p50": 8277,
        "p95": 11287
      },
      "totalTdpW": {
        "p05": 5817200,
        "p50": 6399000,
        "p95": 8726000
      },
      "unitPriceUsd": null,
      "chipSpendUsd": null,
      "tdpEstimated": false,
      "priceEstimated": false,
      "sourceUrl": null,
      "notes": "Cambricon methodology: https://docs.google.com/document/d/1LmVwqNAxL33wipBo7boVf5TRJusubmiLmACy2m0E2ew/edit?usp=sharing; quarterly allocation proportional to reported quarterly revenue",
      "lastModified": "2026-05-12 18:24:35+00:00"
    },
    {
      "key": "Google|TPU v6e|2026-01-01|2026-03-31",
      "name": "Q1 2026 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2026-01-01",
      "endDate": "2026-03-31",
      "quarter": "2026-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 22130,
        "p50": 143532,
        "p95": 260500
      },
      "sourceCompute": {
        "p05": 20531,
        "p50": 133160,
        "p95": 241676
      },
      "totalTdpW": {
        "p05": 8409400,
        "p50": 54542160,
        "p95": 98990000
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 89825670,
        "p50": 582596388,
        "p95": 1057369500
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 18:05:54+00:00"
    },
    {
      "key": "Google|TPU v7|2026-01-01|2026-03-31",
      "name": "Q1 2026 - TPU v7",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v7",
      "startDate": "2026-01-01",
      "endDate": "2026-03-31",
      "quarter": "2026-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 227355,
        "p50": 306054,
        "p95": 396755
      },
      "sourceCompute": {
        "p05": 530074,
        "p50": 713559,
        "p95": 925028
      },
      "totalTdpW": {
        "p05": 218260800,
        "p50": 293811840,
        "p95": 380884800
      },
      "unitPriceUsd": 11737,
      "chipSpendUsd": {
        "p05": 2668465635,
        "p50": 3592155798,
        "p95": 4656713435
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 18:05:55+00:00"
    },
    {
      "key": "Nvidia|B200|2026-01-01|2026-03-31",
      "name": "Q1 2026 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2026-01-01",
      "endDate": "2026-03-31",
      "quarter": "2026-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 296207,
        "p50": 347290,
        "p95": 406782
      },
      "sourceCompute": {
        "p05": 748375,
        "p50": 877438,
        "p95": 1027746
      },
      "totalTdpW": {
        "p05": 355448400,
        "p50": 416748000,
        "p95": 488138400
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 10959659000,
        "p50": 12849730000,
        "p95": 15050934000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-03-2026 17:56",
      "lastModified": "2026-06-03 22:03:10+00:00"
    },
    {
      "key": "Nvidia|B300|2026-01-01|2026-03-31",
      "name": "Q1 2026 - B300",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B300",
      "startDate": "2026-01-01",
      "endDate": "2026-03-31",
      "quarter": "2026-Q1",
      "incomplete": false,
      "productionEligible": true,
      "units": {
        "p05": 841132,
        "p50": 992874,
        "p95": 1166624
      },
      "sourceCompute": {
        "p05": 2125144,
        "p50": 2508524,
        "p95": 2947508
      },
      "totalTdpW": {
        "p05": 1177584800,
        "p50": 1390023600,
        "p95": 1633273600
      },
      "unitPriceUsd": 43000,
      "chipSpendUsd": {
        "p05": 36168676000,
        "p50": 42693582000,
        "p95": 50164832000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Estimates generated on: 06-03-2026 17:56",
      "lastModified": "2026-06-03 22:03:12+00:00"
    },
    {
      "key": "Google|TPU v6e|2026-04-01|2026-06-30",
      "name": "Q2 2026 - TPU v6e",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v6e",
      "startDate": "2026-04-01",
      "endDate": "2026-06-30",
      "quarter": "2026-Q2",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 334,
        "p50": 38608,
        "p95": 75626
      },
      "sourceCompute": {
        "p05": 310,
        "p50": 35818,
        "p95": 70161
      },
      "totalTdpW": {
        "p05": 126920,
        "p50": 14671040,
        "p95": 28737880
      },
      "unitPriceUsd": 4059,
      "chipSpendUsd": {
        "p05": 1355706,
        "p50": 156709872,
        "p95": 306965934
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Broadcom fiscal quarters ending 05/03/2026. Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 18:05:59+00:00"
    },
    {
      "key": "Google|TPU v7|2026-04-01|2026-06-30",
      "name": "Q2 2026 - TPU v7",
      "designer": "Google",
      "designerCountry": "United States of America",
      "chipType": "TPU v7",
      "startDate": "2026-04-01",
      "endDate": "2026-06-30",
      "quarter": "2026-Q2",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 91537,
        "p50": 122139,
        "p95": 157115
      },
      "sourceCompute": {
        "p05": 213417,
        "p50": 284765,
        "p95": 366311
      },
      "totalTdpW": {
        "p05": 87875520,
        "p50": 117253440,
        "p95": 150830400
      },
      "unitPriceUsd": 11737,
      "chipSpendUsd": {
        "p05": 1074369769,
        "p50": 1433545443,
        "p95": 1844058755
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Broadcom fiscal quarters ending 05/03/2026. Estimates generated on: 06-11-2026 12:02",
      "lastModified": "2026-06-11 18:05:59+00:00"
    },
    {
      "key": "Nvidia|B200|2026-04-01|2026-06-30",
      "name": "Q2 2026 - B200",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B200",
      "startDate": "2026-04-01",
      "endDate": "2026-06-30",
      "quarter": "2026-Q2",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 76971,
        "p50": 90245,
        "p95": 105704
      },
      "sourceCompute": {
        "p05": 194469,
        "p50": 228006,
        "p95": 267064
      },
      "totalTdpW": {
        "p05": 92365200,
        "p50": 108294000,
        "p95": 126844800
      },
      "unitPriceUsd": 37000,
      "chipSpendUsd": {
        "p05": 2847927000,
        "p50": 3339065000,
        "p95": 3911048000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Nvidia fiscal quarters ending 4/26/2026. Estimates generated on: 06-03-2026 17:56",
      "lastModified": "2026-06-03 22:03:11+00:00"
    },
    {
      "key": "Nvidia|B300|2026-04-01|2026-06-30",
      "name": "Q2 2026 - B300",
      "designer": "Nvidia",
      "designerCountry": "United States of America",
      "chipType": "B300",
      "startDate": "2026-04-01",
      "endDate": "2026-06-30",
      "quarter": "2026-Q2",
      "incomplete": true,
      "productionEligible": false,
      "units": {
        "p05": 264144,
        "p50": 311796,
        "p95": 366360
      },
      "sourceCompute": {
        "p05": 667367,
        "p50": 787761,
        "p95": 925618
      },
      "totalTdpW": {
        "p05": 369801600,
        "p50": 436514400,
        "p95": 512904000
      },
      "unitPriceUsd": 43000,
      "chipSpendUsd": {
        "p05": 11358192000,
        "p50": 13407228000,
        "p95": 15753480000
      },
      "tdpEstimated": false,
      "priceEstimated": true,
      "sourceUrl": null,
      "notes": "Incomplete: based on Nvidia fiscal quarters ending 4/26/2026. Estimates generated on: 06-03-2026 17:56",
      "lastModified": "2026-06-03 22:03:13+00:00"
    }
  ],
  "cashFlowBenchmark": {
    "observed": [
      {
        "period": "2022-Q1",
        "operatingCashFlow": 65.6,
        "cashCapex": 36.6,
        "capexToOcf": 0.5579268292682927,
        "freeCashFlow": 28.999999999999993,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2022-Q2",
        "operatingCashFlow": 69.2,
        "cashCapex": 38.4,
        "capexToOcf": 0.5549132947976878,
        "freeCashFlow": 30.800000000000004,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2022-Q3",
        "operatingCashFlow": 74,
        "cashCapex": 41,
        "capexToOcf": 0.5540540540540541,
        "freeCashFlow": 33,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2022-Q4",
        "operatingCashFlow": 79.3,
        "cashCapex": 41.9,
        "capexToOcf": 0.5283732660781841,
        "freeCashFlow": 37.4,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2023-Q1",
        "operatingCashFlow": 71,
        "cashCapex": 36.6,
        "capexToOcf": 0.5154929577464789,
        "freeCashFlow": 34.4,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2023-Q2",
        "operatingCashFlow": 96.9,
        "cashCapex": 35.4,
        "capexToOcf": 0.36532507739938075,
        "freeCashFlow": 61.50000000000001,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2023-Q3",
        "operatingCashFlow": 109.8,
        "cashCapex": 38.3,
        "capexToOcf": 0.348816029143898,
        "freeCashFlow": 71.5,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2023-Q4",
        "operatingCashFlow": 99.8,
        "cashCapex": 44.1,
        "capexToOcf": 0.4418837675350702,
        "freeCashFlow": 55.699999999999996,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2024-Q1",
        "operatingCashFlow": 104.5,
        "cashCapex": 46,
        "capexToOcf": 0.44019138755980863,
        "freeCashFlow": 58.5,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2024-Q2",
        "operatingCashFlow": 114.6,
        "cashCapex": 55.6,
        "capexToOcf": 0.48516579406631766,
        "freeCashFlow": 58.99999999999999,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2024-Q3",
        "operatingCashFlow": 123,
        "cashCapex": 61.2,
        "capexToOcf": 0.4975609756097561,
        "freeCashFlow": 61.8,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2024-Q4",
        "operatingCashFlow": 136.3,
        "cashCapex": 76.3,
        "capexToOcf": 0.5597945707997065,
        "freeCashFlow": 60.000000000000014,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2025-Q1",
        "operatingCashFlow": 120.2,
        "cashCapex": 77.8,
        "capexToOcf": 0.6472545757071547,
        "freeCashFlow": 42.400000000000006,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2025-Q2",
        "operatingCashFlow": 134.6,
        "cashCapex": 97.3,
        "capexToOcf": 0.7228826151560178,
        "freeCashFlow": 37.3,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2025-Q3",
        "operatingCashFlow": 167.1,
        "cashCapex": 105.8,
        "capexToOcf": 0.6331538001196888,
        "freeCashFlow": 61.3,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2025-Q4",
        "operatingCashFlow": 180.9,
        "cashCapex": 130.7,
        "capexToOcf": 0.722498618021006,
        "freeCashFlow": 50.20000000000002,
        "kind": "epoch-observed-aggregate"
      },
      {
        "period": "2026-Q1",
        "operatingCashFlow": 157.9,
        "cashCapex": 148.4,
        "capexToOcf": 0.9398353388220393,
        "freeCashFlow": 9.5,
        "kind": "epoch-observed-aggregate"
      }
    ],
    "trend": [
      {
        "period": "2023-Q2",
        "operatingCashFlow": 94.7,
        "cashCapex": 33.2,
        "capexToOcf": 0.3505807814149947,
        "freeCashFlow": 61.5,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2023-Q3",
        "operatingCashFlow": 99.8,
        "cashCapex": 37.8,
        "capexToOcf": 0.3787575150300601,
        "freeCashFlow": 62,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2023-Q4",
        "operatingCashFlow": 105.1,
        "cashCapex": 43.2,
        "capexToOcf": 0.41103710751665085,
        "freeCashFlow": 61.89999999999999,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2024-Q1",
        "operatingCashFlow": 110.8,
        "cashCapex": 49.3,
        "capexToOcf": 0.44494584837545126,
        "freeCashFlow": 61.5,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2024-Q2",
        "operatingCashFlow": 116.7,
        "cashCapex": 56.3,
        "capexToOcf": 0.48243359040274203,
        "freeCashFlow": 60.400000000000006,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2024-Q3",
        "operatingCashFlow": 123,
        "cashCapex": 64.3,
        "capexToOcf": 0.5227642276422764,
        "freeCashFlow": 58.7,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2024-Q4",
        "operatingCashFlow": 129.6,
        "cashCapex": 73.4,
        "capexToOcf": 0.5663580246913581,
        "freeCashFlow": 56.19999999999999,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2025-Q1",
        "operatingCashFlow": 136.6,
        "cashCapex": 83.8,
        "capexToOcf": 0.6134699853587116,
        "freeCashFlow": 52.8,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2025-Q2",
        "operatingCashFlow": 144,
        "cashCapex": 95.7,
        "capexToOcf": 0.6645833333333333,
        "freeCashFlow": 48.3,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2025-Q3",
        "operatingCashFlow": 151.7,
        "cashCapex": 109.3,
        "capexToOcf": 0.7205009887936717,
        "freeCashFlow": 42.39999999999999,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2025-Q4",
        "operatingCashFlow": 159.9,
        "cashCapex": 124.8,
        "capexToOcf": 0.7804878048780487,
        "freeCashFlow": 35.10000000000001,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2026-Q1",
        "operatingCashFlow": 168.5,
        "cashCapex": 142.4,
        "capexToOcf": 0.8451038575667656,
        "freeCashFlow": 26.099999999999994,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2026-Q2",
        "operatingCashFlow": 177.5,
        "cashCapex": 162.6,
        "capexToOcf": 0.916056338028169,
        "freeCashFlow": 14.900000000000006,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2026-Q3",
        "operatingCashFlow": 187.1,
        "cashCapex": 185.7,
        "capexToOcf": 0.9925173703901656,
        "freeCashFlow": 1.4000000000000057,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2026-Q4",
        "operatingCashFlow": 197.2,
        "cashCapex": 212,
        "capexToOcf": 1.0750507099391482,
        "freeCashFlow": -14.800000000000011,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2027-Q1",
        "operatingCashFlow": 207.8,
        "cashCapex": 242,
        "capexToOcf": 1.1645813282001924,
        "freeCashFlow": -34.19999999999999,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2027-Q2",
        "operatingCashFlow": 218.9,
        "cashCapex": 276.3,
        "capexToOcf": 1.262220191868433,
        "freeCashFlow": -57.400000000000006,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2027-Q3",
        "operatingCashFlow": 230.7,
        "cashCapex": 315.5,
        "capexToOcf": 1.3675769397485913,
        "freeCashFlow": -84.80000000000001,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2027-Q4",
        "operatingCashFlow": 243.1,
        "cashCapex": 360.2,
        "capexToOcf": 1.4816947758124228,
        "freeCashFlow": -117.1,
        "kind": "epoch-reconstructed-trend"
      },
      {
        "period": "2028-Q1",
        "operatingCashFlow": 256.2,
        "cashCapex": 411.2,
        "capexToOcf": 1.6049960967993755,
        "freeCashFlow": -155,
        "kind": "epoch-reconstructed-trend"
      }
    ],
    "validation": {
      "sourceScope": "five-hyperscaler-aggregate",
      "observedCount": 17,
      "trendCount": 20,
      "overlapCount": 12,
      "firstObservedPeriod": "2022-Q1",
      "latestObservedPeriod": "2026-Q1",
      "firstTrendPeriod": "2023-Q2",
      "latestTrendPeriod": "2028-Q1",
      "warning": "Epoch is a five-hyperscaler aggregate reconstruction, not company-level point-in-time SEC data."
    },
    "source": {
      "id": "epoch-hyperscaler-capex-vs-cash-flow",
      "label": "Epoch AI · Hyperscaler CapEx vs cash flow",
      "url": "https://epoch.ai/data/charts/hyperscaler-capex-vs-cash-flow/ocf_vs_capex_log_data.csv",
      "role": "aggregate-cross-check-only"
    }
  },
  "epochPower": {
    "actual": [
      {
        "site": "Colossus 2",
        "date": "2025-02-28",
        "period": "2025-Q1",
        "constructionStatus": "Land clearing begins next to the existing building.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Colossus 2",
        "date": "2025-09-08",
        "period": "2025-Q3",
        "constructionStatus": "Battery facility connected to the building. 121 air-cooled chillers installed, which could support 200 MW. In the Duke faciltiy in nearby Mississippi, several natural gas turbines are in place but not fully connected up.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Colossus 2",
        "date": "2025-10-19",
        "period": "2025-Q4",
        "constructionStatus": "Battery facility looks complete (though more might be added). Turbines look connected up, minimal construction around them. We believe this state corresponds to the first compute cluster brought online at this site of \"approximately 110,000 GB200 processors, approximately 210 megawatts of compute power\", as detailed in the [company S-1 filing, page 76](https://www.sec.gov/Archives/edgar/data/1181412/000162828026036936/spaceexplorationtechnologi.htm). Based on those numbers, we believe \"compute power\" corresponds to GPU server power. [Earlier](https://x.com/elonmusk/status/1947715674429919279) [tweets](https://x.com/elonmusk/status/1950251710141567110) from Elon Musk also support this timing, and it's consistent with the estimated cooling capacity based on the satellite image.",
        "buildingsOperational": 1,
        "itNameplateMw": 239,
        "facilityNameplateMw": 323,
        "kind": "observed"
      },
      {
        "site": "Colossus 2",
        "date": "2026-01-13",
        "period": "2026-Q1",
        "constructionStatus": "Since October, an array of dry cooling air-cooled condensers has been added (the array of large fans to the left of the building), and appears almost complete. Two more similar arrays appear to be under construction. More air-cooled chillers, batteries, and gas turbines have also been installed.",
        "buildingsOperational": 1,
        "itNameplateMw": 239,
        "facilityNameplateMw": 323,
        "kind": "observed"
      },
      {
        "site": "Colossus 2",
        "date": "2026-04-06",
        "period": "2026-Q2",
        "constructionStatus": "The first array of dry cooling air-cooled condensers for Building 1 has been completed and is operational. A second array, with larger fans, is about halfway complete (located to the south of the first array). More chillers have also been added. For Building 2, an array of dry cooling air-cooled condensers of the same type as Building 1's first array is beginning construction. We believe this corresponds to the \"second cluster of 110,000 GB300 processors and 220 megawatts of compute power\" from the [company S-1 filing, page 76](https://www.sec.gov/Archives/edgar/data/1181412/000162828026036936/spaceexplorationtechnologi.htm), with compute power corresponding to GPU server power. This is also consistent with our estimates based on cooling equipment.",
        "buildingsOperational": 1,
        "itNameplateMw": 490,
        "facilityNameplateMw": 661,
        "kind": "observed"
      },
      {
        "site": "Colossus 2",
        "date": "2026-07-01",
        "period": "2026-Q3",
        "constructionStatus": "The site is estimated to have at least ~830 MW of GPU server power, with at least \"at least 220,000 additional GB300 processors and over 400 additional megawatts of compute power\", corresponding to the \"next phase of expansion\" found in the following [company S-1 filing, page 76](https://www.sec.gov/Archives/edgar/data/1181412/000162828026036936/spaceexplorationtechnologi.htm). The timing is based on the air-cooled condensers needing to be complete to handle this power capacity. The second array at MACROHARD and the first array at MACROHARDRR, although both projected to be completed prior, are not enough and more cooling capacity is needed. We estimate this expansion to be completed 90 days after April 6th. On one hand, SpaceXAI has progressively added more capacity in less time with their Colossus projects. On the other hand, 400 MW is more capacity than the previous expansions of 210 MW and 220 MW. We also believe that MACROHARDRR will be partly operational with this expansion, because its air-cooled condensor array is expected to be completed by then and fitting the entire expansion into only MACROHARD would result in extremely high levels of power density.",
        "buildingsOperational": 2,
        "itNameplateMw": 946,
        "facilityNameplateMw": 1276,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Atlanta",
        "date": "2023-04-09",
        "period": "2023-Q2",
        "constructionStatus": "Land clearing begins for southern part (Building 1-2)",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Atlanta",
        "date": "2025-10-14",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 and 2 are [operational](https://news.microsoft.com/source/features/ai/from-wisconsin-to-atlanta-microsoft-connects-datacenters-to-build-its-first-ai-superfactory/). Building 1 looked operational sooner, but the buildings [are paired](https://blogs.microsoft.com/blog/2025/09/18/inside-the-worlds-most-powerful-ai-datacenter/) in the Fairwater design. The roof of Building 4 is almost complete, while mechanical equipment is still being installed.",
        "buildingsOperational": 2,
        "itNameplateMw": 321,
        "facilityNameplateMw": 433,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Atlanta",
        "date": "2026-02-13",
        "period": "2026-Q1",
        "constructionStatus": "Building 4 roof is complete and all mechanical equipment appears to be installed. However, there is still a lot of construction activity around the building.",
        "buildingsOperational": 2,
        "itNameplateMw": 321,
        "facilityNameplateMw": 433,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Atlanta",
        "date": "2026-05-15",
        "period": "2026-Q2",
        "constructionStatus": "Building 4 still has some equipment strewn around the perimeter, so we think it is still going through commissioning. Two new buildings at the campus have shells underway, but we don't know if Microsoft is the tenant for those.",
        "buildingsOperational": 2,
        "itNameplateMw": 321,
        "facilityNameplateMw": 433,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Atlanta",
        "date": "2026-06-14",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 and 4 are operational.",
        "buildingsOperational": 4,
        "itNameplateMw": 636,
        "facilityNameplateMw": 859,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2022-04-14",
        "period": "2022-Q2",
        "constructionStatus": "Land clearing begins for Building 1-2",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2025-06-01",
        "period": "2025-Q2",
        "constructionStatus": "Roof complete on Building 5 (QTS-owned). In the northernmost area, land clearing begins on a new Meta site for Buildings 15-19. Building 1 still has construction work around the building and cooling equipment, so it's unlikely to be operational.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2025-09-20",
        "period": "2025-Q3",
        "constructionStatus": "Building 4 operational. Based on our default estimate of roof-to-operational time.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2025-10-14",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 is operational, based on there being minimal construction work and cars in the main carpark. Building 2 still has some construction work around the building. Building 15 roof is complete. The on-site power at Socrates South and Socrates North has some outlines of gas turbines, to be installed later.",
        "buildingsOperational": 1,
        "itNameplateMw": 76,
        "facilityNameplateMw": 99,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2026-01-18",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 2-6 are operational, based on all equipment being in place, the paved ground, and minimal construction equipment by the buildings. Buildings 7-11 all have some kind of power or cooling equipment lining their right side which are not fully installed. Building 13 has chillers installed. Buildings 15-19 roofs are complete. The Socrates South power plant to the right of Buildings 7-11 has 7 gas turbines in place, judging by the exhaust stacks.",
        "buildingsOperational": 6,
        "itNameplateMw": 339,
        "facilityNameplateMw": 441,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2026-02-27",
        "period": "2026-Q1",
        "constructionStatus": "Building 12 is [operational](https://vantage-dc.com/data-center-locations/north-america/new-albany-ohio)",
        "buildingsOperational": 7,
        "itNameplateMw": 408,
        "facilityNameplateMw": 531,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2026-03-12",
        "period": "2026-Q1",
        "constructionStatus": "The Socrates South power plant to the right of Buildings 7-11 now has 10 natural gas turbines in place, judging by the number of exhaust stacks. Battery backup has been installed nearby. To the north, a new section of tent buildings has begun east of Buildings 15-19. It is unclear how those buildings will be powered, if we assume that the Socrates North power plant is just powering Buildings 15-19.",
        "buildingsOperational": 7,
        "itNameplateMw": 408,
        "facilityNameplateMw": 531,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2026-05-18",
        "period": "2026-Q2",
        "constructionStatus": "Building 7-11 (Meta tents) are operational. In January we saw them look almost complete, with some work still ongoing for power equipment. Assuming 3 more months for commissioning, we expect operation by May.",
        "buildingsOperational": 12,
        "itNameplateMw": 562,
        "facilityNameplateMw": 731,
        "kind": "observed"
      },
      {
        "site": "Meta Prometheus",
        "date": "2026-05-28",
        "period": "2026-Q2",
        "constructionStatus": "Building 13 (Vantage) is operational, based on it starting construction about 3 months after Building 12.",
        "buildingsOperational": 13,
        "itNameplateMw": 631,
        "facilityNameplateMw": 820,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2024-02-09",
        "period": "2024-Q1",
        "constructionStatus": "Land clearing begins in the northern section",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2024-06-10",
        "period": "2024-Q2",
        "constructionStatus": "Land clearing begins in the southern section",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2025-05-10",
        "period": "2025-Q2",
        "constructionStatus": "Roof complete on building 11",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2025-06-23",
        "period": "2025-Q2",
        "constructionStatus": "Buildings 1-7 are operational. Based on all of the roofs being completed for over 5 months.",
        "buildingsOperational": 7,
        "itNameplateMw": 398,
        "facilityNameplateMw": 478,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2025-09-26",
        "period": "2025-Q3",
        "constructionStatus": "Roof complete on building 16. Generators are being installed for buildings 8-15. In the north, Building 17 and 18 are under construction. To the south of buildings 8-16, a concrete pad is visible, and an expanded car park next to it.",
        "buildingsOperational": 7,
        "itNameplateMw": 398,
        "facilityNameplateMw": 478,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2025-10-17",
        "period": "2025-Q4",
        "constructionStatus": "Confirmation that nearly 500,000 chips are operational, which fits buildings 1-7. In an [interview](https://www.youtube.com/watch?v=jwgW_gHI1Vs&t=220s), AWS CEO says \"they're already running...about 500,000 [Trainium2] chips in Indiana today\".",
        "buildingsOperational": 7,
        "itNameplateMw": 398,
        "facilityNameplateMw": 478,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2025-12-23",
        "period": "2025-Q4",
        "constructionStatus": "Buildings 8-11 are operational, given it's been over 7 months since their roofs were complete, and the backup generators and roof chimneys look complete. The roof is almost complete for Building 17 and 18.",
        "buildingsOperational": 11,
        "itNameplateMw": 626,
        "facilityNameplateMw": 751,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2026-02-09",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 12-16 still have a few generators that look incomplete, so they are unlikely to be operational just yet. Buildings 17-18 still have ongoing roof work, no generators. Just south of Buildings 9-16, the outlines of a site for Buildings 19-32 are taking shape.",
        "buildingsOperational": 11,
        "itNameplateMw": 626,
        "facilityNameplateMw": 751,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2026-03-23",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 12-16 are operational. Based on how long previous buildings took, when they were in a similar state to Buildings 12-16 in December.",
        "buildingsOperational": 16,
        "itNameplateMw": 910,
        "facilityNameplateMw": 1092,
        "kind": "observed"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2026-06-03",
        "period": "2026-Q2",
        "constructionStatus": "Buildings 17-18 fully roofed but still having surrounding generators/cooling under construction. Cleared land for buildings 19-32 is still bare, with no building foundations visible yet. Based on satellite imagery.",
        "buildingsOperational": 16,
        "itNameplateMw": 910,
        "facilityNameplateMw": 1092,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2024-05-31",
        "period": "2024-Q2",
        "constructionStatus": "Land clearing begins for northern two buildings (Building 1-2)",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2025-06-28",
        "period": "2025-Q2",
        "constructionStatus": "Building 1 looks close to finishing construction, with chillers in place. OpenAI [stated](https://openai.com/index/five-new-stargate-sites/) that \"Oracle began delivering the first NVIDIA GB200 racks in June.\" The \"tenant improvement\" work [is not due](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025000156) until September, however.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2025-09-26",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 is fully operational around this date. The first phase was \"live\" on September 30 according a Crusoe [announcement](https://www.crusoe.ai/resources/newsroom/crusoe-announces-flagship-abilene-data-center-is-live). While the first phase consists of Building 1 and 2, the language doesn't outright confirm that both buildings are fully operational. The announcement also stated that \"Oracle began delivering the first NVIDIA GB200 racks in June\", and we think 3 months is enough time to ram to 50,000 GB200s in Building 1. The satellite image also suggests that Building 1 is complete (shell and equipment done, many cars neatly parked) while Building 2 is ongoing (trucks and construction equipment still present). The 200 MW [substation](https://www.mortenson.com/projects/abilene-data-center-development) built in 2022 and expanded in 2024 is enough to power both buildings. To the right of Building 2, five gas turbines are in place with five more turbines still under construction. Chillers are partly installed for Building 3. Roof is complete for Building 4. The larger 1 GW substation is not complete yet.",
        "buildingsOperational": 1,
        "itNameplateMw": 105,
        "facilityNameplateMw": 147,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2025-12-24",
        "period": "2025-Q4",
        "constructionStatus": "Building 2 is fully operational. This exact date corresponds to the expected completion date of \"Four (4) data hall spaces and an administrative office build-out\" according to a [TDLR filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025007742), but this date is also consistent with satellite imagery. By January 15, Building 2 looked as finished as Building 1, whereas on September 26 it did not look finished.",
        "buildingsOperational": 2,
        "itNameplateMw": 211,
        "facilityNameplateMw": 295,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2026-01-15",
        "period": "2026-Q1",
        "constructionStatus": "The 1 GW substation looks close to completion. Building 3 appears to have all power and cooling equipment installed, but there are still signs of construction work. This seems on track for operation in 3 months. Building 4 has about 80% of chillers installed. Other buildings have few or no chillers installed.",
        "buildingsOperational": 2,
        "itNameplateMw": 211,
        "facilityNameplateMw": 295,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2026-03-24",
        "period": "2026-Q1",
        "constructionStatus": "Building 3 and 4 look complete, but are not fully operational. Not as many cars are parked next to it as Building 1-2 which suggests they may still be ramping up. Building 4 was due by now according to a [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025014756). Building 5 still has light construction activity, while Building 6 still lacks chillers. The on-site power plant to the right of Building 2 looks complete.",
        "buildingsOperational": 2,
        "itNameplateMw": 211,
        "facilityNameplateMw": 295,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2026-05-23",
        "period": "2026-Q2",
        "constructionStatus": "Buildings 3 and 4 are estimated to be operational. On April 22nd, Oracle [posted](https://x.com/i/status/2047012589302153558) that \"In Abilene, 200MW is already operational\". This suggests that there was still only Building 1 and 2 operational. Since Buildings 3 and 4 looked complete from the outside on March 24th, we give it another month after Oracle's post for them to be operational. This would also give the buildings a similar 1 year 4 months timeline that Buildings 1 took from land clearing to being operational.",
        "buildingsOperational": 4,
        "itNameplateMw": 421,
        "facilityNameplateMw": 590,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2023-07-14",
        "period": "2023-Q3",
        "constructionStatus": "Land clearing begins for Building 1.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2025-09-26",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 cooling and backup generators all look complete from above but there is still construction visible around the building. Building 2 is well underway with a foundation and a complete substation. Large carpark and concrete area north of Building 2. Building 3 has a concrete foundation and a substation underway.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2026-01-28",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 looks complete, but based on Microsoft announcements, it's not fully operational yet. Steel framing is underway for Building 2.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2026-04-16",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 is operational. [X post](https://x.com/satyanadella/status/2044767391293509761?s=61) from Microsoft saying this date for Fairwater becoming operational.",
        "buildingsOperational": 1,
        "itNameplateMw": 369,
        "facilityNameplateMw": 442,
        "kind": "observed"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2026-05-15",
        "period": "2026-Q2",
        "constructionStatus": "The main shell of Building 2 looks almost completed. In Area 2 (northwest of Buildings 1-2), the grading for the original design has been replaced with grading for the new [9-building design](https://www.mtpleasantwi.gov/AgendaCenter/ViewFile/Agenda/_01212026-1292), making way for Buildings 3-11. Work continues on the northern substation in Area 2.",
        "buildingsOperational": 1,
        "itNameplateMw": 369,
        "facilityNameplateMw": 442,
        "kind": "observed"
      },
      {
        "site": "Meta Montgomery",
        "date": "2025-03-01",
        "period": "2025-Q1",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Montgomery",
        "date": "2025-07-04",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 and 2 under construction, with all chillers visible.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Montgomery",
        "date": "2026-03-20",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 1 and 2 are nearly complete, but there's still some equipment strewn around the site and few cars in the front carpark, so we expect 3 more months needed for commissioning and server installation. Building 3 has a half-finished roof and Building 4 shell is beginning construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Montgomery",
        "date": "2026-06-18",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 and 2 are operational (estimate).",
        "buildingsOperational": 2,
        "itNameplateMw": 153,
        "facilityNameplateMw": 199,
        "kind": "observed"
      },
      {
        "site": "DayOne Nusajaya",
        "date": "2023-10-01",
        "period": "2023-Q4",
        "constructionStatus": "Construction for Building 1-2 is underway.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "DayOne Nusajaya",
        "date": "2024-12-31",
        "period": "2024-Q4",
        "constructionStatus": "Buildings 1-2 are fully operational. Based on DayOne [reporting](https://web.archive.org/web/20241231165420/https://dayonedc.com/) that 120 MW is in operation in Johor, with [50 MW](https://www.moomoo.com/news/post/41886329/support-ai-computing-deployment-gds-holdings-nusajaya-technology-park-datacenter?level=1&data_ticket=1778269491837872) towards Buildings 4-5. The date is based on the earliest available archived webpage, so this may have happened earlier.",
        "buildingsOperational": 2,
        "itNameplateMw": 50,
        "facilityNameplateMw": 70,
        "kind": "observed"
      },
      {
        "site": "DayOne Nusajaya",
        "date": "2026-01-22",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 3-6 are operational, based on them looking complete. DayOne [reported](https://archive.is/8CFXN) that 390 MW is \"in service\" in Johor as of Jan 30. This is across both Nusajaya (including Phase 1, which we don't include here) and Kempas, but Nusajaya is the vast majority of capacity at this time. Building 7 and 8 look almost complete, while Building 9 and 10 shells are still under construction.",
        "buildingsOperational": 6,
        "itNameplateMw": 240,
        "facilityNameplateMw": 336,
        "kind": "observed"
      },
      {
        "site": "DayOne Nusajaya",
        "date": "2026-04-05",
        "period": "2026-Q2",
        "constructionStatus": "Buildings 7-10 look mostly complete, but there is still some construction work at the edges.",
        "buildingsOperational": 6,
        "itNameplateMw": 240,
        "facilityNameplateMw": 336,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2024-04-24",
        "period": "2024-Q2",
        "constructionStatus": "Construction starts with a road added on site, retrofitting a former Electrolux building.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2024-08-11",
        "period": "2024-Q3",
        "constructionStatus": "First [significant/useful training workload](https://x.ai/colossus) on 25k H100s.",
        "buildingsOperational": 1,
        "itNameplateMw": 35,
        "facilityNameplateMw": 45,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2024-09-02",
        "period": "2024-Q3",
        "constructionStatus": "[100k H100s online](https://archive.is/z39uN).",
        "buildingsOperational": 1,
        "itNameplateMw": 139,
        "facilityNameplateMw": 181,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2025-02-17",
        "period": "2025-Q1",
        "constructionStatus": "150k H100s and 50k H200s online. This is roughly when [Musk](https://archive.is/z39uN) [said](https://archive.is/z39uN), plus on this date they reported \"running jobs with 150K+ GPUs\".",
        "buildingsOperational": 1,
        "itNameplateMw": 278,
        "facilityNameplateMw": 361,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2025-03-06",
        "period": "2025-Q1",
        "constructionStatus": "Second substation almost connected (red cables)",
        "buildingsOperational": 1,
        "itNameplateMw": 278,
        "facilityNameplateMw": 361,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2025-07-22",
        "period": "2025-Q3",
        "constructionStatus": "30k B200s [added](https://archive.is/oHQSA) (in GB200 configuration).",
        "buildingsOperational": 1,
        "itNameplateMw": 340,
        "facilityNameplateMw": 442,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2025-09-17",
        "period": "2025-Q3",
        "constructionStatus": "Third substation looks completed, but it doesn't appear to be connected to the building yet. Some air-cooled chillers removed, while large cooling towers are added.",
        "buildingsOperational": 1,
        "itNameplateMw": 268,
        "facilityNameplateMw": 348,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2025-10-19",
        "period": "2025-Q4",
        "constructionStatus": "There is still construction visible in the third substation yard and next to the new cooling towers.",
        "buildingsOperational": 1,
        "itNameplateMw": 268,
        "facilityNameplateMw": 348,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2025-11-07",
        "period": "2025-Q4",
        "constructionStatus": "Third substation was expected to power the building in Fall.",
        "buildingsOperational": 1,
        "itNameplateMw": 340,
        "facilityNameplateMw": 442,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2026-02-11",
        "period": "2026-Q1",
        "constructionStatus": "All air-cooled chillers have been disconnected and/or removed from the site, leaving only the cooling towers for cooling. The third substation looks complete, with red cables connected to the building.",
        "buildingsOperational": 1,
        "itNameplateMw": 340,
        "facilityNameplateMw": 425,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2026-05-06",
        "period": "2026-Q2",
        "constructionStatus": "Anthropic [announces](https://www.anthropic.com/news/higher-limits-spacex) their agreement with SpaceX to use all of the compute capacity at Colossus 1. They state that this corresponds to more than 300 MW (presumably IT power) and over 220,000 GPUs. This is slightly different to previous reports adding up to 230,000 GPUs, but still roughly consistent with our estimates.",
        "buildingsOperational": 1,
        "itNameplateMw": 340,
        "facilityNameplateMw": 425,
        "kind": "observed"
      },
      {
        "site": "Colossus 1",
        "date": "2026-06-15",
        "period": "2026-Q2",
        "constructionStatus": "No major changes to the data center since February. Solar panels have been placed next to the facility.",
        "buildingsOperational": 1,
        "itNameplateMw": 340,
        "facilityNameplateMw": 425,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Denton TX",
        "date": "2024-12-15",
        "period": "2024-Q4",
        "constructionStatus": "Construction start - Converting existing Bitcoin mining buildings into AI data centers.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Denton TX",
        "date": "2025-05-31",
        "period": "2025-Q2",
        "constructionStatus": "First 8 MW billable tranche dedicated to AI starts running at the site, with another 40 scheduled by the end of the quarter.",
        "buildingsOperational": 1,
        "itNameplateMw": 8,
        "facilityNameplateMw": 11.2,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Denton TX",
        "date": "2025-12-31",
        "period": "2025-Q4",
        "constructionStatus": "67 billable MW dedicated for CoreWeave's AI across three buildings. Half the campus energized.",
        "buildingsOperational": 3,
        "itNameplateMw": 67,
        "facilityNameplateMw": 93.8,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Denton TX",
        "date": "2026-02-23",
        "period": "2026-Q1",
        "constructionStatus": "Satellite imagery shows Denton North largely built out/operational and Denton South first data hall plus support equipment substantially installed. Remaining Denton South buildings still under construction.",
        "buildingsOperational": 3,
        "itNameplateMw": 131,
        "facilityNameplateMw": 183.4,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Denton TX",
        "date": "2026-03-02",
        "period": "2026-Q1",
        "constructionStatus": "Denton North is fully operational running AI (Denton North at 90 MW, Denton South partially running at 41)",
        "buildingsOperational": 3,
        "itNameplateMw": 131,
        "facilityNameplateMw": 183.4,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Denton TX",
        "date": "2026-06-30",
        "period": "2026-Q2",
        "constructionStatus": "Remaining Denton South buildings scheduled to complete by midyear 2026, running the full CoreWeave contracted load.",
        "buildingsOperational": 6,
        "itNameplateMw": 262,
        "facilityNameplateMw": 366.8,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2023-10-01",
        "period": "2023-Q4",
        "constructionStatus": "Land cleared for site expansion, some materials down at substation site. We assume that Buildings 1 and 2 are not running AI workloads at this point due to the lack of cooling infrastructure.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2023-11-02",
        "period": "2023-Q4",
        "constructionStatus": "Building 1 and 2 retrofitting has begun (see [Google Earth](https://earth.google.com/web/@37.48913637,-77.24705465,44.31788662a,1464.06665017d,30.00094375y,3.66969189h,0t,0r/data=ChYqEAgBEgoyMDIzLTExLTAyGAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE)). Building 1 has chillers added to the roof and perimeter, and backup generators added to the perimeter.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2024-01-29",
        "period": "2024-Q1",
        "constructionStatus": "Building 1 (retrofitted) is operational. This is based on it looking complete, and cooling towers possibly showing water vapor plumes, in this [Google Earth image](https://earth.google.com/web/@37.4875167,-77.24806799,43.67572425a,2395.6622579d,30.00094375y,3.66969189h,0t,0r/data=ChYqEAgBEgoyMDI0LTAyLTA2GAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE). Building 2 has chillers added to the roof and perimeter, and backup generators added to the perimeter. Cooling towers near Building 2 have been removed.  Building 3 shell is under construction.",
        "buildingsOperational": 1,
        "itNameplateMw": 47,
        "facilityNameplateMw": 66,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2024-06-23",
        "period": "2024-Q2",
        "constructionStatus": "Building 2 (retrofitted) is operational. This is based on Building 2 looking compelte, and construction around Building 1 and 2 being mostly cleared. A colored motion artifact on one of the Building 1 cooling tower fans suggests it is moving. Building 3 cooling is installed, backup generators partly installed. Building 4 shell is under construction.",
        "buildingsOperational": 2,
        "itNameplateMw": 94,
        "facilityNameplateMw": 132,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2025-02-04",
        "period": "2025-Q1",
        "constructionStatus": "Building 3 is operational, based on the building looking complete and the carpark to the south being full. Three more backup generators added to the Building 1 and 2 area, with a lot more construction equipment again (but this could be a laydown area for Richmond 2). Building 4 has cooling and backup generators fully installed. Building 5 has cooling installed, and backup generators partly installed.",
        "buildingsOperational": 3,
        "itNameplateMw": 142,
        "facilityNameplateMw": 199,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2025-06-03",
        "period": "2025-Q2",
        "constructionStatus": "Building 4 is operational, based on a complete building and full carpark in a [Google Earth image](https://earth.google.com/web/@37.48350155,-77.25010039,60.24751599a,83.68032361d,30.00094375y,3.66969189h,0t,0r/data=CgwqBggBEgAYAUICCAEyKQonCiUKITFZU1hJZlBmRzJ1dUxibWdQOTJzY05sTVB6cXVUZFVXZyABOgMKATBCAggASggIw4mB_QIQAQ). Building 5 does not seem quite operational given the empty carpark and construction activity at the perimeter.",
        "buildingsOperational": 4,
        "itNameplateMw": 190,
        "facilityNameplateMw": 266,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2025-11-19",
        "period": "2025-Q4",
        "constructionStatus": "Building 5 is operational, based on a complete building and full carpark in a [Google Earth image](https://earth.google.com/web/@37.48747566,-77.2485616,47.03705985a,2549.72172121d,30.00094375y,3.66969189h,0t,0r/data=ChYqEAgBEgoyMDI1LTExLTE5GAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE). Construction equipment around Building 1 and 2 has cleared up again.",
        "buildingsOperational": 5,
        "itNameplateMw": 238,
        "facilityNameplateMw": 333,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2025-12-31",
        "period": "2025-Q4",
        "constructionStatus": "No changes to the site since November 2025.",
        "buildingsOperational": 5,
        "itNameplateMw": 238,
        "facilityNameplateMw": 333,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 1",
        "date": "2026-02-13",
        "period": "2026-Q1",
        "constructionStatus": "No changes to the site since December 2025.",
        "buildingsOperational": 5,
        "itNameplateMw": 238,
        "facilityNameplateMw": 333,
        "kind": "observed"
      },
      {
        "site": "Meta Rosemount",
        "date": "2024-05-30",
        "period": "2024-Q2",
        "constructionStatus": "Land is cleared.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Rosemount",
        "date": "2026-03-21",
        "period": "2026-Q1",
        "constructionStatus": "Both buildings and their cooling infrastructure look complete, but the site probably isn't commissioned (tested) yet, and few cars are parked to the right of Building 1. We give another 3 months before it's operational.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Rosemount",
        "date": "2026-06-19",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 and 2 are operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 178,
        "facilityNameplateMw": 241,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2021-10-01",
        "period": "2021-Q4",
        "constructionStatus": "Land clearing begins on the eastern half of the site, for Buildings 1-2",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2023-07-01",
        "period": "2023-Q3",
        "constructionStatus": "Building 2 foundation work begins. Building 1 generators seem complete, cooling towers still under construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2024-04-01",
        "period": "2024-Q2",
        "constructionStatus": "Building 1 operational. No visible construction and roads/parking complete around the building. Building 2 chillers are beginning construction. Foundation work begins for Building 3.",
        "buildingsOperational": 1,
        "itNameplateMw": 65,
        "facilityNameplateMw": 78,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2025-03-01",
        "period": "2025-Q1",
        "constructionStatus": "Building 2 operational. Parking complete, no more visible construction.",
        "buildingsOperational": 2,
        "itNameplateMw": 130,
        "facilityNameplateMw": 156,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2025-10-01",
        "period": "2025-Q4",
        "constructionStatus": "Building 3 operational. Surrounding roads finished, no more visible construction.",
        "buildingsOperational": 3,
        "itNameplateMw": 216,
        "facilityNameplateMw": 260,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2026-02-21",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 1-3 are visibly operational, with steam coming out of the cooling towers. Meanwhile Building 4 is extremely close to completion, with all backup generators complete with only 3 cooling towers missing their fans. ~1/2 the generators are installed for Building 5, and the roof is mostly complete (starting to install the final white layer, with the actual roof structure already complete).",
        "buildingsOperational": 3,
        "itNameplateMw": 216,
        "facilityNameplateMw": 260,
        "kind": "observed"
      },
      {
        "site": "Google Columbus",
        "date": "2026-05-01",
        "period": "2026-Q2",
        "constructionStatus": "Building 4 operational. No more visible construction, and since only 3 fans needed to be installed since Feburary, operational date was likely soon after. Building 5 roof almost complete.",
        "buildingsOperational": 4,
        "itNameplateMw": 303,
        "facilityNameplateMw": 364,
        "kind": "observed"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2023-10-02",
        "period": "2023-Q4",
        "constructionStatus": "Land clearing begins",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2025-03-11",
        "period": "2025-Q1",
        "constructionStatus": "Generators and chillers still being installed on buildings 1-5.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2025-06-23",
        "period": "2025-Q2",
        "constructionStatus": "Buildings 1-5 are operational, based on roofs being completed 5 months ago and generators being installed by 2025-04-10.",
        "buildingsOperational": 5,
        "itNameplateMw": 284,
        "facilityNameplateMw": 341,
        "kind": "observed"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2025-10-04",
        "period": "2025-Q4",
        "constructionStatus": "Confirmation that five buildings are fully equipped with cooling and backup generators.",
        "buildingsOperational": 5,
        "itNameplateMw": 284,
        "facilityNameplateMw": 341,
        "kind": "observed"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2026-06-04",
        "period": "2026-Q2",
        "constructionStatus": "Buildings 6 and 7 roof completed. Building 8 roof nearly completed. Building 9 roof half way up. No new operational buildings.",
        "buildingsOperational": 5,
        "itNameplateMw": 284,
        "facilityNameplateMw": 341,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2024-04-20",
        "period": "2024-Q2",
        "constructionStatus": "Building 1 is operational. Based on ~7 months since roof being completed, and cooling towers being installed sometime within that period. Building 2 roof is complete.",
        "buildingsOperational": 1,
        "itNameplateMw": 68,
        "facilityNameplateMw": 81,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2024-09-13",
        "period": "2024-Q3",
        "constructionStatus": "Building 2 is operational. Google Earth imagery shows 6 cooling towers installed as of 2024-04-20, and a final 7th unit appeared as of 2024-09-13, with minimal construction around the building. Building 3 roof is also complete.",
        "buildingsOperational": 2,
        "itNameplateMw": 147,
        "facilityNameplateMw": 177,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2025-06-01",
        "period": "2025-Q2",
        "constructionStatus": "Building 3 is operational, based on all cooling units and tanks installed, minimal construction work around the building. Building 4 still has some work around the cooling towers. Work is underway on Building 5 - some walls and a few backup generators are in place.",
        "buildingsOperational": 3,
        "itNameplateMw": 226,
        "facilityNameplateMw": 272,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2025-10-14",
        "period": "2025-Q4",
        "constructionStatus": "Building 4 is operational, based on all cooling units and tanks installed, minimal construction work around the building. Building 5 roof is half complete. About half of the backup generators are in place. One cooling tower is partly built.",
        "buildingsOperational": 4,
        "itNameplateMw": 339,
        "facilityNameplateMw": 407,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2026-01-18",
        "period": "2026-Q1",
        "constructionStatus": "Water vapor from cooling towers is present across Building 1-4, confirming their operation. Building 5 roof is still incomplete, but most backup generators and 5 cooling towers have been installed.",
        "buildingsOperational": 4,
        "itNameplateMw": 339,
        "facilityNameplateMw": 407,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2026-03-12",
        "period": "2026-Q1",
        "constructionStatus": "Building 5 has more cooling towers installed but not complete, and the roof is almost complete.",
        "buildingsOperational": 4,
        "itNameplateMw": 339,
        "facilityNameplateMw": 407,
        "kind": "observed"
      },
      {
        "site": "Google New Albany",
        "date": "2026-05-18",
        "period": "2026-Q2",
        "constructionStatus": "Building 5 has all cooling towers installed, and all other components look complete, but there is still light work around the building. Based on that, we estimate 3 more months until operational.",
        "buildingsOperational": 4,
        "itNameplateMw": 339,
        "facilityNameplateMw": 407,
        "kind": "observed"
      },
      {
        "site": "Microsoft Goodyear",
        "date": "2021-06-21",
        "period": "2021-Q2",
        "constructionStatus": "Land clearing begins for Building 1.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft Goodyear",
        "date": "2023-04-24",
        "period": "2023-Q2",
        "constructionStatus": "Building 1 operational. Based on interpolating satellite images from Sentinel-2 and Google Earth.",
        "buildingsOperational": 1,
        "itNameplateMw": 40,
        "facilityNameplateMw": 53,
        "kind": "observed"
      },
      {
        "site": "Microsoft Goodyear",
        "date": "2025-01-16",
        "period": "2025-Q1",
        "constructionStatus": "Building 2 operational. Based on interpolating satellite images from Sentinel-2 and Google Earth.",
        "buildingsOperational": 2,
        "itNameplateMw": 81,
        "facilityNameplateMw": 105,
        "kind": "observed"
      },
      {
        "site": "Microsoft Goodyear",
        "date": "2025-09-01",
        "period": "2025-Q3",
        "constructionStatus": "Building 3 and 4 operational. Based on interpolating satellite images from Sentinel-2 and Google Earth.",
        "buildingsOperational": 4,
        "itNameplateMw": 202,
        "facilityNameplateMw": 263,
        "kind": "observed"
      },
      {
        "site": "Microsoft Goodyear",
        "date": "2025-11-12",
        "period": "2025-Q4",
        "constructionStatus": "Confirmation that Building 3 and 4 look complete.",
        "buildingsOperational": 4,
        "itNameplateMw": 202,
        "facilityNameplateMw": 263,
        "kind": "observed"
      },
      {
        "site": "Microsoft Goodyear",
        "date": "2026-04-27",
        "period": "2026-Q2",
        "constructionStatus": "Foundations appear to be underway for Building 5 and 6, just north of Building 4.",
        "buildingsOperational": 4,
        "itNameplateMw": 202,
        "facilityNameplateMw": 263,
        "kind": "observed"
      },
      {
        "site": "Meta Jeffersonville",
        "date": "2024-02-01",
        "period": "2024-Q1",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Jeffersonville",
        "date": "2026-03-06",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 and 2 shell and cooling look complete, but there's still construction activity. We give it another 3 months to operational.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Jeffersonville",
        "date": "2026-06-04",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 and 2 are operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 178,
        "facilityNameplateMw": 241,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2022-04-01",
        "period": "2022-Q2",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2024-01-29",
        "period": "2024-Q1",
        "constructionStatus": "Building 1 and 2 look complete but we don't think they are operational, as the substation is still under construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2024-06-23",
        "period": "2024-Q2",
        "constructionStatus": "Still not many cars parked at Building 1 and 2, and the east substation looks very close to completion, based on a [Google Earth image](https://earth.google.com/web/@37.48655608,-77.24244153,55.96289131a,2859.52501034d,30.00094375y,0h,0.5917603t,0r/data=ChYqEAgBEgoyMDI0LTA2LTIzGAFCAggBMikKJwolCiExWVNYSWZQZkcydXVMYm1nUDkyc2NObE1QenF1VGRVV2cgAToDCgEwQgIIAEoICMOJgf0CEAE).",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2025-02-04",
        "period": "2025-Q1",
        "constructionStatus": "Building 1 and 2 are operational, based on the east substation looking complete and the carparks being more full. Building 3 has cooling and generators mostly installed. Building 4 roof is partly completed.",
        "buildingsOperational": 2,
        "itNameplateMw": 72,
        "facilityNameplateMw": 101,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2025-11-19",
        "period": "2025-Q4",
        "constructionStatus": "The west substation looks complete, based on a [Google Earth image](https://earth.google.com/web/@37.48673632,-77.24119214,61.15398527a,3616.77426559d,30.00094375y,0.00000001h,0.59183057t,0r/data=CgwqBggBEgAYAUICCAEyKQonCiUKITFZU1hJZlBmRzJ1dUxibWdQOTJzY05sTVB6cXVUZFVXZyABOgMKATBCAggASggIw4mB_QIQAQ). This image also shows one corner of Building 5 that still has construction work, so it's probably not operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 72,
        "facilityNameplateMw": 101,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2025-12-31",
        "period": "2025-Q4",
        "constructionStatus": "Building 3 and 4 are operational, based on the substation being completed earlier, the buildings looking complete, and carparks being moderately full. Building 5 still has construction work.",
        "buildingsOperational": 4,
        "itNameplateMw": 144,
        "facilityNameplateMw": 202,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2026-02-13",
        "period": "2026-Q1",
        "constructionStatus": "Building 5 still has construction work at the perimeter, but given how close it looks to completion, we estimate it's only about 3 months away from operational.",
        "buildingsOperational": 4,
        "itNameplateMw": 144,
        "facilityNameplateMw": 202,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 2",
        "date": "2026-05-14",
        "period": "2026-Q2",
        "constructionStatus": "Building 5 is estimated to be operational, based on the previous entry.",
        "buildingsOperational": 5,
        "itNameplateMw": 180,
        "facilityNameplateMw": 252,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2024-04-01",
        "period": "2024-Q2",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2025-02-04",
        "period": "2025-Q1",
        "constructionStatus": "Building 1 shell is mostly complete, with some chillers installed on the roof. Building 2 shell is under construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2025-11-19",
        "period": "2025-Q4",
        "constructionStatus": "The substation is still under construction, based on a [Google Earth image](https://earth.google.com/web/@37.48033002,-77.25002949,65.53442036a,2152.9927926d,30.00094375y,-0.00000001h,0.59169466t,0r/data=CgwqBggBEgAYAUICCAEyKQonCiUKITFZU1hJZlBmRzJ1dUxibWdQOTJzY05sTVB6cXVUZFVXZyABOgMKATBCAggASggIw4mB_QIQAQ), so we don't think any buildings are operational yet.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2025-12-31",
        "period": "2025-Q4",
        "constructionStatus": "The substation looks complete, but we expect Building 1 still needs commissioning before it is fully operational.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2026-02-13",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 is operational, based on the substation being completed earlier and cars in the carpark. Building 2 and 3 are not operational, based on minor construction work at the perimeter and no cars in the carpark, but we expect they will be operational within 3 months. Building 4 has complete chillers and backup generators, while Building 5 has chillers but only a few backup generators - roughly the state of Building 1 on 2025-02-04.",
        "buildingsOperational": 1,
        "itNameplateMw": 48,
        "facilityNameplateMw": 67,
        "kind": "observed"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2026-05-14",
        "period": "2026-Q2",
        "constructionStatus": "Building 2 and 3 are operational, based on the previous entry.",
        "buildingsOperational": 3,
        "itNameplateMw": 144,
        "facilityNameplateMw": 202,
        "kind": "observed"
      },
      {
        "site": "Meta Kuna",
        "date": "2022-10-03",
        "period": "2022-Q4",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Kuna",
        "date": "2026-03-15",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 and 2 look complete from outside, with all electrical and cooling equipment installed. Construction has started on 2 smaller buldings to the north. Meta announced the arrival of the first server rack the following week.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Kuna",
        "date": "2026-06-01",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 and 2 are operational. The 2nd phase of an offsetting solar array goes online on May 31, 2026.  Idaho Public Utilities Comission's approval for this start date notes that \"[Meta]’s load is expected to increase so much that it will suffer a capacity deficit in June 2026 if served only by Pleasant Valley Solar 1.1,” A redacted table in the staff comments document suggests the data center's load will continue to increase through August, when it presumably reaches the maximum capacity of both buildings.",
        "buildingsOperational": 2,
        "itNameplateMw": 152,
        "facilityNameplateMw": 198,
        "kind": "observed"
      },
      {
        "site": "Meta Temple",
        "date": "2022-04-01",
        "period": "2022-Q2",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Temple",
        "date": "2023-02-05",
        "period": "2023-Q1",
        "constructionStatus": "A traditional H-shaped Meta data center is partially built.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Temple",
        "date": "2023-04-01",
        "period": "2023-Q2",
        "constructionStatus": "The traditional Meta data center has been demolished mid-construction, in favor of Meta's new AI-optimized design.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Temple",
        "date": "2025-11-15",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 and 2 look complete from outside, with all electrical and cooling equipment installed. Space is cleared for Building 3.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Temple",
        "date": "2025-12-09",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 and 2 are operational. Activity related to the air quality permit (namely, emergency diesel generators) was reported to have started as of 2025-12-09. This is our best estimate, but note that the planned completion date in this [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2022017728) is 2026-03-01.",
        "buildingsOperational": 2,
        "itNameplateMw": 152,
        "facilityNameplateMw": 198,
        "kind": "observed"
      },
      {
        "site": "Amazon Ridgeland",
        "date": "2024-02-24",
        "period": "2024-Q1",
        "constructionStatus": "Land clearing begins",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Amazon Ridgeland",
        "date": "2025-10-04",
        "period": "2025-Q4",
        "constructionStatus": "Roof complete on Buildings 3",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Amazon Ridgeland",
        "date": "2026-05-15",
        "period": "2026-Q2",
        "constructionStatus": "Buildings 1-4 are operational, based on the buildings shells and backup generators and most of the landscaping looking complete. Building 5 roof is complete but still lacks cooling equipment.",
        "buildingsOperational": 4,
        "itNameplateMw": 228,
        "facilityNameplateMw": 273,
        "kind": "observed"
      },
      {
        "site": "Google Council Bluffs (East)",
        "date": "2022-09-06",
        "period": "2022-Q3",
        "constructionStatus": "Land clearing begins for east buildings",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Council Bluffs (East)",
        "date": "2024-11-19",
        "period": "2024-Q4",
        "constructionStatus": "Building 1 is operational. Google Earth shows Building 1 had all backup generators and cooling towers installed by the end of August, but construction work was ongoing and there were almost no cars parked. By February 2025, Google Earth shows no construction work and many cars. So our best guess is in the middle, in November 2024. Building 3 roof is complete.",
        "buildingsOperational": 1,
        "itNameplateMw": 79,
        "facilityNameplateMw": 95,
        "kind": "observed"
      },
      {
        "site": "Google Council Bluffs (East)",
        "date": "2025-06-15",
        "period": "2025-Q2",
        "constructionStatus": "Building 2 is operational. Assuming it takes 3 months after generators and cooling towers are finished, similar to Building 1.",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 190,
        "kind": "observed"
      },
      {
        "site": "Google Council Bluffs (East)",
        "date": "2025-07-19",
        "period": "2025-Q3",
        "constructionStatus": "Land clearing begins in the southwest, suggesting more buildings are planned.",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 190,
        "kind": "observed"
      },
      {
        "site": "Google Council Bluffs (East)",
        "date": "2026-01-11",
        "period": "2026-Q1",
        "constructionStatus": "Building 3 has all 34 backup generators installed and 4 cooling towers installed, with 3 more cooling towers under construction. There are gaps between cooling towers suggesting that more could be added. Buildings 1 and 2 are running close to full capacity, given that water vapor is coming out of 5 of 7 cooling towers for each building. The land cleared in the southwest appears to be shaped for two more similar buildings, with notches for substations.",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 190,
        "kind": "observed"
      },
      {
        "site": "Google Council Bluffs (East)",
        "date": "2026-06-10",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 is operational. Assuming it takes 2 months to install all 7 cooling towers, then another 3 months for final touches and commissioning.",
        "buildingsOperational": 3,
        "itNameplateMw": 237,
        "facilityNameplateMw": 284,
        "kind": "observed"
      },
      {
        "site": "Coreweave Helios",
        "date": "2025-05-31",
        "period": "2025-Q2",
        "constructionStatus": "The former [crypto mining](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Commitment-with-CoreWeave-to-Host-Additional-Artificial-Intelligence-and-High-Performance-Computing-Infrastructure-at-Helios-Data-Center-Campus/default.aspx) Helios site begins expanding, with land cleared for additional buildings.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Coreweave Helios",
        "date": "2025-08-27",
        "period": "2025-Q3",
        "constructionStatus": "Backup generator pads and steel framing for chillers are visible, similar to the [3D renderings](https://www.galaxy.com/data-centers).",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Coreweave Helios",
        "date": "2026-04-04",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 appears substantially complete. The main white-roofed data hall is visible with exterior mechanical/electrical equipment rows installed on both sides, and adjacent generator/equipment pads plus laydown yards are active. A large graded pad north of Building 1 suggests preparation for the next phase/building. No clear satellite evidence that the AI/HPC facility is operational yet.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Coreweave Helios",
        "date": "2026-06-30",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 operational at full capacity. This corresponds to \"Phase I\", which is [expected](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Third-Quarter-2025-Financial-Results/default.aspx) to be operational by the end of the first half of 2026.",
        "buildingsOperational": 1,
        "itNameplateMw": 132,
        "facilityNameplateMw": 200,
        "kind": "observed"
      },
      {
        "site": "Microsoft Project Osmium",
        "date": "2018-12-18",
        "period": "2018-Q4",
        "constructionStatus": "Land clearing begins on the north part of the site",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft Project Osmium",
        "date": "2021-01-01",
        "period": "2021-Q1",
        "constructionStatus": "Building 1 and 1st building on the site are operational. Foundation work begins on Building 2",
        "buildingsOperational": 1,
        "itNameplateMw": 48,
        "facilityNameplateMw": 57,
        "kind": "observed"
      },
      {
        "site": "Microsoft Project Osmium",
        "date": "2023-06-30",
        "period": "2023-Q2",
        "constructionStatus": "Building 2 is operational. Estimated based on Microsoft H100 count 2023",
        "buildingsOperational": 2,
        "itNameplateMw": 95,
        "facilityNameplateMw": 114,
        "kind": "observed"
      },
      {
        "site": "Microsoft Project Osmium",
        "date": "2025-03-01",
        "period": "2025-Q1",
        "constructionStatus": "Building 3-4 operational, no visible construction.",
        "buildingsOperational": 4,
        "itNameplateMw": 190,
        "facilityNameplateMw": 228,
        "kind": "observed"
      },
      {
        "site": "Microsoft Project Osmium",
        "date": "2025-10-08",
        "period": "2025-Q4",
        "constructionStatus": "Site already complete.",
        "buildingsOperational": 4,
        "itNameplateMw": 190,
        "facilityNameplateMw": 228,
        "kind": "observed"
      },
      {
        "site": "Microsoft Project Osmium",
        "date": "2026-06-16",
        "period": "2026-Q2",
        "constructionStatus": "No notable changes since October.",
        "buildingsOperational": 4,
        "itNameplateMw": 190,
        "facilityNameplateMw": 228,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Chester VA",
        "date": "2023-09-18",
        "period": "2023-Q3",
        "constructionStatus": "Conversion starts at CTP-01 (Building 1). The data center was formerly owned by Capital One, now leased to CoreWeave. Source: https://www.datacenterdynamics.com/en/news/chirisa-secures-200-million-loan-to-fit-out-virginia-data-center-for-coreweave/",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Chester VA",
        "date": "2024-01-31",
        "period": "2024-Q1",
        "constructionStatus": "Building 1's second data hall scheduled to come online this month.",
        "buildingsOperational": 1,
        "itNameplateMw": 18,
        "facilityNameplateMw": 25,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Chester VA",
        "date": "2024-04-30",
        "period": "2024-Q2",
        "constructionStatus": "Building 1 is scheduled to be fully online by this point, so I count the full 27 MW here.",
        "buildingsOperational": 1,
        "itNameplateMw": 27,
        "facilityNameplateMw": 38,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Chester VA",
        "date": "2025-01-22",
        "period": "2025-Q1",
        "constructionStatus": "Satellite imagery shows Building 1 complete, with Building 2's yard work and early construction visible. Building 3 hasn't started yet, since the old building is still there.",
        "buildingsOperational": 1,
        "itNameplateMw": 27,
        "facilityNameplateMw": 38,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Chester VA",
        "date": "2026-05-20",
        "period": "2026-Q2",
        "constructionStatus": "Based on satellite imagery, Building 3 has cleared its land and is beginning construction. Building 2 is operational judging from the colored motion artifacts on the cooling tower fans.",
        "buildingsOperational": 2,
        "itNameplateMw": 82,
        "facilityNameplateMw": 114,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2021-11-25",
        "period": "2021-Q4",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2024-04-08",
        "period": "2024-Q2",
        "constructionStatus": "Building 1 operational, based on it being 6 months after roof was complete, infrastructure looked complete for 5 months.",
        "buildingsOperational": 1,
        "itNameplateMw": 79,
        "facilityNameplateMw": 95,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2024-07-29",
        "period": "2024-Q3",
        "constructionStatus": "Building 2 has 3 cooling towers installed.",
        "buildingsOperational": 1,
        "itNameplateMw": 79,
        "facilityNameplateMw": 95,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2024-11-19",
        "period": "2024-Q4",
        "constructionStatus": "Building 2 is operational, based on it being 8 months since the roof was complete, and surrounding infrastructure looks just completed (finishing the cooling towers).",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 189,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2025-03-16",
        "period": "2025-Q1",
        "constructionStatus": "Confirmation that there's no obvious construction happening for Building 2. Building 3 roof started.",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 189,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2025-04-21",
        "period": "2025-Q2",
        "constructionStatus": "Confident that Building 2 is operational",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 189,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2025-10-21",
        "period": "2025-Q4",
        "constructionStatus": "Building 3 has all backup generators in place but they are still being installed. Two cooling towers have fans on them, with more underway. To the south of Building 3, more land has been cleared and there's a new carpark. This suggests another building will soon start construction.",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 189,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2026-05-15",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 appears almost complete, with only minimal construction work and equipment remaining. The cooling towers are spaced apart in an unusual way, but there's no obvious sign that more will be installed before operation. Buildings 4 and 5 haven't started construction yet, the cleared land is still empty.",
        "buildingsOperational": 2,
        "itNameplateMw": 158,
        "facilityNameplateMw": 189,
        "kind": "observed"
      },
      {
        "site": "Google Omaha",
        "date": "2026-06-30",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 is operational (estimate). Based on there being minimal construction work as of May 15.",
        "buildingsOperational": 3,
        "itNameplateMw": 237,
        "facilityNameplateMw": 284,
        "kind": "observed"
      },
      {
        "site": "Alibaba Zhangbei",
        "date": "2024-07-23",
        "period": "2024-Q3",
        "constructionStatus": "New chiller configuration starts getting installed on Building 1-3.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Alibaba Zhangbei",
        "date": "2025-09-17",
        "period": "2025-Q3",
        "constructionStatus": "Large substation is visibly connected to transmission lines. New chillers look fully installed on Building 1-3. Since power and cooling is apparently in place, we expect Building 1-3 are operational. Chillers are almost installed on Building 4-6, with construction equipment still around the building.",
        "buildingsOperational": 3,
        "itNameplateMw": 85,
        "facilityNameplateMw": 102,
        "kind": "observed"
      },
      {
        "site": "Alibaba Zhangbei",
        "date": "2025-12-23",
        "period": "2025-Q4",
        "constructionStatus": "Chillers look fully installed on Building 4-6. Some chillers on Building 4 and 5 appear to have snow in the fan holes, suggesting they are not operating and other chillers are operating (since warm air would melt the snow). There is still a bit of construction equipment around Building 6 so it may not be quite operational.",
        "buildingsOperational": 3,
        "itNameplateMw": 85,
        "facilityNameplateMw": 102,
        "kind": "observed"
      },
      {
        "site": "Alibaba Zhangbei",
        "date": "2026-01-03",
        "period": "2026-Q1",
        "constructionStatus": "Expect Building 4-6 have finished upgrading with new chillers.",
        "buildingsOperational": 6,
        "itNameplateMw": 169,
        "facilityNameplateMw": 203,
        "kind": "observed"
      },
      {
        "site": "Google Lincoln",
        "date": "2023-07-01",
        "period": "2023-Q3",
        "constructionStatus": "Land clearing begins for the site",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Lincoln",
        "date": "2025-10-23",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 looks mostly complete: the large items like generators and substation are done. It is just missing 2 more cooling towers (4 fans). They just seem to be paving and setting up the secondary equipment so it is probably a few months away from operation. Building 2 foundation has been laid.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Lincoln",
        "date": "2026-05-12",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 operational. This is based on the fact that is no more visible equipment or construction around the building, and based on previous imagery and when construction started on the last pieces of equipment (fans). Building 2's roof is complete, with generator construction more than halfway complete and cooling construction beginning. Electrical equipment on the side of Building 2 is also around halfway complete.",
        "buildingsOperational": 1,
        "itNameplateMw": 141,
        "facilityNameplateMw": 170,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2023-10-08",
        "period": "2023-Q4",
        "constructionStatus": "Land clearing begins simultaneously for all three zones (west, north, and south) after an [official ceremony](https://web.archive.org/web/20260624112951/http://nmg.news.cn/20231008/57bb95be6791497db95bc7d2f229a68e/c.html). Two of the zones later have the cooling capacity indicative of AI workloads.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2025-02-24",
        "period": "2025-Q1",
        "constructionStatus": "Building 1 is structurally complete, and building 4 is structurally complete apart from some remaining cooling towers. Buildings 2 and 5 have begun construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2025-04-01",
        "period": "2025-Q2",
        "constructionStatus": "4 structure complete via satellite imagery",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2025-06-01",
        "period": "2025-Q2",
        "constructionStatus": "Building 1 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
        "buildingsOperational": 1,
        "itNameplateMw": 47.6,
        "facilityNameplateMw": 54.8,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2025-07-01",
        "period": "2025-Q3",
        "constructionStatus": "Building 4 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
        "buildingsOperational": 2,
        "itNameplateMw": 95.3,
        "facilityNameplateMw": 109.6,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2026-02-01",
        "period": "2026-Q1",
        "constructionStatus": "Building 2 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
        "buildingsOperational": 3,
        "itNameplateMw": 150.2,
        "facilityNameplateMw": 172.8,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2026-03-05",
        "period": "2026-Q1",
        "constructionStatus": "Three of the six (phase 1) buildings planned across the three zones are operational. One other is near completion, apart from backup generators. The third zone does not have cooling sufficient for AI.",
        "buildingsOperational": 3,
        "itNameplateMw": 150.2,
        "facilityNameplateMw": 172.8,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2026-05-12",
        "period": "2026-Q2",
        "constructionStatus": "Satellite imagery shows buildings 4 and 5 are all structurally finished, with landscaping complete.",
        "buildingsOperational": 3,
        "itNameplateMw": 150.2,
        "facilityNameplateMw": 172.8,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2026-06-07",
        "period": "2026-Q2",
        "constructionStatus": "Satellite imagery shows buildings 1, 2, 3, and 4 are all finished, with landscaping complete.",
        "buildingsOperational": 3,
        "itNameplateMw": 150.2,
        "facilityNameplateMw": 172.8,
        "kind": "observed"
      },
      {
        "site": "Huawei Horinger",
        "date": "2026-07-01",
        "period": "2026-Q3",
        "constructionStatus": "Building 5 is operational, assuming a 3 month fit out post structural completion, as can be seen via satellite imagery.",
        "buildingsOperational": 4,
        "itNameplateMw": 241.8,
        "facilityNameplateMw": 278,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2024-03-15",
        "period": "2024-Q1",
        "constructionStatus": "Land clearing begins late March, as can be seen in satellite images (eastern part: buildings 1 & 2). VNET officially [announces](https://web.archive.org/web/20250620154431/https://www.vnet.com/portal/article/index/cid/14/id/876.html) its signing ceremony with the Ulanqab municipal government and Shandong Hi-Speed Holdings.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2025-02-05",
        "period": "2025-Q1",
        "constructionStatus": "Satellite imagery shows five buildings (1, 2, 3, 4, 5) under construction. Chillers are in place, but no roof is complete for any building.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2025-07-01",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 is operational, based on a 3-month fit-out period after structural completion in April, as can be seen from satellite imagery.",
        "buildingsOperational": 1,
        "itNameplateMw": 38,
        "facilityNameplateMw": 43,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2025-08-01",
        "period": "2025-Q3",
        "constructionStatus": "Satellite imagery shows that in total nine buildings have started construction, with building 1 being the only one operational. Buildings 2 and 5 are structurally complete, and the final roofs for buildings 3 and 4 have begun.",
        "buildingsOperational": 1,
        "itNameplateMw": 38,
        "facilityNameplateMw": 43,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2025-11-01",
        "period": "2025-Q4",
        "constructionStatus": "Buildings 2 and 5 are operational, based on a 3-month fit-out period after structural completion in August, as can be seen from satellite imagery. Land clearing for the northern part of campus (buildings 10 and 11) has started.",
        "buildingsOperational": 3,
        "itNameplateMw": 171,
        "facilityNameplateMw": 194,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2025-12-01",
        "period": "2025-Q4",
        "constructionStatus": "Building 4 is operational, similarly based on a 3-month fit-out period after structural completion in September, as seen from satellite imagery.",
        "buildingsOperational": 4,
        "itNameplateMw": 221,
        "facilityNameplateMw": 252,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2026-03-05",
        "period": "2026-Q1",
        "constructionStatus": "Satellite imagery shows four operational buildings (1, 2, 4, 5), and the western part of campus (6, 7, 8, 9) has made significant construction progress. The foundation for the northern part of campus (10, 11) has started.",
        "buildingsOperational": 4,
        "itNameplateMw": 221,
        "facilityNameplateMw": 252,
        "kind": "observed"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2026-05-06",
        "period": "2026-Q2",
        "constructionStatus": "Satellite imagery shows building 9 has completed all its chillers, with only its roof remaining. Previous building completion timelines would imply this building will be operational by the end of 2026.",
        "buildingsOperational": 4,
        "itNameplateMw": 221,
        "facilityNameplateMw": 252,
        "kind": "observed"
      },
      {
        "site": "Google The Dalles",
        "date": "2023-05-21",
        "period": "2023-Q2",
        "constructionStatus": "First signs of construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google The Dalles",
        "date": "2025-03-07",
        "period": "2025-Q1",
        "constructionStatus": "Building 1 is estimated to be operational, based on all external equipment being installed.",
        "buildingsOperational": 1,
        "itNameplateMw": 77,
        "facilityNameplateMw": 93,
        "kind": "observed"
      },
      {
        "site": "Google The Dalles",
        "date": "2026-04-29",
        "period": "2026-Q2",
        "constructionStatus": "Building 2 is estimated to be operational, based on all external equipment being installed, and ordinary cars parked by the building.",
        "buildingsOperational": 2,
        "itNameplateMw": 154,
        "facilityNameplateMw": 185,
        "kind": "observed"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2024-10-01",
        "period": "2024-Q4",
        "constructionStatus": "Land clearing begins for Building 1, also known as CB-1, the first AI/HPC building on the site.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2025-10-01",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 is operational. Based on Terawulf [saying](https://investors.terawulf.com/news-events/press-releases/detail/126/terawulf-reports-third-quarter-2025-results) \"As of September 30, 2025, the site has energized 245 MW of Bitcoin-mining capacity and 22.5 MW of HPC capacity.\" The small \"Wulf Den\" building was [said](https://investors.terawulf.com/news-events/press-releases/detail/99/terawulf-to-deliver-over-70-mw-of-data-center) to be 2 MW of IT power while CB-1 would be 16 MW. This is roughly consistent with 22.5 MW of total facility power. This building is [leased](https://investors.terawulf.com/news-events/press-releases/detail/99/terawulf-to-deliver-over-70-mw-of-data-center) to Core42, a subsidiary of UAE-based G42. It likely uses NVIDIA DGX B200 servers.",
        "buildingsOperational": 1,
        "itNameplateMw": 16,
        "facilityNameplateMw": 19,
        "kind": "observed"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2026-03-02",
        "period": "2026-Q1",
        "constructionStatus": "Buildings 1-3 all appear to have a complete building and cooling equipment. Building 4 shell is still under construction, but 17 cooling units are already loaded on the roof. The outline of Building 5 is visible at the foundation.",
        "buildingsOperational": 1,
        "itNameplateMw": 16,
        "facilityNameplateMw": 19,
        "kind": "observed"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2026-03-31",
        "period": "2026-Q1",
        "constructionStatus": "Building 2 is operational. On February 26, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB2A is operational, presumably making up half the final capacity. CB2B was expected in March 2026. This building is [leased](https://investors.terawulf.com/news-events/press-releases/detail/99/terawulf-to-deliver-over-70-mw-of-data-center) to Core42, a subsidiary of UAE-based G42. It likely uses NVIDIA DGX B200 servers.",
        "buildingsOperational": 2,
        "itNameplateMw": 58,
        "facilityNameplateMw": 68,
        "kind": "observed"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2026-05-31",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 is operational. On February 26, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB3 was expected to be energized by mid-May 2026. This building is [leased](https://investors.terawulf.com/news-events/press-releases/detail/112/terawulf-signs-200-mw-10-year-ai-hosting-agreements-with) to Fluidstack, likely contains [Google TPUs](https://www.datacenterdynamics.com/en/news/google-offers-its-tpus-to-ai-cloud-providers-report/), and is likely used by [Anthropic](https://www.anthropic.com/news/anthropic-invests-50-billion-in-american-ai-infrastructure).",
        "buildingsOperational": 3,
        "itNameplateMw": 100,
        "facilityNameplateMw": 117,
        "kind": "observed"
      },
      {
        "site": "Google Arcola",
        "date": "2024-10-01",
        "period": "2024-Q4",
        "constructionStatus": "Building 1 foundation started",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Arcola",
        "date": "2025-09-08",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 roof complete, cooling towers in progress.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Arcola",
        "date": "2026-04-09",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 appears almost complete, with minimal construction activity.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Arcola",
        "date": "2026-06-16",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 is operational, based off of colored motion artifacts from cooling towers.",
        "buildingsOperational": 1,
        "itNameplateMw": 77,
        "facilityNameplateMw": 93,
        "kind": "observed"
      },
      {
        "site": "Meta Gallatin",
        "date": "2023-09-11",
        "period": "2023-Q3",
        "constructionStatus": "Land clearing starts for Building 1.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Gallatin",
        "date": "2026-02-09",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 shell and cooling looks complete, but construction equipment still seen around cooling and building. We estimate another 4 months to operational.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Gallatin",
        "date": "2026-06-15",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 is operational (estimate).",
        "buildingsOperational": 1,
        "itNameplateMw": 87,
        "facilityNameplateMw": 114,
        "kind": "observed"
      },
      {
        "site": "Meta Los Lunas",
        "date": "2024-07-24",
        "period": "2024-Q3",
        "constructionStatus": "Land clearing starts for new building.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Los Lunas",
        "date": "2026-03-01",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 looks operational.",
        "buildingsOperational": 1,
        "itNameplateMw": 87,
        "facilityNameplateMw": 105,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2023-10-31",
        "period": "2023-Q4",
        "constructionStatus": "Start of construction for the first building, according to [Applied Digital](https://ir.applieddigital.com/news-events/press-releases/detail/75/applied-digital-announces-groundbreaking-of). CoreWeave was not leased yet at this site, but this is the construction start date we're using for relevance.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2025-05-28",
        "period": "2025-Q2",
        "constructionStatus": "CoreWeave signed the first lease package for 250 MW. No buildings online yet. This is according to an [SEC 8-k filing](https://www.sec.gov/Archives/edgar/data/1144879/000164117225013199/form8-k.htm) from this date.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2025-08-29",
        "period": "2025-Q3",
        "constructionStatus": "[A new 150 MW lease](https://ir.applieddigital.com/news-events/press-releases/detail/128/applied-digital-finalizes-additional-150mw-lease-with) brings CoreWeave to 400 MW total contracted. The project is now clearly scheduled to be a three-building CoreWeave campus.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2025-10-27",
        "period": "2025-Q4",
        "constructionStatus": "The first 50 MW slice of Building 1 has reached Ready for Service status according to [this report](https://ir.applieddigital.com/news-events/press-releases/detail/133/applied-digital-achieves-ready-for-service-for-phase-1-at). This is the first point where we would count any CoreWeave capacity as operational.",
        "buildingsOperational": 1,
        "itNameplateMw": 50,
        "facilityNameplateMw": 65,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2025-11-24",
        "period": "2025-Q4",
        "constructionStatus": "[This Applied Digital report](https://ir.applieddigital.com/news-events/press-releases/detail/137/applied-digital-completes-phase-ii-ready-for-service-at) says the rest of Building 1 has reached Ready for Service, bringing the first building to its expected 100 MW. We can treat this as the first completed data center building.",
        "buildingsOperational": 1,
        "itNameplateMw": 68,
        "facilityNameplateMw": 88,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2026-03-27",
        "period": "2026-Q1",
        "constructionStatus": "According to satellite imagery, Building 1 looks complete and in service, with the surrounding power/cooling equipment also operational. (Note: this image doesn't provide a view of buildings 2 or 3, though it's very safe to assume they're under construction at this stage, considering they're still under construction in the satellite image 3 months from now.)",
        "buildingsOperational": 1,
        "itNameplateMw": 68,
        "facilityNameplateMw": 88,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2026-06-30",
        "period": "2026-Q2",
        "constructionStatus": "According to satellite imagery, Building 2 is fully roofed and shell complete, with rooftop chillers mostly installed. Building 3 construction is well underway, with about 1/4 of the roofing done and the foundation laid out.",
        "buildingsOperational": 1,
        "itNameplateMw": 68,
        "facilityNameplateMw": 88,
        "kind": "observed"
      },
      {
        "site": "Google Storey County",
        "date": "2023-08-30",
        "period": "2023-Q3",
        "constructionStatus": "Building 1, which was first operational in 2021, has increased power capacity by about 75%. This is based on the expansion of the dry cooling array from 4 to 7 columns (seen on [Google Earth](https://earth.google.com/web/@39.4948785,-119.43174359,1568.8659293a,562.69639351d,35y,-0h,0t,0r/)). Its backup generators also grew from 18 to 33, an 83% increase. Around this time (2023 Q3) the quarterly PUE of the campus is 1.24, down from the initial 1.29 in 2022 Q3. Since no other buildings have been added, these changes indicate an increase in power density, which may entail a new generation of hardware getting installed.",
        "buildingsOperational": 1,
        "itNameplateMw": 81,
        "facilityNameplateMw": 107,
        "kind": "observed"
      },
      {
        "site": "Google Storey County",
        "date": "2025-03-11",
        "period": "2025-Q1",
        "constructionStatus": "Building 2 now has generators in place, but there is still a crane and construction work present.",
        "buildingsOperational": 1,
        "itNameplateMw": 81,
        "facilityNameplateMw": 107,
        "kind": "observed"
      },
      {
        "site": "Google Storey County",
        "date": "2025-06-30",
        "period": "2025-Q2",
        "constructionStatus": "Building 2 is operational. Based on a [Google Earth image](https://earth.google.com/web/@39.49733738,-119.43113543,1552.05877612a,1467.7067385d,35y,0h,0t,0r/) showing complete building shell, mechanical equipment and generators, plus cars parked at the front.",
        "buildingsOperational": 2,
        "itNameplateMw": 161,
        "facilityNameplateMw": 214,
        "kind": "observed"
      },
      {
        "site": "Google Storey County",
        "date": "2025-09-28",
        "period": "2025-Q3",
        "constructionStatus": "Building 3 foundation is underway. Building 2 exterior looks totally clean/landscaped.",
        "buildingsOperational": 2,
        "itNameplateMw": 161,
        "facilityNameplateMw": 214,
        "kind": "observed"
      },
      {
        "site": "Google Storey County",
        "date": "2026-04-13",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 has a partially complete shell, electrical and mechanical equipment. Building 4 foundation is underway.",
        "buildingsOperational": 2,
        "itNameplateMw": 161,
        "facilityNameplateMw": 214,
        "kind": "observed"
      },
      {
        "site": "Google Lancaster",
        "date": "2021-10-01",
        "period": "2021-Q4",
        "constructionStatus": "Land clearing in progress for the site",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Lancaster",
        "date": "2024-01-01",
        "period": "2024-Q1",
        "constructionStatus": "Building 1 operational. This is estimated based on construction progress in [October 2023](https://earth.google.com/web/@39.72490515,-82.68845499,280.4138206a,1128.806013d,35y,-0h,0t,0r/data=CnUaXRJXCiUweDg4NDc4OWI3MDRhZGE1MWQ6MHg0Y2Q1MjE2ZGM0YTQ0YTc5GSZeVEH73ENAISDkBo2qq1TAKhwxMDQgV2hpbGV5IFJkLCBMYW5jYXN0ZXIsIE9IGAIgASoQCAESCjIwMjMtMDUtMTAYAUICCAFCAggASg0I____________ARAA). This also corresponds to a [2023 article](https://ohiocapitaljournal.com/2023/08/29/google-announces-plans-to-invest-1-7-billion-in-a-trio-of-central-ohio-data-centers/) where a Google spokesperson says that the \"the Lancaster data center will open later this year\".",
        "buildingsOperational": 1,
        "itNameplateMw": 68,
        "facilityNameplateMw": 82,
        "kind": "observed"
      },
      {
        "site": "Google Lancaster",
        "date": "2025-09-11",
        "period": "2025-Q3",
        "constructionStatus": "Building 2 is close to completion. Structurally it is already complete, but there is still some equipment strewn around the building that suggests commissioning is ongoing.",
        "buildingsOperational": 1,
        "itNameplateMw": 68,
        "facilityNameplateMw": 82,
        "kind": "observed"
      },
      {
        "site": "Google Lancaster",
        "date": "2025-10-31",
        "period": "2025-Q4",
        "constructionStatus": "Building 2 operational. This is supported by the state of Building 2 a month prior, which is entirely complete outside of some equipment that was removed later on.",
        "buildingsOperational": 2,
        "itNameplateMw": 137,
        "facilityNameplateMw": 164,
        "kind": "observed"
      },
      {
        "site": "Google Lancaster",
        "date": "2026-03-12",
        "period": "2026-Q1",
        "constructionStatus": "At this point, Building 1 and 2 have since already been operational. Additionally, there is visible steam showing clear evidence of operational for both before this date.",
        "buildingsOperational": 2,
        "itNameplateMw": 137,
        "facilityNameplateMw": 164,
        "kind": "observed"
      },
      {
        "site": "Google Midlothian",
        "date": "2023-11-28",
        "period": "2023-Q4",
        "constructionStatus": "Visible land clearing around the area for Building 1",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Midlothian",
        "date": "2024-10-01",
        "period": "2024-Q4",
        "constructionStatus": "Building 1 roof is complete.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Midlothian",
        "date": "2026-04-19",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 is probably mostly operational despite some cooling towers yet to be installed. In the original building permit Google only expected to build 6 new cooling towers, but they've extended the row further. This might be to support new chips with denser power configurations. Across the road, you can see the beginnings of land development for what is likely an expansion of the site, but we don't have any details on it yet.",
        "buildingsOperational": 1,
        "itNameplateMw": 69,
        "facilityNameplateMw": 82,
        "kind": "observed"
      },
      {
        "site": "Google Midlothian",
        "date": "2026-07-01",
        "period": "2026-Q3",
        "constructionStatus": "Estimated full completion of the expanded row of cooling towers and backup generators.",
        "buildingsOperational": 1,
        "itNameplateMw": 103,
        "facilityNameplateMw": 123,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2022-07-01",
        "period": "2022-Q3",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2025-05-15",
        "period": "2025-Q2",
        "constructionStatus": "Building 1 and 2 are operational. Based on Oracle [announcing](https://docs.oracle.com/en-us/iaas/releasenotes/oci/new-region-batam.htm) the Indonesia North (Batam) region is available, and both buildings looking complete soon after, in June.",
        "buildingsOperational": 2,
        "itNameplateMw": 33,
        "facilityNameplateMw": 43,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2025-06-13",
        "period": "2025-Q2",
        "constructionStatus": "Building 3 shell is partly built. Building 1 and 2 look complete.",
        "buildingsOperational": 2,
        "itNameplateMw": 33,
        "facilityNameplateMw": 43,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2025-10-01",
        "period": "2025-Q4",
        "constructionStatus": "Building 3 has cooling towers beginning to be installed.",
        "buildingsOperational": 2,
        "itNameplateMw": 33,
        "facilityNameplateMw": 43,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2026-03-19",
        "period": "2026-Q1",
        "constructionStatus": "Building 3 looks complete including building shell, chillers and backup generators.",
        "buildingsOperational": 2,
        "itNameplateMw": 33,
        "facilityNameplateMw": 43,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2026-04-17",
        "period": "2026-Q2",
        "constructionStatus": "Building 3 is operational. Based on it looking complete as of March, and DayOne [posting](https://www.linkedin.com/posts/dayonedc-datacenter-batam-ugcPost-7450899048925986816-Wxqu/) a video of the facility on this date. In one shot of the video, fan movement is visible for all buildings, suggesting they are all operational.",
        "buildingsOperational": 3,
        "itNameplateMw": 72,
        "facilityNameplateMw": 94,
        "kind": "observed"
      },
      {
        "site": "Oracle Batam",
        "date": "2026-05-06",
        "period": "2026-Q2",
        "constructionStatus": "The three buildings look unchanged since March.",
        "buildingsOperational": 3,
        "itNameplateMw": 72,
        "facilityNameplateMw": 94,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2020-03-04",
        "period": "2020-Q1",
        "constructionStatus": "Land clearing begins for Building 1 of expansion.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2022-10-16",
        "period": "2022-Q4",
        "constructionStatus": "Building 2 under construction. Building 3 begins construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2023-01-23",
        "period": "2023-Q1",
        "constructionStatus": "Building 1 assumed operational due to vapor from cooling towers. Building 2 4/7 cooling towers installed. Building 3 roof complete coverage but unfinished.",
        "buildingsOperational": 1,
        "itNameplateMw": 79,
        "facilityNameplateMw": 95,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2024-02-15",
        "period": "2024-Q1",
        "constructionStatus": "Building 2 assumed operational due to vapor from cooling towers. Building 3 5/7 cooling towers installed.",
        "buildingsOperational": 1,
        "itNameplateMw": 79,
        "facilityNameplateMw": 95,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2024-08-03",
        "period": "2024-Q3",
        "constructionStatus": "Building 3 look operational.",
        "buildingsOperational": 3,
        "itNameplateMw": 237,
        "facilityNameplateMw": 284,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2025-11-03",
        "period": "2025-Q4",
        "constructionStatus": "Land cleared for Building 4 and 5.",
        "buildingsOperational": 3,
        "itNameplateMw": 237,
        "facilityNameplateMw": 284,
        "kind": "observed"
      },
      {
        "site": "Google Papillion",
        "date": "2026-05-04",
        "period": "2026-Q2",
        "constructionStatus": "Building 4 shell mostly complete, Building 5 steel framing is underway.",
        "buildingsOperational": 3,
        "itNameplateMw": 237,
        "facilityNameplateMw": 284,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Marble NC",
        "date": "2024-06-25",
        "period": "2024-Q2",
        "constructionStatus": "Core Scientific announced that CoreWeave would receive about 70 MW of HPC infrastructure from 100 MW of owned infrastructure. Site modifications were expected to begin in H2 2024.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Marble NC",
        "date": "2026-03-02",
        "period": "2026-Q1",
        "constructionStatus": "Marble had achieved full site energization. Two of three data halls had been delivered at 36 billable MW, supporting about 15000 Grace Blackwell GPUs. The third hall was still in commissioning.",
        "buildingsOperational": 1,
        "itNameplateMw": 36,
        "facilityNameplateMw": 50.4,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Marble NC",
        "date": "2026-04-17",
        "period": "2026-Q2",
        "constructionStatus": "Satellite imagery shows the main data hall and southern utility yard substantially complete. No new public MW disclosure, so this keeps the March 2026 public 36 MW state.",
        "buildingsOperational": 1,
        "itNameplateMw": 36,
        "facilityNameplateMw": 50.4,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Marble NC",
        "date": "2026-05-06",
        "period": "2026-Q2",
        "constructionStatus": "Core Scientific said Marble was fully handed over to CoreWeave with about 65 MW of billable customer power online.",
        "buildingsOperational": 1,
        "itNameplateMw": 65,
        "facilityNameplateMw": 91,
        "kind": "observed"
      },
      {
        "site": "Google Waltham Cross",
        "date": "2024-01-01",
        "period": "2024-Q1",
        "constructionStatus": "Land clearing begins (Sentinel-2 imagery).",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Waltham Cross",
        "date": "2025-09-01",
        "period": "2025-Q3",
        "constructionStatus": "Building complete and operational; full buildout reached. Sentinel-2 imagery shows the building finished with components installed and cars in the car park. Confirmed by Google's official blog post announcing the Waltham Cross data centre opening (https://blog.google/company-news/inside-google/around-the-globe/google-europe/united-kingdom/waltham-cross-data-centre/).",
        "buildingsOperational": 1,
        "itNameplateMw": 88,
        "facilityNameplateMw": 124,
        "kind": "observed"
      },
      {
        "site": "Google Waltham Cross",
        "date": "2026-04-23",
        "period": "2026-Q2",
        "constructionStatus": "Full buildout reconfirmed via high-resolution Pléiades-Neo satellite image; no capacity change since September 2025.",
        "buildingsOperational": 1,
        "itNameplateMw": 88,
        "facilityNameplateMw": 124,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT40",
        "date": "2018-12-28",
        "period": "2018-Q4",
        "constructionStatus": "Land clearing begins for the site, specifically digging up a parking lot and making outlines for the buildings. Evident on [Google Earth](https://earth.google.com/web/@29.4149522,-98.80304495,292.48816289a,1532.49619452d,35y,0h,0t,0r/).",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT40",
        "date": "2024-05-24",
        "period": "2024-Q2",
        "constructionStatus": "Building 1 operational. Estimated 3 months out from February, when there was still construction equipment.",
        "buildingsOperational": 1,
        "itNameplateMw": 47,
        "facilityNameplateMw": 66,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT40",
        "date": "2025-12-01",
        "period": "2025-Q4",
        "constructionStatus": "Building 2 operational. No more construction on building, and surrounding roads are also complete.",
        "buildingsOperational": 2,
        "itNameplateMw": 75,
        "facilityNameplateMw": 106,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT40",
        "date": "2026-02-04",
        "period": "2026-Q1",
        "constructionStatus": "Site has already been completed, with no more visible construction on any building.",
        "buildingsOperational": 2,
        "itNameplateMw": 75,
        "facilityNameplateMw": 106,
        "kind": "observed"
      },
      {
        "site": "Google Mesa",
        "date": "2023-07-01",
        "period": "2023-Q3",
        "constructionStatus": "Land clearing begins for the entire site.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Mesa",
        "date": "2025-07-01",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 is operational. This is based on the state of construction on 2025-03-02 as seen on [Google Earth](https://earth.google.com/web/@33.35450568,-111.67805903,407.02398359a,2119.1496037d,35y,-0h,0t,0r/data=ChYqEAgBEgoyMDI1LTAzLTAyGAFCAggBQgIIAEoNCP___________wEQAA), where building shell and external components seems to have been completed, but there is still a lot of construction equipment present. That equipment appears to have been cleared up by this date, 4 months later, with the 2025-09-07 satellite imagery providing an upper bound. Construction has begun on the Building 2 roof, with work beginning on the areas for cooling and generators as well.",
        "buildingsOperational": 1,
        "itNameplateMw": 90,
        "facilityNameplateMw": 126,
        "kind": "observed"
      },
      {
        "site": "Google Mesa",
        "date": "2025-09-07",
        "period": "2025-Q3",
        "constructionStatus": "Building 2 roof is mostly completed. Building 2's backup generators are almost complete, and cooling is a little more than halfway complete. The Building 2 substation is also under construction.",
        "buildingsOperational": 1,
        "itNameplateMw": 90,
        "facilityNameplateMw": 126,
        "kind": "observed"
      },
      {
        "site": "Google Mesa",
        "date": "2026-05-15",
        "period": "2026-Q2",
        "constructionStatus": "Building 2 is close to being operational. There is only construction left on the backup generators, which are almost complete. Some equipment is also strewn around the building, especially near the air-cooled chillers. Preparation seems to have begun for Building 3 at the site.",
        "buildingsOperational": 1,
        "itNameplateMw": 90,
        "facilityNameplateMw": 126,
        "kind": "observed"
      },
      {
        "site": "STACK Infrastructure NVA02",
        "date": "2019-10-19",
        "period": "2019-Q4",
        "constructionStatus": "Land clearing begins by Peterson Companies for Stack Infrastructure, which is noted in the [news](https://www.bisnow.com/washington-dc/news/data-center/peterson-cos-partnering-to-build-4m-sf-data-center-campus-in-manassas-102646) and visible on satellite imagery.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "STACK Infrastructure NVA02",
        "date": "2024-10-01",
        "period": "2024-Q4",
        "constructionStatus": "Building 1 is operational, which is assumed to be three months after the last backup diesel generators are finished. The generators were first seen to be finished July 1 from satellite imagery [(a clear image of this can be seen on July 29 via Google Earth).](https://earth.google.com/web/search/38%c2%b044%2745%2e12%22N+77%c2%b032%2716%2e47%22W/@38.7458667,-77.5379083,83.89135729a,642.01325639d,35y,0h,0t,0r/data=CjQiJgokCTo0Rh9P7TVAETk0Rh9P7TXAGX6C6a6li0VAIQ_0AAa-ik7AKgYIARIAGAFCAggBQgIIAEoNCP___________wEQAA)",
        "buildingsOperational": 1,
        "itNameplateMw": 85,
        "facilityNameplateMw": 118,
        "kind": "observed"
      },
      {
        "site": "STACK Infrastructure NVA02",
        "date": "2026-02-14",
        "period": "2026-Q1",
        "constructionStatus": "All buildings have begun construction (with groundwork starting for AI building 6), as depicted by satellite imagery.",
        "buildingsOperational": 1,
        "itNameplateMw": 85,
        "facilityNameplateMw": 118,
        "kind": "observed"
      },
      {
        "site": "Google Red Oak",
        "date": "2023-04-30",
        "period": "2023-Q2",
        "constructionStatus": "First signs of development/land clearing",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Red Oak",
        "date": "2025-08-25",
        "period": "2025-Q3",
        "constructionStatus": "Building 1 is operational, based on a Google Earth [image](https://earth.google.com/web/@32.53855187,-96.7936939,182.71625265a,4648.56607908d,30.00094375y,3.66969189h,0t,0r/) showing a completed building shell and equipment, and the large construction car park being emptied. Building 2 shell looks mostly completed.",
        "buildingsOperational": 1,
        "itNameplateMw": 77,
        "facilityNameplateMw": 93,
        "kind": "observed"
      },
      {
        "site": "Google Red Oak",
        "date": "2026-02-06",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 appears active - the surrounding land is finished including the site entrance and the parking lot. The dry coolers for Building 2 are nearly complete although the building is still clearly a construction zone. The Building 2 substation also appears complete.",
        "buildingsOperational": 1,
        "itNameplateMw": 77,
        "facilityNameplateMw": 93,
        "kind": "observed"
      },
      {
        "site": "Stream Phoenix",
        "date": "2022-10-30",
        "period": "2022-Q4",
        "constructionStatus": "Construction beginning, as can be seen on satellite. Major renovations on western side of the non AI building (PX1), including adding generators and cooling towers.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Stream Phoenix",
        "date": "2026-01-31",
        "period": "2026-Q1",
        "constructionStatus": "Major construction has finished on AI building 1, and AI building 6 has been expedited, as depicted by satellite imagery.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Stream Phoenix",
        "date": "2026-05-01",
        "period": "2026-Q2",
        "constructionStatus": "Estimated: AI building 1 should be operational. Major construction work finished by January 31, 2026, and the shell looked complete by that date. We estimate after three months the building will be operational.",
        "buildingsOperational": 1,
        "itNameplateMw": 64,
        "facilityNameplateMw": 77,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT14",
        "date": "2022-02-18",
        "period": "2022-Q1",
        "constructionStatus": "Land clearing for the site is almost complete. Informed using imagery on [Google Earth](https://earth.google.com/web/@29.476115,-98.68118,277.21295794a,724.52967601d,35y,0h,0t,0r/)",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT14",
        "date": "2024-07-01",
        "period": "2024-Q3",
        "constructionStatus": "Building 1 operational. The first 2 data halls of Building 1 (with chillers already installed) are likely to be already operational. Although construction was completed prior, the on-site substation was previously incomplete, so we believe it was only operational at this point.",
        "buildingsOperational": 1,
        "itNameplateMw": 19,
        "facilityNameplateMw": 26,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT14",
        "date": "2025-08-03",
        "period": "2025-Q3",
        "constructionStatus": "Building 2 chiller installation is a little more than halfway complete, and chiller installation for the last data hall of Building 1 is also around halfway complete.",
        "buildingsOperational": 1,
        "itNameplateMw": 19,
        "facilityNameplateMw": 26,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT14",
        "date": "2026-02-28",
        "period": "2026-Q1",
        "constructionStatus": "No more visible construction around either building, just a little equipment. Roads fully built around buildings as well.",
        "buildingsOperational": 1,
        "itNameplateMw": 19,
        "facilityNameplateMw": 26,
        "kind": "observed"
      },
      {
        "site": "Microsoft SAT14",
        "date": "2026-03-31",
        "period": "2026-Q1",
        "constructionStatus": "Building 2 fully operational, Building 1 expanded. Construction is already visibly complete. Additionally, construction phases [Phase 2](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2021019471), [Phase 3](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2021019588), and [Phase 4](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2021019686) on TDLR that collectively represent the completion of the site have a completion date of 2026-03-31.",
        "buildingsOperational": 2,
        "itNameplateMw": 47,
        "facilityNameplateMw": 66,
        "kind": "observed"
      },
      {
        "site": "Vantage TX1",
        "date": "2023-12-15",
        "period": "2023-Q4",
        "constructionStatus": "Land clearing begins for both Building 1 & Building 2",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Vantage TX1",
        "date": "2026-02-15",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 operational; Roads around Building 1 complete, all cooling and side generator equipment construction has since finished as well. Although this is still earlier than the completion date reported on TDLR, based on the appearance, we believe it is operational. Reported IT power of 32 MW. [Source](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2024007561)",
        "buildingsOperational": 1,
        "itNameplateMw": 32,
        "facilityNameplateMw": 44.8,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Dalton 1 & 2",
        "date": "2024-06-03",
        "period": "2024-Q2",
        "constructionStatus": "According to a [few](https://investors.corescientific.com/news-events/press-releases/detail/74/core-scientific-to-provide-approximately-200-mw-of-infrastructure-to-host-coreweaves-high-performance-computing-services-capturing-significant-ai-compute-opportunity) [sources](https://www.sec.gov/Archives/edgar/data/1839341/000162828025008302/core-20241231.htm), Core Scientific announced that they're rebuilding their existing Dalton 1 (and we're assuming 2) datacenter to run AI using CoreWeave's GPUs, of which contract was first signed on this date. According to the press release, \"The site modifications are expected to commence early in the second half of 2024 and achieve operational status in the first half of 2025.\"",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Dalton 1 & 2",
        "date": "2025-05-01",
        "period": "2025-Q2",
        "constructionStatus": "Core Scientific investor presentation clearly shows Dalton 1 with a cleared pad on this month for construction. Source: https://investors.corescientific.com/sec-filings/all-sec-filings/content/0001140361-25-039864/0001140361-25-039864.pdf",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Dalton 1 & 2",
        "date": "2025-08-29",
        "period": "2025-Q3",
        "constructionStatus": "Based on Satellite imagery, Dalton 1 is still under construction. The building appears mostly roofed except for the entrance area, and there are no cooling units or backup generators installed yet.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Dalton 1 & 2",
        "date": "2026-02-20",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 is operational, given it was announced completed 4 months ago and looks completed in satellite imagery. All cooling/mechanical rows are installed, with no obvious active building construction visible.",
        "buildingsOperational": 1,
        "itNameplateMw": 28,
        "facilityNameplateMw": 40,
        "kind": "observed"
      },
      {
        "site": "Start Campus Sines Data Campus",
        "date": "2022-01-01",
        "period": "2022-Q1",
        "constructionStatus": "Land clearing begins for Building 1 (SIN01)",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Start Campus Sines Data Campus",
        "date": "2024-10-31",
        "period": "2024-Q4",
        "constructionStatus": "Building 1 (SIN01) is completed, but at this point it likely not being used for AI as the collaboration with Microsoft that resulted in GB300s did not occur until Q1 2026. The completion is based both on satellite imagery, which shows the building fully completed, and a [March 2025 article](https://econews.pt/2025/03/24/start-campus-to-start-construction-of-second-data-centre-building-in-sines-by-end-june/) that says it \"has been in operation since October\", which is October of 2024.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Start Campus Sines Data Campus",
        "date": "2026-04-03",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 (SIN01) operational for AI, with the first deployment of 12,600 Nvidia GB300 NVL72s to the site being reported completed \"Q1 2026\" based on the [corporate announcement](https://lp.startcampus.pt/start-campus-hosts-eus-first-nvidia-gb300-chips-with-nscale-for-microsoft). Land clearing also begins for Building 2 (SIN02), with faint dirt outlines for roads and building foundations visible.",
        "buildingsOperational": 1,
        "itNameplateMw": 33,
        "facilityNameplateMw": 40,
        "kind": "observed"
      },
      {
        "site": "Google Pryor (North)",
        "date": "2024-07-19",
        "period": "2024-Q3",
        "constructionStatus": "Building 1 is operational, based on default roof-to-operational time.",
        "buildingsOperational": 1,
        "itNameplateMw": 53,
        "facilityNameplateMw": 63,
        "kind": "observed"
      },
      {
        "site": "Google Pryor (North)",
        "date": "2025-01-28",
        "period": "2025-Q1",
        "constructionStatus": "Building 2 is being retrofitted from a warehouse. The roof is being painted white, and cooling towers and a new substation are being built just south of the building (based on later imagery).",
        "buildingsOperational": 1,
        "itNameplateMw": 53,
        "facilityNameplateMw": 63,
        "kind": "observed"
      },
      {
        "site": "Google Pryor (North)",
        "date": "2025-10-19",
        "period": "2025-Q4",
        "constructionStatus": "The new substation for Building 2 looks mostly complete, half of the cooling towers are installed. The black patch in the top left of the building suggests that the new roof is not quite complete.",
        "buildingsOperational": 1,
        "itNameplateMw": 53,
        "facilityNameplateMw": 63,
        "kind": "observed"
      },
      {
        "site": "Google Pryor (North)",
        "date": "2026-05-26",
        "period": "2026-Q2",
        "constructionStatus": "Building 2 looks almost complete, but still appears to have three cooling towers missing. We therefore expect another 3 months until full operation.",
        "buildingsOperational": 1,
        "itNameplateMw": 53,
        "facilityNameplateMw": 63,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Muskogee OK",
        "date": "2024-11-18",
        "period": "2024-Q4",
        "constructionStatus": "Core Scientific, CoreWeave, and Port Muskogee publicly announce groundbreaking for the 100 MW Muskogee HPC data center. Core Scientific [says](https://investors.corescientific.com/news-events/press-releases/detail/99/core-scientific-and-port-muskogee-break-ground-on-100-mw-hpc-data-center) the site will provide about 70 MW of critical IT load for CoreWeave's NVIDIA GPUs.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Muskogee OK",
        "date": "2026-04-09",
        "period": "2026-Q2",
        "constructionStatus": "Based on satellite imagery, Building 1 looks mostly complete, but the site still appears to be in construction or commissioning. Not much progress has happened in the past 4 months, and a Q2 2026 finish seems unlikely.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "CoreWeave Muskogee OK",
        "date": "2026-06-13",
        "period": "2026-Q2",
        "constructionStatus": "Based on satellite imagery, Building 1 has completed construction, with adjacent land cleared for what we're assuming will have power substations/generators. We can assume Building 1 is not operational from all the yard work directly surrounding it, and the lack of a parking lot. Building 2 (The one not leased to CoreWeave) is still in land clearing phase.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Crusoe Abilene Expansion",
        "date": "2025-11-02",
        "period": "2025-Q4",
        "constructionStatus": "Land clearing begins for Buildings 1-2.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Crusoe Abilene Expansion",
        "date": "2026-01-15",
        "period": "2026-Q1",
        "constructionStatus": "Land clearing continues.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "EdgeCore Mesa PH03",
        "date": "2026-01-17",
        "period": "2026-Q1",
        "constructionStatus": "Both buildings complete",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Goodnight",
        "date": "2025-05-19",
        "period": "2025-Q2",
        "constructionStatus": "Land clearing begins",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Goodnight",
        "date": "2025-10-16",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 and 2 under construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Goodnight",
        "date": "2025-12-23",
        "period": "2025-Q4",
        "constructionStatus": "Construction on Building 1 and 2 looks about halfway to completion. Foundations and utility trenches are visible for Building 3-4. Building 5-6 have an outline. The substation appears to be expanding.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Goodnight",
        "date": "2026-04-16",
        "period": "2026-Q2",
        "constructionStatus": "Progress is made on all buildings, Building 1 and 2 specically have begun to install cooling structures. The substation expansion seems to be nearing completion.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2024-05-01",
        "period": "2024-Q2",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2025-10-27",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 cooling towers and generators starting to be put in place. There's a foundation for Building 2 and 3.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2025-12-29",
        "period": "2025-Q4",
        "constructionStatus": "About half of Building 1 generators are in place. Building 2 roofing has started - about where Google Omaha Building 3 was on 2025-03-16.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2026-04-16",
        "period": "2026-Q2",
        "constructionStatus": "Building 1's generators are still only about halfway in place, and ~1/2 the cooling towers are still under construction. Building 2 roofing has been completed, and visible foundations have been built for cooling towers and generators.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2024-04-01",
        "period": "2024-Q2",
        "constructionStatus": "First signs of development/land clearing",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2024-09-13",
        "period": "2024-Q3",
        "constructionStatus": "Roof complete on Building 1 (the 'H'), although we suspect this building is not for AI compute due to the construction speed, irregular design, and lack of external cooling.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2025-06-10",
        "period": "2025-Q2",
        "constructionStatus": "After a long quiet period they've laid foundations for Building 2 and the substation.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2025-10-01",
        "period": "2025-Q4",
        "constructionStatus": "Building 2 looks externally complete",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2026-03-01",
        "period": "2026-Q1",
        "constructionStatus": "The chillers for Buildings 2 and 3 are both a little less than half done and the buildings still look like active construction sites.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Kansas City East",
        "date": "2024-01-01",
        "period": "2024-Q1",
        "constructionStatus": "Land clearing has begun for the site",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Kansas City East",
        "date": "2024-03-01",
        "period": "2024-Q1",
        "constructionStatus": "Foundation work begins on Building 1",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Kansas City East",
        "date": "2024-10-01",
        "period": "2024-Q4",
        "constructionStatus": "Foundation work begins on Building 2. Building 1 roof is fully black.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Kansas City East",
        "date": "2025-07-01",
        "period": "2025-Q3",
        "constructionStatus": "Foundation work begins for Building 3. Building 1 generators seem complete.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Kansas City East",
        "date": "2025-11-01",
        "period": "2025-Q4",
        "constructionStatus": "Foundation work begins for Building 4. Building 2 roof is almost complete, and construction appears to have started on cooling. Building 1 cooling construction continues, and the substation right next to it seems finished as well.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Google Kansas City East",
        "date": "2026-04-16",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 is almost complete, with only cooling needing 4 more fans. Building 2 backup generator construction has begun, and cooling tower installation is about halfway complete. Building 3's roof is almost complete, and construction has started on generators and cooling. A clear foundation has been cleared for Building 4, though no construction has begun.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Aiken",
        "date": "2024-05-30",
        "period": "2024-Q2",
        "constructionStatus": "Land clearing begins",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Aiken",
        "date": "2026-04-08",
        "period": "2026-Q2",
        "constructionStatus": "Buildings 1 and 2 are nearly complete, but there's still some equipment strewn around the site. We expect 3 more months needed for commissioning and server installation.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Cheyenne",
        "date": "2024-05-15",
        "period": "2024-Q2",
        "constructionStatus": "Ground is being cleared.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Cheyenne",
        "date": "2025-01-30",
        "period": "2025-Q1",
        "constructionStatus": "Structure for Building 1 and 2 under construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Cheyenne",
        "date": "2026-03-22",
        "period": "2026-Q1",
        "constructionStatus": "Building 1 shell and cooling looks complete, Building 2 roof almost complete.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Hyperion",
        "date": "2024-12-20",
        "period": "2024-Q4",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Hyperion",
        "date": "2025-10-19",
        "period": "2025-Q4",
        "constructionStatus": "Foundations are underway for the main buildings, and the overall layout aligns with the [architectural renderings](https://engineering.fb.com/2025/09/29/data-infrastructure/metas-infrastructure-evolution-and-the-advent-of-ai/) published in 2025.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Hyperion",
        "date": "2026-04-19",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 and 2 roof is finished and cooling is at an advanced stage of installation. Building 3 and 6 roof and cooling in progress.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Sarpy",
        "date": "2024-08-01",
        "period": "2024-Q3",
        "constructionStatus": "Building 1 grading underway.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "Meta Sarpy",
        "date": "2026-05-04",
        "period": "2026-Q2",
        "constructionStatus": "Building 1 shell, electrical and cooling equipment looks complete, with minimal construction work, so we expect it to be operational within 3 months.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Lordstown",
        "date": "2025-10-12",
        "period": "2025-Q4",
        "constructionStatus": "Land clearing begins in the front of the site (the side facing the Ohio Turnpike), clearing away a parking lot and solar array",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Lordstown",
        "date": "2026-02-27",
        "period": "2026-Q1",
        "constructionStatus": "Still no visible construction, although construction within preexisting facilities",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Michigan",
        "date": "2025-12-04",
        "period": "2025-Q4",
        "constructionStatus": "Land clearing begins for the entire site",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Michigan",
        "date": "2026-01-20",
        "period": "2026-Q1",
        "constructionStatus": "Land clearing continues for all buildings (1-3)",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Michigan",
        "date": "2026-03-12",
        "period": "2026-Q1",
        "constructionStatus": "Groundwork is visible for Building 1, at the left end of the site.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Milam",
        "date": "2025-09-27",
        "period": "2025-Q3",
        "constructionStatus": "Land clearing begins for the site",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Milam",
        "date": "2026-01-04",
        "period": "2026-Q1",
        "constructionStatus": "Small sections of building foundation construction begins, and land clearing appears to be mostly finished",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Milam",
        "date": "2026-03-23",
        "period": "2026-Q1",
        "constructionStatus": "Steel framing and roofing is underway for Building 1.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate New Mexico",
        "date": "2025-10-01",
        "period": "2025-Q4",
        "constructionStatus": "Construction and land clearing begins",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate New Mexico",
        "date": "2026-02-06",
        "period": "2026-Q1",
        "constructionStatus": "Land clearing continues, foundation construction begins 2 of the main buildings (Building B & D). Construction also beginning on modular chiller plants.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2025-08-01",
        "period": "2025-Q3",
        "constructionStatus": "Land clearing begins.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2026-01-18",
        "period": "2026-Q1",
        "constructionStatus": "The layout of Buildings 1-5 is visible. Steel framing has just started on Building 1.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2026-04-14",
        "period": "2026-Q2",
        "constructionStatus": "Steel framing is underway for Buildings 1-3, and roofing is underway for Building 1.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate UAE",
        "date": "2025-06-09",
        "period": "2025-Q2",
        "constructionStatus": "Land clearing begins for Building 1 and 2",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate UAE",
        "date": "2025-11-16",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 and 2 are partly constructed. No clear evidence of more buildings starting construction.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Wisconsin",
        "date": "2026-01-02",
        "period": "2026-Q1",
        "constructionStatus": "Ground broken for the facility, land clearing begins for all buildings",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "OpenAI Stargate Wisconsin",
        "date": "2026-02-14",
        "period": "2026-Q1",
        "constructionStatus": "Land clearing continues, foundation construction clearly begins for eastern and northern buildings (Building 1-2)",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Cedar Rapids",
        "date": "2025-01-17",
        "period": "2025-Q1",
        "constructionStatus": "Land clearing begins for Building 1-3.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Cedar Rapids",
        "date": "2025-10-27",
        "period": "2025-Q4",
        "constructionStatus": "Building 1 roof is complete, with air-cooled chillers in place. Building 2 and 3 roofs are partly completed. Building 4 and 5 have a foundation.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      },
      {
        "site": "QTS Cedar Rapids",
        "date": "2026-05-07",
        "period": "2026-Q2",
        "constructionStatus": "Based on satellite imagery, Buildings 1-3 look externally complete. Buildings 4-6 are far along, with roofs largely in place, while the eastern Building 7 foundation is well underway. No buildings operational yet.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "observed"
      }
    ],
    "projected": [
      {
        "site": "Meta Prometheus",
        "date": "2026-08-26",
        "period": "2026-Q3",
        "constructionStatus": "Building 14 (Vantage) operational, based on it starting construction about 3 months after Building 13.",
        "buildingsOperational": 14,
        "itNameplateMw": 700,
        "facilityNameplateMw": 910,
        "kind": "projected"
      },
      {
        "site": "Meta Prometheus",
        "date": "2026-10-01",
        "period": "2026-Q4",
        "constructionStatus": "Socrates South and Socrates North gas power plants are operational, coinciding with Building 15-19 being operational. Based [on](https://dis.puc.state.oh.us/CaseRecord.aspx?CaseNo=25-0188-EL-BGN) [documents](https://dis.puc.state.oh.us/ViewImage.aspx?CMID=A1001001A25E29B42006E01696) [stating](https://www.williams.com/wp-content/uploads/sites/8/2025/03/Socrates-North-Fact-Sheet-Final-1.pdf) \"late Third or early Fourth Quarter of 2026\", \"late 2026\", \"November 2026\", \"third quarter of 2026\".",
        "buildingsOperational": 20,
        "itNameplateMw": 854,
        "facilityNameplateMw": 1110,
        "kind": "projected"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2026-10-19",
        "period": "2026-Q4",
        "constructionStatus": "Buildings 17-18 are operational. This is an estimate based on a rule of thumb of \"operational 5 months after roof is complete\", assuming the roofs took one more month after 2025-12-23. Also added four more months to account for commissioning and adjacent cooling units not being complete yet.",
        "buildingsOperational": 18,
        "itNameplateMw": 1037,
        "facilityNameplateMw": 1244,
        "kind": "projected"
      },
      {
        "site": "Anthropic-Amazon New Carlisle",
        "date": "2028-03-17",
        "period": "2028-Q1",
        "constructionStatus": "Buildings 19-32 are operational. This is an estimate based on how long Buildings 1-16 took to become operational. In May 2026, the foundation of several buildings and a substation was visible at the site of Buildings 19-32. Buildings 1-16 took 1 year and 10 months to go from a similar state to operational. So we add 1 year and 10 months to May 2026 to get this date estimate. The power capacity is based on an [air quality permit](https://t.co/HsAO7oyKa2) filed in May 2026, and the compute capacity is based on Trainium3 chips.",
        "buildingsOperational": 32,
        "itNameplateMw": 1925,
        "facilityNameplateMw": 2310,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Abilene",
        "date": "2026-11-01",
        "period": "2026-Q4",
        "constructionStatus": "Buildings 5-8 are estimated to be operational. On March 24, Building 8 roughly looked like where Building 3 was in September. Building 3 is estimated to be operational in April, 7 months later. This naively suggests Building 8 will be operational by early November, 7 months after March 24.",
        "buildingsOperational": 8,
        "itNameplateMw": 843,
        "facilityNameplateMw": 1180,
        "kind": "projected"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2027-02-20",
        "period": "2027-Q1",
        "constructionStatus": "Building 2 is operational. This is estimated based on (1) the delay between Building 1 and Building 2 starting land clearing, (2) in March 2025, a Microsoft spokesperson [said](https://www.wpr.org/news/microsoft-pauses-construction-on-parts-of-mount-pleasant-site-again) “fully on track” with the first phase , where “southern datacenter buildings complete, and preparation begins for operations” was [expected](https://local.microsoft.com/blog/mount-pleasant-datacenter-project-update/) by late 2026. Finally, while it's not 100% consistent with our estimates, MISO was [planning](https://cdn.misoenergy.org/NEW%20LOAD%20ANNOUNCEMENTS%20IN%20MISO%20REGIONS%2012062024684954.pdf) 1480 MW of load for Microsoft in Mount Pleasant in 2026.",
        "buildingsOperational": 2,
        "itNameplateMw": 737,
        "facilityNameplateMw": 885,
        "kind": "projected"
      },
      {
        "site": "Microsoft Fairwater Wisconsin",
        "date": "2028-05-13",
        "period": "2028-Q2",
        "constructionStatus": "Buildings 3-11 are estimated to be operational. The grading for this revised 9-building plan was underway in May 2026, and we assume an average 2-year [build time](https://epoch.ai/data-insights/data-centers-buildout-speeds) from that point.",
        "buildingsOperational": 11,
        "itNameplateMw": 2263,
        "facilityNameplateMw": 2715,
        "kind": "projected"
      },
      {
        "site": "Meta Montgomery",
        "date": "2027-01-02",
        "period": "2027-Q1",
        "constructionStatus": "Buildings 5 and 6 are operational (estimate). Based on the tent buildings at Meta Prometheus taking about 11 months from starting the tent structure to estimated operation.",
        "buildingsOperational": 4,
        "itNameplateMw": 204,
        "facilityNameplateMw": 266,
        "kind": "projected"
      },
      {
        "site": "Meta Montgomery",
        "date": "2027-02-23",
        "period": "2027-Q1",
        "constructionStatus": "Buildings 3 and 4 are operational (estimate). In September 2025, Building 1 and 2 appeared to be in a similar state to Building 3 and 4 in May 2026. Based on that, we apply an 8-month delay to the Building 1 and 2 operational date to get the Building 3 and 4 operational date.",
        "buildingsOperational": 6,
        "itNameplateMw": 358,
        "facilityNameplateMw": 465,
        "kind": "projected"
      },
      {
        "site": "DayOne Nusajaya",
        "date": "2026-10-02",
        "period": "2026-Q4",
        "constructionStatus": "Buildings 7-10 are operational. Judging by their state in April 2026, we expect 3 months to finish construction and another 3 months to ramp to full capacity.",
        "buildingsOperational": 10,
        "itNameplateMw": 473,
        "facilityNameplateMw": 662,
        "kind": "projected"
      },
      {
        "site": "Google Columbus",
        "date": "2027-07-01",
        "period": "2027-Q3",
        "constructionStatus": "Building 5 operational. The [transmission line construction notice](https://www.aeptransmission.com/ohio/docs/Hartman%20Farms%20Extension%20No.%202%20138%20kV%20Transmission%20Line%20Project%20Construction%20Notice.pdf) that expands site by 100 MW is assumed to be entirely for Building 5, and has an in-service date of July 1, 2027 (page 3). Estimate taken on the safe side based on completion times for Building 3-4 from when roof was complete.",
        "buildingsOperational": 5,
        "itNameplateMw": 386,
        "facilityNameplateMw": 464,
        "kind": "projected"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2027-03-01",
        "period": "2027-Q1",
        "constructionStatus": "Buildings 6 and 7 operational, estimated from roofs having been completed 9 months ago (similar timeline to AWS buildings at New Carlisle in 2025).",
        "buildingsOperational": 7,
        "itNameplateMw": 284,
        "facilityNameplateMw": 478,
        "kind": "projected"
      },
      {
        "site": "Amazon Madison Mega Site",
        "date": "2028-03-15",
        "period": "2028-Q1",
        "constructionStatus": "Buildings 8-12 are operational. In June of 2026 only a faint outline of buildings 10,11 and 12 is visible, estimating construction completion to be the end of 2027, alligning with [expected completion by 2027](https://www.datacenterdynamics.com/en/news/aws-confirmed-as-company-behind-10bn-mississippi-data-center-development/). This final estimates adds three months to that for server installation.",
        "buildingsOperational": 12,
        "itNameplateMw": 683,
        "facilityNameplateMw": 819,
        "kind": "projected"
      },
      {
        "site": "Google New Albany",
        "date": "2026-08-16",
        "period": "2026-Q3",
        "constructionStatus": "Building 5 is operational. Estimated from the high-res image from May.",
        "buildingsOperational": 5,
        "itNameplateMw": 453,
        "facilityNameplateMw": 543,
        "kind": "projected"
      },
      {
        "site": "QTS Richmond 3",
        "date": "2027-02-13",
        "period": "2027-Q1",
        "constructionStatus": "Building 4 and 5 are operational, based on Building 5 being roughly 1 year behind Building 1 in satellite imagery.",
        "buildingsOperational": 5,
        "itNameplateMw": 240,
        "facilityNameplateMw": 336,
        "kind": "projected"
      },
      {
        "site": "Meta Temple",
        "date": "2026-09-30",
        "period": "2026-Q3",
        "constructionStatus": "Building 3 is operational. Based on the stated completion date in this [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026008019)",
        "buildingsOperational": 3,
        "itNameplateMw": 178,
        "facilityNameplateMw": 231,
        "kind": "projected"
      },
      {
        "site": "Amazon Ridgeland",
        "date": "2027-02-09",
        "period": "2027-Q1",
        "constructionStatus": "Building 5 is operational (estimate).",
        "buildingsOperational": 5,
        "itNameplateMw": 284,
        "facilityNameplateMw": 341,
        "kind": "projected"
      },
      {
        "site": "Amazon Ridgeland",
        "date": "2028-09-29",
        "period": "2028-Q3",
        "constructionStatus": "Buildings 6-14 are operational (estimate). Buildings 1-4 took an estimated 2.25 years on this site. We assume Buildings 6-14 get underway by July 2026, and take the same time as Buildings 1-4. This is later than the [expected completion by 2027](https://www.datacenterdynamics.com/en/news/aws-confirmed-as-company-behind-10bn-mississippi-data-center-development/).",
        "buildingsOperational": 14,
        "itNameplateMw": 840,
        "facilityNameplateMw": 1008,
        "kind": "projected"
      },
      {
        "site": "Coreweave Helios",
        "date": "2028-01-01",
        "period": "2028-Q1",
        "constructionStatus": "Building 2 and 3 are operational at full capacity. This corresponds to \"Phase II\", which is [expected](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Third-Quarter-2025-Financial-Results/default.aspx) to be delivered \"throughout 2027\". We assume it takes until the end of 2027 to reach full capacity.",
        "buildingsOperational": 3,
        "itNameplateMw": 396,
        "facilityNameplateMw": 600,
        "kind": "projected"
      },
      {
        "site": "Coreweave Helios",
        "date": "2029-01-01",
        "period": "2029-Q1",
        "constructionStatus": "Building 4 operational at full capacity. This corresponds to \"Phase III\", which is [expected](https://investor.galaxy.com/news/news-details/2025/Galaxy-Announces-Third-Quarter-2025-Financial-Results/default.aspx) to be delivered \"starting in 2028\". We assume it takes until the end of 2028 to reach full capacity.",
        "buildingsOperational": 4,
        "itNameplateMw": 528,
        "facilityNameplateMw": 800,
        "kind": "projected"
      },
      {
        "site": "CoreWeave Chester VA",
        "date": "2027-06-30",
        "period": "2027-Q2",
        "constructionStatus": "Buildings 3 is estimated complete by the end of Q1 2027, based on the current PowerHouse schedule. Added another three months to account for commissioning and server installation.",
        "buildingsOperational": 3,
        "itNameplateMw": 113,
        "facilityNameplateMw": 197,
        "kind": "projected"
      },
      {
        "site": "Google Omaha",
        "date": "2028-01-23",
        "period": "2028-Q1",
        "constructionStatus": "Building 4 is operational. Expect a 4th building because there's enough land cleared for it. Assuming the foundation starts at the end of May 2026 and it takes a similar time to Building 3 from foundation to operational (1 year 8 months).",
        "buildingsOperational": 4,
        "itNameplateMw": 316,
        "facilityNameplateMw": 379,
        "kind": "projected"
      },
      {
        "site": "Google Omaha",
        "date": "2028-07-23",
        "period": "2028-Q3",
        "constructionStatus": "Building 5 is operational. We expect a 5th building because there's enough land cleared for one. We assume a roughly 6-month delay after Building 4.",
        "buildingsOperational": 5,
        "itNameplateMw": 395,
        "facilityNameplateMw": 474,
        "kind": "projected"
      },
      {
        "site": "Google Lincoln",
        "date": "2027-10-01",
        "period": "2027-Q4",
        "constructionStatus": "Building 2 operational. Estimated based on the construction timeline for Building 1, specifically the time to operational since the roof was complete and the time to operational since the foundation work began.",
        "buildingsOperational": 2,
        "itNameplateMw": 283,
        "facilityNameplateMw": 339,
        "kind": "projected"
      },
      {
        "site": "VNET Bayin Ulanqab",
        "date": "2027-09-01",
        "period": "2027-Q3",
        "constructionStatus": "Estimated: the nine-building section of the campus is projected to be fully operational by late 2027 or early 2028. VNET's eastern cluster (buildings 1-5) took roughly a year each from clearing to operational based on satellite imagery. The western cluster (buildings 6-9) was cleared in late 2024 but as of mid-2026 is not yet structurally complete, putting each on track for ~2 years from clearing to operational. Buildings 10 and 11 are projected to be completed sometime later. Comparable data centers in Ulanqab are expected to take at least 6 months per phase ([China Unicom](https://archive.ph/bJDHl)).",
        "buildingsOperational": 9,
        "itNameplateMw": 700,
        "facilityNameplateMw": 798,
        "kind": "projected"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2026-10-31",
        "period": "2026-Q4",
        "constructionStatus": "Building 4 is operational. On February 26, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB4 was expected to be energized by Q3 2026. This building is [leased](https://investors.terawulf.com/news-events/press-releases/detail/112/terawulf-signs-200-mw-10-year-ai-hosting-agreements-with) to Fluidstack, likely contains [Google TPUs](https://www.datacenterdynamics.com/en/news/google-offers-its-tpus-to-ai-cloud-providers-report/), and is likely used by [Anthropic](https://www.anthropic.com/news/anthropic-invests-50-billion-in-american-ai-infrastructure).",
        "buildingsOperational": 4,
        "itNameplateMw": 268,
        "facilityNameplateMw": 313,
        "kind": "projected"
      },
      {
        "site": "Fluidstack Lake Mariner",
        "date": "2027-03-31",
        "period": "2027-Q1",
        "constructionStatus": "Building 5 is operational. On February 26, Terawulf [stated](https://investors.terawulf.com/news-events/press-releases/detail/132/terawulf-reports-fourth-quarter-and-full-year-2025-results) that CB5 was expected to be energized by Q4 2026. However, based on the pace of Building 4, and comparisons to other projects like Stargate Abilene, we think this is optimistic. We expect a 3-month delay past the end of Q4 2026 to get to full operational capacity. This building is [leased](https://investors.terawulf.com/news-events/press-releases/detail/112/terawulf-signs-200-mw-10-year-ai-hosting-agreements-with) to Fluidstack, likely contains [Google TPUs](https://www.datacenterdynamics.com/en/news/google-offers-its-tpus-to-ai-cloud-providers-report/), and is likely used by [Anthropic](https://www.anthropic.com/news/anthropic-invests-50-billion-in-american-ai-infrastructure).",
        "buildingsOperational": 5,
        "itNameplateMw": 436,
        "facilityNameplateMw": 509,
        "kind": "projected"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2026-12-31",
        "period": "2026-Q4",
        "constructionStatus": "According to the [schedule](https://ir.applieddigital.com/news-events/press-releases/detail/128/applied-digital-finalizes-additional-150mw-lease-with), Building 2 should be online sometime in the second half of 2026. We can estimate the end of 2026 for 250 MW operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 88,
        "facilityNameplateMw": 114,
        "kind": "projected"
      },
      {
        "site": "CoreWeave Ellendale ND",
        "date": "2027-06-01",
        "period": "2027-Q2",
        "constructionStatus": "According to [schedule](https://ir.applieddigital.com/news-events/press-releases/detail/128/applied-digital-finalizes-additional-150mw-lease-with), Building 3 should come online in the first half of 2027. That would bring the full PF1 campus to 400 MW, according to the contract.",
        "buildingsOperational": 3,
        "itNameplateMw": 400,
        "facilityNameplateMw": 520,
        "kind": "projected"
      },
      {
        "site": "Google Storey County",
        "date": "2027-06-30",
        "period": "2027-Q2",
        "constructionStatus": "Building 3 is estimated to be operational. We estimate the operational date by analogy to the time that Building 1 took to go from a foundation to being operational. The power capacity is based on the number of generators reported in an air quality permit [application](https://ndep-onbase.nv.gov/api/Document/AeFo%C3%89pjclbkomJ7CWpPryLOjA6FQT9HFrkSuMWbMXTpKCzSR%C3%81W1f8zzFhGhik1iZCcNSpuTRRqNXD1inrrpBxtA%3D/) (p.92-93). The dry cooler array is more than double the size of the Building 1 array, which suggests an even larger power capacity than we estimate, but we believe the generator-based estimate is more reliable here.",
        "buildingsOperational": 3,
        "itNameplateMw": 300,
        "facilityNameplateMw": 389,
        "kind": "projected"
      },
      {
        "site": "Google Mesa",
        "date": "2026-08-15",
        "period": "2026-Q3",
        "constructionStatus": "Building 2 is operational. This is estimated based on the close-to-complete construction status from May 2026.",
        "buildingsOperational": 2,
        "itNameplateMw": 183,
        "facilityNameplateMw": 237,
        "kind": "projected"
      },
      {
        "site": "STACK Infrastructure NVA02",
        "date": "2028-01-01",
        "period": "2028-Q1",
        "constructionStatus": "Estimate: All 6 AI data center buildings will be finished in 2028, assuming a groundbreak-to-operational timeline of 18-24 months. One is complete, three are clearly under construction, and the last two data centers are still breaking ground and laying foundations.",
        "buildingsOperational": 6,
        "itNameplateMw": 348,
        "facilityNameplateMw": 487,
        "kind": "projected"
      },
      {
        "site": "Google Red Oak",
        "date": "2026-12-01",
        "period": "2026-Q4",
        "constructionStatus": "Building 2 is estimated to be operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 154,
        "facilityNameplateMw": 185,
        "kind": "projected"
      },
      {
        "site": "Stream Phoenix",
        "date": "2030-01-01",
        "period": "2030-Q1",
        "constructionStatus": "Although official [promotional sources](https://www.streamdatacenters.com/wp-content/uploads/2026/01/SDC-Goodyear-CaseStudy-251218.pdf) estimate the campus to be fully operational in 10-12 years, it is likely to be finished sooner than this given the empirical durations for other data center campuses as well as because AI building 6 has been expedited. The first AI building took approximately 24 months to complete. Assuming construction for a new building starts midway for every building, then the campus will be complete in 4 years for the 5 remaining buildings, since AI buildings 2 and 6 are both underway.",
        "buildingsOperational": 6,
        "itNameplateMw": 220,
        "facilityNameplateMw": 267,
        "kind": "projected"
      },
      {
        "site": "Vantage TX1",
        "date": "2027-08-31",
        "period": "2027-Q3",
        "constructionStatus": "Estimated construction completion date of Building 2. [Construction Project Filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026001234)",
        "buildingsOperational": 2,
        "itNameplateMw": 128,
        "facilityNameplateMw": 179.2,
        "kind": "projected"
      },
      {
        "site": "Start Campus Sines Data Campus",
        "date": "2027-09-30",
        "period": "2027-Q3",
        "constructionStatus": "Building 2 (SIN02) projected to be operational. This is based on the timeline provided in the [factsheet](https://23712035.hs-sites.com/hubfs/SINES_02.PDF.pdf?hsCtaAttrib=199407154715) for the site. We expect VR200 GPUs to be used as a lot of those chips will have already been available in September 2027, and the \"up to 600kW racks\" in the factsheet suggest they are aiming for this.",
        "buildingsOperational": 2,
        "itNameplateMw": 233,
        "facilityNameplateMw": 280,
        "kind": "projected"
      },
      {
        "site": "Google Pryor (North)",
        "date": "2026-08-24",
        "period": "2026-Q3",
        "constructionStatus": "Building 2 is operational (estimate).",
        "buildingsOperational": 2,
        "itNameplateMw": 368,
        "facilityNameplateMw": 442,
        "kind": "projected"
      },
      {
        "site": "CoreWeave Muskogee OK",
        "date": "2026-12-31",
        "period": "2026-Q4",
        "constructionStatus": "Estimating building 1 is operational by the end of the year, judging from the building currently completed, the completed power substation to the southwest. The surrounding yard work/construction will likely still take several months, judging from the slow pace.",
        "buildingsOperational": 1,
        "itNameplateMw": 70,
        "facilityNameplateMw": 98,
        "kind": "projected"
      },
      {
        "site": "CoreWeave Muskogee OK",
        "date": "2027-12-31",
        "period": "2027-Q4",
        "constructionStatus": "Core Scientific expects initial delivery of the second, unleased 82.5 MW Muskogee building in Q4 2027. Not signed to have CoreWeave GPUs as of yet, but may change in the future. Source: https://www.sec.gov/Archives/edgar/data/1839341/000162828026030918/exhibit991polarispressre.htm",
        "buildingsOperational": 2,
        "itNameplateMw": 153,
        "facilityNameplateMw": 181,
        "kind": "projected"
      },
      {
        "site": "Crusoe Abilene Expansion",
        "date": "2027-09-17",
        "period": "2027-Q3",
        "constructionStatus": "Building 1 operational. Based on the completion date to \"build-out an office and data hall\", stated in a [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026008308).",
        "buildingsOperational": 1,
        "itNameplateMw": 336,
        "facilityNameplateMw": 470,
        "kind": "projected"
      },
      {
        "site": "Crusoe Abilene Expansion",
        "date": "2027-11-11",
        "period": "2027-Q4",
        "constructionStatus": "Building 2 operational. Based on the completion date to \"build-out an office and data hall\", stated in a [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026008308).",
        "buildingsOperational": 2,
        "itNameplateMw": 672,
        "facilityNameplateMw": 941,
        "kind": "projected"
      },
      {
        "site": "Goodnight",
        "date": "2026-12-15",
        "period": "2026-Q4",
        "constructionStatus": "Building 1 operational. This [regulatory document](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025027064) lists the completion date for Building 1 as 2026-09-12, the current status suggests this estimate will not be met.  From the timeline seen at the Abilene, Texas site for the same building styles we estimate operability to occur 8 months after the state seen in April 2026.",
        "buildingsOperational": 1,
        "itNameplateMw": 103,
        "facilityNameplateMw": 132.5,
        "kind": "projected"
      },
      {
        "site": "Goodnight",
        "date": "2027-02-15",
        "period": "2027-Q1",
        "constructionStatus": "Building 2 operational. The completion date for [Building 2 Tenant Improvement](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2025027065) is 2026-11-07, about 2 months later than Building 1. We therefore add 2 months to the Building 1 operational date.",
        "buildingsOperational": 2,
        "itNameplateMw": 206,
        "facilityNameplateMw": 265,
        "kind": "projected"
      },
      {
        "site": "Goodnight",
        "date": "2027-10-01",
        "period": "2027-Q4",
        "constructionStatus": "6 buildings are operational. This is based on:\n1. A [regulatory filing](https://www.tdlr.texas.gov/TABS/Search/Project/TABS2026010861) for Building 6 with a completion date of 2027-07-30. Normally there is a follow-up filing for \"tenant improvement\" which involves building the interior, with a completion date 1-3 months after the initial filing.\n2. A project deadline of EOY 2027 in the [original tax abatement agreement](https://www.co.armstrong.tx.us/upload/page/5361/Phase%201%20Tax%20Abatement%20Agreement%20-%20Signed.pdf)\n3. The similar 8-building project in Abilene taking an estimated 2 years and 2 months.",
        "buildingsOperational": 6,
        "itNameplateMw": 1006,
        "facilityNameplateMw": 1294.1,
        "kind": "projected"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2026-12-31",
        "period": "2026-Q4",
        "constructionStatus": "Building 1 is operational. There is still work to be done since April, and Q4 2026 operational estimate was based on visible progress then.",
        "buildingsOperational": 1,
        "itNameplateMw": 87,
        "facilityNameplateMw": 105,
        "kind": "projected"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2027-02-22",
        "period": "2027-Q1",
        "constructionStatus": "Building 2 is operational. Based on Google Omaha Building 3 taking about 14 months from starting the roof to operation.",
        "buildingsOperational": 2,
        "itNameplateMw": 174,
        "facilityNameplateMw": 209,
        "kind": "projected"
      },
      {
        "site": "Google Cedar Rapids",
        "date": "2027-05-23",
        "period": "2027-Q2",
        "constructionStatus": "Building 3 is operational. Earlier satellite images suggest it was about 3 months behind Building 2.",
        "buildingsOperational": 3,
        "itNameplateMw": 261,
        "facilityNameplateMw": 314,
        "kind": "projected"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2026-12-01",
        "period": "2026-Q4",
        "constructionStatus": "Estimated operational date of Building 2, the first AI compute building. However, this represents less than 1/5 of the estimated total compute being available because chips installed in the future will be more power-efficient.",
        "buildingsOperational": 1,
        "itNameplateMw": 173,
        "facilityNameplateMw": 207,
        "kind": "projected"
      },
      {
        "site": "Google Fort Wayne",
        "date": "2028-04-01",
        "period": "2028-Q2",
        "constructionStatus": "Estimated completion time for all 5 main AI buildings assuming construction continues at the same rate, based on the observed timelines of Buildings 2 and 3.",
        "buildingsOperational": 5,
        "itNameplateMw": 863,
        "facilityNameplateMw": 1035,
        "kind": "projected"
      },
      {
        "site": "Google Kansas City East",
        "date": "2026-08-01",
        "period": "2026-Q3",
        "constructionStatus": "Building 1 operational. Estimated based on present construction progress and typical timelines.",
        "buildingsOperational": 1,
        "itNameplateMw": 105,
        "facilityNameplateMw": 126,
        "kind": "projected"
      },
      {
        "site": "Meta Aiken",
        "date": "2026-07-15",
        "period": "2026-Q3",
        "constructionStatus": "Building 1 and 2 are operational (estimate).",
        "buildingsOperational": 2,
        "itNameplateMw": 142,
        "facilityNameplateMw": 185,
        "kind": "projected"
      },
      {
        "site": "Meta Cheyenne",
        "date": "2026-07-25",
        "period": "2026-Q3",
        "constructionStatus": "Both buildings estimated to be operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 152,
        "facilityNameplateMw": 182,
        "kind": "projected"
      },
      {
        "site": "Meta Cheyenne",
        "date": "2027-02-15",
        "period": "2027-Q1",
        "constructionStatus": "Buildings 3 and 4 are similar in style and size to the ones seen at the Prometheus site, we estimate their operability based on that timeline.",
        "buildingsOperational": 4,
        "itNameplateMw": 220,
        "facilityNameplateMw": 264,
        "kind": "projected"
      },
      {
        "site": "Meta Hyperion",
        "date": "2026-12-01",
        "period": "2026-Q4",
        "constructionStatus": "New [power stations](https://drive.google.com/file/d/1D4eUHwEuirNi0g3IU_xGOti3PcC8fcXi/view?usp=sharing) are in service for a 1.8 GW load at Holly Ridge. However, the data center is still not operational.",
        "buildingsOperational": 0,
        "itNameplateMw": 0,
        "facilityNameplateMw": 0,
        "kind": "projected"
      },
      {
        "site": "Meta Hyperion",
        "date": "2028-01-01",
        "period": "2028-Q1",
        "constructionStatus": "First phase is operational, based on a [Meta blog post](https://drive.google.com/file/d/1PmFNgOwkPepwjpGIbNUuPJP0LNgIqe7l/view?usp=sharing). We assume that this aligns with the three natural gas turbines being completed, for a total of 2262 MW capacity, but that these turbines have a backup role. This is close to the 1800 MW of load requested from the grid. Meta [claims](https://engineering.fb.com/2025/09/29/data-infrastructure/metas-infrastructure-evolution-and-the-advent-of-ai/) that \"The Hyperion cluster will have a 5-gigawatt capacity once complete\", but so far there is no concrete evidence for this happening at the Holly Ridge site alone.",
        "buildingsOperational": 9,
        "itNameplateMw": 1676,
        "facilityNameplateMw": 2262,
        "kind": "projected"
      },
      {
        "site": "Meta Sarpy",
        "date": "2026-08-02",
        "period": "2026-Q3",
        "constructionStatus": "Building 1 is operational (estimate).",
        "buildingsOperational": 1,
        "itNameplateMw": 80,
        "facilityNameplateMw": 105,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Michigan",
        "date": "2028-12-31",
        "period": "2028-Q4",
        "constructionStatus": "Buildings 1-3 operational. Based on when maximum power load will be provided by DTE energy (Dec 2027), which can be extended by a year. [Source, page 3](https://mi-psc.my.site.com/sfc/servlet.shepherd/version/download/068cs00001MH71XAAT)",
        "buildingsOperational": 3,
        "itNameplateMw": 988,
        "facilityNameplateMw": 1383,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Milam",
        "date": "2028-12-31",
        "period": "2028-Q4",
        "constructionStatus": "All buildings finished, site is fully operational. Our reasoning is that examples so far take a median of 2-2.5 years to go from land clearing to 1 GW. This suggests around 2028-01-01 here. However, due to delays being more likely than speedups and the fact that this base rate data is still unproven, the more conservative estimate is made. The current state of the site also supports this estimation.",
        "buildingsOperational": null,
        "itNameplateMw": 857,
        "facilityNameplateMw": 1200,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate New Mexico",
        "date": "2028-12-31",
        "period": "2028-Q4",
        "constructionStatus": "Estimated construction completion date of the site. Stormwater permitting says 2027-12-31 for stormwater construction to finish, but for a more conservative estimate and based on the current state of the site, we pushed the final date by a year beyond it. [Source, page 2](https://drive.google.com/file/d/1vVKvPogq2TkeFn7ibnp0GNqz8aB4tZXz/view?usp=sharing)",
        "buildingsOperational": 4,
        "itNameplateMw": 1578,
        "facilityNameplateMw": 2210,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2027-08-15",
        "period": "2027-Q3",
        "constructionStatus": "Building 1 is operational (estimate). TDLR lists the construction completion date for Building 1 as 2027-02-15. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 1,
        "itNameplateMw": 140,
        "facilityNameplateMw": 196,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2027-10-19",
        "period": "2027-Q4",
        "constructionStatus": "Building 2 is operational (estimate). TDLR lists the construction completion date for Building 2 as 2027-04-19. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 2,
        "itNameplateMw": 280,
        "facilityNameplateMw": 392,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2027-11-18",
        "period": "2027-Q4",
        "constructionStatus": "Building 3 is operational (estimate). TDLR lists the construction completion date for Building 3 as 2027-05-18. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 3,
        "itNameplateMw": 420,
        "facilityNameplateMw": 588,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-02-11",
        "period": "2028-Q1",
        "constructionStatus": "Building 4 is operational (estimate). TDLR lists the construction completion date for Building 4 as 2027-08-11. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 4,
        "itNameplateMw": 560,
        "facilityNameplateMw": 784,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-03-08",
        "period": "2028-Q1",
        "constructionStatus": "Building 5 is operational (estimate). TDLR lists the construction completion date for Building 5 as 2027-09-08. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 5,
        "itNameplateMw": 700,
        "facilityNameplateMw": 980,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-04-04",
        "period": "2028-Q2",
        "constructionStatus": "Building 6 is operational (estimate). TDLR lists the construction completion date for Building 6 as 2027-10-04. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 6,
        "itNameplateMw": 840,
        "facilityNameplateMw": 1176,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-05-12",
        "period": "2028-Q2",
        "constructionStatus": "Building 7 is operational (estimate). TDLR lists the construction completion date for Building 7 as 2027-11-12. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 7,
        "itNameplateMw": 980,
        "facilityNameplateMw": 1372,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-10-17",
        "period": "2028-Q4",
        "constructionStatus": "Building 8 is operational (estimate). TDLR lists the construction completion date for Building 8 as 2028-04-17. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 8,
        "itNameplateMw": 1120,
        "facilityNameplateMw": 1568,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-10-18",
        "period": "2028-Q4",
        "constructionStatus": "Building 9 is operational (estimate). TDLR lists the construction completion date for Building 9 as 2028-04-18. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 9,
        "itNameplateMw": 1260,
        "facilityNameplateMw": 1764,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Shackelford",
        "date": "2028-11-11",
        "period": "2028-Q4",
        "constructionStatus": "Building 10 is operational (estimate). TDLR lists the construction completion date for Building 10 as 2028-05-11. We add 6 months for commissioning, installation etc. before assuming the building is fully operational.",
        "buildingsOperational": 10,
        "itNameplateMw": 1400,
        "facilityNameplateMw": 1960,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate UAE",
        "date": "2026-12-01",
        "period": "2026-Q4",
        "constructionStatus": "Building 1 and 2 are operational. The similar data center in Ajman, UAE was delayed by over a year, now due in December 2026 (compare [1](https://khaznadatacenters.com/press-release/khazna-expands-infrastructure-to-accelerate-uaes-leadership-in-artificial-intelligence/), [2](https://khaznadatacenters.com/press-release/khazna-announces-the-uaes-first-ai-optimized-data-center-and-the-largest-in-its-portfolio-powering-the-nations-drive-toward-ai-leadership/)). The buildings here looked 3-6 months behind the Ajman building as of November 2025, but they were moving faster. So we think Building 1 and 2 are on track for 200 MW by December 2026, along with the Ajman building.",
        "buildingsOperational": 2,
        "itNameplateMw": 200,
        "facilityNameplateMw": 280,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate UAE",
        "date": "2028-01-01",
        "period": "2028-Q1",
        "constructionStatus": "1 GW of IT power is operational. We haven’t seen expansion beyond 200 MW as of November 2025. Optimistically, 8 more 100 MW buildings start construction in December 2025, in parallel, and take 1.5 years like the first two buildings, hitting 1 GW by Q3 2027. More realistically, there's some staggering of construction over several months, like Stargate Abilene. Our median estimate is January 2028.",
        "buildingsOperational": 10,
        "itNameplateMw": 1000,
        "facilityNameplateMw": 1400,
        "kind": "projected"
      },
      {
        "site": "OpenAI Stargate Wisconsin",
        "date": "2028-12-31",
        "period": "2028-Q4",
        "constructionStatus": "Building 4 and supporting facilities/buildings operational, whole facility now operational. Based on the [environmental analysis (page 6)](https://drive.google.com/file/d/1ft2ZzqAYZtsTqMwyML4eo_EFYuclVxE6/view?usp=sharing) filed for the site.",
        "buildingsOperational": 4,
        "itNameplateMw": 902,
        "facilityNameplateMw": 1300,
        "kind": "projected"
      },
      {
        "site": "QTS Cedar Rapids",
        "date": "2026-11-15",
        "period": "2026-Q4",
        "constructionStatus": "Buildings 1-3 are operational. Based on the expected completion date reported by [local news](https://corridorbusiness.com/scope-of-qts-data-project-in-cedar-rapids-continuing-to-grow/): “A QTS spokesperson said in July [2025] that the first phase of the project was expected to be completed in late 2026.\"",
        "buildingsOperational": 3,
        "itNameplateMw": 448,
        "facilityNameplateMw": 627,
        "kind": "projected"
      },
      {
        "site": "QTS Cedar Rapids",
        "date": "2027-11-15",
        "period": "2027-Q4",
        "constructionStatus": "Buildings 4-7 are operational. Based on the expected completion date reported by [local news](https://corridorbusiness.com/scope-of-qts-data-project-in-cedar-rapids-continuing-to-grow/): “A QTS spokesperson said in July [2025] that [...] The second phase is expected to be completed in late 2027.\"",
        "buildingsOperational": 7,
        "itNameplateMw": 1133,
        "facilityNameplateMw": 1587,
        "kind": "projected"
      }
    ],
    "frontier": {
      "actual": [
        {
          "site": "Google Papillion",
          "date": "2024-08-11",
          "period": "2024-Q3",
          "capacityIndex": 80344,
          "kind": "observed-frontier"
        },
        {
          "site": "Colossus 1",
          "date": "2024-09-02",
          "period": "2024-Q3",
          "capacityIndex": 100000,
          "kind": "observed-frontier"
        },
        {
          "site": "Colossus 1",
          "date": "2025-02-17",
          "period": "2025-Q1",
          "capacityIndex": 200000,
          "kind": "observed-frontier"
        },
        {
          "site": "Anthropic-Amazon New Carlisle",
          "date": "2025-06-23",
          "period": "2025-Q2",
          "capacityIndex": 300152,
          "kind": "observed-frontier"
        },
        {
          "site": "Microsoft Fairwater Atlanta",
          "date": "2025-10-14",
          "period": "2025-Q4",
          "capacityIndex": 373926,
          "kind": "observed-frontier"
        },
        {
          "site": "Anthropic-Amazon New Carlisle",
          "date": "2025-12-23",
          "period": "2025-Q4",
          "capacityIndex": 471450,
          "kind": "observed-frontier"
        },
        {
          "site": "Meta Prometheus",
          "date": "2026-02-27",
          "period": "2026-Q1",
          "capacityIndex": 493684,
          "kind": "observed-frontier"
        },
        {
          "site": "Anthropic-Amazon New Carlisle",
          "date": "2026-03-23",
          "period": "2026-Q1",
          "capacityIndex": 687216,
          "kind": "observed-frontier"
        },
        {
          "site": "Meta Prometheus",
          "date": "2026-05-28",
          "period": "2026-Q2",
          "capacityIndex": 763012,
          "kind": "observed-frontier"
        }
      ],
      "projected": [
        {
          "site": "Anthropic-Amazon New Carlisle",
          "date": "2026-06-21",
          "period": "2026-Q2",
          "capacityIndex": 818595,
          "kind": "future-frontier"
        },
        {
          "site": "Colossus 2",
          "date": "2026-07-01",
          "period": "2026-Q3",
          "capacityIndex": 1111673,
          "kind": "future-frontier"
        },
        {
          "site": "Goodnight",
          "date": "2027-10-01",
          "period": "2027-Q4",
          "capacityIndex": 2011117,
          "kind": "future-frontier"
        },
        {
          "site": "QTS Cedar Rapids",
          "date": "2027-11-15",
          "period": "2027-Q4",
          "capacityIndex": 3518580,
          "kind": "future-frontier"
        },
        {
          "site": "Meta Hyperion",
          "date": "2028-01-01",
          "period": "2028-Q1",
          "capacityIndex": 3693785,
          "kind": "future-frontier"
        }
      ],
      "excludedOtherRows": 222,
      "excludedAnalyticRows": 1200
    },
    "constraints": {
      "currentSingleSiteItNameplateCeilingMw": 946,
      "projectedSingleSiteItNameplateCeilingMw": 2263,
      "medianObservedFrontierRecordIntervalDays": 68,
      "futureFrontierDates": [
        "2026-06-21",
        "2026-07-01",
        "2027-10-01",
        "2027-11-15",
        "2028-01-01"
      ],
      "frontierGlobalSumAllowed": false
    },
    "quality": {
      "asOf": "2026-07-14",
      "totalTimelineRows": 411,
      "actualRows": 337,
      "projectedRows": 74,
      "coveredActualSites": 54,
      "projectedSites": 44,
      "zeroPowerRows": 149,
      "latestActualDate": "2026-07-01",
      "latestProjectedDate": "2030-01-01",
      "latestActualItNameplateGw": 11.156799999999999,
      "latestActualFacilityNameplateGw": 14.301599999999999,
      "weightedObservedPue": 1.2818729384769827,
      "classification": "Timeline dates through 2026-07-14 are observations; later dates and every explicit Future frontier row remain projections."
    },
    "source": {
      "id": "epoch-ai-data-center-power",
      "label": "Epoch AI · AI Data Centers",
      "url": "https://epoch.ai/data/data_centers/data_center_timelines.csv",
      "frontierUrl": "https://epoch.ai/data/charts/largest-data-center-compute/frontier_data_centers.csv",
      "role": "site-observation-and-constraint-only"
    }
  },
  "companies": {
    "alphabet": {
      "id": "alphabet",
      "name": "Alphabet",
      "cik": "0001652044",
      "quarters": [
        {
          "period": "2017-Q1",
          "end": "2017-03-31",
          "capex": 2.508,
          "capexFirstReported": 2.508,
          "capexLatestRestated": 2.508,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-05-02",
          "capexFiledLatest": "2018-04-24",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.508,
          "capexLatest": 2.508,
          "capexRestatementPct": 0,
          "firstFiled": "2017-05-02",
          "latestFiled": "2018-04-24",
          "filed": "2018-04-24",
          "revenue": 24.75,
          "revenueFirstReported": 24.75,
          "revenueLatestRestated": 24.75,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-05-02",
          "revenueFiledLatest": "2018-04-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.548,
          "operatingCashFlowFirstReported": 9.548,
          "operatingCashFlowLatestRestated": 9.548,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-05-02",
          "operatingCashFlowFiledLatest": "2018-04-24",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2017-Q2",
          "end": "2017-06-30",
          "capex": 2.831,
          "capexFirstReported": 2.831,
          "capexLatestRestated": 2.831,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-07-25",
          "capexFiledLatest": "2018-07-24",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.831,
          "capexLatest": 2.831,
          "capexRestatementPct": 0,
          "firstFiled": "2017-07-25",
          "latestFiled": "2018-07-24",
          "filed": "2018-07-24",
          "revenue": 26.01,
          "revenueFirstReported": 26.01,
          "revenueLatestRestated": 26.01,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-07-25",
          "revenueFiledLatest": "2018-07-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.403,
          "operatingCashFlowFirstReported": 7.403,
          "operatingCashFlowLatestRestated": 7.403,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-07-25",
          "operatingCashFlowFiledLatest": "2018-07-24",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2017-Q3",
          "end": "2017-09-30",
          "capex": 3.538,
          "capexFirstReported": 3.538,
          "capexLatestRestated": 3.538,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-10-27",
          "capexFiledLatest": "2018-10-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.538,
          "capexLatest": 3.538,
          "capexRestatementPct": 0,
          "firstFiled": "2017-10-27",
          "latestFiled": "2018-10-26",
          "filed": "2018-10-26",
          "revenue": 27.772,
          "revenueFirstReported": 27.772,
          "revenueLatestRestated": 27.772,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-10-27",
          "revenueFiledLatest": "2018-10-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.872,
          "operatingCashFlowFirstReported": 9.872,
          "operatingCashFlowLatestRestated": 9.872,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-10-27",
          "operatingCashFlowFiledLatest": "2018-10-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2017-Q4",
          "end": "2017-12-31",
          "capex": 4.307,
          "capexFirstReported": 4.307,
          "capexLatestRestated": 4.307,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-02-06",
          "capexFiledLatest": "2020-02-04",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 4.307,
          "capexLatest": 4.307,
          "capexRestatementPct": 0,
          "firstFiled": "2018-02-06",
          "latestFiled": "2020-02-04",
          "filed": "2020-02-04",
          "revenue": 32.323,
          "revenueFirstReported": 32.323,
          "revenueLatestRestated": 32.323,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-02-06",
          "revenueFiledLatest": "2020-02-04",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 10.268,
          "operatingCashFlowFirstReported": 10.268,
          "operatingCashFlowLatestRestated": 10.268,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-02-06",
          "operatingCashFlowFiledLatest": "2020-02-04",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2018-Q1",
          "end": "2018-03-31",
          "capex": 7.299,
          "capexFirstReported": 7.299,
          "capexLatestRestated": 7.299,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-04-24",
          "capexFiledLatest": "2019-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 7.299,
          "capexLatest": 7.299,
          "capexRestatementPct": 0,
          "firstFiled": "2018-04-24",
          "latestFiled": "2019-04-30",
          "filed": "2019-04-30",
          "revenue": 31.146,
          "revenueFirstReported": 31.146,
          "revenueLatestRestated": 31.146,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-04-24",
          "revenueFiledLatest": "2019-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 11.642,
          "operatingCashFlowFirstReported": 11.642,
          "operatingCashFlowLatestRestated": 11.642,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-04-24",
          "operatingCashFlowFiledLatest": "2019-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q2",
          "end": "2018-06-30",
          "capex": 5.477,
          "capexFirstReported": 5.477,
          "capexLatestRestated": 5.477,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-07-24",
          "capexFiledLatest": "2019-07-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.477,
          "capexLatest": 5.477,
          "capexRestatementPct": 0,
          "firstFiled": "2018-07-24",
          "latestFiled": "2019-07-26",
          "filed": "2019-07-26",
          "revenue": 32.657,
          "revenueFirstReported": 32.657,
          "revenueLatestRestated": 32.657,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-07-24",
          "revenueFiledLatest": "2019-07-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 10.132,
          "operatingCashFlowFirstReported": 10.132,
          "operatingCashFlowLatestRestated": 10.132,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-07-24",
          "operatingCashFlowFiledLatest": "2019-07-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2018-Q3",
          "end": "2018-09-30",
          "capex": 5.282,
          "capexFirstReported": 5.282,
          "capexLatestRestated": 5.282,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-10-26",
          "capexFiledLatest": "2019-10-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.282,
          "capexLatest": 5.282,
          "capexRestatementPct": 0,
          "firstFiled": "2018-10-26",
          "latestFiled": "2019-10-29",
          "filed": "2019-10-29",
          "revenue": 33.74,
          "revenueFirstReported": 33.74,
          "revenueLatestRestated": 33.74,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-10-26",
          "revenueFiledLatest": "2019-10-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.21,
          "operatingCashFlowFirstReported": 13.21,
          "operatingCashFlowLatestRestated": 13.21,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-10-26",
          "operatingCashFlowFiledLatest": "2019-10-29",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2018-Q4",
          "end": "2018-12-31",
          "capex": 7.081,
          "capexFirstReported": 7.081,
          "capexLatestRestated": 7.081,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-02-05",
          "capexFiledLatest": "2021-02-03",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 7.081,
          "capexLatest": 7.081,
          "capexRestatementPct": 0,
          "firstFiled": "2019-02-05",
          "latestFiled": "2021-02-03",
          "filed": "2021-02-03",
          "revenue": 39.276,
          "revenueFirstReported": 39.276,
          "revenueLatestRestated": 39.276,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-02-05",
          "revenueFiledLatest": "2020-02-04",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 12.987,
          "operatingCashFlowFirstReported": 12.987,
          "operatingCashFlowLatestRestated": 12.987,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-02-05",
          "operatingCashFlowFiledLatest": "2021-02-03",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2019-Q1",
          "end": "2019-03-31",
          "capex": 4.638,
          "capexFirstReported": 4.638,
          "capexLatestRestated": 4.638,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-04-30",
          "capexFiledLatest": "2020-04-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 4.638,
          "capexLatest": 4.638,
          "capexRestatementPct": 0,
          "firstFiled": "2019-04-30",
          "latestFiled": "2020-04-29",
          "filed": "2020-04-29",
          "revenue": 36.339,
          "revenueFirstReported": 36.339,
          "revenueLatestRestated": 36.339,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-04-30",
          "revenueFiledLatest": "2020-04-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12,
          "operatingCashFlowFirstReported": 12,
          "operatingCashFlowLatestRestated": 12,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-04-30",
          "operatingCashFlowFiledLatest": "2020-04-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q2",
          "end": "2019-06-30",
          "capex": 6.126,
          "capexFirstReported": 6.126,
          "capexLatestRestated": 6.126,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-07-26",
          "capexFiledLatest": "2020-07-31",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.126,
          "capexLatest": 6.126,
          "capexRestatementPct": 0,
          "firstFiled": "2019-07-26",
          "latestFiled": "2020-07-31",
          "filed": "2020-07-31",
          "revenue": 38.944,
          "revenueFirstReported": 38.944,
          "revenueLatestRestated": 38.944,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-07-26",
          "revenueFiledLatest": "2020-07-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.627,
          "operatingCashFlowFirstReported": 12.627,
          "operatingCashFlowLatestRestated": 12.627,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-07-26",
          "operatingCashFlowFiledLatest": "2020-07-31",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2019-Q3",
          "end": "2019-09-30",
          "capex": 6.732,
          "capexFirstReported": 6.732,
          "capexLatestRestated": 6.732,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-10-29",
          "capexFiledLatest": "2020-10-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.732,
          "capexLatest": 6.732,
          "capexRestatementPct": 0,
          "firstFiled": "2019-10-29",
          "latestFiled": "2020-10-30",
          "filed": "2020-10-30",
          "revenue": 40.499,
          "revenueFirstReported": 40.499,
          "revenueLatestRestated": 40.499,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-10-29",
          "revenueFiledLatest": "2020-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 15.466,
          "operatingCashFlowFirstReported": 15.466,
          "operatingCashFlowLatestRestated": 15.466,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-10-29",
          "operatingCashFlowFiledLatest": "2020-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2019-Q4",
          "end": "2019-12-31",
          "capex": 6.052,
          "capexFirstReported": 6.052,
          "capexLatestRestated": 6.052,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-02-04",
          "capexFiledLatest": "2022-02-02",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 6.052,
          "capexLatest": 6.052,
          "capexRestatementPct": 0,
          "firstFiled": "2020-02-04",
          "latestFiled": "2022-02-02",
          "filed": "2022-02-02",
          "revenue": 46.075,
          "revenueFirstReported": 46.075,
          "revenueLatestRestated": 46.075,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-02-04",
          "revenueFiledLatest": "2020-10-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 14.427,
          "operatingCashFlowFirstReported": 14.427,
          "operatingCashFlowLatestRestated": 14.427,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-02-04",
          "operatingCashFlowFiledLatest": "2022-02-02",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2020-Q1",
          "end": "2020-03-31",
          "capex": 6.005,
          "capexFirstReported": 6.005,
          "capexLatestRestated": 6.005,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-04-29",
          "capexFiledLatest": "2021-04-28",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.005,
          "capexLatest": 6.005,
          "capexRestatementPct": 0,
          "firstFiled": "2020-04-29",
          "latestFiled": "2021-04-28",
          "filed": "2021-04-28",
          "revenue": 41.159,
          "revenueFirstReported": 41.159,
          "revenueLatestRestated": 41.159,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-04-29",
          "revenueFiledLatest": "2021-04-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 11.451,
          "operatingCashFlowFirstReported": 11.451,
          "operatingCashFlowLatestRestated": 11.451,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-04-29",
          "operatingCashFlowFiledLatest": "2021-04-28",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q2",
          "end": "2020-06-30",
          "capex": 5.391,
          "capexFirstReported": 5.391,
          "capexLatestRestated": 5.391,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-07-31",
          "capexFiledLatest": "2020-07-31",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.391,
          "capexLatest": 5.391,
          "capexRestatementPct": 0,
          "firstFiled": "2020-07-31",
          "latestFiled": "2020-07-31",
          "filed": "2020-07-31",
          "revenue": 38.297,
          "revenueFirstReported": 38.297,
          "revenueLatestRestated": 38.297,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-07-31",
          "revenueFiledLatest": "2021-07-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.993,
          "operatingCashFlowFirstReported": 13.993,
          "operatingCashFlowLatestRestated": 13.993,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-07-31",
          "operatingCashFlowFiledLatest": "2021-07-28",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2020-Q3",
          "end": "2020-09-30",
          "capex": 5.406,
          "capexFirstReported": 5.406,
          "capexLatestRestated": 5.406,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-10-30",
          "capexFiledLatest": "2020-10-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.406,
          "capexLatest": 5.406,
          "capexRestatementPct": 0,
          "firstFiled": "2020-10-30",
          "latestFiled": "2020-10-30",
          "filed": "2020-10-30",
          "revenue": 46.173,
          "revenueFirstReported": 46.173,
          "revenueLatestRestated": 46.173,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-10-30",
          "revenueFiledLatest": "2021-10-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 17.003,
          "operatingCashFlowFirstReported": 17.003,
          "operatingCashFlowLatestRestated": 17.003,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-10-30",
          "operatingCashFlowFiledLatest": "2021-10-27",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2020-Q4",
          "end": "2020-12-31",
          "capex": 5.479,
          "capexFirstReported": 5.479,
          "capexLatestRestated": 5.479,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-02-03",
          "capexFiledLatest": "2023-02-03",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 5.479,
          "capexLatest": 5.479,
          "capexRestatementPct": 0,
          "firstFiled": "2021-02-03",
          "latestFiled": "2023-02-03",
          "filed": "2023-02-03",
          "revenue": 56.898,
          "revenueFirstReported": 56.898,
          "revenueLatestRestated": 56.898,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-02-03",
          "revenueFiledLatest": "2023-02-03",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 22.677,
          "operatingCashFlowFirstReported": 22.677,
          "operatingCashFlowLatestRestated": 22.677,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-02-03",
          "operatingCashFlowFiledLatest": "2023-02-03",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2021-Q1",
          "end": "2021-03-31",
          "capex": 5.942,
          "capexFirstReported": 5.942,
          "capexLatestRestated": 5.942,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-04-28",
          "capexFiledLatest": "2022-04-27",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.942,
          "capexLatest": 5.942,
          "capexRestatementPct": 0,
          "firstFiled": "2021-04-28",
          "latestFiled": "2022-04-27",
          "filed": "2022-04-27",
          "revenue": 55.314,
          "revenueFirstReported": 55.314,
          "revenueLatestRestated": 55.314,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-04-28",
          "revenueFiledLatest": "2022-04-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 19.289,
          "operatingCashFlowFirstReported": 19.289,
          "operatingCashFlowLatestRestated": 19.289,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-04-28",
          "operatingCashFlowFiledLatest": "2022-04-27",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q2",
          "end": "2021-06-30",
          "capex": 5.496,
          "capexFirstReported": 5.496,
          "capexLatestRestated": 5.496,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-07-28",
          "capexFiledLatest": "2022-07-27",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 5.496,
          "capexLatest": 5.496,
          "capexRestatementPct": 0,
          "firstFiled": "2021-07-28",
          "latestFiled": "2022-07-27",
          "filed": "2022-07-27",
          "revenue": 61.88,
          "revenueFirstReported": 61.88,
          "revenueLatestRestated": 61.88,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-07-28",
          "revenueFiledLatest": "2022-07-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 21.89,
          "operatingCashFlowFirstReported": 21.89,
          "operatingCashFlowLatestRestated": 21.89,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-07-28",
          "operatingCashFlowFiledLatest": "2022-07-27",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2021-Q3",
          "end": "2021-09-30",
          "capex": 6.819,
          "capexFirstReported": 6.819,
          "capexLatestRestated": 6.819,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-10-27",
          "capexFiledLatest": "2022-10-26",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 6.819,
          "capexLatest": 6.819,
          "capexRestatementPct": 0,
          "firstFiled": "2021-10-27",
          "latestFiled": "2022-10-26",
          "filed": "2022-10-26",
          "revenue": 65.118,
          "revenueFirstReported": 65.118,
          "revenueLatestRestated": 65.118,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-10-27",
          "revenueFiledLatest": "2022-10-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 25.539,
          "operatingCashFlowFirstReported": 25.539,
          "operatingCashFlowLatestRestated": 25.539,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-10-27",
          "operatingCashFlowFiledLatest": "2022-10-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2021-Q4",
          "end": "2021-12-31",
          "capex": 6.383,
          "capexFirstReported": 6.383,
          "capexLatestRestated": 6.383,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-02-02",
          "capexFiledLatest": "2024-01-31",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 6.383,
          "capexLatest": 6.383,
          "capexRestatementPct": 0,
          "firstFiled": "2022-02-02",
          "latestFiled": "2024-01-31",
          "filed": "2024-01-31",
          "revenue": 75.325,
          "revenueFirstReported": 75.325,
          "revenueLatestRestated": 75.325,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-02-02",
          "revenueFiledLatest": "2024-01-31",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 24.934,
          "operatingCashFlowFirstReported": 24.934,
          "operatingCashFlowLatestRestated": 24.934,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-02-02",
          "operatingCashFlowFiledLatest": "2024-01-31",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2022-Q1",
          "end": "2022-03-31",
          "capex": 9.786,
          "capexFirstReported": 9.786,
          "capexLatestRestated": 9.786,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-04-27",
          "capexFiledLatest": "2023-04-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 9.786,
          "capexLatest": 9.786,
          "capexRestatementPct": 0,
          "firstFiled": "2022-04-27",
          "latestFiled": "2023-04-26",
          "filed": "2023-04-26",
          "revenue": 68.011,
          "revenueFirstReported": 68.011,
          "revenueLatestRestated": 68.011,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-04-27",
          "revenueFiledLatest": "2023-04-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 25.106,
          "operatingCashFlowFirstReported": 25.106,
          "operatingCashFlowLatestRestated": 25.106,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-04-27",
          "operatingCashFlowFiledLatest": "2023-04-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q2",
          "end": "2022-06-30",
          "capex": 6.828,
          "capexFirstReported": 6.828,
          "capexLatestRestated": 6.828,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-07-27",
          "capexFiledLatest": "2023-07-26",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 6.828,
          "capexLatest": 6.828,
          "capexRestatementPct": 0,
          "firstFiled": "2022-07-27",
          "latestFiled": "2023-07-26",
          "filed": "2023-07-26",
          "revenue": 69.685,
          "revenueFirstReported": 69.685,
          "revenueLatestRestated": 69.685,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-07-27",
          "revenueFiledLatest": "2023-07-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 19.422,
          "operatingCashFlowFirstReported": 19.422,
          "operatingCashFlowLatestRestated": 19.422,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-07-27",
          "operatingCashFlowFiledLatest": "2023-07-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2022-Q3",
          "end": "2022-09-30",
          "capex": 7.276,
          "capexFirstReported": 7.276,
          "capexLatestRestated": 7.276,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-10-26",
          "capexFiledLatest": "2023-10-25",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 7.276,
          "capexLatest": 7.276,
          "capexRestatementPct": 0,
          "firstFiled": "2022-10-26",
          "latestFiled": "2023-10-25",
          "filed": "2023-10-25",
          "revenue": 69.092,
          "revenueFirstReported": 69.092,
          "revenueLatestRestated": 69.092,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-10-26",
          "revenueFiledLatest": "2023-10-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 23.353,
          "operatingCashFlowFirstReported": 23.353,
          "operatingCashFlowLatestRestated": 23.353,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-10-26",
          "operatingCashFlowFiledLatest": "2023-10-25",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2022-Q4",
          "end": "2022-12-31",
          "capex": 7.595,
          "capexFirstReported": 7.595,
          "capexLatestRestated": 7.595,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-02-03",
          "capexFiledLatest": "2025-02-05",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 7.595,
          "capexLatest": 7.595,
          "capexRestatementPct": 0,
          "firstFiled": "2023-02-03",
          "latestFiled": "2025-02-05",
          "filed": "2025-02-05",
          "revenue": 76.048,
          "revenueFirstReported": 76.048,
          "revenueLatestRestated": 76.048,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-02-03",
          "revenueFiledLatest": "2025-02-05",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 23.614,
          "operatingCashFlowFirstReported": 23.614,
          "operatingCashFlowLatestRestated": 23.614,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-02-03",
          "operatingCashFlowFiledLatest": "2025-02-05",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2023-Q1",
          "end": "2023-03-31",
          "capex": 6.289,
          "capexFirstReported": 6.289,
          "capexLatestRestated": 6.289,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-04-26",
          "capexFiledLatest": "2024-04-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.289,
          "capexLatest": 6.289,
          "capexRestatementPct": 0,
          "firstFiled": "2023-04-26",
          "latestFiled": "2024-04-26",
          "filed": "2024-04-26",
          "revenue": 69.787,
          "revenueFirstReported": 69.787,
          "revenueLatestRestated": 69.787,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-04-26",
          "revenueFiledLatest": "2024-04-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 23.509,
          "operatingCashFlowFirstReported": 23.509,
          "operatingCashFlowLatestRestated": 23.509,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-04-26",
          "operatingCashFlowFiledLatest": "2024-04-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q2",
          "end": "2023-06-30",
          "capex": 6.888,
          "capexFirstReported": 6.888,
          "capexLatestRestated": 6.888,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-07-26",
          "capexFiledLatest": "2024-07-24",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 6.888,
          "capexLatest": 6.888,
          "capexRestatementPct": 0,
          "firstFiled": "2023-07-26",
          "latestFiled": "2024-07-24",
          "filed": "2024-07-24",
          "revenue": 74.604,
          "revenueFirstReported": 74.604,
          "revenueLatestRestated": 74.604,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-07-26",
          "revenueFiledLatest": "2024-07-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 28.666,
          "operatingCashFlowFirstReported": 28.666,
          "operatingCashFlowLatestRestated": 28.666,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-07-26",
          "operatingCashFlowFiledLatest": "2024-07-24",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2023-Q3",
          "end": "2023-09-30",
          "capex": 8.055,
          "capexFirstReported": 8.055,
          "capexLatestRestated": 8.055,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-10-25",
          "capexFiledLatest": "2024-10-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 8.055,
          "capexLatest": 8.055,
          "capexRestatementPct": 0,
          "firstFiled": "2023-10-25",
          "latestFiled": "2024-10-30",
          "filed": "2024-10-30",
          "revenue": 76.693,
          "revenueFirstReported": 76.693,
          "revenueLatestRestated": 76.693,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-10-25",
          "revenueFiledLatest": "2024-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 30.656,
          "operatingCashFlowFirstReported": 30.656,
          "operatingCashFlowLatestRestated": 30.656,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-10-25",
          "operatingCashFlowFiledLatest": "2024-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2023-Q4",
          "end": "2023-12-31",
          "capex": 11.019,
          "capexFirstReported": 11.019,
          "capexLatestRestated": 11.019,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-01-31",
          "capexFiledLatest": "2026-02-05",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 11.019,
          "capexLatest": 11.019,
          "capexRestatementPct": 0,
          "firstFiled": "2024-01-31",
          "latestFiled": "2026-02-05",
          "filed": "2026-02-05",
          "revenue": 86.31,
          "revenueFirstReported": 86.31,
          "revenueLatestRestated": 86.31,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-01-31",
          "revenueFiledLatest": "2025-02-05",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 18.915,
          "operatingCashFlowFirstReported": 18.915,
          "operatingCashFlowLatestRestated": 18.915,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-01-31",
          "operatingCashFlowFiledLatest": "2026-02-05",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2024-Q1",
          "end": "2024-03-31",
          "capex": 12.012,
          "capexFirstReported": 12.012,
          "capexLatestRestated": 12.012,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-04-26",
          "capexFiledLatest": "2025-04-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 12.012,
          "capexLatest": 12.012,
          "capexRestatementPct": 0,
          "firstFiled": "2024-04-26",
          "latestFiled": "2025-04-25",
          "filed": "2025-04-25",
          "revenue": 80.539,
          "revenueFirstReported": 80.539,
          "revenueLatestRestated": 80.539,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-04-26",
          "revenueFiledLatest": "2025-04-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 28.848,
          "operatingCashFlowFirstReported": 28.848,
          "operatingCashFlowLatestRestated": 28.848,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-04-26",
          "operatingCashFlowFiledLatest": "2025-04-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q2",
          "end": "2024-06-30",
          "capex": 13.186,
          "capexFirstReported": 13.186,
          "capexLatestRestated": 13.186,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-07-24",
          "capexFiledLatest": "2025-07-24",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 13.186,
          "capexLatest": 13.186,
          "capexRestatementPct": 0,
          "firstFiled": "2024-07-24",
          "latestFiled": "2025-07-24",
          "filed": "2025-07-24",
          "revenue": 84.742,
          "revenueFirstReported": 84.742,
          "revenueLatestRestated": 84.742,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-07-24",
          "revenueFiledLatest": "2024-07-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 26.64,
          "operatingCashFlowFirstReported": 26.64,
          "operatingCashFlowLatestRestated": 26.64,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-07-24",
          "operatingCashFlowFiledLatest": "2025-07-24",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2024-Q3",
          "end": "2024-09-30",
          "capex": 13.061,
          "capexFirstReported": 13.061,
          "capexLatestRestated": 13.061,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-10-30",
          "capexFiledLatest": "2025-10-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 13.061,
          "capexLatest": 13.061,
          "capexRestatementPct": 0,
          "firstFiled": "2024-10-30",
          "latestFiled": "2025-10-30",
          "filed": "2025-10-30",
          "revenue": 88.268,
          "revenueFirstReported": 88.268,
          "revenueLatestRestated": 88.268,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-10-30",
          "revenueFiledLatest": "2024-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 30.698,
          "operatingCashFlowFirstReported": 30.698,
          "operatingCashFlowLatestRestated": 30.698,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-10-30",
          "operatingCashFlowFiledLatest": "2025-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2024-Q4",
          "end": "2024-12-31",
          "capex": 14.276,
          "capexFirstReported": 14.276,
          "capexLatestRestated": 14.276,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-02-05",
          "capexFiledLatest": "2026-02-05",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 14.276,
          "capexLatest": 14.276,
          "capexRestatementPct": 0,
          "firstFiled": "2025-02-05",
          "latestFiled": "2026-02-05",
          "filed": "2026-02-05",
          "revenue": 96.469,
          "revenueFirstReported": 96.469,
          "revenueLatestRestated": 96.469,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-02-05",
          "revenueFiledLatest": "2025-02-05",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 39.113,
          "operatingCashFlowFirstReported": 39.113,
          "operatingCashFlowLatestRestated": 39.113,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-02-05",
          "operatingCashFlowFiledLatest": "2026-02-05",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2025-Q1",
          "end": "2025-03-31",
          "capex": 17.197,
          "capexFirstReported": 17.197,
          "capexLatestRestated": 17.197,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-04-25",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 17.197,
          "capexLatest": 17.197,
          "capexRestatementPct": 0,
          "firstFiled": "2025-04-25",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 90.234,
          "revenueFirstReported": 90.234,
          "revenueLatestRestated": 90.234,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-04-25",
          "revenueFiledLatest": "2025-04-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 36.15,
          "operatingCashFlowFirstReported": 36.15,
          "operatingCashFlowLatestRestated": 36.15,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-04-25",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q2",
          "end": "2025-06-30",
          "capex": 22.446,
          "capexFirstReported": 22.446,
          "capexLatestRestated": 22.446,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-07-24",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 22.446,
          "capexLatest": 22.446,
          "capexRestatementPct": 0,
          "firstFiled": "2025-07-24",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 96.428,
          "revenueFirstReported": 96.428,
          "revenueLatestRestated": 96.428,
          "revenueTag": "Revenues",
          "revenueFiledFirst": "2025-07-24",
          "revenueFiledLatest": "2025-07-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 27.747,
          "operatingCashFlowFirstReported": 27.747,
          "operatingCashFlowLatestRestated": 27.747,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-07-24",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2025-Q3",
          "end": "2025-09-30",
          "capex": 23.953,
          "capexFirstReported": 23.953,
          "capexLatestRestated": 23.953,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-10-30",
          "capexFiledLatest": "2025-10-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 23.953,
          "capexLatest": 23.953,
          "capexRestatementPct": 0,
          "firstFiled": "2025-10-30",
          "latestFiled": "2025-10-30",
          "filed": "2025-10-30",
          "revenue": 102.346,
          "revenueFirstReported": 102.346,
          "revenueLatestRestated": 102.346,
          "revenueTag": "Revenues",
          "revenueFiledFirst": "2025-10-30",
          "revenueFiledLatest": "2025-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 48.414,
          "operatingCashFlowFirstReported": 48.414,
          "operatingCashFlowLatestRestated": 48.414,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-10-30",
          "operatingCashFlowFiledLatest": "2025-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2025-Q4",
          "end": "2025-12-31",
          "capex": 27.851,
          "capexFirstReported": 27.851,
          "capexLatestRestated": 27.851,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-02-05",
          "capexFiledLatest": "2026-02-05",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 27.851,
          "capexLatest": 27.851,
          "capexRestatementPct": 0,
          "firstFiled": "2026-02-05",
          "latestFiled": "2026-02-05",
          "filed": "2026-02-05",
          "revenue": 113.829,
          "revenueFirstReported": 113.829,
          "revenueLatestRestated": 113.829,
          "revenueTag": "Revenues",
          "revenueFiledFirst": "2026-02-05",
          "revenueFiledLatest": "2026-02-05",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 52.402,
          "operatingCashFlowFirstReported": 52.402,
          "operatingCashFlowLatestRestated": 52.402,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-02-05",
          "operatingCashFlowFiledLatest": "2026-02-05",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2026-Q1",
          "end": "2026-03-31",
          "capex": 35.674,
          "capexFirstReported": 35.674,
          "capexLatestRestated": 35.674,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-04-30",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 35.674,
          "capexLatest": 35.674,
          "capexRestatementPct": 0,
          "firstFiled": "2026-04-30",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 109.896,
          "revenueFirstReported": 109.896,
          "revenueLatestRestated": 109.896,
          "revenueTag": "Revenues",
          "revenueFiledFirst": "2026-04-30",
          "revenueFiledLatest": "2026-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 45.79,
          "operatingCashFlowFirstReported": 45.79,
          "operatingCashFlowLatestRestated": 45.79,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-04-30",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        }
      ]
    },
    "microsoft": {
      "id": "microsoft",
      "name": "Microsoft",
      "cik": "0000789019",
      "quarters": [
        {
          "period": "2017-Q1",
          "end": "2017-03-31",
          "capex": 1.695,
          "capexFirstReported": 1.695,
          "capexLatestRestated": 1.695,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-04-27",
          "capexFiledLatest": "2018-04-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 1.695,
          "capexLatest": 1.695,
          "capexRestatementPct": 0,
          "firstFiled": "2017-04-27",
          "latestFiled": "2018-04-26",
          "filed": "2018-04-26",
          "revenue": 23.212,
          "revenueFirstReported": 22.09,
          "revenueLatestRestated": 23.212,
          "revenueTag": "SalesRevenueNet",
          "revenueFiledFirst": "2017-04-27",
          "revenueFiledLatest": "2018-04-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 10.66,
          "operatingCashFlowFirstReported": 10.66,
          "operatingCashFlowLatestRestated": 10.66,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-04-26",
          "operatingCashFlowFiledLatest": "2018-04-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2017-Q2",
          "end": "2017-06-30",
          "capex": 2.283,
          "capexFirstReported": 2.283,
          "capexLatestRestated": 2.283,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-08-02",
          "capexFiledLatest": "2019-08-01",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 2.283,
          "capexLatest": 2.283,
          "capexRestatementPct": 0,
          "firstFiled": "2017-08-02",
          "latestFiled": "2019-08-01",
          "filed": "2019-08-01",
          "revenue": 25.605,
          "revenueFirstReported": 23.317,
          "revenueLatestRestated": 25.605,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-08-02",
          "revenueFiledLatest": "2019-08-01",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 11.005,
          "operatingCashFlowFirstReported": 11.005,
          "operatingCashFlowLatestRestated": 11.005,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-08-03",
          "operatingCashFlowFiledLatest": "2019-08-01",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2017-Q3",
          "end": "2017-09-30",
          "capex": 2.132,
          "capexFirstReported": 2.132,
          "capexLatestRestated": 2.132,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-10-26",
          "capexFiledLatest": "2018-10-24",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.132,
          "capexLatest": 2.132,
          "capexRestatementPct": 0,
          "firstFiled": "2017-10-26",
          "latestFiled": "2018-10-24",
          "filed": "2018-10-24",
          "revenue": 24.538,
          "revenueFirstReported": 24.538,
          "revenueLatestRestated": 24.538,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-10-26",
          "revenueFiledLatest": "2018-10-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.44,
          "operatingCashFlowFirstReported": 12.44,
          "operatingCashFlowLatestRestated": 12.44,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-10-24",
          "operatingCashFlowFiledLatest": "2018-10-24",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2017-Q4",
          "end": "2017-12-31",
          "capex": 2.586,
          "capexFirstReported": 2.586,
          "capexLatestRestated": 2.586,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-01-31",
          "capexFiledLatest": "2019-01-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.586,
          "capexLatest": 2.586,
          "capexRestatementPct": 0,
          "firstFiled": "2018-01-31",
          "latestFiled": "2019-01-30",
          "filed": "2019-01-30",
          "revenue": 28.918,
          "revenueFirstReported": 28.918,
          "revenueLatestRestated": 28.918,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-01-31",
          "revenueFiledLatest": "2019-01-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.875,
          "operatingCashFlowFirstReported": 7.875,
          "operatingCashFlowLatestRestated": 7.875,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-01-31",
          "operatingCashFlowFiledLatest": "2019-01-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q1",
          "end": "2018-03-31",
          "capex": 2.934,
          "capexFirstReported": 2.934,
          "capexLatestRestated": 2.934,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-04-26",
          "capexFiledLatest": "2019-04-24",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.934,
          "capexLatest": 2.934,
          "capexRestatementPct": 0,
          "firstFiled": "2018-04-26",
          "latestFiled": "2019-04-24",
          "filed": "2019-04-24",
          "revenue": 26.819,
          "revenueFirstReported": 26.819,
          "revenueLatestRestated": 26.819,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-04-26",
          "revenueFiledLatest": "2019-04-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.151,
          "operatingCashFlowFirstReported": 12.151,
          "operatingCashFlowLatestRestated": 12.151,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-04-26",
          "operatingCashFlowFiledLatest": "2019-04-24",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q2",
          "end": "2018-06-30",
          "capex": 3.98,
          "capexFirstReported": 3.98,
          "capexLatestRestated": 3.98,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-08-03",
          "capexFiledLatest": "2020-07-30",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 3.98,
          "capexLatest": 3.98,
          "capexRestatementPct": 0,
          "firstFiled": "2018-08-03",
          "latestFiled": "2020-07-30",
          "filed": "2020-07-30",
          "revenue": 30.085,
          "revenueFirstReported": 30.085,
          "revenueLatestRestated": 30.085,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-08-03",
          "revenueFiledLatest": "2020-07-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 11.418,
          "operatingCashFlowFirstReported": 11.418,
          "operatingCashFlowLatestRestated": 11.418,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-08-03",
          "operatingCashFlowFiledLatest": "2020-07-30",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2018-Q3",
          "end": "2018-09-30",
          "capex": 3.602,
          "capexFirstReported": 3.602,
          "capexLatestRestated": 3.602,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-10-24",
          "capexFiledLatest": "2019-10-23",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.602,
          "capexLatest": 3.602,
          "capexRestatementPct": 0,
          "firstFiled": "2018-10-24",
          "latestFiled": "2019-10-23",
          "filed": "2019-10-23",
          "revenue": 29.084,
          "revenueFirstReported": 29.084,
          "revenueLatestRestated": 29.084,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-10-24",
          "revenueFiledLatest": "2019-10-23",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.657,
          "operatingCashFlowFirstReported": 13.657,
          "operatingCashFlowLatestRestated": 13.657,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-10-24",
          "operatingCashFlowFiledLatest": "2019-10-23",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q4",
          "end": "2018-12-31",
          "capex": 3.707,
          "capexFirstReported": 3.707,
          "capexLatestRestated": 3.707,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-01-30",
          "capexFiledLatest": "2020-01-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.707,
          "capexLatest": 3.707,
          "capexRestatementPct": 0,
          "firstFiled": "2019-01-30",
          "latestFiled": "2020-01-29",
          "filed": "2020-01-29",
          "revenue": 32.471,
          "revenueFirstReported": 32.471,
          "revenueLatestRestated": 32.471,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-01-30",
          "revenueFiledLatest": "2020-01-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 8.9,
          "operatingCashFlowFirstReported": 8.9,
          "operatingCashFlowLatestRestated": 8.9,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-01-30",
          "operatingCashFlowFiledLatest": "2020-01-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q1",
          "end": "2019-03-31",
          "capex": 2.565,
          "capexFirstReported": 2.565,
          "capexLatestRestated": 2.565,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-04-24",
          "capexFiledLatest": "2020-04-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.565,
          "capexLatest": 2.565,
          "capexRestatementPct": 0,
          "firstFiled": "2019-04-24",
          "latestFiled": "2020-04-29",
          "filed": "2020-04-29",
          "revenue": 30.571,
          "revenueFirstReported": 30.571,
          "revenueLatestRestated": 30.571,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-04-24",
          "revenueFiledLatest": "2020-04-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.52,
          "operatingCashFlowFirstReported": 13.52,
          "operatingCashFlowLatestRestated": 13.52,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-04-24",
          "operatingCashFlowFiledLatest": "2020-04-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q2",
          "end": "2019-06-30",
          "capex": 4.051,
          "capexFirstReported": 4.051,
          "capexLatestRestated": 4.051,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-08-01",
          "capexFiledLatest": "2021-07-29",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 4.051,
          "capexLatest": 4.051,
          "capexRestatementPct": 0,
          "firstFiled": "2019-08-01",
          "latestFiled": "2021-07-29",
          "filed": "2021-07-29",
          "revenue": 33.717,
          "revenueFirstReported": 33.717,
          "revenueLatestRestated": 33.717,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-08-01",
          "revenueFiledLatest": "2021-07-29",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 16.108,
          "operatingCashFlowFirstReported": 16.108,
          "operatingCashFlowLatestRestated": 16.108,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-08-01",
          "operatingCashFlowFiledLatest": "2021-07-29",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2019-Q3",
          "end": "2019-09-30",
          "capex": 3.385,
          "capexFirstReported": 3.385,
          "capexLatestRestated": 3.385,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-10-23",
          "capexFiledLatest": "2020-10-27",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.385,
          "capexLatest": 3.385,
          "capexRestatementPct": 0,
          "firstFiled": "2019-10-23",
          "latestFiled": "2020-10-27",
          "filed": "2020-10-27",
          "revenue": 33.055,
          "revenueFirstReported": 33.055,
          "revenueLatestRestated": 33.055,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-10-23",
          "revenueFiledLatest": "2020-10-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.818,
          "operatingCashFlowFirstReported": 13.818,
          "operatingCashFlowLatestRestated": 13.818,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-10-23",
          "operatingCashFlowFiledLatest": "2020-10-27",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q4",
          "end": "2019-12-31",
          "capex": 3.545,
          "capexFirstReported": 3.545,
          "capexLatestRestated": 3.545,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-01-29",
          "capexFiledLatest": "2021-01-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.545,
          "capexLatest": 3.545,
          "capexRestatementPct": 0,
          "firstFiled": "2020-01-29",
          "latestFiled": "2021-01-26",
          "filed": "2021-01-26",
          "revenue": 36.906,
          "revenueFirstReported": 36.906,
          "revenueLatestRestated": 36.906,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-01-29",
          "revenueFiledLatest": "2021-01-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 10.68,
          "operatingCashFlowFirstReported": 10.68,
          "operatingCashFlowLatestRestated": 10.68,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-01-29",
          "operatingCashFlowFiledLatest": "2021-01-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q1",
          "end": "2020-03-31",
          "capex": 3.767,
          "capexFirstReported": 3.767,
          "capexLatestRestated": 3.767,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-04-29",
          "capexFiledLatest": "2021-04-27",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.767,
          "capexLatest": 3.767,
          "capexRestatementPct": 0,
          "firstFiled": "2020-04-29",
          "latestFiled": "2021-04-27",
          "filed": "2021-04-27",
          "revenue": 35.021,
          "revenueFirstReported": 35.021,
          "revenueLatestRestated": 35.021,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-04-29",
          "revenueFiledLatest": "2021-04-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 17.504,
          "operatingCashFlowFirstReported": 17.504,
          "operatingCashFlowLatestRestated": 17.504,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-04-29",
          "operatingCashFlowFiledLatest": "2021-04-27",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q2",
          "end": "2020-06-30",
          "capex": 4.744,
          "capexFirstReported": 4.744,
          "capexLatestRestated": 4.744,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-07-30",
          "capexFiledLatest": "2022-07-28",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 4.744,
          "capexLatest": 4.744,
          "capexRestatementPct": 0,
          "firstFiled": "2020-07-30",
          "latestFiled": "2022-07-28",
          "filed": "2022-07-28",
          "revenue": 38.033,
          "revenueFirstReported": 38.033,
          "revenueLatestRestated": 38.033,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-07-30",
          "revenueFiledLatest": "2022-07-28",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 18.673,
          "operatingCashFlowFirstReported": 18.673,
          "operatingCashFlowLatestRestated": 18.673,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-07-30",
          "operatingCashFlowFiledLatest": "2022-07-28",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2020-Q3",
          "end": "2020-09-30",
          "capex": 4.907,
          "capexFirstReported": 4.907,
          "capexLatestRestated": 4.907,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-10-27",
          "capexFiledLatest": "2021-10-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 4.907,
          "capexLatest": 4.907,
          "capexRestatementPct": 0,
          "firstFiled": "2020-10-27",
          "latestFiled": "2021-10-26",
          "filed": "2021-10-26",
          "revenue": 37.154,
          "revenueFirstReported": 37.154,
          "revenueLatestRestated": 37.154,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-10-27",
          "revenueFiledLatest": "2021-10-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 19.335,
          "operatingCashFlowFirstReported": 19.335,
          "operatingCashFlowLatestRestated": 19.335,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-10-27",
          "operatingCashFlowFiledLatest": "2021-10-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q4",
          "end": "2020-12-31",
          "capex": 4.174,
          "capexFirstReported": 4.174,
          "capexLatestRestated": 4.174,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-01-26",
          "capexFiledLatest": "2022-01-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 4.174,
          "capexLatest": 4.174,
          "capexRestatementPct": 0,
          "firstFiled": "2021-01-26",
          "latestFiled": "2022-01-25",
          "filed": "2022-01-25",
          "revenue": 43.076,
          "revenueFirstReported": 43.076,
          "revenueLatestRestated": 43.076,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-01-26",
          "revenueFiledLatest": "2022-01-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.516,
          "operatingCashFlowFirstReported": 12.516,
          "operatingCashFlowLatestRestated": 12.516,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-01-26",
          "operatingCashFlowFiledLatest": "2022-01-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q1",
          "end": "2021-03-31",
          "capex": 5.089,
          "capexFirstReported": 5.089,
          "capexLatestRestated": 5.089,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-04-27",
          "capexFiledLatest": "2022-04-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.089,
          "capexLatest": 5.089,
          "capexRestatementPct": 0,
          "firstFiled": "2021-04-27",
          "latestFiled": "2022-04-26",
          "filed": "2022-04-26",
          "revenue": 41.706,
          "revenueFirstReported": 41.706,
          "revenueLatestRestated": 41.706,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-04-27",
          "revenueFiledLatest": "2022-04-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 22.179,
          "operatingCashFlowFirstReported": 22.179,
          "operatingCashFlowLatestRestated": 22.179,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-04-27",
          "operatingCashFlowFiledLatest": "2022-04-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q2",
          "end": "2021-06-30",
          "capex": 6.452,
          "capexFirstReported": 6.452,
          "capexLatestRestated": 6.452,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-07-29",
          "capexFiledLatest": "2023-07-27",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 6.452,
          "capexLatest": 6.452,
          "capexRestatementPct": 0,
          "firstFiled": "2021-07-29",
          "latestFiled": "2023-07-27",
          "filed": "2023-07-27",
          "revenue": 46.152,
          "revenueFirstReported": 46.152,
          "revenueLatestRestated": 46.152,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-07-29",
          "revenueFiledLatest": "2023-07-27",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 22.71,
          "operatingCashFlowFirstReported": 22.71,
          "operatingCashFlowLatestRestated": 22.71,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-07-29",
          "operatingCashFlowFiledLatest": "2023-07-27",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2021-Q3",
          "end": "2021-09-30",
          "capex": 5.81,
          "capexFirstReported": 5.81,
          "capexLatestRestated": 5.81,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-10-26",
          "capexFiledLatest": "2022-10-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.81,
          "capexLatest": 5.81,
          "capexRestatementPct": 0,
          "firstFiled": "2021-10-26",
          "latestFiled": "2022-10-25",
          "filed": "2022-10-25",
          "revenue": 45.317,
          "revenueFirstReported": 45.317,
          "revenueLatestRestated": 45.317,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-10-26",
          "revenueFiledLatest": "2022-10-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 24.54,
          "operatingCashFlowFirstReported": 24.54,
          "operatingCashFlowLatestRestated": 24.54,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-10-26",
          "operatingCashFlowFiledLatest": "2022-10-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q4",
          "end": "2021-12-31",
          "capex": 5.865,
          "capexFirstReported": 5.865,
          "capexLatestRestated": 5.865,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-01-25",
          "capexFiledLatest": "2023-01-24",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.865,
          "capexLatest": 5.865,
          "capexRestatementPct": 0,
          "firstFiled": "2022-01-25",
          "latestFiled": "2023-01-24",
          "filed": "2023-01-24",
          "revenue": 51.728,
          "revenueFirstReported": 51.728,
          "revenueLatestRestated": 51.728,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-01-25",
          "revenueFiledLatest": "2023-01-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 14.48,
          "operatingCashFlowFirstReported": 14.48,
          "operatingCashFlowLatestRestated": 14.48,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-01-25",
          "operatingCashFlowFiledLatest": "2023-01-24",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q1",
          "end": "2022-03-31",
          "capex": 5.34,
          "capexFirstReported": 5.34,
          "capexLatestRestated": 5.34,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-04-26",
          "capexFiledLatest": "2023-04-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.34,
          "capexLatest": 5.34,
          "capexRestatementPct": 0,
          "firstFiled": "2022-04-26",
          "latestFiled": "2023-04-25",
          "filed": "2023-04-25",
          "revenue": 49.36,
          "revenueFirstReported": 49.36,
          "revenueLatestRestated": 49.36,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-04-26",
          "revenueFiledLatest": "2023-04-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 25.386,
          "operatingCashFlowFirstReported": 25.386,
          "operatingCashFlowLatestRestated": 25.386,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-04-26",
          "operatingCashFlowFiledLatest": "2023-04-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q2",
          "end": "2022-06-30",
          "capex": 6.871,
          "capexFirstReported": 6.871,
          "capexLatestRestated": 6.871,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-07-28",
          "capexFiledLatest": "2024-07-30",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 6.871,
          "capexLatest": 6.871,
          "capexRestatementPct": 0,
          "firstFiled": "2022-07-28",
          "latestFiled": "2024-07-30",
          "filed": "2024-07-30",
          "revenue": 51.865,
          "revenueFirstReported": 51.865,
          "revenueLatestRestated": 51.865,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-07-28",
          "revenueFiledLatest": "2024-07-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 24.629,
          "operatingCashFlowFirstReported": 24.629,
          "operatingCashFlowLatestRestated": 24.629,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-07-28",
          "operatingCashFlowFiledLatest": "2024-07-30",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2022-Q3",
          "end": "2022-09-30",
          "capex": 6.283,
          "capexFirstReported": 6.283,
          "capexLatestRestated": 6.283,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-10-25",
          "capexFiledLatest": "2023-10-24",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.283,
          "capexLatest": 6.283,
          "capexRestatementPct": 0,
          "firstFiled": "2022-10-25",
          "latestFiled": "2023-10-24",
          "filed": "2023-10-24",
          "revenue": 50.122,
          "revenueFirstReported": 50.122,
          "revenueLatestRestated": 50.122,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-10-25",
          "revenueFiledLatest": "2023-10-24",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 23.198,
          "operatingCashFlowFirstReported": 23.198,
          "operatingCashFlowLatestRestated": 23.198,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-10-25",
          "operatingCashFlowFiledLatest": "2023-10-24",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q4",
          "end": "2022-12-31",
          "capex": 6.274,
          "capexFirstReported": 6.274,
          "capexLatestRestated": 6.274,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-01-24",
          "capexFiledLatest": "2024-01-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.274,
          "capexLatest": 6.274,
          "capexRestatementPct": 0,
          "firstFiled": "2023-01-24",
          "latestFiled": "2024-01-30",
          "filed": "2024-01-30",
          "revenue": 52.747,
          "revenueFirstReported": 52.747,
          "revenueLatestRestated": 52.747,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-01-24",
          "revenueFiledLatest": "2024-01-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 11.173,
          "operatingCashFlowFirstReported": 11.173,
          "operatingCashFlowLatestRestated": 11.173,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-01-24",
          "operatingCashFlowFiledLatest": "2024-01-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q1",
          "end": "2023-03-31",
          "capex": 6.607,
          "capexFirstReported": 6.607,
          "capexLatestRestated": 6.607,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-04-25",
          "capexFiledLatest": "2024-04-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.607,
          "capexLatest": 6.607,
          "capexRestatementPct": 0,
          "firstFiled": "2023-04-25",
          "latestFiled": "2024-04-25",
          "filed": "2024-04-25",
          "revenue": 52.857,
          "revenueFirstReported": 52.857,
          "revenueLatestRestated": 52.857,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-04-25",
          "revenueFiledLatest": "2024-04-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 24.441,
          "operatingCashFlowFirstReported": 24.441,
          "operatingCashFlowLatestRestated": 24.441,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-04-25",
          "operatingCashFlowFiledLatest": "2024-04-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q2",
          "end": "2023-06-30",
          "capex": 8.943,
          "capexFirstReported": 8.943,
          "capexLatestRestated": 8.943,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-07-27",
          "capexFiledLatest": "2025-07-30",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 8.943,
          "capexLatest": 8.943,
          "capexRestatementPct": 0,
          "firstFiled": "2023-07-27",
          "latestFiled": "2025-07-30",
          "filed": "2025-07-30",
          "revenue": 56.189,
          "revenueFirstReported": 56.189,
          "revenueLatestRestated": 56.189,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-07-27",
          "revenueFiledLatest": "2025-07-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 28.77,
          "operatingCashFlowFirstReported": 28.77,
          "operatingCashFlowLatestRestated": 28.77,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-07-27",
          "operatingCashFlowFiledLatest": "2025-07-30",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2023-Q3",
          "end": "2023-09-30",
          "capex": 9.917,
          "capexFirstReported": 9.917,
          "capexLatestRestated": 9.917,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-10-24",
          "capexFiledLatest": "2024-10-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 9.917,
          "capexLatest": 9.917,
          "capexRestatementPct": 0,
          "firstFiled": "2023-10-24",
          "latestFiled": "2024-10-30",
          "filed": "2024-10-30",
          "revenue": 56.517,
          "revenueFirstReported": 56.517,
          "revenueLatestRestated": 56.517,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-10-24",
          "revenueFiledLatest": "2024-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 30.583,
          "operatingCashFlowFirstReported": 30.583,
          "operatingCashFlowLatestRestated": 30.583,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-10-24",
          "operatingCashFlowFiledLatest": "2024-10-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q4",
          "end": "2023-12-31",
          "capex": 9.735,
          "capexFirstReported": 9.735,
          "capexLatestRestated": 9.735,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-01-30",
          "capexFiledLatest": "2025-01-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 9.735,
          "capexLatest": 9.735,
          "capexRestatementPct": 0,
          "firstFiled": "2024-01-30",
          "latestFiled": "2025-01-29",
          "filed": "2025-01-29",
          "revenue": 62.02,
          "revenueFirstReported": 62.02,
          "revenueLatestRestated": 62.02,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-01-30",
          "revenueFiledLatest": "2025-01-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 18.853,
          "operatingCashFlowFirstReported": 18.853,
          "operatingCashFlowLatestRestated": 18.853,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-01-30",
          "operatingCashFlowFiledLatest": "2025-01-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q1",
          "end": "2024-03-31",
          "capex": 10.952,
          "capexFirstReported": 10.952,
          "capexLatestRestated": 10.952,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-04-25",
          "capexFiledLatest": "2025-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 10.952,
          "capexLatest": 10.952,
          "capexRestatementPct": 0,
          "firstFiled": "2024-04-25",
          "latestFiled": "2025-04-30",
          "filed": "2025-04-30",
          "revenue": 61.858,
          "revenueFirstReported": 61.858,
          "revenueLatestRestated": 61.858,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-04-25",
          "revenueFiledLatest": "2025-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 31.917,
          "operatingCashFlowFirstReported": 31.917,
          "operatingCashFlowLatestRestated": 31.917,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-04-25",
          "operatingCashFlowFiledLatest": "2025-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q2",
          "end": "2024-06-30",
          "capex": 13.873,
          "capexFirstReported": 13.873,
          "capexLatestRestated": 13.873,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-07-30",
          "capexFiledLatest": "2025-07-30",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 13.873,
          "capexLatest": 13.873,
          "capexRestatementPct": 0,
          "firstFiled": "2024-07-30",
          "latestFiled": "2025-07-30",
          "filed": "2025-07-30",
          "revenue": 64.727,
          "revenueFirstReported": 64.727,
          "revenueLatestRestated": 64.727,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-07-30",
          "revenueFiledLatest": "2025-07-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 37.195,
          "operatingCashFlowFirstReported": 37.195,
          "operatingCashFlowLatestRestated": 37.195,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-07-30",
          "operatingCashFlowFiledLatest": "2025-07-30",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2024-Q3",
          "end": "2024-09-30",
          "capex": 14.923,
          "capexFirstReported": 14.923,
          "capexLatestRestated": 14.923,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-10-30",
          "capexFiledLatest": "2025-10-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 14.923,
          "capexLatest": 14.923,
          "capexRestatementPct": 0,
          "firstFiled": "2024-10-30",
          "latestFiled": "2025-10-29",
          "filed": "2025-10-29",
          "revenue": 65.585,
          "revenueFirstReported": 65.585,
          "revenueLatestRestated": 65.585,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-10-30",
          "revenueFiledLatest": "2025-10-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 34.18,
          "operatingCashFlowFirstReported": 34.18,
          "operatingCashFlowLatestRestated": 34.18,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-10-30",
          "operatingCashFlowFiledLatest": "2025-10-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q4",
          "end": "2024-12-31",
          "capex": 15.804,
          "capexFirstReported": 15.804,
          "capexLatestRestated": 15.804,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-01-29",
          "capexFiledLatest": "2026-01-28",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 15.804,
          "capexLatest": 15.804,
          "capexRestatementPct": 0,
          "firstFiled": "2025-01-29",
          "latestFiled": "2026-01-28",
          "filed": "2026-01-28",
          "revenue": 69.632,
          "revenueFirstReported": 69.632,
          "revenueLatestRestated": 69.632,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-01-29",
          "revenueFiledLatest": "2026-01-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 22.291,
          "operatingCashFlowFirstReported": 22.291,
          "operatingCashFlowLatestRestated": 22.291,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-01-29",
          "operatingCashFlowFiledLatest": "2026-01-28",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q1",
          "end": "2025-03-31",
          "capex": 16.745,
          "capexFirstReported": 16.745,
          "capexLatestRestated": 16.745,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-04-30",
          "capexFiledLatest": "2026-04-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 16.745,
          "capexLatest": 16.745,
          "capexRestatementPct": 0,
          "firstFiled": "2025-04-30",
          "latestFiled": "2026-04-29",
          "filed": "2026-04-29",
          "revenue": 70.066,
          "revenueFirstReported": 70.066,
          "revenueLatestRestated": 70.066,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-04-30",
          "revenueFiledLatest": "2026-04-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 37.044,
          "operatingCashFlowFirstReported": 37.044,
          "operatingCashFlowLatestRestated": 37.044,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-04-30",
          "operatingCashFlowFiledLatest": "2026-04-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q2",
          "end": "2025-06-30",
          "capex": 17.079,
          "capexFirstReported": 17.079,
          "capexLatestRestated": 17.079,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-07-30",
          "capexFiledLatest": "2026-04-29",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 17.079,
          "capexLatest": 17.079,
          "capexRestatementPct": 0,
          "firstFiled": "2025-07-30",
          "latestFiled": "2026-04-29",
          "filed": "2026-04-29",
          "revenue": 76.441,
          "revenueFirstReported": 76.441,
          "revenueLatestRestated": 76.441,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-07-30",
          "revenueFiledLatest": "2026-04-29",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 42.647,
          "operatingCashFlowFirstReported": 42.647,
          "operatingCashFlowLatestRestated": 42.647,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-07-30",
          "operatingCashFlowFiledLatest": "2026-04-29",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2025-Q3",
          "end": "2025-09-30",
          "capex": 19.394,
          "capexFirstReported": 19.394,
          "capexLatestRestated": 19.394,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-10-29",
          "capexFiledLatest": "2025-10-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 19.394,
          "capexLatest": 19.394,
          "capexRestatementPct": 0,
          "firstFiled": "2025-10-29",
          "latestFiled": "2025-10-29",
          "filed": "2025-10-29",
          "revenue": 77.673,
          "revenueFirstReported": 77.673,
          "revenueLatestRestated": 77.673,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-10-29",
          "revenueFiledLatest": "2025-10-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 45.057,
          "operatingCashFlowFirstReported": 45.057,
          "operatingCashFlowLatestRestated": 45.057,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-10-29",
          "operatingCashFlowFiledLatest": "2025-10-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q4",
          "end": "2025-12-31",
          "capex": 29.876,
          "capexFirstReported": 29.876,
          "capexLatestRestated": 29.876,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-01-28",
          "capexFiledLatest": "2026-01-28",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 29.876,
          "capexLatest": 29.876,
          "capexRestatementPct": 0,
          "firstFiled": "2026-01-28",
          "latestFiled": "2026-01-28",
          "filed": "2026-01-28",
          "revenue": 81.273,
          "revenueFirstReported": 81.273,
          "revenueLatestRestated": 81.273,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-01-28",
          "revenueFiledLatest": "2026-01-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 35.758,
          "operatingCashFlowFirstReported": 35.758,
          "operatingCashFlowLatestRestated": 35.758,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-01-28",
          "operatingCashFlowFiledLatest": "2026-01-28",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2026-Q1",
          "end": "2026-03-31",
          "capex": 30.876,
          "capexFirstReported": 30.876,
          "capexLatestRestated": 30.876,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-04-29",
          "capexFiledLatest": "2026-04-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 30.876,
          "capexLatest": 30.876,
          "capexRestatementPct": 0,
          "firstFiled": "2026-04-29",
          "latestFiled": "2026-04-29",
          "filed": "2026-04-29",
          "revenue": 82.886,
          "revenueFirstReported": 82.886,
          "revenueLatestRestated": 82.886,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-04-29",
          "revenueFiledLatest": "2026-04-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 46.679,
          "operatingCashFlowFirstReported": 46.679,
          "operatingCashFlowLatestRestated": 46.679,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-04-29",
          "operatingCashFlowFiledLatest": "2026-04-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        }
      ]
    },
    "amazon": {
      "id": "amazon",
      "name": "Amazon",
      "cik": "0001018724",
      "quarters": [
        {
          "period": "2017-Q3",
          "end": "2017-09-30",
          "capex": 3.074,
          "capexFirstReported": 3.074,
          "capexLatestRestated": 3.074,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2018-10-26",
          "capexFiledLatest": "2018-10-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.074,
          "capexLatest": 3.074,
          "capexRestatementPct": 0,
          "firstFiled": "2018-10-26",
          "latestFiled": "2018-10-26",
          "filed": "2018-10-26",
          "revenue": 43.744,
          "revenueFirstReported": 43.744,
          "revenueLatestRestated": 43.744,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-10-27",
          "revenueFiledLatest": "2018-10-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.777,
          "operatingCashFlowFirstReported": 3.851,
          "operatingCashFlowLatestRestated": 3.777,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-10-27",
          "operatingCashFlowFiledLatest": "2018-10-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 2.912,
          "depreciationFirstReported": 2.912,
          "depreciationLatestRestated": 2.912,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2017-10-27",
          "depreciationFiledLatest": "2018-10-26",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2017-Q4",
          "end": "2017-12-31",
          "capex": 3.619,
          "capexFirstReported": 3.619,
          "capexLatestRestated": 3.619,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-02-01",
          "capexFiledLatest": "2020-01-31",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 3.619,
          "capexLatest": 3.619,
          "capexRestatementPct": 0,
          "firstFiled": "2019-02-01",
          "latestFiled": "2020-01-31",
          "filed": "2020-01-31",
          "revenue": 60.453,
          "revenueFirstReported": 60.453,
          "revenueLatestRestated": 60.453,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-02-02",
          "revenueFiledLatest": "2020-01-31",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 12.358,
          "operatingCashFlowFirstReported": 12.344,
          "operatingCashFlowLatestRestated": 12.358,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-02-02",
          "operatingCashFlowFiledLatest": "2020-01-31",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 3.498,
          "depreciationFirstReported": 3.498,
          "depreciationLatestRestated": 3.498,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-02-02",
          "depreciationFiledLatest": "2020-01-31",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2018-Q1",
          "end": "2018-03-31",
          "capex": 3.098,
          "capexFirstReported": 3.098,
          "capexLatestRestated": 3.098,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-04-26",
          "capexFiledLatest": "2019-04-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.098,
          "capexLatest": 3.098,
          "capexRestatementPct": 0,
          "firstFiled": "2019-04-26",
          "latestFiled": "2019-04-26",
          "filed": "2019-04-26",
          "revenue": 51.042,
          "revenueFirstReported": 51.042,
          "revenueLatestRestated": 51.042,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-04-27",
          "revenueFiledLatest": "2019-04-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": -1.791,
          "operatingCashFlowFirstReported": -1.791,
          "operatingCashFlowLatestRestated": -1.791,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-04-27",
          "operatingCashFlowFiledLatest": "2019-04-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 3.671,
          "depreciationFirstReported": 3.671,
          "depreciationLatestRestated": 3.671,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-04-27",
          "depreciationFiledLatest": "2019-04-26",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q2",
          "end": "2018-06-30",
          "capex": 3.243,
          "capexFirstReported": 3.243,
          "capexLatestRestated": 3.243,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-07-26",
          "capexFiledLatest": "2019-07-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.243,
          "capexLatest": 3.243,
          "capexRestatementPct": 0,
          "firstFiled": "2019-07-26",
          "latestFiled": "2019-07-26",
          "filed": "2019-07-26",
          "revenue": 52.886,
          "revenueFirstReported": 52.886,
          "revenueLatestRestated": 52.886,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-07-27",
          "revenueFiledLatest": "2019-07-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.449,
          "operatingCashFlowFirstReported": 7.449,
          "operatingCashFlowLatestRestated": 7.449,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-07-27",
          "operatingCashFlowFiledLatest": "2019-07-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 3.63,
          "depreciationFirstReported": 3.63,
          "depreciationLatestRestated": 3.63,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-07-27",
          "depreciationFiledLatest": "2019-07-26",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q3",
          "end": "2018-09-30",
          "capex": 3.352,
          "capexFirstReported": 3.352,
          "capexLatestRestated": 3.352,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2018-10-26",
          "capexFiledLatest": "2019-10-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.352,
          "capexLatest": 3.352,
          "capexRestatementPct": 0,
          "firstFiled": "2018-10-26",
          "latestFiled": "2019-10-25",
          "filed": "2019-10-25",
          "revenue": 56.576,
          "revenueFirstReported": 56.576,
          "revenueLatestRestated": 56.576,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-10-26",
          "revenueFiledLatest": "2019-10-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 8.588,
          "operatingCashFlowFirstReported": 8.588,
          "operatingCashFlowLatestRestated": 8.588,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-10-26",
          "operatingCashFlowFiledLatest": "2019-10-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 3.778,
          "depreciationFirstReported": 3.778,
          "depreciationLatestRestated": 3.778,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-10-26",
          "depreciationFiledLatest": "2019-10-25",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q4",
          "end": "2018-12-31",
          "capex": 3.734,
          "capexFirstReported": 3.734,
          "capexLatestRestated": 3.734,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-02-01",
          "capexFiledLatest": "2021-02-03",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 3.734,
          "capexLatest": 3.734,
          "capexRestatementPct": 0,
          "firstFiled": "2019-02-01",
          "latestFiled": "2021-02-03",
          "filed": "2021-02-03",
          "revenue": 72.383,
          "revenueFirstReported": 72.383,
          "revenueLatestRestated": 72.383,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-02-01",
          "revenueFiledLatest": "2021-02-03",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 16.477,
          "operatingCashFlowFirstReported": 16.477,
          "operatingCashFlowLatestRestated": 16.477,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-02-01",
          "operatingCashFlowFiledLatest": "2021-02-03",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 4.262,
          "depreciationFirstReported": 4.262,
          "depreciationLatestRestated": 4.262,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-02-01",
          "depreciationFiledLatest": "2021-02-03",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2019-Q1",
          "end": "2019-03-31",
          "capex": 3.29,
          "capexFirstReported": 3.29,
          "capexLatestRestated": 3.29,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-04-26",
          "capexFiledLatest": "2020-05-01",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.29,
          "capexLatest": 3.29,
          "capexRestatementPct": 0,
          "firstFiled": "2019-04-26",
          "latestFiled": "2020-05-01",
          "filed": "2020-05-01",
          "revenue": 59.7,
          "revenueFirstReported": 59.7,
          "revenueLatestRestated": 59.7,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-04-26",
          "revenueFiledLatest": "2020-05-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 1.846,
          "operatingCashFlowFirstReported": 1.846,
          "operatingCashFlowLatestRestated": 1.846,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-04-26",
          "operatingCashFlowFiledLatest": "2020-05-01",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 4.854,
          "depreciationFirstReported": 4.854,
          "depreciationLatestRestated": 4.854,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-04-26",
          "depreciationFiledLatest": "2020-05-01",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q2",
          "end": "2019-06-30",
          "capex": 3.562,
          "capexFirstReported": 3.562,
          "capexLatestRestated": 3.562,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-07-26",
          "capexFiledLatest": "2020-07-31",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.562,
          "capexLatest": 3.562,
          "capexRestatementPct": 0,
          "firstFiled": "2019-07-26",
          "latestFiled": "2020-07-31",
          "filed": "2020-07-31",
          "revenue": 63.404,
          "revenueFirstReported": 63.404,
          "revenueLatestRestated": 63.404,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-07-26",
          "revenueFiledLatest": "2020-07-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.118,
          "operatingCashFlowFirstReported": 9.118,
          "operatingCashFlowLatestRestated": 9.118,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-07-26",
          "operatingCashFlowFiledLatest": "2020-07-31",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 5.202,
          "depreciationFirstReported": 5.202,
          "depreciationLatestRestated": 5.202,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-07-26",
          "depreciationFiledLatest": "2020-07-31",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q3",
          "end": "2019-09-30",
          "capex": 4.697,
          "capexFirstReported": 4.697,
          "capexLatestRestated": 4.697,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2019-10-25",
          "capexFiledLatest": "2020-10-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 4.697,
          "capexLatest": 4.697,
          "capexRestatementPct": 0,
          "firstFiled": "2019-10-25",
          "latestFiled": "2020-10-30",
          "filed": "2020-10-30",
          "revenue": 69.981,
          "revenueFirstReported": 69.981,
          "revenueLatestRestated": 69.981,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-10-25",
          "revenueFiledLatest": "2020-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.892,
          "operatingCashFlowFirstReported": 7.892,
          "operatingCashFlowLatestRestated": 7.892,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-10-25",
          "operatingCashFlowFiledLatest": "2020-10-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 5.563,
          "depreciationFirstReported": 5.563,
          "depreciationLatestRestated": 5.563,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-10-25",
          "depreciationFiledLatest": "2020-10-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q4",
          "end": "2019-12-31",
          "capex": 5.312,
          "capexFirstReported": 5.312,
          "capexLatestRestated": 5.312,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2020-01-31",
          "capexFiledLatest": "2022-02-04",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 5.312,
          "capexLatest": 5.312,
          "capexRestatementPct": 0,
          "firstFiled": "2020-01-31",
          "latestFiled": "2022-02-04",
          "filed": "2022-02-04",
          "revenue": 87.436,
          "revenueFirstReported": 87.436,
          "revenueLatestRestated": 87.436,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-01-31",
          "revenueFiledLatest": "2022-02-04",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 19.659,
          "operatingCashFlowFirstReported": 19.659,
          "operatingCashFlowLatestRestated": 19.659,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-01-31",
          "operatingCashFlowFiledLatest": "2022-02-04",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 6.17,
          "depreciationFirstReported": 6.17,
          "depreciationLatestRestated": 6.17,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-01-31",
          "depreciationFiledLatest": "2022-02-04",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2020-Q1",
          "end": "2020-03-31",
          "capex": 6.795,
          "capexFirstReported": 6.795,
          "capexLatestRestated": 6.795,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2020-05-01",
          "capexFiledLatest": "2021-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.795,
          "capexLatest": 6.795,
          "capexRestatementPct": 0,
          "firstFiled": "2020-05-01",
          "latestFiled": "2021-04-30",
          "filed": "2021-04-30",
          "revenue": 75.452,
          "revenueFirstReported": 75.452,
          "revenueLatestRestated": 75.452,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-05-01",
          "revenueFiledLatest": "2021-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.064,
          "operatingCashFlowFirstReported": 3.064,
          "operatingCashFlowLatestRestated": 3.064,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-05-01",
          "operatingCashFlowFiledLatest": "2021-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 5.362,
          "depreciationFirstReported": 5.362,
          "depreciationLatestRestated": 5.362,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-05-01",
          "depreciationFiledLatest": "2021-04-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q2",
          "end": "2020-06-30",
          "capex": 7.459,
          "capexFirstReported": 7.459,
          "capexLatestRestated": 7.459,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2020-07-31",
          "capexFiledLatest": "2021-07-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 7.459,
          "capexLatest": 7.459,
          "capexRestatementPct": 0,
          "firstFiled": "2020-07-31",
          "latestFiled": "2021-07-30",
          "filed": "2021-07-30",
          "revenue": 88.912,
          "revenueFirstReported": 88.912,
          "revenueLatestRestated": 88.912,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-07-31",
          "revenueFiledLatest": "2021-07-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 20.606,
          "operatingCashFlowFirstReported": 20.606,
          "operatingCashFlowLatestRestated": 20.606,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-07-31",
          "operatingCashFlowFiledLatest": "2021-07-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 5.748,
          "depreciationFirstReported": 5.748,
          "depreciationLatestRestated": 5.748,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-07-31",
          "depreciationFiledLatest": "2021-07-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q3",
          "end": "2020-09-30",
          "capex": 11.063,
          "capexFirstReported": 11.063,
          "capexLatestRestated": 11.063,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2020-10-30",
          "capexFiledLatest": "2021-10-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 11.063,
          "capexLatest": 11.063,
          "capexRestatementPct": 0,
          "firstFiled": "2020-10-30",
          "latestFiled": "2021-10-29",
          "filed": "2021-10-29",
          "revenue": 96.145,
          "revenueFirstReported": 96.145,
          "revenueLatestRestated": 96.145,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-10-30",
          "revenueFiledLatest": "2021-10-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 11.964,
          "operatingCashFlowFirstReported": 11.964,
          "operatingCashFlowLatestRestated": 11.964,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-10-30",
          "operatingCashFlowFiledLatest": "2021-10-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 6.523,
          "depreciationFirstReported": 6.523,
          "depreciationLatestRestated": 6.523,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-10-30",
          "depreciationFiledLatest": "2021-10-29",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q4",
          "end": "2020-12-31",
          "capex": 14.823,
          "capexFirstReported": 14.823,
          "capexLatestRestated": 14.823,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2021-02-03",
          "capexFiledLatest": "2023-02-03",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 14.823,
          "capexLatest": 14.823,
          "capexRestatementPct": 0,
          "firstFiled": "2021-02-03",
          "latestFiled": "2023-02-03",
          "filed": "2023-02-03",
          "revenue": 125.555,
          "revenueFirstReported": 125.555,
          "revenueLatestRestated": 125.555,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-02-03",
          "revenueFiledLatest": "2023-02-03",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 30.431,
          "operatingCashFlowFirstReported": 30.431,
          "operatingCashFlowLatestRestated": 30.431,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-02-03",
          "operatingCashFlowFiledLatest": "2023-02-03",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 7.547,
          "depreciationFirstReported": 7.618,
          "depreciationLatestRestated": 7.547,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-02-03",
          "depreciationFiledLatest": "2023-02-03",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2021-Q1",
          "end": "2021-03-31",
          "capex": 12.082,
          "capexFirstReported": 12.082,
          "capexLatestRestated": 12.082,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2021-04-30",
          "capexFiledLatest": "2022-04-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 12.082,
          "capexLatest": 12.082,
          "capexRestatementPct": 0,
          "firstFiled": "2021-04-30",
          "latestFiled": "2022-04-29",
          "filed": "2022-04-29",
          "revenue": 108.518,
          "revenueFirstReported": 108.518,
          "revenueLatestRestated": 108.518,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-04-30",
          "revenueFiledLatest": "2022-04-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 4.213,
          "operatingCashFlowFirstReported": 4.213,
          "operatingCashFlowLatestRestated": 4.213,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-04-30",
          "operatingCashFlowFiledLatest": "2022-04-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 7.508,
          "depreciationFirstReported": 7.508,
          "depreciationLatestRestated": 7.508,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-04-30",
          "depreciationFiledLatest": "2022-04-29",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q2",
          "end": "2021-06-30",
          "capex": 14.288,
          "capexFirstReported": 14.288,
          "capexLatestRestated": 14.288,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2021-07-30",
          "capexFiledLatest": "2022-07-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 14.288,
          "capexLatest": 14.288,
          "capexRestatementPct": 0,
          "firstFiled": "2021-07-30",
          "latestFiled": "2022-07-29",
          "filed": "2022-07-29",
          "revenue": 113.08,
          "revenueFirstReported": 113.08,
          "revenueLatestRestated": 113.08,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-07-30",
          "revenueFiledLatest": "2022-07-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.715,
          "operatingCashFlowFirstReported": 12.715,
          "operatingCashFlowLatestRestated": 12.715,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-07-30",
          "operatingCashFlowFiledLatest": "2022-07-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 8.038,
          "depreciationFirstReported": 8.038,
          "depreciationLatestRestated": 8.038,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-07-30",
          "depreciationFiledLatest": "2022-07-29",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q3",
          "end": "2021-09-30",
          "capex": 15.748,
          "capexFirstReported": 15.748,
          "capexLatestRestated": 15.748,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2021-10-29",
          "capexFiledLatest": "2022-10-28",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 15.748,
          "capexLatest": 15.748,
          "capexRestatementPct": 0,
          "firstFiled": "2021-10-29",
          "latestFiled": "2022-10-28",
          "filed": "2022-10-28",
          "revenue": 110.812,
          "revenueFirstReported": 110.812,
          "revenueLatestRestated": 110.812,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-10-29",
          "revenueFiledLatest": "2022-10-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.313,
          "operatingCashFlowFirstReported": 7.313,
          "operatingCashFlowLatestRestated": 7.313,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-10-29",
          "operatingCashFlowFiledLatest": "2022-10-28",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 8.948,
          "depreciationFirstReported": 8.948,
          "depreciationLatestRestated": 8.948,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-10-29",
          "depreciationFiledLatest": "2022-10-28",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q4",
          "end": "2021-12-31",
          "capex": 18.935,
          "capexFirstReported": 18.935,
          "capexLatestRestated": 18.935,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2022-02-04",
          "capexFiledLatest": "2024-02-02",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 18.935,
          "capexLatest": 18.935,
          "capexRestatementPct": 0,
          "firstFiled": "2022-02-04",
          "latestFiled": "2024-02-02",
          "filed": "2024-02-02",
          "revenue": 137.412,
          "revenueFirstReported": 137.412,
          "revenueLatestRestated": 137.412,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-02-04",
          "revenueFiledLatest": "2024-02-02",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 22.086,
          "operatingCashFlowFirstReported": 22.086,
          "operatingCashFlowLatestRestated": 22.086,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-02-04",
          "operatingCashFlowFiledLatest": "2024-02-02",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 9.939,
          "depreciationFirstReported": 9.802,
          "depreciationLatestRestated": 9.939,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-02-04",
          "depreciationFiledLatest": "2024-02-02",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2022-Q1",
          "end": "2022-03-31",
          "capex": 14.951,
          "capexFirstReported": 14.951,
          "capexLatestRestated": 14.951,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2022-04-29",
          "capexFiledLatest": "2023-04-28",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 14.951,
          "capexLatest": 14.951,
          "capexRestatementPct": 0,
          "firstFiled": "2022-04-29",
          "latestFiled": "2023-04-28",
          "filed": "2023-04-28",
          "revenue": 116.444,
          "revenueFirstReported": 116.444,
          "revenueLatestRestated": 116.444,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-04-29",
          "revenueFiledLatest": "2023-04-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": -2.79,
          "operatingCashFlowFirstReported": -2.79,
          "operatingCashFlowLatestRestated": -2.79,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-04-29",
          "operatingCashFlowFiledLatest": "2023-04-28",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 9.193,
          "depreciationFirstReported": 8.978,
          "depreciationLatestRestated": 9.193,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-04-29",
          "depreciationFiledLatest": "2023-04-28",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q2",
          "end": "2022-06-30",
          "capex": 15.724,
          "capexFirstReported": 15.724,
          "capexLatestRestated": 15.724,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2022-07-29",
          "capexFiledLatest": "2023-08-04",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 15.724,
          "capexLatest": 15.724,
          "capexRestatementPct": 0,
          "firstFiled": "2022-07-29",
          "latestFiled": "2023-08-04",
          "filed": "2023-08-04",
          "revenue": 121.234,
          "revenueFirstReported": 121.234,
          "revenueLatestRestated": 121.234,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-07-29",
          "revenueFiledLatest": "2023-08-04",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 8.965,
          "operatingCashFlowFirstReported": 8.965,
          "operatingCashFlowLatestRestated": 8.965,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-07-29",
          "operatingCashFlowFiledLatest": "2023-08-04",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 9.716,
          "depreciationFirstReported": 9.594,
          "depreciationLatestRestated": 9.716,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-07-29",
          "depreciationFiledLatest": "2023-08-04",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q3",
          "end": "2022-09-30",
          "capex": 16.378,
          "capexFirstReported": 16.378,
          "capexLatestRestated": 16.378,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2022-10-28",
          "capexFiledLatest": "2023-10-27",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 16.378,
          "capexLatest": 16.378,
          "capexRestatementPct": 0,
          "firstFiled": "2022-10-28",
          "latestFiled": "2023-10-27",
          "filed": "2023-10-27",
          "revenue": 127.101,
          "revenueFirstReported": 127.101,
          "revenueLatestRestated": 127.101,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-10-28",
          "revenueFiledLatest": "2023-10-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 11.404,
          "operatingCashFlowFirstReported": 11.404,
          "operatingCashFlowLatestRestated": 11.404,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-10-28",
          "operatingCashFlowFiledLatest": "2023-10-27",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 10.327,
          "depreciationFirstReported": 10.204,
          "depreciationLatestRestated": 10.327,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-10-28",
          "depreciationFiledLatest": "2023-10-27",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q4",
          "end": "2022-12-31",
          "capex": 16.592,
          "capexFirstReported": 16.592,
          "capexLatestRestated": 16.592,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2023-02-03",
          "capexFiledLatest": "2025-02-07",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 16.592,
          "capexLatest": 16.592,
          "capexRestatementPct": 0,
          "firstFiled": "2023-02-03",
          "latestFiled": "2025-02-07",
          "filed": "2025-02-07",
          "revenue": 149.204,
          "revenueFirstReported": 149.204,
          "revenueLatestRestated": 149.204,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-02-03",
          "revenueFiledLatest": "2025-02-07",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 29.173,
          "operatingCashFlowFirstReported": 29.173,
          "operatingCashFlowLatestRestated": 29.173,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-02-03",
          "operatingCashFlowFiledLatest": "2025-02-07",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 12.685,
          "depreciationFirstReported": 13.145,
          "depreciationLatestRestated": 12.685,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-02-03",
          "depreciationFiledLatest": "2025-02-07",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2023-Q1",
          "end": "2023-03-31",
          "capex": 14.207,
          "capexFirstReported": 14.207,
          "capexLatestRestated": 14.207,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2023-04-28",
          "capexFiledLatest": "2024-05-01",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 14.207,
          "capexLatest": 14.207,
          "capexRestatementPct": 0,
          "firstFiled": "2023-04-28",
          "latestFiled": "2024-05-01",
          "filed": "2024-05-01",
          "revenue": 127.358,
          "revenueFirstReported": 127.358,
          "revenueLatestRestated": 127.358,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-04-28",
          "revenueFiledLatest": "2024-05-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 4.788,
          "operatingCashFlowFirstReported": 4.788,
          "operatingCashFlowLatestRestated": 4.788,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-04-28",
          "operatingCashFlowFiledLatest": "2024-05-01",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 11.123,
          "depreciationFirstReported": 11.123,
          "depreciationLatestRestated": 11.123,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-04-28",
          "depreciationFiledLatest": "2024-05-01",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q2",
          "end": "2023-06-30",
          "capex": 11.455,
          "capexFirstReported": 11.455,
          "capexLatestRestated": 11.455,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2023-08-04",
          "capexFiledLatest": "2024-08-02",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 11.455,
          "capexLatest": 11.455,
          "capexRestatementPct": 0,
          "firstFiled": "2023-08-04",
          "latestFiled": "2024-08-02",
          "filed": "2024-08-02",
          "revenue": 134.383,
          "revenueFirstReported": 134.383,
          "revenueLatestRestated": 134.383,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-08-04",
          "revenueFiledLatest": "2024-08-02",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 16.476,
          "operatingCashFlowFirstReported": 16.476,
          "operatingCashFlowLatestRestated": 16.476,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-08-04",
          "operatingCashFlowFiledLatest": "2024-08-02",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 11.589,
          "depreciationFirstReported": 11.589,
          "depreciationLatestRestated": 11.589,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-08-04",
          "depreciationFiledLatest": "2024-08-02",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q3",
          "end": "2023-09-30",
          "capex": 12.479,
          "capexFirstReported": 12.479,
          "capexLatestRestated": 12.479,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2023-10-27",
          "capexFiledLatest": "2024-11-01",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 12.479,
          "capexLatest": 12.479,
          "capexRestatementPct": 0,
          "firstFiled": "2023-10-27",
          "latestFiled": "2024-11-01",
          "filed": "2024-11-01",
          "revenue": 143.083,
          "revenueFirstReported": 143.083,
          "revenueLatestRestated": 143.083,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-10-27",
          "revenueFiledLatest": "2024-11-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 21.217,
          "operatingCashFlowFirstReported": 21.217,
          "operatingCashFlowLatestRestated": 21.217,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-10-27",
          "operatingCashFlowFiledLatest": "2024-11-01",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 12.131,
          "depreciationFirstReported": 12.131,
          "depreciationLatestRestated": 12.131,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-10-27",
          "depreciationFiledLatest": "2024-11-01",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q4",
          "end": "2023-12-31",
          "capex": 14.588,
          "capexFirstReported": 14.588,
          "capexLatestRestated": 14.588,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2024-02-02",
          "capexFiledLatest": "2026-02-06",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 14.588,
          "capexLatest": 14.588,
          "capexRestatementPct": 0,
          "firstFiled": "2024-02-02",
          "latestFiled": "2026-02-06",
          "filed": "2026-02-06",
          "revenue": 169.961,
          "revenueFirstReported": 169.961,
          "revenueLatestRestated": 169.961,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-02-02",
          "revenueFiledLatest": "2026-02-06",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 42.465,
          "operatingCashFlowFirstReported": 42.465,
          "operatingCashFlowLatestRestated": 42.465,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-02-02",
          "operatingCashFlowFiledLatest": "2026-02-06",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 13.82,
          "depreciationFirstReported": 13.82,
          "depreciationLatestRestated": 13.82,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-02-02",
          "depreciationFiledLatest": "2026-02-06",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2024-Q1",
          "end": "2024-03-31",
          "capex": 14.925,
          "capexFirstReported": 14.925,
          "capexLatestRestated": 14.925,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2024-05-01",
          "capexFiledLatest": "2025-05-02",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 14.925,
          "capexLatest": 14.925,
          "capexRestatementPct": 0,
          "firstFiled": "2024-05-01",
          "latestFiled": "2025-05-02",
          "filed": "2025-05-02",
          "revenue": 143.313,
          "revenueFirstReported": 143.313,
          "revenueLatestRestated": 143.313,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-05-01",
          "revenueFiledLatest": "2025-05-02",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 18.989,
          "operatingCashFlowFirstReported": 18.989,
          "operatingCashFlowLatestRestated": 18.989,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-05-01",
          "operatingCashFlowFiledLatest": "2025-05-02",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 11.684,
          "depreciationFirstReported": 11.684,
          "depreciationLatestRestated": 11.684,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-05-01",
          "depreciationFiledLatest": "2025-05-02",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q2",
          "end": "2024-06-30",
          "capex": 17.62,
          "capexFirstReported": 17.62,
          "capexLatestRestated": 17.62,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2024-08-02",
          "capexFiledLatest": "2025-08-01",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 17.62,
          "capexLatest": 17.62,
          "capexRestatementPct": 0,
          "firstFiled": "2024-08-02",
          "latestFiled": "2025-08-01",
          "filed": "2025-08-01",
          "revenue": 147.977,
          "revenueFirstReported": 147.977,
          "revenueLatestRestated": 147.977,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-08-02",
          "revenueFiledLatest": "2025-08-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 25.281,
          "operatingCashFlowFirstReported": 25.281,
          "operatingCashFlowLatestRestated": 25.281,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-08-02",
          "operatingCashFlowFiledLatest": "2025-08-01",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 12.038,
          "depreciationFirstReported": 12.038,
          "depreciationLatestRestated": 12.038,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-08-02",
          "depreciationFiledLatest": "2025-08-01",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q3",
          "end": "2024-09-30",
          "capex": 22.62,
          "capexFirstReported": 22.62,
          "capexLatestRestated": 22.62,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2024-11-01",
          "capexFiledLatest": "2025-10-31",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 22.62,
          "capexLatest": 22.62,
          "capexRestatementPct": 0,
          "firstFiled": "2024-11-01",
          "latestFiled": "2025-10-31",
          "filed": "2025-10-31",
          "revenue": 158.877,
          "revenueFirstReported": 158.877,
          "revenueLatestRestated": 158.877,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-11-01",
          "revenueFiledLatest": "2025-10-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 25.971,
          "operatingCashFlowFirstReported": 25.971,
          "operatingCashFlowLatestRestated": 25.971,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-11-01",
          "operatingCashFlowFiledLatest": "2025-10-31",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 13.442,
          "depreciationFirstReported": 13.442,
          "depreciationLatestRestated": 13.442,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-11-01",
          "depreciationFiledLatest": "2025-10-31",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q4",
          "end": "2024-12-31",
          "capex": 27.834,
          "capexFirstReported": 27.834,
          "capexLatestRestated": 27.834,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2025-02-07",
          "capexFiledLatest": "2026-02-06",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 27.834,
          "capexLatest": 27.834,
          "capexRestatementPct": 0,
          "firstFiled": "2025-02-07",
          "latestFiled": "2026-02-06",
          "filed": "2026-02-06",
          "revenue": 187.792,
          "revenueFirstReported": 187.792,
          "revenueLatestRestated": 187.792,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-02-07",
          "revenueFiledLatest": "2026-02-06",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 45.636,
          "operatingCashFlowFirstReported": 45.636,
          "operatingCashFlowLatestRestated": 45.636,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-02-07",
          "operatingCashFlowFiledLatest": "2026-02-06",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 15.631,
          "depreciationFirstReported": 15.631,
          "depreciationLatestRestated": 15.631,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-02-07",
          "depreciationFiledLatest": "2026-02-06",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2025-Q1",
          "end": "2025-03-31",
          "capex": 25.019,
          "capexFirstReported": 25.019,
          "capexLatestRestated": 25.019,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2025-05-02",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 25.019,
          "capexLatest": 25.019,
          "capexRestatementPct": 0,
          "firstFiled": "2025-05-02",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 155.667,
          "revenueFirstReported": 155.667,
          "revenueLatestRestated": 155.667,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-05-02",
          "revenueFiledLatest": "2026-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 17.015,
          "operatingCashFlowFirstReported": 17.015,
          "operatingCashFlowLatestRestated": 17.015,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-05-02",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 14.262,
          "depreciationFirstReported": 14.262,
          "depreciationLatestRestated": 14.262,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-05-02",
          "depreciationFiledLatest": "2026-04-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q2",
          "end": "2025-06-30",
          "capex": 32.183,
          "capexFirstReported": 32.183,
          "capexLatestRestated": 32.183,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2025-08-01",
          "capexFiledLatest": "2025-08-01",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 32.183,
          "capexLatest": 32.183,
          "capexRestatementPct": 0,
          "firstFiled": "2025-08-01",
          "latestFiled": "2025-08-01",
          "filed": "2025-08-01",
          "revenue": 167.702,
          "revenueFirstReported": 167.702,
          "revenueLatestRestated": 167.702,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-08-01",
          "revenueFiledLatest": "2025-08-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 32.515,
          "operatingCashFlowFirstReported": 32.515,
          "operatingCashFlowLatestRestated": 32.515,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-08-01",
          "operatingCashFlowFiledLatest": "2025-08-01",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 15.227,
          "depreciationFirstReported": 15.227,
          "depreciationLatestRestated": 15.227,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-08-01",
          "depreciationFiledLatest": "2025-08-01",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q3",
          "end": "2025-09-30",
          "capex": 35.095,
          "capexFirstReported": 35.095,
          "capexLatestRestated": 35.095,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2025-10-31",
          "capexFiledLatest": "2025-10-31",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 35.095,
          "capexLatest": 35.095,
          "capexRestatementPct": 0,
          "firstFiled": "2025-10-31",
          "latestFiled": "2025-10-31",
          "filed": "2025-10-31",
          "revenue": 180.169,
          "revenueFirstReported": 180.169,
          "revenueLatestRestated": 180.169,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-10-31",
          "revenueFiledLatest": "2025-10-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 35.525,
          "operatingCashFlowFirstReported": 35.525,
          "operatingCashFlowLatestRestated": 35.525,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-10-31",
          "operatingCashFlowFiledLatest": "2025-10-31",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 16.796,
          "depreciationFirstReported": 16.796,
          "depreciationLatestRestated": 16.796,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-10-31",
          "depreciationFiledLatest": "2025-10-31",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q4",
          "end": "2025-12-31",
          "capex": 39.522,
          "capexFirstReported": 39.522,
          "capexLatestRestated": 39.522,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2026-02-06",
          "capexFiledLatest": "2026-02-06",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 39.522,
          "capexLatest": 39.522,
          "capexRestatementPct": 0,
          "firstFiled": "2026-02-06",
          "latestFiled": "2026-02-06",
          "filed": "2026-02-06",
          "revenue": 213.386,
          "revenueFirstReported": 213.386,
          "revenueLatestRestated": 213.386,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-02-06",
          "revenueFiledLatest": "2026-02-06",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 54.459,
          "operatingCashFlowFirstReported": 54.459,
          "operatingCashFlowLatestRestated": 54.459,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-02-06",
          "operatingCashFlowFiledLatest": "2026-02-06",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 19.471,
          "depreciationFirstReported": 19.471,
          "depreciationLatestRestated": 19.471,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2026-02-06",
          "depreciationFiledLatest": "2026-02-06",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2026-Q1",
          "end": "2026-03-31",
          "capex": 44.203,
          "capexFirstReported": 44.203,
          "capexLatestRestated": 44.203,
          "capexTag": "PaymentsToAcquireProductiveAssets",
          "capexFiledFirst": "2026-04-30",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 44.203,
          "capexLatest": 44.203,
          "capexRestatementPct": 0,
          "firstFiled": "2026-04-30",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 181.519,
          "revenueFirstReported": 181.519,
          "revenueLatestRestated": 181.519,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-04-30",
          "revenueFiledLatest": "2026-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 26.032,
          "operatingCashFlowFirstReported": 26.032,
          "operatingCashFlowLatestRestated": 26.032,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-04-30",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 18.945,
          "depreciationFirstReported": 18.945,
          "depreciationLatestRestated": 18.945,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2026-04-30",
          "depreciationFiledLatest": "2026-04-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        }
      ]
    },
    "meta": {
      "id": "meta",
      "name": "Meta",
      "cik": "0001326801",
      "quarters": [
        {
          "period": "2017-Q1",
          "end": "2017-03-31",
          "capex": 1.271,
          "capexFirstReported": 1.271,
          "capexLatestRestated": 1.271,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-05-04",
          "capexFiledLatest": "2018-04-26",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 1.271,
          "capexLatest": 1.271,
          "capexRestatementPct": 0,
          "firstFiled": "2017-05-04",
          "latestFiled": "2018-04-26",
          "filed": "2018-04-26",
          "revenue": 8.032,
          "revenueFirstReported": 8.032,
          "revenueLatestRestated": 8.032,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-05-04",
          "revenueFiledLatest": "2018-04-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 5.058,
          "operatingCashFlowFirstReported": 5.058,
          "operatingCashFlowLatestRestated": 5.058,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-05-04",
          "operatingCashFlowFiledLatest": "2018-04-26",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 0.671,
          "depreciationFirstReported": 0.671,
          "depreciationLatestRestated": 0.671,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2017-05-04",
          "depreciationFiledLatest": "2018-04-26",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2017-Q2",
          "end": "2017-06-30",
          "capex": 1.444,
          "capexFirstReported": 1.444,
          "capexLatestRestated": 1.444,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-07-27",
          "capexFiledLatest": "2018-07-26",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 1.444,
          "capexLatest": 1.444,
          "capexRestatementPct": 0,
          "firstFiled": "2017-07-27",
          "latestFiled": "2018-07-26",
          "filed": "2018-07-26",
          "revenue": 9.321,
          "revenueFirstReported": 9.321,
          "revenueLatestRestated": 9.321,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-07-27",
          "revenueFiledLatest": "2018-07-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 5.36,
          "operatingCashFlowFirstReported": 5.36,
          "operatingCashFlowLatestRestated": 5.36,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-07-27",
          "operatingCashFlowFiledLatest": "2018-07-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 0.729,
          "depreciationFirstReported": 0.729,
          "depreciationLatestRestated": 0.729,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2017-07-27",
          "depreciationFiledLatest": "2018-07-26",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2017-Q3",
          "end": "2017-09-30",
          "capex": 1.755,
          "capexFirstReported": 1.755,
          "capexLatestRestated": 1.755,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-11-02",
          "capexFiledLatest": "2018-10-31",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 1.755,
          "capexLatest": 1.755,
          "capexRestatementPct": 0,
          "firstFiled": "2017-11-02",
          "latestFiled": "2018-10-31",
          "filed": "2018-10-31",
          "revenue": 10.328,
          "revenueFirstReported": 10.328,
          "revenueLatestRestated": 10.328,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-11-02",
          "revenueFiledLatest": "2018-10-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6.127,
          "operatingCashFlowFirstReported": 6.127,
          "operatingCashFlowLatestRestated": 6.127,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2017-11-02",
          "operatingCashFlowFiledLatest": "2018-10-31",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 0.772,
          "depreciationFirstReported": 0.772,
          "depreciationLatestRestated": 0.772,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2017-11-02",
          "depreciationFiledLatest": "2018-10-31",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2017-Q4",
          "end": "2017-12-31",
          "capex": 2.263,
          "capexFirstReported": 2.263,
          "capexLatestRestated": 2.263,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-02-01",
          "capexFiledLatest": "2020-01-30",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 2.263,
          "capexLatest": 2.263,
          "capexRestatementPct": 0,
          "firstFiled": "2018-02-01",
          "latestFiled": "2020-01-30",
          "filed": "2020-01-30",
          "revenue": 12.972,
          "revenueFirstReported": 12.972,
          "revenueLatestRestated": 12.972,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-02-01",
          "revenueFiledLatest": "2020-01-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 7.671,
          "operatingCashFlowFirstReported": 7.671,
          "operatingCashFlowLatestRestated": 7.671,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-02-01",
          "operatingCashFlowFiledLatest": "2020-01-30",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 0.853,
          "depreciationFirstReported": 0.853,
          "depreciationLatestRestated": 0.853,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-02-01",
          "depreciationFiledLatest": "2020-01-30",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2018-Q1",
          "end": "2018-03-31",
          "capex": 2.812,
          "capexFirstReported": 2.812,
          "capexLatestRestated": 2.812,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-04-26",
          "capexFiledLatest": "2019-04-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.812,
          "capexLatest": 2.812,
          "capexRestatementPct": 0,
          "firstFiled": "2018-04-26",
          "latestFiled": "2019-04-25",
          "filed": "2019-04-25",
          "revenue": 11.966,
          "revenueFirstReported": 11.966,
          "revenueLatestRestated": 11.966,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-04-26",
          "revenueFiledLatest": "2019-04-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.86,
          "operatingCashFlowFirstReported": 7.86,
          "operatingCashFlowLatestRestated": 7.86,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-04-26",
          "operatingCashFlowFiledLatest": "2019-04-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 0.949,
          "depreciationFirstReported": 0.949,
          "depreciationLatestRestated": 0.949,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-04-26",
          "depreciationFiledLatest": "2019-04-25",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q2",
          "end": "2018-06-30",
          "capex": 3.46,
          "capexFirstReported": 3.46,
          "capexLatestRestated": 3.46,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-07-26",
          "capexFiledLatest": "2019-07-25",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.46,
          "capexLatest": 3.46,
          "capexRestatementPct": 0,
          "firstFiled": "2018-07-26",
          "latestFiled": "2019-07-25",
          "filed": "2019-07-25",
          "revenue": 13.231,
          "revenueFirstReported": 13.231,
          "revenueLatestRestated": 13.231,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-07-26",
          "revenueFiledLatest": "2019-07-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6.298,
          "operatingCashFlowFirstReported": 6.298,
          "operatingCashFlowLatestRestated": 6.298,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-07-26",
          "operatingCashFlowFiledLatest": "2019-07-25",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.034,
          "depreciationFirstReported": 1.034,
          "depreciationLatestRestated": 1.034,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-07-26",
          "depreciationFiledLatest": "2019-07-25",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2018-Q3",
          "end": "2018-09-30",
          "capex": 3.342,
          "capexFirstReported": 3.342,
          "capexLatestRestated": 3.342,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-10-31",
          "capexFiledLatest": "2019-10-31",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.342,
          "capexLatest": 3.342,
          "capexRestatementPct": 0,
          "firstFiled": "2018-10-31",
          "latestFiled": "2019-10-31",
          "filed": "2019-10-31",
          "revenue": 13.727,
          "revenueFirstReported": 13.727,
          "revenueLatestRestated": 13.727,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-10-31",
          "revenueFiledLatest": "2019-10-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.498,
          "operatingCashFlowFirstReported": 7.498,
          "operatingCashFlowLatestRestated": 7.498,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-10-31",
          "operatingCashFlowFiledLatest": "2019-10-31",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.107,
          "depreciationFirstReported": 1.107,
          "depreciationLatestRestated": 1.107,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2018-10-31",
          "depreciationFiledLatest": "2019-10-31",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2018-Q4",
          "end": "2018-12-31",
          "capex": 4.301,
          "capexFirstReported": 4.301,
          "capexLatestRestated": 4.301,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-01-31",
          "capexFiledLatest": "2021-01-28",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 4.301,
          "capexLatest": 4.301,
          "capexRestatementPct": 0,
          "firstFiled": "2019-01-31",
          "latestFiled": "2021-01-28",
          "filed": "2021-01-28",
          "revenue": 16.914,
          "revenueFirstReported": 16.914,
          "revenueLatestRestated": 16.914,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-01-31",
          "revenueFiledLatest": "2021-01-28",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 7.618,
          "operatingCashFlowFirstReported": 7.618,
          "operatingCashFlowLatestRestated": 7.618,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-01-31",
          "operatingCashFlowFiledLatest": "2021-01-28",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 1.225,
          "depreciationFirstReported": 1.225,
          "depreciationLatestRestated": 1.225,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-01-31",
          "depreciationFiledLatest": "2021-01-28",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2019-Q1",
          "end": "2019-03-31",
          "capex": 3.837,
          "capexFirstReported": 3.837,
          "capexLatestRestated": 3.837,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-04-25",
          "capexFiledLatest": "2020-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.837,
          "capexLatest": 3.837,
          "capexRestatementPct": 0,
          "firstFiled": "2019-04-25",
          "latestFiled": "2020-04-30",
          "filed": "2020-04-30",
          "revenue": 15.077,
          "revenueFirstReported": 15.077,
          "revenueLatestRestated": 15.077,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-04-25",
          "revenueFiledLatest": "2020-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.308,
          "operatingCashFlowFirstReported": 9.308,
          "operatingCashFlowLatestRestated": 9.308,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-04-25",
          "operatingCashFlowFiledLatest": "2020-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 1.355,
          "depreciationFirstReported": 1.355,
          "depreciationLatestRestated": 1.355,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-04-25",
          "depreciationFiledLatest": "2020-04-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q2",
          "end": "2019-06-30",
          "capex": 3.633,
          "capexFirstReported": 3.633,
          "capexLatestRestated": 3.633,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-07-25",
          "capexFiledLatest": "2020-07-31",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.633,
          "capexLatest": 3.633,
          "capexRestatementPct": 0,
          "firstFiled": "2019-07-25",
          "latestFiled": "2020-07-31",
          "filed": "2020-07-31",
          "revenue": 16.886,
          "revenueFirstReported": 16.886,
          "revenueLatestRestated": 16.886,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-07-25",
          "revenueFiledLatest": "2020-07-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 8.616,
          "operatingCashFlowFirstReported": 8.616,
          "operatingCashFlowLatestRestated": 8.616,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-07-25",
          "operatingCashFlowFiledLatest": "2020-07-31",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.502,
          "depreciationFirstReported": 1.502,
          "depreciationLatestRestated": 1.502,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-07-25",
          "depreciationFiledLatest": "2020-07-31",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2019-Q3",
          "end": "2019-09-30",
          "capex": 3.532,
          "capexFirstReported": 3.532,
          "capexLatestRestated": 3.532,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-10-31",
          "capexFiledLatest": "2020-10-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.532,
          "capexLatest": 3.532,
          "capexRestatementPct": 0,
          "firstFiled": "2019-10-31",
          "latestFiled": "2020-10-30",
          "filed": "2020-10-30",
          "revenue": 17.652,
          "revenueFirstReported": 17.652,
          "revenueLatestRestated": 17.652,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-10-31",
          "revenueFiledLatest": "2020-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.307,
          "operatingCashFlowFirstReported": 9.307,
          "operatingCashFlowLatestRestated": 9.307,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-10-31",
          "operatingCashFlowFiledLatest": "2020-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.416,
          "depreciationFirstReported": 1.416,
          "depreciationLatestRestated": 1.416,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2019-10-31",
          "depreciationFiledLatest": "2020-10-30",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2019-Q4",
          "end": "2019-12-31",
          "capex": 4.1,
          "capexFirstReported": 4.1,
          "capexLatestRestated": 4.1,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-01-30",
          "capexFiledLatest": "2022-02-03",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 4.1,
          "capexLatest": 4.1,
          "capexRestatementPct": 0,
          "firstFiled": "2020-01-30",
          "latestFiled": "2022-02-03",
          "filed": "2022-02-03",
          "revenue": 21.082,
          "revenueFirstReported": 21.082,
          "revenueLatestRestated": 21.082,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-01-30",
          "revenueFiledLatest": "2022-02-03",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 9.083,
          "operatingCashFlowFirstReported": 9.083,
          "operatingCashFlowLatestRestated": 9.083,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-01-30",
          "operatingCashFlowFiledLatest": "2022-02-03",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 1.468,
          "depreciationFirstReported": 1.468,
          "depreciationLatestRestated": 1.468,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-01-30",
          "depreciationFiledLatest": "2022-02-03",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2020-Q1",
          "end": "2020-03-31",
          "capex": 3.558,
          "capexFirstReported": 3.558,
          "capexLatestRestated": 3.558,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-04-30",
          "capexFiledLatest": "2021-04-29",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 3.558,
          "capexLatest": 3.558,
          "capexRestatementPct": 0,
          "firstFiled": "2020-04-30",
          "latestFiled": "2021-04-29",
          "filed": "2021-04-29",
          "revenue": 17.737,
          "revenueFirstReported": 17.737,
          "revenueLatestRestated": 17.737,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-04-30",
          "revenueFiledLatest": "2021-04-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 11.001,
          "operatingCashFlowFirstReported": 11.001,
          "operatingCashFlowLatestRestated": 11.001,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-04-30",
          "operatingCashFlowFiledLatest": "2021-04-29",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 1.597,
          "depreciationFirstReported": 1.597,
          "depreciationLatestRestated": 1.597,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-04-30",
          "depreciationFiledLatest": "2021-04-29",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q2",
          "end": "2020-06-30",
          "capex": 3.255,
          "capexFirstReported": 3.255,
          "capexLatestRestated": 3.255,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-07-31",
          "capexFiledLatest": "2021-07-29",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.255,
          "capexLatest": 3.255,
          "capexRestatementPct": 0,
          "firstFiled": "2020-07-31",
          "latestFiled": "2021-07-29",
          "filed": "2021-07-29",
          "revenue": 18.687,
          "revenueFirstReported": 18.687,
          "revenueLatestRestated": 18.687,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-07-31",
          "revenueFiledLatest": "2021-07-29",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.877,
          "operatingCashFlowFirstReported": 3.877,
          "operatingCashFlowLatestRestated": 3.877,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-07-31",
          "operatingCashFlowFiledLatest": "2021-07-29",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.704,
          "depreciationFirstReported": 1.704,
          "depreciationLatestRestated": 1.704,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-07-31",
          "depreciationFiledLatest": "2021-07-29",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2020-Q3",
          "end": "2020-09-30",
          "capex": 3.689,
          "capexFirstReported": 3.689,
          "capexLatestRestated": 3.689,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-10-30",
          "capexFiledLatest": "2021-10-26",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.689,
          "capexLatest": 3.689,
          "capexRestatementPct": 0,
          "firstFiled": "2020-10-30",
          "latestFiled": "2021-10-26",
          "filed": "2021-10-26",
          "revenue": 21.47,
          "revenueFirstReported": 21.47,
          "revenueLatestRestated": 21.47,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-10-30",
          "revenueFiledLatest": "2021-10-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.829,
          "operatingCashFlowFirstReported": 9.829,
          "operatingCashFlowLatestRestated": 9.829,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-10-30",
          "operatingCashFlowFiledLatest": "2021-10-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.698,
          "depreciationFirstReported": 1.698,
          "depreciationLatestRestated": 1.698,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2020-10-30",
          "depreciationFiledLatest": "2021-10-26",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2020-Q4",
          "end": "2020-12-31",
          "capex": 4.661,
          "capexFirstReported": 4.613,
          "capexLatestRestated": 4.661,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-01-28",
          "capexFiledLatest": "2023-02-02",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 4.613,
          "capexLatest": 4.661,
          "capexRestatementPct": 1.0405376110990572,
          "firstFiled": "2021-01-28",
          "latestFiled": "2023-02-02",
          "filed": "2023-02-02",
          "revenue": 28.072,
          "revenueFirstReported": 28.072,
          "revenueLatestRestated": 28.072,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-01-28",
          "revenueFiledLatest": "2023-02-02",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 14.04,
          "operatingCashFlowFirstReported": 14.04,
          "operatingCashFlowLatestRestated": 14.04,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-01-28",
          "operatingCashFlowFiledLatest": "2023-02-02",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 1.863,
          "depreciationFirstReported": 1.863,
          "depreciationLatestRestated": 1.863,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-01-28",
          "depreciationFiledLatest": "2023-02-02",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2021-Q1",
          "end": "2021-03-31",
          "capex": 4.303,
          "capexFirstReported": 4.272,
          "capexLatestRestated": 4.303,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-04-29",
          "capexFiledLatest": "2022-04-28",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 4.272,
          "capexLatest": 4.303,
          "capexRestatementPct": 0.7256554307116136,
          "firstFiled": "2021-04-29",
          "latestFiled": "2022-04-28",
          "filed": "2022-04-28",
          "revenue": 26.171,
          "revenueFirstReported": 26.171,
          "revenueLatestRestated": 26.171,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-04-29",
          "revenueFiledLatest": "2022-04-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.242,
          "operatingCashFlowFirstReported": 12.242,
          "operatingCashFlowLatestRestated": 12.242,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-04-29",
          "operatingCashFlowFiledLatest": "2022-04-28",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 1.972,
          "depreciationFirstReported": 1.972,
          "depreciationLatestRestated": 1.972,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-04-29",
          "depreciationFiledLatest": "2022-04-28",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q2",
          "end": "2021-06-30",
          "capex": 4.641,
          "capexFirstReported": 4.612,
          "capexLatestRestated": 4.641,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-07-29",
          "capexFiledLatest": "2022-07-28",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 4.612,
          "capexLatest": 4.641,
          "capexRestatementPct": 0.6287944492627817,
          "firstFiled": "2021-07-29",
          "latestFiled": "2022-07-28",
          "filed": "2022-07-28",
          "revenue": 29.077,
          "revenueFirstReported": 29.077,
          "revenueLatestRestated": 29.077,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-07-29",
          "revenueFiledLatest": "2022-07-28",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.247,
          "operatingCashFlowFirstReported": 13.247,
          "operatingCashFlowLatestRestated": 13.247,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-07-29",
          "operatingCashFlowFiledLatest": "2022-07-28",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.986,
          "depreciationFirstReported": 1.986,
          "depreciationLatestRestated": 1.986,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-07-29",
          "depreciationFiledLatest": "2022-07-28",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2021-Q3",
          "end": "2021-09-30",
          "capex": 4.346,
          "capexFirstReported": 4.314,
          "capexLatestRestated": 4.346,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-10-26",
          "capexFiledLatest": "2022-10-27",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 4.314,
          "capexLatest": 4.346,
          "capexRestatementPct": 0.7417709782104875,
          "firstFiled": "2021-10-26",
          "latestFiled": "2022-10-27",
          "filed": "2022-10-27",
          "revenue": 29.01,
          "revenueFirstReported": 29.01,
          "revenueLatestRestated": 29.01,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-10-26",
          "revenueFiledLatest": "2022-10-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 14.09,
          "operatingCashFlowFirstReported": 14.09,
          "operatingCashFlowLatestRestated": 14.09,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-10-26",
          "operatingCashFlowFiledLatest": "2022-10-27",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.995,
          "depreciationFirstReported": 1.995,
          "depreciationLatestRestated": 1.995,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2021-10-26",
          "depreciationFiledLatest": "2022-10-27",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2021-Q4",
          "end": "2021-12-31",
          "capex": 5.4,
          "capexFirstReported": 5.369,
          "capexLatestRestated": 5.4,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-02-03",
          "capexFiledLatest": "2024-02-02",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 5.369,
          "capexLatest": 5.4,
          "capexRestatementPct": 0.577388712981941,
          "firstFiled": "2022-02-03",
          "latestFiled": "2024-02-02",
          "filed": "2024-02-02",
          "revenue": 33.671,
          "revenueFirstReported": 33.671,
          "revenueLatestRestated": 33.671,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-02-03",
          "revenueFiledLatest": "2024-02-02",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 18.104,
          "operatingCashFlowFirstReported": 18.104,
          "operatingCashFlowLatestRestated": 18.104,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-02-03",
          "operatingCashFlowFiledLatest": "2024-02-02",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 2.014,
          "depreciationFirstReported": 2.014,
          "depreciationLatestRestated": 2.014,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-02-03",
          "depreciationFiledLatest": "2024-02-02",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2022-Q1",
          "end": "2022-03-31",
          "capex": 5.441,
          "capexFirstReported": 5.441,
          "capexLatestRestated": 5.441,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-04-28",
          "capexFiledLatest": "2023-04-27",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 5.441,
          "capexLatest": 5.441,
          "capexRestatementPct": 0,
          "firstFiled": "2022-04-28",
          "latestFiled": "2023-04-27",
          "filed": "2023-04-27",
          "revenue": 27.908,
          "revenueFirstReported": 27.908,
          "revenueLatestRestated": 27.908,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-04-28",
          "revenueFiledLatest": "2023-04-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 14.076,
          "operatingCashFlowFirstReported": 14.076,
          "operatingCashFlowLatestRestated": 14.076,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-04-28",
          "operatingCashFlowFiledLatest": "2023-04-27",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 2.156,
          "depreciationFirstReported": 2.156,
          "depreciationLatestRestated": 2.156,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-04-28",
          "depreciationFiledLatest": "2023-04-27",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q2",
          "end": "2022-06-30",
          "capex": 7.572,
          "capexFirstReported": 7.572,
          "capexLatestRestated": 7.572,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-07-28",
          "capexFiledLatest": "2023-07-27",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 7.572,
          "capexLatest": 7.572,
          "capexRestatementPct": 0,
          "firstFiled": "2022-07-28",
          "latestFiled": "2023-07-27",
          "filed": "2023-07-27",
          "revenue": 28.822,
          "revenueFirstReported": 28.822,
          "revenueLatestRestated": 28.822,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-07-28",
          "revenueFiledLatest": "2023-07-27",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 12.196,
          "operatingCashFlowFirstReported": 12.196,
          "operatingCashFlowLatestRestated": 12.196,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-07-28",
          "operatingCashFlowFiledLatest": "2023-07-27",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 1.979,
          "depreciationFirstReported": 1.979,
          "depreciationLatestRestated": 1.979,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-07-28",
          "depreciationFiledLatest": "2023-07-27",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2022-Q3",
          "end": "2022-09-30",
          "capex": 9.375,
          "capexFirstReported": 9.375,
          "capexLatestRestated": 9.375,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-10-27",
          "capexFiledLatest": "2023-10-26",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 9.375,
          "capexLatest": 9.375,
          "capexRestatementPct": 0,
          "firstFiled": "2022-10-27",
          "latestFiled": "2023-10-26",
          "filed": "2023-10-26",
          "revenue": 27.714,
          "revenueFirstReported": 27.714,
          "revenueLatestRestated": 27.714,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-10-27",
          "revenueFiledLatest": "2023-10-26",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 9.692,
          "operatingCashFlowFirstReported": 9.692,
          "operatingCashFlowLatestRestated": 9.692,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-10-27",
          "operatingCashFlowFiledLatest": "2023-10-26",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 2.175,
          "depreciationFirstReported": 2.175,
          "depreciationLatestRestated": 2.175,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2022-10-27",
          "depreciationFiledLatest": "2023-10-26",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2022-Q4",
          "end": "2022-12-31",
          "capex": 8.798,
          "capexFirstReported": 9.043,
          "capexLatestRestated": 8.798,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-02-02",
          "capexFiledLatest": "2025-01-30",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 9.043,
          "capexLatest": 8.798,
          "capexRestatementPct": -2.7092778945040363,
          "firstFiled": "2023-02-02",
          "latestFiled": "2025-01-30",
          "filed": "2025-01-30",
          "revenue": 32.165,
          "revenueFirstReported": 32.165,
          "revenueLatestRestated": 32.165,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-02-02",
          "revenueFiledLatest": "2025-01-30",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 14.511,
          "operatingCashFlowFirstReported": 14.511,
          "operatingCashFlowLatestRestated": 14.511,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-02-02",
          "operatingCashFlowFiledLatest": "2025-01-30",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 2.376,
          "depreciationFirstReported": 2.376,
          "depreciationLatestRestated": 2.376,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-02-02",
          "depreciationFiledLatest": "2025-01-30",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2023-Q1",
          "end": "2023-03-31",
          "capex": 6.823,
          "capexFirstReported": 6.842,
          "capexLatestRestated": 6.823,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-04-27",
          "capexFiledLatest": "2024-04-25",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.842,
          "capexLatest": 6.823,
          "capexRestatementPct": -0.27769657994738406,
          "firstFiled": "2023-04-27",
          "latestFiled": "2024-04-25",
          "filed": "2024-04-25",
          "revenue": 28.645,
          "revenueFirstReported": 28.645,
          "revenueLatestRestated": 28.645,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-04-27",
          "revenueFiledLatest": "2024-04-25",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 13.998,
          "operatingCashFlowFirstReported": 13.998,
          "operatingCashFlowLatestRestated": 13.998,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-04-27",
          "operatingCashFlowFiledLatest": "2024-04-25",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 2.524,
          "depreciationFirstReported": 2.524,
          "depreciationLatestRestated": 2.524,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-04-27",
          "depreciationFiledLatest": "2024-04-25",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q2",
          "end": "2023-06-30",
          "capex": 6.134,
          "capexFirstReported": 6.216,
          "capexLatestRestated": 6.134,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-07-27",
          "capexFiledLatest": "2024-08-01",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 6.216,
          "capexLatest": 6.134,
          "capexRestatementPct": -1.3191763191763184,
          "firstFiled": "2023-07-27",
          "latestFiled": "2024-08-01",
          "filed": "2024-08-01",
          "revenue": 31.999,
          "revenueFirstReported": 31.999,
          "revenueLatestRestated": 31.999,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-07-27",
          "revenueFiledLatest": "2024-08-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 17.309,
          "operatingCashFlowFirstReported": 17.309,
          "operatingCashFlowLatestRestated": 17.309,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-07-27",
          "operatingCashFlowFiledLatest": "2024-08-01",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 2.623,
          "depreciationFirstReported": 2.623,
          "depreciationLatestRestated": 2.623,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-07-27",
          "depreciationFiledLatest": "2024-08-01",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2023-Q3",
          "end": "2023-09-30",
          "capex": 6.496,
          "capexFirstReported": 6.543,
          "capexLatestRestated": 6.496,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-10-26",
          "capexFiledLatest": "2024-10-31",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 6.543,
          "capexLatest": 6.496,
          "capexRestatementPct": -0.7183249274033354,
          "firstFiled": "2023-10-26",
          "latestFiled": "2024-10-31",
          "filed": "2024-10-31",
          "revenue": 34.146,
          "revenueFirstReported": 34.146,
          "revenueLatestRestated": 34.146,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-10-26",
          "revenueFiledLatest": "2024-10-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 20.402,
          "operatingCashFlowFirstReported": 20.402,
          "operatingCashFlowLatestRestated": 20.402,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-10-26",
          "operatingCashFlowFiledLatest": "2024-10-31",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 2.859,
          "depreciationFirstReported": 2.859,
          "depreciationLatestRestated": 2.859,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2023-10-26",
          "depreciationFiledLatest": "2024-10-31",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2023-Q4",
          "end": "2023-12-31",
          "capex": 7.592,
          "capexFirstReported": 7.665,
          "capexLatestRestated": 7.592,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-02-02",
          "capexFiledLatest": "2026-01-29",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 7.665,
          "capexLatest": 7.592,
          "capexRestatementPct": -0.952380952380949,
          "firstFiled": "2024-02-02",
          "latestFiled": "2026-01-29",
          "filed": "2026-01-29",
          "revenue": 40.111,
          "revenueFirstReported": 40.111,
          "revenueLatestRestated": 40.111,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-02-02",
          "revenueFiledLatest": "2026-01-29",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 19.404,
          "operatingCashFlowFirstReported": 19.404,
          "operatingCashFlowLatestRestated": 19.404,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-02-02",
          "operatingCashFlowFiledLatest": "2026-01-29",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 3.172,
          "depreciationFirstReported": 3.172,
          "depreciationLatestRestated": 3.172,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-02-02",
          "depreciationFiledLatest": "2026-01-29",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2024-Q1",
          "end": "2024-03-31",
          "capex": 6.4,
          "capexFirstReported": 6.4,
          "capexLatestRestated": 6.4,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-04-25",
          "capexFiledLatest": "2025-05-01",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 6.4,
          "capexLatest": 6.4,
          "capexRestatementPct": 0,
          "firstFiled": "2024-04-25",
          "latestFiled": "2025-05-01",
          "filed": "2025-05-01",
          "revenue": 36.455,
          "revenueFirstReported": 36.455,
          "revenueLatestRestated": 36.455,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-04-25",
          "revenueFiledLatest": "2025-05-01",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 19.246,
          "operatingCashFlowFirstReported": 19.246,
          "operatingCashFlowLatestRestated": 19.246,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-04-25",
          "operatingCashFlowFiledLatest": "2025-05-01",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 3.374,
          "depreciationFirstReported": 3.374,
          "depreciationLatestRestated": 3.374,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-04-25",
          "depreciationFiledLatest": "2025-05-01",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q2",
          "end": "2024-06-30",
          "capex": 8.173,
          "capexFirstReported": 8.173,
          "capexLatestRestated": 8.173,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-08-01",
          "capexFiledLatest": "2025-07-31",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 8.173,
          "capexLatest": 8.173,
          "capexRestatementPct": 0,
          "firstFiled": "2024-08-01",
          "latestFiled": "2025-07-31",
          "filed": "2025-07-31",
          "revenue": 39.071,
          "revenueFirstReported": 39.071,
          "revenueLatestRestated": 39.071,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-08-01",
          "revenueFiledLatest": "2025-07-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 19.37,
          "operatingCashFlowFirstReported": 19.37,
          "operatingCashFlowLatestRestated": 19.37,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-08-01",
          "operatingCashFlowFiledLatest": "2025-07-31",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 3.637,
          "depreciationFirstReported": 3.637,
          "depreciationLatestRestated": 3.637,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-08-01",
          "depreciationFiledLatest": "2025-07-31",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2024-Q3",
          "end": "2024-09-30",
          "capex": 8.258,
          "capexFirstReported": 8.258,
          "capexLatestRestated": 8.258,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-10-31",
          "capexFiledLatest": "2025-10-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 8.258,
          "capexLatest": 8.258,
          "capexRestatementPct": 0,
          "firstFiled": "2024-10-31",
          "latestFiled": "2025-10-30",
          "filed": "2025-10-30",
          "revenue": 40.589,
          "revenueFirstReported": 40.589,
          "revenueLatestRestated": 40.589,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-10-31",
          "revenueFiledLatest": "2025-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 24.724,
          "operatingCashFlowFirstReported": 24.724,
          "operatingCashFlowLatestRestated": 24.724,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-10-31",
          "operatingCashFlowFiledLatest": "2025-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 4.027,
          "depreciationFirstReported": 4.027,
          "depreciationLatestRestated": 4.027,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2024-10-31",
          "depreciationFiledLatest": "2025-10-30",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2024-Q4",
          "end": "2024-12-31",
          "capex": 14.425,
          "capexFirstReported": 14.425,
          "capexLatestRestated": 14.425,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-01-30",
          "capexFiledLatest": "2026-01-29",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 14.425,
          "capexLatest": 14.425,
          "capexRestatementPct": 0,
          "firstFiled": "2025-01-30",
          "latestFiled": "2026-01-29",
          "filed": "2026-01-29",
          "revenue": 48.385,
          "revenueFirstReported": 48.385,
          "revenueLatestRestated": 48.385,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-01-30",
          "revenueFiledLatest": "2026-01-29",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 27.988,
          "operatingCashFlowFirstReported": 27.988,
          "operatingCashFlowLatestRestated": 27.988,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-01-30",
          "operatingCashFlowFiledLatest": "2026-01-29",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 4.46,
          "depreciationFirstReported": 4.46,
          "depreciationLatestRestated": 4.46,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-01-30",
          "depreciationFiledLatest": "2026-01-29",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2025-Q1",
          "end": "2025-03-31",
          "capex": 12.941,
          "capexFirstReported": 12.941,
          "capexLatestRestated": 12.941,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-05-01",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 12.941,
          "capexLatest": 12.941,
          "capexRestatementPct": 0,
          "firstFiled": "2025-05-01",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 42.314,
          "revenueFirstReported": 42.314,
          "revenueLatestRestated": 42.314,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-05-01",
          "revenueFiledLatest": "2026-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 24.026,
          "operatingCashFlowFirstReported": 24.026,
          "operatingCashFlowLatestRestated": 24.026,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-05-01",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 3.9,
          "depreciationFirstReported": 3.9,
          "depreciationLatestRestated": 3.9,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-05-01",
          "depreciationFiledLatest": "2026-04-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q2",
          "end": "2025-06-30",
          "capex": 16.538,
          "capexFirstReported": 16.538,
          "capexLatestRestated": 16.538,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-07-31",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 16.538,
          "capexLatest": 16.538,
          "capexRestatementPct": 0,
          "firstFiled": "2025-07-31",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 47.516,
          "revenueFirstReported": 47.516,
          "revenueLatestRestated": 47.516,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-07-31",
          "revenueFiledLatest": "2025-07-31",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 25.561,
          "operatingCashFlowFirstReported": 25.561,
          "operatingCashFlowLatestRestated": 25.561,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-07-31",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 4.342,
          "depreciationFirstReported": 4.342,
          "depreciationLatestRestated": 4.342,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-07-31",
          "depreciationFiledLatest": "2026-04-30",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2025-Q3",
          "end": "2025-09-30",
          "capex": 18.829,
          "capexFirstReported": 18.829,
          "capexLatestRestated": 18.829,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-10-30",
          "capexFiledLatest": "2025-10-30",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 18.829,
          "capexLatest": 18.829,
          "capexRestatementPct": 0,
          "firstFiled": "2025-10-30",
          "latestFiled": "2025-10-30",
          "filed": "2025-10-30",
          "revenue": 51.242,
          "revenueFirstReported": 51.242,
          "revenueLatestRestated": 51.242,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-10-30",
          "revenueFiledLatest": "2025-10-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 29.999,
          "operatingCashFlowFirstReported": 29.999,
          "operatingCashFlowLatestRestated": 29.999,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-10-30",
          "operatingCashFlowFiledLatest": "2025-10-30",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference",
          "depreciation": 4.963,
          "depreciationFirstReported": 4.963,
          "depreciationLatestRestated": 4.963,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2025-10-30",
          "depreciationFiledLatest": "2025-10-30",
          "depreciationExtractionFirst": "cumulative-difference",
          "depreciationExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2025-Q4",
          "end": "2025-12-31",
          "capex": 21.383,
          "capexFirstReported": 21.383,
          "capexLatestRestated": 21.383,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-01-29",
          "capexFiledLatest": "2026-01-29",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 21.383,
          "capexLatest": 21.383,
          "capexRestatementPct": 0,
          "firstFiled": "2026-01-29",
          "latestFiled": "2026-01-29",
          "filed": "2026-01-29",
          "revenue": 59.893,
          "revenueFirstReported": 59.893,
          "revenueLatestRestated": 59.893,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-01-29",
          "revenueFiledLatest": "2026-01-29",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 36.214,
          "operatingCashFlowFirstReported": 36.214,
          "operatingCashFlowLatestRestated": 36.214,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-01-29",
          "operatingCashFlowFiledLatest": "2026-01-29",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual",
          "depreciation": 5.411,
          "depreciationFirstReported": 5.411,
          "depreciationLatestRestated": 5.411,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2026-01-29",
          "depreciationFiledLatest": "2026-01-29",
          "depreciationExtractionFirst": "fy-residual",
          "depreciationExtractionLatest": "fy-residual"
        },
        {
          "period": "2026-Q1",
          "end": "2026-03-31",
          "capex": 18.997,
          "capexFirstReported": 18.997,
          "capexLatestRestated": 18.997,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-04-30",
          "capexFiledLatest": "2026-04-30",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 18.997,
          "capexLatest": 18.997,
          "capexRestatementPct": 0,
          "firstFiled": "2026-04-30",
          "latestFiled": "2026-04-30",
          "filed": "2026-04-30",
          "revenue": 56.311,
          "revenueFirstReported": 56.311,
          "revenueLatestRestated": 56.311,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-04-30",
          "revenueFiledLatest": "2026-04-30",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 32.226,
          "operatingCashFlowFirstReported": 32.226,
          "operatingCashFlowLatestRestated": 32.226,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-04-30",
          "operatingCashFlowFiledLatest": "2026-04-30",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone",
          "depreciation": 5.999,
          "depreciationFirstReported": 5.999,
          "depreciationLatestRestated": 5.999,
          "depreciationTag": "DepreciationDepletionAndAmortization",
          "depreciationFiledFirst": "2026-04-30",
          "depreciationFiledLatest": "2026-04-30",
          "depreciationExtractionFirst": "standalone",
          "depreciationExtractionLatest": "standalone"
        }
      ]
    },
    "oracle": {
      "id": "oracle",
      "name": "Oracle",
      "cik": "0001341439",
      "quarters": [
        {
          "period": "2017-Q2",
          "end": "2017-05-31",
          "capex": 0.525,
          "capexFirstReported": 0.525,
          "capexLatestRestated": 0.525,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-06-27",
          "capexFiledLatest": "2019-06-21",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 0.525,
          "capexLatest": 0.525,
          "capexRestatementPct": 0,
          "firstFiled": "2017-06-27",
          "latestFiled": "2019-06-21",
          "filed": "2019-06-21",
          "revenue": 10.957,
          "revenueFirstReported": 10.893,
          "revenueLatestRestated": 10.957,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-06-27",
          "revenueFiledLatest": "2019-06-21",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual"
        },
        {
          "period": "2017-Q3",
          "end": "2017-08-31",
          "capex": 0.473,
          "capexFirstReported": 0.473,
          "capexLatestRestated": 0.473,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-09-18",
          "capexFiledLatest": "2018-09-19",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 0.473,
          "capexLatest": 0.473,
          "capexRestatementPct": 0,
          "firstFiled": "2017-09-18",
          "latestFiled": "2018-09-19",
          "filed": "2018-09-19",
          "revenue": 9.104,
          "revenueFirstReported": 9.187,
          "revenueLatestRestated": 9.104,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-09-18",
          "revenueFiledLatest": "2018-09-19",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6.566,
          "operatingCashFlowFirstReported": 6.566,
          "operatingCashFlowLatestRestated": 6.566,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-09-19",
          "operatingCashFlowFiledLatest": "2018-09-19",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2017-Q4",
          "end": "2017-11-30",
          "capex": 0.599,
          "capexFirstReported": 0.599,
          "capexLatestRestated": 0.599,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2017-12-18",
          "capexFiledLatest": "2018-12-19",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.599,
          "capexLatest": 0.599,
          "capexRestatementPct": 0,
          "firstFiled": "2017-12-18",
          "latestFiled": "2018-12-19",
          "filed": "2018-12-19",
          "revenue": 9.589,
          "revenueFirstReported": 9.621,
          "revenueLatestRestated": 9.589,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2017-12-18",
          "revenueFiledLatest": "2018-12-19",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 0.85,
          "operatingCashFlowFirstReported": 0.85,
          "operatingCashFlowLatestRestated": 0.85,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-12-19",
          "operatingCashFlowFiledLatest": "2018-12-19",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2018-Q1",
          "end": "2018-02-28",
          "capex": 0.286,
          "capexFirstReported": 0.286,
          "capexLatestRestated": 0.286,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-03-21",
          "capexFiledLatest": "2019-03-18",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.286,
          "capexLatest": 0.286,
          "capexRestatementPct": 0,
          "firstFiled": "2018-03-21",
          "latestFiled": "2019-03-18",
          "filed": "2019-03-18",
          "revenue": 9.676,
          "revenueFirstReported": 9.771,
          "revenueLatestRestated": 9.676,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-03-21",
          "revenueFiledLatest": "2019-03-18",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.31,
          "operatingCashFlowFirstReported": 3.31,
          "operatingCashFlowLatestRestated": 3.31,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-03-18",
          "operatingCashFlowFiledLatest": "2019-03-18",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2018-Q2",
          "end": "2018-05-31",
          "capex": 0.378,
          "capexFirstReported": 0.378,
          "capexLatestRestated": 0.378,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-06-22",
          "capexFiledLatest": "2020-06-22",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 0.378,
          "capexLatest": 0.378,
          "capexRestatementPct": 0,
          "firstFiled": "2018-06-22",
          "latestFiled": "2020-06-22",
          "filed": "2020-06-22",
          "revenue": 11.014,
          "revenueFirstReported": 11.252,
          "revenueLatestRestated": 11.014,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-06-22",
          "revenueFiledLatest": "2020-06-22",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 4.66,
          "operatingCashFlowFirstReported": 8.82,
          "operatingCashFlowLatestRestated": 4.66,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-09-19",
          "operatingCashFlowFiledLatest": "2020-06-22",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2018-Q3",
          "end": "2018-08-31",
          "capex": 0.383,
          "capexFirstReported": 0.383,
          "capexLatestRestated": 0.383,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-09-19",
          "capexFiledLatest": "2019-09-13",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 0.383,
          "capexLatest": 0.383,
          "capexRestatementPct": 0,
          "firstFiled": "2018-09-19",
          "latestFiled": "2019-09-13",
          "filed": "2019-09-13",
          "revenue": 9.193,
          "revenueFirstReported": 9.193,
          "revenueLatestRestated": 9.193,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-09-19",
          "revenueFiledLatest": "2019-09-13",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6.722,
          "operatingCashFlowFirstReported": 6.722,
          "operatingCashFlowLatestRestated": 6.722,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-09-19",
          "operatingCashFlowFiledLatest": "2019-09-13",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2018-Q4",
          "end": "2018-11-30",
          "capex": 0.421,
          "capexFirstReported": 0.421,
          "capexLatestRestated": 0.421,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2018-12-19",
          "capexFiledLatest": "2019-12-13",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.421,
          "capexLatest": 0.421,
          "capexRestatementPct": 0,
          "firstFiled": "2018-12-19",
          "latestFiled": "2019-12-13",
          "filed": "2019-12-13",
          "revenue": 9.562,
          "revenueFirstReported": 9.562,
          "revenueLatestRestated": 9.562,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2018-12-19",
          "revenueFiledLatest": "2019-12-13",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 0.546,
          "operatingCashFlowFirstReported": 0.546,
          "operatingCashFlowLatestRestated": 0.546,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2018-12-19",
          "operatingCashFlowFiledLatest": "2019-12-13",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2019-Q1",
          "end": "2019-02-28",
          "capex": 0.443,
          "capexFirstReported": 0.443,
          "capexLatestRestated": 0.443,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-03-18",
          "capexFiledLatest": "2020-03-13",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.443,
          "capexLatest": 0.443,
          "capexRestatementPct": 0,
          "firstFiled": "2019-03-18",
          "latestFiled": "2020-03-13",
          "filed": "2020-03-13",
          "revenue": 9.614,
          "revenueFirstReported": 9.614,
          "revenueLatestRestated": 9.614,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-03-18",
          "revenueFiledLatest": "2020-03-13",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 2.861,
          "operatingCashFlowFirstReported": 2.861,
          "operatingCashFlowLatestRestated": 2.861,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-03-18",
          "operatingCashFlowFiledLatest": "2020-03-13",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2019-Q2",
          "end": "2019-05-31",
          "capex": 0.413,
          "capexFirstReported": 0.413,
          "capexLatestRestated": 0.413,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-06-21",
          "capexFiledLatest": "2021-06-21",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 0.413,
          "capexLatest": 0.413,
          "capexRestatementPct": 0,
          "firstFiled": "2019-06-21",
          "latestFiled": "2021-06-21",
          "filed": "2021-06-21",
          "revenue": 11.137,
          "revenueFirstReported": 11.137,
          "revenueLatestRestated": 11.137,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-06-21",
          "revenueFiledLatest": "2021-06-21",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 4.422,
          "operatingCashFlowFirstReported": 4.422,
          "operatingCashFlowLatestRestated": 4.422,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-06-21",
          "operatingCashFlowFiledLatest": "2021-06-21",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2019-Q3",
          "end": "2019-08-31",
          "capex": 0.386,
          "capexFirstReported": 0.386,
          "capexLatestRestated": 0.386,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-09-13",
          "capexFiledLatest": "2020-09-15",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 0.386,
          "capexLatest": 0.386,
          "capexRestatementPct": 0,
          "firstFiled": "2019-09-13",
          "latestFiled": "2020-09-15",
          "filed": "2020-09-15",
          "revenue": 9.218,
          "revenueFirstReported": 9.218,
          "revenueLatestRestated": 9.218,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-09-13",
          "revenueFiledLatest": "2020-09-15",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6,
          "operatingCashFlowFirstReported": 6,
          "operatingCashFlowLatestRestated": 6,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-09-13",
          "operatingCashFlowFiledLatest": "2020-09-15",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2019-Q4",
          "end": "2019-11-30",
          "capex": 0.349,
          "capexFirstReported": 0.349,
          "capexLatestRestated": 0.349,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2019-12-13",
          "capexFiledLatest": "2020-12-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.349,
          "capexLatest": 0.349,
          "capexRestatementPct": 0,
          "firstFiled": "2019-12-13",
          "latestFiled": "2020-12-11",
          "filed": "2020-12-11",
          "revenue": 9.614,
          "revenueFirstReported": 9.614,
          "revenueLatestRestated": 9.614,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2019-12-13",
          "revenueFiledLatest": "2020-12-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 0.513,
          "operatingCashFlowFirstReported": 0.513,
          "operatingCashFlowLatestRestated": 0.513,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2019-12-13",
          "operatingCashFlowFiledLatest": "2020-12-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2020-Q1",
          "end": "2020-02-29",
          "capex": 0.396,
          "capexFirstReported": 0.396,
          "capexLatestRestated": 0.396,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-03-13",
          "capexFiledLatest": "2021-03-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.396,
          "capexLatest": 0.396,
          "capexRestatementPct": 0,
          "firstFiled": "2020-03-13",
          "latestFiled": "2021-03-11",
          "filed": "2021-03-11",
          "revenue": 9.796,
          "revenueFirstReported": 9.796,
          "revenueLatestRestated": 9.796,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-03-13",
          "revenueFiledLatest": "2021-03-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.012,
          "operatingCashFlowFirstReported": 3.012,
          "operatingCashFlowLatestRestated": 3.012,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-03-13",
          "operatingCashFlowFiledLatest": "2021-03-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2020-Q2",
          "end": "2020-05-31",
          "capex": 0.433,
          "capexFirstReported": 0.433,
          "capexLatestRestated": 0.433,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-06-22",
          "capexFiledLatest": "2022-06-21",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 0.433,
          "capexLatest": 0.433,
          "capexRestatementPct": 0,
          "firstFiled": "2020-06-22",
          "latestFiled": "2022-06-21",
          "filed": "2022-06-21",
          "revenue": 10.439,
          "revenueFirstReported": 10.439,
          "revenueLatestRestated": 10.439,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-06-22",
          "revenueFiledLatest": "2022-06-21",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 3.614,
          "operatingCashFlowFirstReported": 3.614,
          "operatingCashFlowLatestRestated": 3.614,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-06-22",
          "operatingCashFlowFiledLatest": "2022-06-21",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2020-Q3",
          "end": "2020-08-31",
          "capex": 0.436,
          "capexFirstReported": 0.436,
          "capexLatestRestated": 0.436,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-09-15",
          "capexFiledLatest": "2021-09-13",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 0.436,
          "capexLatest": 0.436,
          "capexRestatementPct": 0,
          "firstFiled": "2020-09-15",
          "latestFiled": "2021-09-13",
          "filed": "2021-09-13",
          "revenue": 9.367,
          "revenueFirstReported": 9.367,
          "revenueLatestRestated": 9.367,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-09-15",
          "revenueFiledLatest": "2021-09-13",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 5.953,
          "operatingCashFlowFirstReported": 5.953,
          "operatingCashFlowLatestRestated": 5.953,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-09-15",
          "operatingCashFlowFiledLatest": "2021-09-13",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2020-Q4",
          "end": "2020-11-30",
          "capex": 0.568,
          "capexFirstReported": 0.568,
          "capexLatestRestated": 0.568,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2020-12-11",
          "capexFiledLatest": "2021-12-10",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.568,
          "capexLatest": 0.568,
          "capexRestatementPct": 0,
          "firstFiled": "2020-12-11",
          "latestFiled": "2021-12-10",
          "filed": "2021-12-10",
          "revenue": 9.8,
          "revenueFirstReported": 9.8,
          "revenueLatestRestated": 9.8,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2020-12-11",
          "revenueFiledLatest": "2021-12-10",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 1.388,
          "operatingCashFlowFirstReported": 1.388,
          "operatingCashFlowLatestRestated": 1.388,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2020-12-11",
          "operatingCashFlowFiledLatest": "2021-12-10",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2021-Q1",
          "end": "2021-02-28",
          "capex": 0.414,
          "capexFirstReported": 0.414,
          "capexLatestRestated": 0.414,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-03-11",
          "capexFiledLatest": "2022-03-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.414,
          "capexLatest": 0.414,
          "capexRestatementPct": 0,
          "firstFiled": "2021-03-11",
          "latestFiled": "2022-03-11",
          "filed": "2022-03-11",
          "revenue": 10.085,
          "revenueFirstReported": 10.085,
          "revenueLatestRestated": 10.085,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-03-11",
          "revenueFiledLatest": "2022-03-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.704,
          "operatingCashFlowFirstReported": 3.704,
          "operatingCashFlowLatestRestated": 3.704,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-03-11",
          "operatingCashFlowFiledLatest": "2022-03-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2021-Q2",
          "end": "2021-05-31",
          "capex": 0.717,
          "capexFirstReported": 0.717,
          "capexLatestRestated": 0.717,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-06-21",
          "capexFiledLatest": "2023-06-20",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 0.717,
          "capexLatest": 0.717,
          "capexRestatementPct": 0,
          "firstFiled": "2021-06-21",
          "latestFiled": "2023-06-20",
          "filed": "2023-06-20",
          "revenue": 11.227,
          "revenueFirstReported": 11.227,
          "revenueLatestRestated": 11.227,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-06-21",
          "revenueFiledLatest": "2023-06-20",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 4.842,
          "operatingCashFlowFirstReported": 4.842,
          "operatingCashFlowLatestRestated": 4.842,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-06-21",
          "operatingCashFlowFiledLatest": "2023-06-20",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2021-Q3",
          "end": "2021-08-31",
          "capex": 1.062,
          "capexFirstReported": 1.062,
          "capexLatestRestated": 1.062,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-09-13",
          "capexFiledLatest": "2022-09-13",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 1.062,
          "capexLatest": 1.062,
          "capexRestatementPct": 0,
          "firstFiled": "2021-09-13",
          "latestFiled": "2022-09-13",
          "filed": "2022-09-13",
          "revenue": 9.728,
          "revenueFirstReported": 9.728,
          "revenueLatestRestated": 9.728,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-09-13",
          "revenueFiledLatest": "2022-09-13",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 5.391,
          "operatingCashFlowFirstReported": 5.391,
          "operatingCashFlowLatestRestated": 5.391,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-09-13",
          "operatingCashFlowFiledLatest": "2022-09-13",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2021-Q4",
          "end": "2021-11-30",
          "capex": 0.925,
          "capexFirstReported": 0.925,
          "capexLatestRestated": 0.925,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2021-12-10",
          "capexFiledLatest": "2022-12-13",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 0.925,
          "capexLatest": 0.925,
          "capexRestatementPct": 0,
          "firstFiled": "2021-12-10",
          "latestFiled": "2022-12-13",
          "filed": "2022-12-13",
          "revenue": 10.36,
          "revenueFirstReported": 10.36,
          "revenueLatestRestated": 10.36,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2021-12-10",
          "revenueFiledLatest": "2022-12-13",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": -3.682,
          "operatingCashFlowFirstReported": -3.682,
          "operatingCashFlowLatestRestated": -3.682,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2021-12-10",
          "operatingCashFlowFiledLatest": "2022-12-13",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2022-Q1",
          "end": "2022-02-28",
          "capex": 1.101,
          "capexFirstReported": 1.101,
          "capexLatestRestated": 1.101,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-03-11",
          "capexFiledLatest": "2023-03-10",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 1.101,
          "capexLatest": 1.101,
          "capexRestatementPct": 0,
          "firstFiled": "2022-03-11",
          "latestFiled": "2023-03-10",
          "filed": "2023-03-10",
          "revenue": 10.513,
          "revenueFirstReported": 10.513,
          "revenueLatestRestated": 10.513,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-03-11",
          "revenueFiledLatest": "2023-03-10",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 3.845,
          "operatingCashFlowFirstReported": 3.845,
          "operatingCashFlowLatestRestated": 3.845,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-03-11",
          "operatingCashFlowFiledLatest": "2023-03-10",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2022-Q2",
          "end": "2022-05-31",
          "capex": 1.423,
          "capexFirstReported": 1.423,
          "capexLatestRestated": 1.423,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-06-21",
          "capexFiledLatest": "2024-06-20",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 1.423,
          "capexLatest": 1.423,
          "capexRestatementPct": 0,
          "firstFiled": "2022-06-21",
          "latestFiled": "2024-06-20",
          "filed": "2024-06-20",
          "revenue": 11.84,
          "revenueFirstReported": 11.84,
          "revenueLatestRestated": 11.84,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-06-21",
          "revenueFiledLatest": "2024-06-20",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 3.985,
          "operatingCashFlowFirstReported": 3.985,
          "operatingCashFlowLatestRestated": 3.985,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-06-21",
          "operatingCashFlowFiledLatest": "2024-06-20",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2022-Q3",
          "end": "2022-08-31",
          "capex": 1.719,
          "capexFirstReported": 1.719,
          "capexLatestRestated": 1.719,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-09-13",
          "capexFiledLatest": "2023-09-12",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 1.719,
          "capexLatest": 1.719,
          "capexRestatementPct": 0,
          "firstFiled": "2022-09-13",
          "latestFiled": "2023-09-12",
          "filed": "2023-09-12",
          "revenue": 11.445,
          "revenueFirstReported": 11.445,
          "revenueLatestRestated": 11.445,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-09-13",
          "revenueFiledLatest": "2023-09-12",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6.394,
          "operatingCashFlowFirstReported": 6.394,
          "operatingCashFlowLatestRestated": 6.394,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-09-13",
          "operatingCashFlowFiledLatest": "2023-09-12",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2022-Q4",
          "end": "2022-11-30",
          "capex": 2.435,
          "capexFirstReported": 2.435,
          "capexLatestRestated": 2.435,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2022-12-13",
          "capexFiledLatest": "2023-12-12",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 2.435,
          "capexLatest": 2.435,
          "capexRestatementPct": 0,
          "firstFiled": "2022-12-13",
          "latestFiled": "2023-12-12",
          "filed": "2023-12-12",
          "revenue": 12.275,
          "revenueFirstReported": 12.275,
          "revenueLatestRestated": 12.275,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2022-12-13",
          "revenueFiledLatest": "2023-12-12",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 0.849,
          "operatingCashFlowFirstReported": 0.849,
          "operatingCashFlowLatestRestated": 0.849,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2022-12-13",
          "operatingCashFlowFiledLatest": "2023-12-12",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2023-Q1",
          "end": "2023-02-28",
          "capex": 2.628,
          "capexFirstReported": 2.628,
          "capexLatestRestated": 2.628,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-03-10",
          "capexFiledLatest": "2024-03-12",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 2.628,
          "capexLatest": 2.628,
          "capexRestatementPct": 0,
          "firstFiled": "2023-03-10",
          "latestFiled": "2024-03-12",
          "filed": "2024-03-12",
          "revenue": 12.398,
          "revenueFirstReported": 12.398,
          "revenueLatestRestated": 12.398,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-03-10",
          "revenueFiledLatest": "2024-03-12",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 4.275,
          "operatingCashFlowFirstReported": 4.275,
          "operatingCashFlowLatestRestated": 4.275,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-03-10",
          "operatingCashFlowFiledLatest": "2024-03-12",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2023-Q2",
          "end": "2023-05-31",
          "capex": 1.913,
          "capexFirstReported": 1.913,
          "capexLatestRestated": 1.913,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-06-20",
          "capexFiledLatest": "2025-06-18",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 1.913,
          "capexLatest": 1.913,
          "capexRestatementPct": 0,
          "firstFiled": "2023-06-20",
          "latestFiled": "2025-06-18",
          "filed": "2025-06-18",
          "revenue": 13.836,
          "revenueFirstReported": 13.836,
          "revenueLatestRestated": 13.836,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-06-20",
          "revenueFiledLatest": "2025-06-18",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 5.647,
          "operatingCashFlowFirstReported": 5.647,
          "operatingCashFlowLatestRestated": 5.647,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-06-20",
          "operatingCashFlowFiledLatest": "2025-06-18",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2023-Q3",
          "end": "2023-08-31",
          "capex": 1.314,
          "capexFirstReported": 1.314,
          "capexLatestRestated": 1.314,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-09-12",
          "capexFiledLatest": "2024-09-10",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 1.314,
          "capexLatest": 1.314,
          "capexRestatementPct": 0,
          "firstFiled": "2023-09-12",
          "latestFiled": "2024-09-10",
          "filed": "2024-09-10",
          "revenue": 12.453,
          "revenueFirstReported": 12.453,
          "revenueLatestRestated": 12.453,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-09-12",
          "revenueFiledLatest": "2024-09-10",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 6.974,
          "operatingCashFlowFirstReported": 6.974,
          "operatingCashFlowLatestRestated": 6.974,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-09-12",
          "operatingCashFlowFiledLatest": "2024-09-10",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2023-Q4",
          "end": "2023-11-30",
          "capex": 1.08,
          "capexFirstReported": 1.08,
          "capexLatestRestated": 1.08,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2023-12-12",
          "capexFiledLatest": "2024-12-10",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 1.08,
          "capexLatest": 1.08,
          "capexRestatementPct": 0,
          "firstFiled": "2023-12-12",
          "latestFiled": "2024-12-10",
          "filed": "2024-12-10",
          "revenue": 12.941,
          "revenueFirstReported": 12.941,
          "revenueLatestRestated": 12.941,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2023-12-12",
          "revenueFiledLatest": "2024-12-10",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 0.143,
          "operatingCashFlowFirstReported": 0.143,
          "operatingCashFlowLatestRestated": 0.143,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2023-12-12",
          "operatingCashFlowFiledLatest": "2024-12-10",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2024-Q1",
          "end": "2024-02-29",
          "capex": 1.674,
          "capexFirstReported": 1.674,
          "capexLatestRestated": 1.674,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-03-12",
          "capexFiledLatest": "2025-03-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 1.674,
          "capexLatest": 1.674,
          "capexRestatementPct": 0,
          "firstFiled": "2024-03-12",
          "latestFiled": "2025-03-11",
          "filed": "2025-03-11",
          "revenue": 13.28,
          "revenueFirstReported": 13.28,
          "revenueLatestRestated": 13.28,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-03-12",
          "revenueFiledLatest": "2025-03-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 5.475,
          "operatingCashFlowFirstReported": 5.475,
          "operatingCashFlowLatestRestated": 5.475,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-03-12",
          "operatingCashFlowFiledLatest": "2025-03-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2024-Q2",
          "end": "2024-05-31",
          "capex": 2.798,
          "capexFirstReported": 2.798,
          "capexLatestRestated": 2.798,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-06-20",
          "capexFiledLatest": "2026-06-22",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 2.798,
          "capexLatest": 2.798,
          "capexRestatementPct": 0,
          "firstFiled": "2024-06-20",
          "latestFiled": "2026-06-22",
          "filed": "2026-06-22",
          "revenue": 14.287,
          "revenueFirstReported": 14.287,
          "revenueLatestRestated": 14.287,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-06-20",
          "revenueFiledLatest": "2026-06-22",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 6.081,
          "operatingCashFlowFirstReported": 6.081,
          "operatingCashFlowLatestRestated": 6.081,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-06-20",
          "operatingCashFlowFiledLatest": "2026-06-22",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2024-Q3",
          "end": "2024-08-31",
          "capex": 2.303,
          "capexFirstReported": 2.303,
          "capexLatestRestated": 2.303,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-09-10",
          "capexFiledLatest": "2025-09-10",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 2.303,
          "capexLatest": 2.303,
          "capexRestatementPct": 0,
          "firstFiled": "2024-09-10",
          "latestFiled": "2025-09-10",
          "filed": "2025-09-10",
          "revenue": 13.307,
          "revenueFirstReported": 13.307,
          "revenueLatestRestated": 13.307,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-09-10",
          "revenueFiledLatest": "2025-09-10",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.427,
          "operatingCashFlowFirstReported": 7.427,
          "operatingCashFlowLatestRestated": 7.427,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-09-10",
          "operatingCashFlowFiledLatest": "2025-09-10",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2024-Q4",
          "end": "2024-11-30",
          "capex": 3.97,
          "capexFirstReported": 3.97,
          "capexLatestRestated": 3.97,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2024-12-10",
          "capexFiledLatest": "2025-12-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 3.97,
          "capexLatest": 3.97,
          "capexRestatementPct": 0,
          "firstFiled": "2024-12-10",
          "latestFiled": "2025-12-11",
          "filed": "2025-12-11",
          "revenue": 14.059,
          "revenueFirstReported": 14.059,
          "revenueLatestRestated": 14.059,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2024-12-10",
          "revenueFiledLatest": "2025-12-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 1.304,
          "operatingCashFlowFirstReported": 1.304,
          "operatingCashFlowLatestRestated": 1.304,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2024-12-10",
          "operatingCashFlowFiledLatest": "2025-12-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2025-Q1",
          "end": "2025-02-28",
          "capex": 5.862,
          "capexFirstReported": 5.862,
          "capexLatestRestated": 5.862,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-03-11",
          "capexFiledLatest": "2026-03-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 5.862,
          "capexLatest": 5.862,
          "capexRestatementPct": 0,
          "firstFiled": "2025-03-11",
          "latestFiled": "2026-03-11",
          "filed": "2026-03-11",
          "revenue": 14.13,
          "revenueFirstReported": 14.13,
          "revenueLatestRestated": 14.13,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-03-11",
          "revenueFiledLatest": "2026-03-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 5.933,
          "operatingCashFlowFirstReported": 5.933,
          "operatingCashFlowLatestRestated": 5.933,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-03-11",
          "operatingCashFlowFiledLatest": "2026-03-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2025-Q2",
          "end": "2025-05-31",
          "capex": 9.08,
          "capexFirstReported": 9.08,
          "capexLatestRestated": 9.08,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-06-18",
          "capexFiledLatest": "2026-06-22",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 9.08,
          "capexLatest": 9.08,
          "capexRestatementPct": 0,
          "firstFiled": "2025-06-18",
          "latestFiled": "2026-06-22",
          "filed": "2026-06-22",
          "revenue": 15.903,
          "revenueFirstReported": 15.903,
          "revenueLatestRestated": 15.903,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-06-18",
          "revenueFiledLatest": "2026-06-22",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 6.157,
          "operatingCashFlowFirstReported": 6.157,
          "operatingCashFlowLatestRestated": 6.157,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-06-18",
          "operatingCashFlowFiledLatest": "2026-06-22",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        },
        {
          "period": "2025-Q3",
          "end": "2025-08-31",
          "capex": 8.502,
          "capexFirstReported": 8.502,
          "capexLatestRestated": 8.502,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-09-10",
          "capexFiledLatest": "2025-09-10",
          "capexExtractionFirst": "standalone",
          "capexExtractionLatest": "standalone",
          "capexAsFirstReported": 8.502,
          "capexLatest": 8.502,
          "capexRestatementPct": 0,
          "firstFiled": "2025-09-10",
          "latestFiled": "2025-09-10",
          "filed": "2025-09-10",
          "revenue": 14.926,
          "revenueFirstReported": 14.926,
          "revenueLatestRestated": 14.926,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-09-10",
          "revenueFiledLatest": "2025-09-10",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 8.14,
          "operatingCashFlowFirstReported": 8.14,
          "operatingCashFlowLatestRestated": 8.14,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-09-10",
          "operatingCashFlowFiledLatest": "2025-09-10",
          "operatingCashFlowExtractionFirst": "standalone",
          "operatingCashFlowExtractionLatest": "standalone"
        },
        {
          "period": "2025-Q4",
          "end": "2025-11-30",
          "capex": 12.033,
          "capexFirstReported": 12.033,
          "capexLatestRestated": 12.033,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2025-12-11",
          "capexFiledLatest": "2025-12-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 12.033,
          "capexLatest": 12.033,
          "capexRestatementPct": 0,
          "firstFiled": "2025-12-11",
          "latestFiled": "2025-12-11",
          "filed": "2025-12-11",
          "revenue": 16.058,
          "revenueFirstReported": 16.058,
          "revenueLatestRestated": 16.058,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2025-12-11",
          "revenueFiledLatest": "2025-12-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 2.066,
          "operatingCashFlowFirstReported": 2.066,
          "operatingCashFlowLatestRestated": 2.066,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2025-12-11",
          "operatingCashFlowFiledLatest": "2025-12-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2026-Q1",
          "end": "2026-02-28",
          "capex": 18.635,
          "capexFirstReported": 18.635,
          "capexLatestRestated": 18.635,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-03-11",
          "capexFiledLatest": "2026-03-11",
          "capexExtractionFirst": "cumulative-difference",
          "capexExtractionLatest": "cumulative-difference",
          "capexAsFirstReported": 18.635,
          "capexLatest": 18.635,
          "capexRestatementPct": 0,
          "firstFiled": "2026-03-11",
          "latestFiled": "2026-03-11",
          "filed": "2026-03-11",
          "revenue": 17.19,
          "revenueFirstReported": 17.19,
          "revenueLatestRestated": 17.19,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-03-11",
          "revenueFiledLatest": "2026-03-11",
          "revenueExtractionFirst": "standalone",
          "revenueExtractionLatest": "standalone",
          "operatingCashFlow": 7.151,
          "operatingCashFlowFirstReported": 7.151,
          "operatingCashFlowLatestRestated": 7.151,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-03-11",
          "operatingCashFlowFiledLatest": "2026-03-11",
          "operatingCashFlowExtractionFirst": "cumulative-difference",
          "operatingCashFlowExtractionLatest": "cumulative-difference"
        },
        {
          "period": "2026-Q2",
          "end": "2026-05-31",
          "capex": 16.493,
          "capexFirstReported": 16.493,
          "capexLatestRestated": 16.493,
          "capexTag": "PaymentsToAcquirePropertyPlantAndEquipment",
          "capexFiledFirst": "2026-06-22",
          "capexFiledLatest": "2026-06-22",
          "capexExtractionFirst": "fy-residual",
          "capexExtractionLatest": "fy-residual",
          "capexAsFirstReported": 16.493,
          "capexLatest": 16.493,
          "capexRestatementPct": 0,
          "firstFiled": "2026-06-22",
          "latestFiled": "2026-06-22",
          "filed": "2026-06-22",
          "revenue": 19.184,
          "revenueFirstReported": 19.184,
          "revenueLatestRestated": 19.184,
          "revenueTag": "RevenueFromContractWithCustomerExcludingAssessedTax",
          "revenueFiledFirst": "2026-06-22",
          "revenueFiledLatest": "2026-06-22",
          "revenueExtractionFirst": "fy-residual",
          "revenueExtractionLatest": "fy-residual",
          "operatingCashFlow": 14.62,
          "operatingCashFlowFirstReported": 14.62,
          "operatingCashFlowLatestRestated": 14.62,
          "operatingCashFlowTag": "NetCashProvidedByUsedInOperatingActivities",
          "operatingCashFlowFiledFirst": "2026-06-22",
          "operatingCashFlowFiledLatest": "2026-06-22",
          "operatingCashFlowExtractionFirst": "fy-residual",
          "operatingCashFlowExtractionLatest": "fy-residual"
        }
      ]
    }
  },
  "sources": [
    {
      "id": "sec",
      "label": "SEC EDGAR Company Facts",
      "url": "https://www.sec.gov/edgar/sec-api-documentation",
      "tier": "official",
      "cadence": "quarterly"
    },
    {
      "id": "npm",
      "label": "npm Downloads API",
      "url": "https://github.com/npm/registry/blob/master/docs/download-counts.md",
      "tier": "platform",
      "cadence": "daily"
    },
    {
      "id": "wikimedia",
      "label": "Wikimedia Pageviews API",
      "url": "https://doc.wikimedia.org/generated-data-platform/aqs/analytics-api/reference/page-views.html",
      "tier": "platform",
      "cadence": "daily"
    },
    {
      "id": "epoch",
      "label": "Epoch AI Data Center Timelines",
      "url": "https://epoch.ai/data/data-centers-documentation/downloads",
      "tier": "research",
      "cadence": "irregular"
    },
    {
      "id": "epoch-eci",
      "label": "Epoch Capabilities Index",
      "url": "https://epoch.ai/eci",
      "tier": "research",
      "cadence": "model release"
    },
    {
      "id": "epoch-models",
      "label": "Epoch Frontier AI Models",
      "url": "https://epoch.ai/data/ai-models-documentation/downloads",
      "tier": "research",
      "cadence": "irregular"
    },
    {
      "id": "epoch-chips",
      "label": "Epoch AI Chip Sales",
      "url": "https://epoch.ai/data/ai-chip-sales",
      "tier": "research",
      "cadence": "quarterly"
    },
    {
      "id": "epoch-cashflow",
      "label": "Epoch AI Hyperscaler CapEx vs Cash Flow",
      "url": "https://epoch.ai/data-insights/hyperscaler-capex-vs-cash-flow",
      "tier": "research-cross-check",
      "cadence": "irregular"
    },
    {
      "id": "epoch-frontier-centers",
      "label": "Epoch AI Largest Data Center Compute",
      "url": "https://epoch.ai/data-insights/largest-data-center-compute",
      "tier": "research-constraint",
      "cadence": "irregular"
    },
    {
      "id": "openrouter",
      "label": "OpenRouter Rankings Daily",
      "url": "https://openrouter.ai/docs/api/api-reference/datasets/get-rankings-daily",
      "tier": "pending-key",
      "cadence": "daily"
    }
  ]
}
